/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * K3X API
 * The K3X API description
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountImpersonationActiveOrganizationBodyDto,
  AddCompanyAsLeadResponseDto,
  AddCustomFieldOptionBodyDto,
  AddSuperadminCreditsBodyDto,
  AddSuperadminCreditsResponseDto,
  AiComposeBodyDto,
  AiComposeResponseDto,
  AiComposeTemplateResponseDto,
  AiRuntimeEventDto,
  AiSuggestionsBodyDto,
  AiSuggestionsResponseDto,
  AssignPhoneNumberBodyDto,
  AuthorizeGoogleConnectionResponseDto,
  AuthorizeMicrosoftConnectionResponseDto,
  AutocompleteContactsParams,
  AutocompleteContactsResponseDto,
  AutocompleteLeadsParams,
  AutocompleteLeadsResponseDto,
  BulkArchiveAiAgentsBodyDto,
  BulkArchiveAiAgentsResponseDto,
  BulkArchiveContactsBodyDto,
  BulkArchiveCustomFieldsBodyDto,
  BulkArchiveLeadsBodyDto,
  BulkArchiveResponseDto,
  BulkAssignLeadOwnersBodyDto,
  BulkRecipientsBodyDto,
  BulkRecipientsResponseDto,
  BulkRunAiAgentsBodyDto,
  BulkSendResponseDto,
  ChangeBillingPlanBodyDto,
  ChangeBillingPlanResponseDto,
  ChangeOrganizationPriceBodyDto,
  ChangeSuperadminBillingPlanCreditsBodyDto,
  ChangeSuperadminBillingPlanCreditsResponseDto,
  ClearConnectionDataBodyDto,
  CountRecordsBodyDto,
  CountRecordsResponseDto,
  CountSmartViewRecordsBodyDto,
  CountSmartViewRecordsResponseDto,
  CreateAiAgentBodyDto,
  CreateAiAgentThreadBodyDto,
  CreateAiAssistantThreadNodeRequestDto,
  CreateAiAssistantThreadNodeResponseDto,
  CreateAiAssistantThreadRequestDto,
  CreateAiAssistantThreadResponseDto,
  CreateAiComposeTemplateBodyDto,
  CreateBillingCheckoutSessionBodyDto,
  CreateBillingTopUpCheckoutSessionBodyDto,
  CreateBillingTopUpCheckoutSessionResponseDto,
  CreateBulkEmailBodyDto,
  CreateBulkSmsBodyDto,
  CreateCalendarEventBodyDto,
  CreateCalendarEventResponseDto,
  CreateCallEventBodyDto,
  CreateCheckoutSessionResponseDto,
  CreateContactBodyDto,
  CreateContactCustomFieldBodyDto,
  CreateContactEmailBodyDto,
  CreateContactFieldLabelBodyDto,
  CreateContactPhoneNumberBodyDto,
  CreateCustomFieldBodyDto,
  CreateDatabaseSearchTabBodyDto,
  CreateDatabaseSearchTabResponseDto,
  CreateDealBodyDto,
  CreateDealCustomFieldBodyDto,
  CreateDealStageBodyDto,
  CreateEmailBodyDto,
  CreateGoogleConnectionBodyDto,
  CreateImportJobDto,
  CreateImportUploadUrlDto,
  CreateLeadBodyDto,
  CreateLeadContactBodyDto,
  CreateLeadContactResponseDto,
  CreateLeadCustomFieldBodyDto,
  CreateLeadNoteBodyDto,
  CreateLeadResponseDto,
  CreateLeadWebsiteBodyDto,
  CreateMicrosoftConnectionBodyDto,
  CreateOrganizationBodyDto,
  CreateOrganizationMembershipInvitationBodyDto,
  CreateOrganizationRoleBodyDto,
  CreatePortalSessionResponseDto,
  CreateRevealAsyncResponseDto,
  CreateRevealSyncResponseDto,
  CreateSmartViewBodyDto,
  CreateSmartViewResponseDto,
  CreateSmsBodyDto,
  CreateSuperadminBillingPlanBodyDto,
  CreateSuperadminOrganizationBodyDto,
  CreateUserBodyDto,
  CustomFieldResponseDto,
  DatabaseCompanyPeopleBodyDto,
  DatabaseCompanyResponseDto,
  DatabaseCountBodyDto,
  DatabaseCountResponseDto,
  DatabaseFiltersResponseDto,
  DatabaseOptionsResponseDto,
  DatabaseSearchBodyDto,
  DatabaseSearchCompaniesBodyDto,
  DatabaseSearchCompaniesResponseDto,
  DatabaseSearchResponseDto,
  DatabaseSearchTabDto,
  DeleteCalendarEventParams,
  DeleteConnectionBodyDto,
  DeleteConnectionResponseDto,
  EmailResponseDto,
  ExtendSuperadminTrialBodyDto,
  ExtendSuperadminTrialResponseDto,
  GenerateBillingTestUsageBodyDto,
  GenerateBillingTestUsageResponseDto,
  GetAccessTokenResponseDto,
  GetAccountInvitationResponseDto,
  GetAccountResponseDto,
  GetAgentWebhookDeliveryResponseDto,
  GetAiAgentResponseDto,
  GetAiAgentThreadResponseDto,
  GetAiAssistantThreadResponseDto,
  GetBillingHistoryResponseDto,
  GetBillingOverviewResponseDto,
  GetBillingPlanTiersResponseDto,
  GetBillingRateCardResponseDto,
  GetBillingTopUpCheckoutSessionResponseDto,
  GetBillingUpgradePreviewParams,
  GetBillingUsageHistoryParams,
  GetEmailThreadResponseDto,
  GetLeadFeedParams,
  GetLeadFeedResponseDto,
  GetLeadFileDownloadUrlParams,
  GetLeadFileDownloadUrlResponseDto,
  GetLeadResponseDto,
  GetNotificationSettingsResponseDto,
  GetOrganizationAiSettingsResponseDto,
  GetOrganizationAnalyticsParams,
  GetOrganizationAnalyticsResponseDto,
  GetOrganizationMembershipResponseDto,
  GetOrganizationResponseDto,
  GetOrganizationRoleResponseDto,
  GetPipelineMetadataResponseDto,
  GetSettingsResponseDto,
  GetSuperadminAnalyticsParams,
  GetSuperadminAnalyticsResponseDto,
  GetSuperadminBillingReportParams,
  GetSuperadminBillingReportResponseDto,
  GetSuperadminOrganizationBillingResponseDto,
  GetTwilioAccountResponseDto,
  GetUpgradePreviewResponseDto,
  GlobalSearchBodyDto,
  GlobalSearchResponseDto,
  ImpersonateUserBodyDto,
  ImpersonateUserResponseDto,
  ImportJobResponseDto,
  ImportUploadTargetResponseDto,
  InitiateCallBodyDto,
  InitiateCallResponseDto,
  LeadNoteResponseDto,
  ListActivityEventsResponseDto,
  ListAgentWebhookSettingsParams,
  ListAgentWebhookSettingsResponseDto,
  ListAiAgentOutboundDeliveriesParams,
  ListAiAgentRecordsParams,
  ListAiAgentRecordsResponseDto,
  ListAiAgentThreadsParams,
  ListAiAgentThreadsResponseDto,
  ListAiAgentsParams,
  ListAiAgentsResponseDto,
  ListAiAssistantThreadsResponseDto,
  ListAiComposeTemplateMessagesResponseDto,
  ListAiComposeTemplatesParams,
  ListAiComposeTemplatesResponseDto,
  ListAiMemoriesResponseDto,
  ListCalendarEventsParams,
  ListCalendarEventsResponseDto,
  ListCallsResponseDto,
  ListConnectedAppsResponseDto,
  ListConnectionsParams,
  ListConnectionsResponseDto,
  ListContactFieldLabelsResponseDto,
  ListCustomFieldsResponseDto,
  ListDatabaseRevealJobsParams,
  ListDatabaseSearchTabsResponseDto,
  ListDealBoardColumnBodyDto,
  ListDealBoardColumnResponseDto,
  ListDealStagesResponseDto,
  ListDealsResponseDto,
  ListEmailsParams,
  ListEmailsResponseDto,
  ListImportJobsParams,
  ListImportJobsResponseDto,
  ListLeadAiAgentThreadsParams,
  ListLeadAiAgentThreadsResponseDto,
  ListLeadFilesParams,
  ListLeadFilesResponseDto,
  ListMessagesResponseDto,
  ListOrganizationMembershipInvitationsResponseDto,
  ListOrganizationMembershipsResponseDto,
  ListOrganizationRolesResponseDto,
  ListOutboundDeliveriesResponseDto,
  ListPhoneNumbersResponseDto,
  ListRecordBoardColumnBodyDto,
  ListRevealJobsResponseDto,
  ListSendingMailboxesResponseDto,
  ListSmartViewAvailableFieldsResponseDto,
  ListSmartViewsParams,
  ListSmartViewsResponseDto,
  ListSuperadminActivityParams,
  ListSuperadminBillingAdjustmentsParams,
  ListSuperadminBillingAdjustmentsResponseDto,
  ListSuperadminBillingPlansResponseDto,
  ListSuperadminFailedBillingEventsResponseDto,
  ListSuperadminOrganizationsParams,
  ListSuperadminOrganizationsResponseDto,
  ListTwilioCallsParams,
  ListTwilioMessagesParams,
  ListTwilioPhoneNumbersParams,
  ListUsersParams,
  ListUsersResponseDto,
  LoadAiAgentRecordDetailsBodyDto,
  LoadAiAgentRecordDetailsResponseDto,
  LoadRecordDetailsBodyDto,
  LoadRecordDetailsResponseDto,
  MergeLeadsBodyDto,
  NotifyBillingAdminsBodyDto,
  NotifyBillingAdminsResponseDto,
  PriceTiersResponseDto,
  ProvisionPhoneNumberBodyDto,
  ReconcileSuperadminOrganizationResponseDto,
  RefundSuperadminTopUpBodyDto,
  RefundSuperadminTopUpResponseDto,
  RegisterTwilioA2pBodyDto,
  RemoveSuperadminCreditsBodyDto,
  RemoveSuperadminCreditsResponseDto,
  ReorderCustomFieldOptionsBodyDto,
  ReorderSmartViewsBodyDto,
  ReplaceCustomFieldOptionsBodyDto,
  ReplaceDealStagesBodyDto,
  ReplaySuperadminBillingEventResponseDto,
  ResumeAiAssistantThreadRequestDto,
  RevealEstimateResponseDto,
  RevealFiltersSelectionDto,
  RevealIdsSelectionDto,
  RevealJobResponseDto,
  RevealJobWithResultsResponseDto,
  SearchAvailableNumbersResponseDto,
  SearchAvailableTwilioNumbersParams,
  SearchDatabaseOptionsParams,
  SearchRecordsBodyDto,
  SearchRecordsResponseDto,
  SendPushTestBodyDto,
  SendPushTestResponseDto,
  SendStepTestBodyDto,
  SendStepTestResponseDto,
  SetLeadPrimaryContactBodyDto,
  SetSuperadminAutoRechargeLockBodyDto,
  SetSuperadminAutoRechargeLockResponseDto,
  SetSuperadminBillingDefaultPlanBodyDto,
  SetSuperadminBillingDefaultPlanResponseDto,
  SetUserSessionRecordingBodyDto,
  SmsResponseDto,
  StartAiAssistantThreadRequestDto,
  StopAiAssistantThread200,
  SuperadminActivityEventDetailResponseDto,
  SuperadminBillingPlanDto,
  TouchDatabaseSearchTabBodyDto,
  UpdateAccountProfileBodyDto,
  UpdateAgentMapperBodyDto,
  UpdateAiAgentBodyDto,
  UpdateAiComposeTemplateBodyDto,
  UpdateAiMemoryBodyDto,
  UpdateBillingAutoRechargeBodyDto,
  UpdateBillingAutoRechargeResponseDto,
  UpdateCalendarEventBodyDto,
  UpdateConnectionSignatureBodyDto,
  UpdateContactBodyDto,
  UpdateContactCustomFieldValueBodyDto,
  UpdateContactEmailBodyDto,
  UpdateContactFieldLabelBodyDto,
  UpdateContactPhoneNumberBodyDto,
  UpdateCustomFieldBodyDto,
  UpdateCustomFieldOptionBodyDto,
  UpdateDatabaseSearchTabBodyDto,
  UpdateDealBodyDto,
  UpdateDealCustomFieldValueBodyDto,
  UpdateDealStageBodyDto,
  UpdateEmailBodyDto,
  UpdateImportMappingDto,
  UpdateLeadBodyDto,
  UpdateLeadCustomFieldValueBodyDto,
  UpdateLeadNoteBodyDto,
  UpdateLeadOwnersBodyDto,
  UpdateNotificationSettingsBodyDto,
  UpdateOrganizationAiSettingsBodyDto,
  UpdateOrganizationMembershipBodyDto,
  UpdateOrganizationMembershipProfileBodyDto,
  UpdateOrganizationOnboardingBodyDto,
  UpdateOrganizationProfileBodyDto,
  UpdateOrganizationRoleBodyDto,
  UpdateSettingsBodyDto,
  UpdateSmartViewBodyDto,
  UpdateSmsBodyDto,
  UpdateSuperadminBillingPlanBodyDto,
  UpdateSuperadminOrganizationProfileBodyDto,
  UpgradeSubscriptionBodyDto,
  UpgradeSubscriptionResponseDto,
  UploadLeadFileResponseDto,
  ValidateImportDto
} from './model';

import { axiosInstance } from '../axios.instance';
import type { ErrorType , BodyType } from '../axios.instance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Server-side logout: revokes all Firebase refresh tokens for the user so that
already-issued ID tokens are rejected by AuthGuard (checkRevoked) on the next
request — on this and every other device/relying party. The client is expected
to call this before `signOut()`.
 */
export type logoutAccountResponse204 = {
  data: void
  status: 204
}

export type logoutAccountResponseSuccess = (logoutAccountResponse204) & {
  headers: Headers;
};
;

export type logoutAccountResponse = (logoutAccountResponseSuccess)

export const getLogoutAccountUrl = () => {




  return `/account/logout`
}

export const logoutAccount = async ( options?: RequestInit): Promise<logoutAccountResponse> => {

  return axiosInstance<logoutAccountResponse>(getLogoutAccountUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLogoutAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAccount>>, TError,void, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutAccount>>, TError,void, TContext> => {

const mutationKey = ['logoutAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutAccount>>, void> = () => {


          return  logoutAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutAccountMutationResult = NonNullable<Awaited<ReturnType<typeof logoutAccount>>>

    export type LogoutAccountMutationError = ErrorType<unknown>

    /**
 * @summary Server-side logout: revokes all Firebase refresh tokens for the user so that
already-issued ID tokens are rejected by AuthGuard (checkRevoked) on the next
request — on this and every other device/relying party. The client is expected
to call this before `signOut()`.
 */
export const useLogoutAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutAccount>>, TError,void, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logoutAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutAccountMutationOptions(options), queryClient);
    }

export type getAccountResponse200 = {
  data: GetAccountResponseDto
  status: 200
}

export type getAccountResponseSuccess = (getAccountResponse200) & {
  headers: Headers;
};
;

export type getAccountResponse = (getAccountResponseSuccess)

export const getGetAccountUrl = () => {




  return `/account`
}

export const getAccount = async ( options?: RequestInit): Promise<getAccountResponse> => {

  return axiosInstance<getAccountResponse>(getGetAccountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountQueryKey = () => {
    return [
    `/account`
    ] as const;
    }


export const getGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccount>>> = ({ signal }) => getAccount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccount>>>
export type GetAccountQueryError = ErrorType<unknown>


export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccount>>,
          TError,
          Awaited<ReturnType<typeof getAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccount<TData = Awaited<ReturnType<typeof getAccount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAccountInvitationResponse200 = {
  data: GetAccountInvitationResponseDto
  status: 200
}

export type getAccountInvitationResponseSuccess = (getAccountInvitationResponse200) & {
  headers: Headers;
};
;

export type getAccountInvitationResponse = (getAccountInvitationResponseSuccess)

export const getGetAccountInvitationUrl = (invitationId: string,) => {




  return `/account/invitations/${invitationId}`
}

export const getAccountInvitation = async (invitationId: string, options?: RequestInit): Promise<getAccountInvitationResponse> => {

  return axiosInstance<getAccountInvitationResponse>(getGetAccountInvitationUrl(invitationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAccountInvitationQueryKey = (invitationId: string,) => {
    return [
    `/account/invitations/${invitationId}`
    ] as const;
    }


export const getGetAccountInvitationQueryOptions = <TData = Awaited<ReturnType<typeof getAccountInvitation>>, TError = ErrorType<unknown>>(invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountInvitationQueryKey(invitationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountInvitation>>> = ({ signal }) => getAccountInvitation(invitationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(invitationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountInvitation>>>
export type GetAccountInvitationQueryError = ErrorType<unknown>


export function useGetAccountInvitation<TData = Awaited<ReturnType<typeof getAccountInvitation>>, TError = ErrorType<unknown>>(
 invitationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountInvitation>>,
          TError,
          Awaited<ReturnType<typeof getAccountInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountInvitation<TData = Awaited<ReturnType<typeof getAccountInvitation>>, TError = ErrorType<unknown>>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountInvitation>>,
          TError,
          Awaited<ReturnType<typeof getAccountInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountInvitation<TData = Awaited<ReturnType<typeof getAccountInvitation>>, TError = ErrorType<unknown>>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccountInvitation<TData = Awaited<ReturnType<typeof getAccountInvitation>>, TError = ErrorType<unknown>>(
 invitationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountInvitation>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccountInvitationQueryOptions(invitationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type recordAccountImpersonationActiveOrganizationResponse204 = {
  data: void
  status: 204
}

export type recordAccountImpersonationActiveOrganizationResponseSuccess = (recordAccountImpersonationActiveOrganizationResponse204) & {
  headers: Headers;
};
;

export type recordAccountImpersonationActiveOrganizationResponse = (recordAccountImpersonationActiveOrganizationResponseSuccess)

export const getRecordAccountImpersonationActiveOrganizationUrl = () => {




  return `/account/impersonation/active-organization`
}

export const recordAccountImpersonationActiveOrganization = async (accountImpersonationActiveOrganizationBodyDto: AccountImpersonationActiveOrganizationBodyDto, options?: RequestInit): Promise<recordAccountImpersonationActiveOrganizationResponse> => {

  return axiosInstance<recordAccountImpersonationActiveOrganizationResponse>(getRecordAccountImpersonationActiveOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      accountImpersonationActiveOrganizationBodyDto,)
  }
);}




export const getRecordAccountImpersonationActiveOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>, TError,{data: BodyType<AccountImpersonationActiveOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>, TError,{data: BodyType<AccountImpersonationActiveOrganizationBodyDto>}, TContext> => {

const mutationKey = ['recordAccountImpersonationActiveOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>, {data: BodyType<AccountImpersonationActiveOrganizationBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  recordAccountImpersonationActiveOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAccountImpersonationActiveOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>>
    export type RecordAccountImpersonationActiveOrganizationMutationBody = BodyType<AccountImpersonationActiveOrganizationBodyDto>
    export type RecordAccountImpersonationActiveOrganizationMutationError = ErrorType<unknown>

    export const useRecordAccountImpersonationActiveOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>, TError,{data: BodyType<AccountImpersonationActiveOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordAccountImpersonationActiveOrganization>>,
        TError,
        {data: BodyType<AccountImpersonationActiveOrganizationBodyDto>},
        TContext
      > => {
      return useMutation(getRecordAccountImpersonationActiveOrganizationMutationOptions(options), queryClient);
    }

export type updateAccountProfileResponse204 = {
  data: void
  status: 204
}

export type updateAccountProfileResponseSuccess = (updateAccountProfileResponse204) & {
  headers: Headers;
};
;

export type updateAccountProfileResponse = (updateAccountProfileResponseSuccess)

export const getUpdateAccountProfileUrl = () => {




  return `/account/profile`
}

export const updateAccountProfile = async (updateAccountProfileBodyDto: UpdateAccountProfileBodyDto, options?: RequestInit): Promise<updateAccountProfileResponse> => {

  return axiosInstance<updateAccountProfileResponse>(getUpdateAccountProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAccountProfileBodyDto,)
  }
);}




export const getUpdateAccountProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountProfile>>, TError,{data: BodyType<UpdateAccountProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAccountProfile>>, TError,{data: BodyType<UpdateAccountProfileBodyDto>}, TContext> => {

const mutationKey = ['updateAccountProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAccountProfile>>, {data: BodyType<UpdateAccountProfileBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  updateAccountProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAccountProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateAccountProfile>>>
    export type UpdateAccountProfileMutationBody = BodyType<UpdateAccountProfileBodyDto>
    export type UpdateAccountProfileMutationError = ErrorType<unknown>

    export const useUpdateAccountProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAccountProfile>>, TError,{data: BodyType<UpdateAccountProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAccountProfile>>,
        TError,
        {data: BodyType<UpdateAccountProfileBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateAccountProfileMutationOptions(options), queryClient);
    }

export type acceptAccountInvitationResponse204 = {
  data: void
  status: 204
}

export type acceptAccountInvitationResponseSuccess = (acceptAccountInvitationResponse204) & {
  headers: Headers;
};
;

export type acceptAccountInvitationResponse = (acceptAccountInvitationResponseSuccess)

export const getAcceptAccountInvitationUrl = (invitationId: string,) => {




  return `/account/invitations/${invitationId}/accept`
}

export const acceptAccountInvitation = async (invitationId: string, options?: RequestInit): Promise<acceptAccountInvitationResponse> => {

  return axiosInstance<acceptAccountInvitationResponse>(getAcceptAccountInvitationUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptAccountInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAccountInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptAccountInvitation>>, TError,{invitationId: string}, TContext> => {

const mutationKey = ['acceptAccountInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptAccountInvitation>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  acceptAccountInvitation(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptAccountInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptAccountInvitation>>>

    export type AcceptAccountInvitationMutationError = ErrorType<unknown>

    export const useAcceptAccountInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAccountInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptAccountInvitation>>,
        TError,
        {invitationId: string},
        TContext
      > => {
      return useMutation(getAcceptAccountInvitationMutationOptions(options), queryClient);
    }

export type rejectAccountInvitationResponse204 = {
  data: void
  status: 204
}

export type rejectAccountInvitationResponseSuccess = (rejectAccountInvitationResponse204) & {
  headers: Headers;
};
;

export type rejectAccountInvitationResponse = (rejectAccountInvitationResponseSuccess)

export const getRejectAccountInvitationUrl = (invitationId: string,) => {




  return `/account/invitations/${invitationId}/reject`
}

export const rejectAccountInvitation = async (invitationId: string, options?: RequestInit): Promise<rejectAccountInvitationResponse> => {

  return axiosInstance<rejectAccountInvitationResponse>(getRejectAccountInvitationUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRejectAccountInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccountInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAccountInvitation>>, TError,{invitationId: string}, TContext> => {

const mutationKey = ['rejectAccountInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAccountInvitation>>, {invitationId: string}> = (props) => {
          const {invitationId} = props ?? {};

          return  rejectAccountInvitation(invitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectAccountInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAccountInvitation>>>

    export type RejectAccountInvitationMutationError = ErrorType<unknown>

    export const useRejectAccountInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAccountInvitation>>, TError,{invitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAccountInvitation>>,
        TError,
        {invitationId: string},
        TContext
      > => {
      return useMutation(getRejectAccountInvitationMutationOptions(options), queryClient);
    }

export type getOrganizationAnalyticsResponse200 = {
  data: GetOrganizationAnalyticsResponseDto
  status: 200
}

export type getOrganizationAnalyticsResponseSuccess = (getOrganizationAnalyticsResponse200) & {
  headers: Headers;
};
;

export type getOrganizationAnalyticsResponse = (getOrganizationAnalyticsResponseSuccess)

export const getGetOrganizationAnalyticsUrl = (organizationId: string,
    params: GetOrganizationAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/analytics?${stringifiedParams}` : `/organizations/${organizationId}/analytics`
}

export const getOrganizationAnalytics = async (organizationId: string,
    params: GetOrganizationAnalyticsParams, options?: RequestInit): Promise<getOrganizationAnalyticsResponse> => {

  return axiosInstance<getOrganizationAnalyticsResponse>(getGetOrganizationAnalyticsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationAnalyticsQueryKey = (organizationId: string,
    params?: GetOrganizationAnalyticsParams,) => {
    return [
    `/organizations/${organizationId}/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrganizationAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError = ErrorType<unknown>>(organizationId: string,
    params: GetOrganizationAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationAnalyticsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationAnalytics>>> = ({ signal }) => getOrganizationAnalytics(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationAnalytics>>>
export type GetOrganizationAnalyticsQueryError = ErrorType<unknown>


export function useGetOrganizationAnalytics<TData = Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: GetOrganizationAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationAnalytics<TData = Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: GetOrganizationAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationAnalytics<TData = Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: GetOrganizationAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationAnalytics<TData = Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: GetOrganizationAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationAnalyticsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getBillingOverviewResponse200 = {
  data: GetBillingOverviewResponseDto
  status: 200
}

export type getBillingOverviewResponseSuccess = (getBillingOverviewResponse200) & {
  headers: Headers;
};
;

export type getBillingOverviewResponse = (getBillingOverviewResponseSuccess)

export const getGetBillingOverviewUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/overview`
}

export const getBillingOverview = async (organizationId: string, options?: RequestInit): Promise<getBillingOverviewResponse> => {

  return axiosInstance<getBillingOverviewResponse>(getGetBillingOverviewUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingOverviewQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/billing/overview`
    ] as const;
    }


export const getGetBillingOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingOverviewQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingOverview>>> = ({ signal }) => getBillingOverview(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingOverview>>>
export type GetBillingOverviewQueryError = ErrorType<unknown>


export function useGetBillingOverview<TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingOverview>>,
          TError,
          Awaited<ReturnType<typeof getBillingOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingOverview<TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingOverview>>,
          TError,
          Awaited<ReturnType<typeof getBillingOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingOverview<TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingOverview<TData = Awaited<ReturnType<typeof getBillingOverview>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingOverview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingOverviewQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getBillingRateCardResponse200 = {
  data: GetBillingRateCardResponseDto
  status: 200
}

export type getBillingRateCardResponseSuccess = (getBillingRateCardResponse200) & {
  headers: Headers;
};
;

export type getBillingRateCardResponse = (getBillingRateCardResponseSuccess)

export const getGetBillingRateCardUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/rate-card`
}

export const getBillingRateCard = async (organizationId: string, options?: RequestInit): Promise<getBillingRateCardResponse> => {

  return axiosInstance<getBillingRateCardResponse>(getGetBillingRateCardUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingRateCardQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/billing/rate-card`
    ] as const;
    }


export const getGetBillingRateCardQueryOptions = <TData = Awaited<ReturnType<typeof getBillingRateCard>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingRateCardQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingRateCard>>> = ({ signal }) => getBillingRateCard(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingRateCardQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingRateCard>>>
export type GetBillingRateCardQueryError = ErrorType<unknown>


export function useGetBillingRateCard<TData = Awaited<ReturnType<typeof getBillingRateCard>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingRateCard>>,
          TError,
          Awaited<ReturnType<typeof getBillingRateCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingRateCard<TData = Awaited<ReturnType<typeof getBillingRateCard>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingRateCard>>,
          TError,
          Awaited<ReturnType<typeof getBillingRateCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingRateCard<TData = Awaited<ReturnType<typeof getBillingRateCard>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingRateCard<TData = Awaited<ReturnType<typeof getBillingRateCard>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingRateCard>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingRateCardQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Billing history: the customer's Stripe invoices (paid, unpaid, canceled, refunded) with the
credits each bought, the trial and support credits, and the scheduled next charge.
 */
export type getBillingHistoryResponse200 = {
  data: GetBillingHistoryResponseDto
  status: 200
}

export type getBillingHistoryResponseSuccess = (getBillingHistoryResponse200) & {
  headers: Headers;
};
;

export type getBillingHistoryResponse = (getBillingHistoryResponseSuccess)

export const getGetBillingHistoryUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/history`
}

export const getBillingHistory = async (organizationId: string, options?: RequestInit): Promise<getBillingHistoryResponse> => {

  return axiosInstance<getBillingHistoryResponse>(getGetBillingHistoryUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingHistoryQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/billing/history`
    ] as const;
    }


export const getGetBillingHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getBillingHistory>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingHistoryQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingHistory>>> = ({ signal }) => getBillingHistory(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingHistory>>>
export type GetBillingHistoryQueryError = ErrorType<unknown>


export function useGetBillingHistory<TData = Awaited<ReturnType<typeof getBillingHistory>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingHistory>>,
          TError,
          Awaited<ReturnType<typeof getBillingHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingHistory<TData = Awaited<ReturnType<typeof getBillingHistory>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingHistory>>,
          TError,
          Awaited<ReturnType<typeof getBillingHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingHistory<TData = Awaited<ReturnType<typeof getBillingHistory>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Billing history: the customer's Stripe invoices (paid, unpaid, canceled, refunded) with the
credits each bought, the trial and support credits, and the scheduled next charge.
 */

export function useGetBillingHistory<TData = Awaited<ReturnType<typeof getBillingHistory>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingHistoryQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getBillingUsageHistoryResponse200 = {
  data: void
  status: 200
}

export type getBillingUsageHistoryResponseSuccess = (getBillingUsageHistoryResponse200) & {
  headers: Headers;
};
;

export type getBillingUsageHistoryResponse = (getBillingUsageHistoryResponseSuccess)

export const getGetBillingUsageHistoryUrl = (organizationId: string,
    params?: GetBillingUsageHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/billing/usage/history?${stringifiedParams}` : `/organizations/${organizationId}/billing/usage/history`
}

export const getBillingUsageHistory = async (organizationId: string,
    params?: GetBillingUsageHistoryParams, options?: RequestInit): Promise<getBillingUsageHistoryResponse> => {

  return axiosInstance<getBillingUsageHistoryResponse>(getGetBillingUsageHistoryUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingUsageHistoryQueryKey = (organizationId: string,
    params?: GetBillingUsageHistoryParams,) => {
    return [
    `/organizations/${organizationId}/billing/usage/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBillingUsageHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getBillingUsageHistory>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: GetBillingUsageHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUsageHistoryQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingUsageHistory>>> = ({ signal }) => getBillingUsageHistory(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUsageHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingUsageHistory>>>
export type GetBillingUsageHistoryQueryError = ErrorType<unknown>


export function useGetBillingUsageHistory<TData = Awaited<ReturnType<typeof getBillingUsageHistory>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  GetBillingUsageHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUsageHistory>>,
          TError,
          Awaited<ReturnType<typeof getBillingUsageHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUsageHistory<TData = Awaited<ReturnType<typeof getBillingUsageHistory>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUsageHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUsageHistory>>,
          TError,
          Awaited<ReturnType<typeof getBillingUsageHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUsageHistory<TData = Awaited<ReturnType<typeof getBillingUsageHistory>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUsageHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUsageHistory<TData = Awaited<ReturnType<typeof getBillingUsageHistory>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUsageHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUsageHistory>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingUsageHistoryQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary The plans a customer may pick, cheapest first: every tier that is not hidden.
 */
export type getBillingPlanTiersResponse200 = {
  data: GetBillingPlanTiersResponseDto
  status: 200
}

export type getBillingPlanTiersResponseSuccess = (getBillingPlanTiersResponse200) & {
  headers: Headers;
};
;

export type getBillingPlanTiersResponse = (getBillingPlanTiersResponseSuccess)

export const getGetBillingPlanTiersUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/plan-tiers`
}

export const getBillingPlanTiers = async (organizationId: string, options?: RequestInit): Promise<getBillingPlanTiersResponse> => {

  return axiosInstance<getBillingPlanTiersResponse>(getGetBillingPlanTiersUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingPlanTiersQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/billing/plan-tiers`
    ] as const;
    }


export const getGetBillingPlanTiersQueryOptions = <TData = Awaited<ReturnType<typeof getBillingPlanTiers>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingPlanTiersQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingPlanTiers>>> = ({ signal }) => getBillingPlanTiers(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingPlanTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingPlanTiers>>>
export type GetBillingPlanTiersQueryError = ErrorType<unknown>


export function useGetBillingPlanTiers<TData = Awaited<ReturnType<typeof getBillingPlanTiers>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingPlanTiers>>,
          TError,
          Awaited<ReturnType<typeof getBillingPlanTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingPlanTiers<TData = Awaited<ReturnType<typeof getBillingPlanTiers>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingPlanTiers>>,
          TError,
          Awaited<ReturnType<typeof getBillingPlanTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingPlanTiers<TData = Awaited<ReturnType<typeof getBillingPlanTiers>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The plans a customer may pick, cheapest first: every tier that is not hidden.
 */

export function useGetBillingPlanTiers<TData = Awaited<ReturnType<typeof getBillingPlanTiers>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingPlanTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingPlanTiersQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary An active subscription moves to another plan for sale. No proration: the new price and its
credits start with the next billing period.
 */
export type changeBillingPlanResponse200 = {
  data: ChangeBillingPlanResponseDto
  status: 200
}

export type changeBillingPlanResponseSuccess = (changeBillingPlanResponse200) & {
  headers: Headers;
};
;

export type changeBillingPlanResponse = (changeBillingPlanResponseSuccess)

export const getChangeBillingPlanUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/plan`
}

export const changeBillingPlan = async (organizationId: string,
    changeBillingPlanBodyDto: ChangeBillingPlanBodyDto, options?: RequestInit): Promise<changeBillingPlanResponse> => {

  return axiosInstance<changeBillingPlanResponse>(getChangeBillingPlanUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeBillingPlanBodyDto,)
  }
);}




export const getChangeBillingPlanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBillingPlan>>, TError,{organizationId: string;data: BodyType<ChangeBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeBillingPlan>>, TError,{organizationId: string;data: BodyType<ChangeBillingPlanBodyDto>}, TContext> => {

const mutationKey = ['changeBillingPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeBillingPlan>>, {organizationId: string;data: BodyType<ChangeBillingPlanBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  changeBillingPlan(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeBillingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof changeBillingPlan>>>
    export type ChangeBillingPlanMutationBody = BodyType<ChangeBillingPlanBodyDto>
    export type ChangeBillingPlanMutationError = ErrorType<unknown>

    /**
 * @summary An active subscription moves to another plan for sale. No proration: the new price and its
credits start with the next billing period.
 */
export const useChangeBillingPlan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeBillingPlan>>, TError,{organizationId: string;data: BodyType<ChangeBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeBillingPlan>>,
        TError,
        {organizationId: string;data: BodyType<ChangeBillingPlanBodyDto>},
        TContext
      > => {
      return useMutation(getChangeBillingPlanMutationOptions(options), queryClient);
    }

export type createBillingCheckoutSessionResponse200 = {
  data: CreateCheckoutSessionResponseDto
  status: 200
}

export type createBillingCheckoutSessionResponseSuccess = (createBillingCheckoutSessionResponse200) & {
  headers: Headers;
};
;

export type createBillingCheckoutSessionResponse = (createBillingCheckoutSessionResponseSuccess)

export const getCreateBillingCheckoutSessionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/checkout-session`
}

export const createBillingCheckoutSession = async (organizationId: string,
    createBillingCheckoutSessionBodyDto: CreateBillingCheckoutSessionBodyDto, options?: RequestInit): Promise<createBillingCheckoutSessionResponse> => {

  return axiosInstance<createBillingCheckoutSessionResponse>(getCreateBillingCheckoutSessionUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBillingCheckoutSessionBodyDto,)
  }
);}




export const getCreateBillingCheckoutSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingCheckoutSessionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingCheckoutSessionBodyDto>}, TContext> => {

const mutationKey = ['createBillingCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingCheckoutSession>>, {organizationId: string;data: BodyType<CreateBillingCheckoutSessionBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createBillingCheckoutSession(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingCheckoutSession>>>
    export type CreateBillingCheckoutSessionMutationBody = BodyType<CreateBillingCheckoutSessionBodyDto>
    export type CreateBillingCheckoutSessionMutationError = ErrorType<unknown>

    export const useCreateBillingCheckoutSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingCheckoutSessionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBillingCheckoutSession>>,
        TError,
        {organizationId: string;data: BodyType<CreateBillingCheckoutSessionBodyDto>},
        TContext
      > => {
      return useMutation(getCreateBillingCheckoutSessionMutationOptions(options), queryClient);
    }

export type createBillingTopUpCheckoutSessionResponse200 = {
  data: CreateBillingTopUpCheckoutSessionResponseDto
  status: 200
}

export type createBillingTopUpCheckoutSessionResponseSuccess = (createBillingTopUpCheckoutSessionResponse200) & {
  headers: Headers;
};
;

export type createBillingTopUpCheckoutSessionResponse = (createBillingTopUpCheckoutSessionResponseSuccess)

export const getCreateBillingTopUpCheckoutSessionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/top-up/checkout-session`
}

export const createBillingTopUpCheckoutSession = async (organizationId: string,
    createBillingTopUpCheckoutSessionBodyDto: CreateBillingTopUpCheckoutSessionBodyDto, options?: RequestInit): Promise<createBillingTopUpCheckoutSessionResponse> => {

  return axiosInstance<createBillingTopUpCheckoutSessionResponse>(getCreateBillingTopUpCheckoutSessionUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBillingTopUpCheckoutSessionBodyDto,)
  }
);}




export const getCreateBillingTopUpCheckoutSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingTopUpCheckoutSessionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingTopUpCheckoutSessionBodyDto>}, TContext> => {

const mutationKey = ['createBillingTopUpCheckoutSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>, {organizationId: string;data: BodyType<CreateBillingTopUpCheckoutSessionBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createBillingTopUpCheckoutSession(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingTopUpCheckoutSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>>
    export type CreateBillingTopUpCheckoutSessionMutationBody = BodyType<CreateBillingTopUpCheckoutSessionBodyDto>
    export type CreateBillingTopUpCheckoutSessionMutationError = ErrorType<unknown>

    export const useCreateBillingTopUpCheckoutSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>, TError,{organizationId: string;data: BodyType<CreateBillingTopUpCheckoutSessionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBillingTopUpCheckoutSession>>,
        TError,
        {organizationId: string;data: BodyType<CreateBillingTopUpCheckoutSessionBodyDto>},
        TContext
      > => {
      return useMutation(getCreateBillingTopUpCheckoutSessionMutationOptions(options), queryClient);
    }

export type getBillingTopUpCheckoutSessionResponse200 = {
  data: GetBillingTopUpCheckoutSessionResponseDto
  status: 200
}

export type getBillingTopUpCheckoutSessionResponseSuccess = (getBillingTopUpCheckoutSessionResponse200) & {
  headers: Headers;
};
;

export type getBillingTopUpCheckoutSessionResponse = (getBillingTopUpCheckoutSessionResponseSuccess)

export const getGetBillingTopUpCheckoutSessionUrl = (organizationId: string,
    sessionId: string,) => {




  return `/organizations/${organizationId}/billing/top-up/checkout-session/${sessionId}`
}

export const getBillingTopUpCheckoutSession = async (organizationId: string,
    sessionId: string, options?: RequestInit): Promise<getBillingTopUpCheckoutSessionResponse> => {

  return axiosInstance<getBillingTopUpCheckoutSessionResponse>(getGetBillingTopUpCheckoutSessionUrl(organizationId,sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingTopUpCheckoutSessionQueryKey = (organizationId: string,
    sessionId: string,) => {
    return [
    `/organizations/${organizationId}/billing/top-up/checkout-session/${sessionId}`
    ] as const;
    }


export const getGetBillingTopUpCheckoutSessionQueryOptions = <TData = Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError = ErrorType<unknown>>(organizationId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingTopUpCheckoutSessionQueryKey(organizationId,sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>> = ({ signal }) => getBillingTopUpCheckoutSession(organizationId,sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && sessionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingTopUpCheckoutSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>>
export type GetBillingTopUpCheckoutSessionQueryError = ErrorType<unknown>


export function useGetBillingTopUpCheckoutSession<TData = Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError = ErrorType<unknown>>(
 organizationId: string,
    sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>,
          TError,
          Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingTopUpCheckoutSession<TData = Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError = ErrorType<unknown>>(
 organizationId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>,
          TError,
          Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingTopUpCheckoutSession<TData = Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError = ErrorType<unknown>>(
 organizationId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingTopUpCheckoutSession<TData = Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError = ErrorType<unknown>>(
 organizationId: string,
    sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingTopUpCheckoutSession>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingTopUpCheckoutSessionQueryOptions(organizationId,sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Turn auto-recharge on or off (UC-16). Turning it on needs a saved card, an active plan, no
scheduled cancellation and no open dispute, and charges right away if the balance is already
under 2,500.
 */
export type updateBillingAutoRechargeResponse200 = {
  data: UpdateBillingAutoRechargeResponseDto
  status: 200
}

export type updateBillingAutoRechargeResponseSuccess = (updateBillingAutoRechargeResponse200) & {
  headers: Headers;
};
;

export type updateBillingAutoRechargeResponse = (updateBillingAutoRechargeResponseSuccess)

export const getUpdateBillingAutoRechargeUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/auto-recharge`
}

export const updateBillingAutoRecharge = async (organizationId: string,
    updateBillingAutoRechargeBodyDto: UpdateBillingAutoRechargeBodyDto, options?: RequestInit): Promise<updateBillingAutoRechargeResponse> => {

  return axiosInstance<updateBillingAutoRechargeResponse>(getUpdateBillingAutoRechargeUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateBillingAutoRechargeBodyDto,)
  }
);}




export const getUpdateBillingAutoRechargeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingAutoRecharge>>, TError,{organizationId: string;data: BodyType<UpdateBillingAutoRechargeBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBillingAutoRecharge>>, TError,{organizationId: string;data: BodyType<UpdateBillingAutoRechargeBodyDto>}, TContext> => {

const mutationKey = ['updateBillingAutoRecharge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBillingAutoRecharge>>, {organizationId: string;data: BodyType<UpdateBillingAutoRechargeBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateBillingAutoRecharge(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBillingAutoRechargeMutationResult = NonNullable<Awaited<ReturnType<typeof updateBillingAutoRecharge>>>
    export type UpdateBillingAutoRechargeMutationBody = BodyType<UpdateBillingAutoRechargeBodyDto>
    export type UpdateBillingAutoRechargeMutationError = ErrorType<unknown>

    /**
 * @summary Turn auto-recharge on or off (UC-16). Turning it on needs a saved card, an active plan, no
scheduled cancellation and no open dispute, and charges right away if the balance is already
under 2,500.
 */
export const useUpdateBillingAutoRecharge = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBillingAutoRecharge>>, TError,{organizationId: string;data: BodyType<UpdateBillingAutoRechargeBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBillingAutoRecharge>>,
        TError,
        {organizationId: string;data: BodyType<UpdateBillingAutoRechargeBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateBillingAutoRechargeMutationOptions(options), queryClient);
    }

/**
 * @summary A rep's "Notify admin" when blocked by credits: emails the billing managers and the owner, at
most once an hour per organization. Any member may call it — no billing permission.
 */
export type notifyBillingAdminsResponse200 = {
  data: NotifyBillingAdminsResponseDto
  status: 200
}

export type notifyBillingAdminsResponseSuccess = (notifyBillingAdminsResponse200) & {
  headers: Headers;
};
;

export type notifyBillingAdminsResponse = (notifyBillingAdminsResponseSuccess)

export const getNotifyBillingAdminsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/notify-billing-admins`
}

export const notifyBillingAdmins = async (organizationId: string,
    notifyBillingAdminsBodyDto: NotifyBillingAdminsBodyDto, options?: RequestInit): Promise<notifyBillingAdminsResponse> => {

  return axiosInstance<notifyBillingAdminsResponse>(getNotifyBillingAdminsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      notifyBillingAdminsBodyDto,)
  }
);}




export const getNotifyBillingAdminsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyBillingAdmins>>, TError,{organizationId: string;data: BodyType<NotifyBillingAdminsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notifyBillingAdmins>>, TError,{organizationId: string;data: BodyType<NotifyBillingAdminsBodyDto>}, TContext> => {

const mutationKey = ['notifyBillingAdmins'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notifyBillingAdmins>>, {organizationId: string;data: BodyType<NotifyBillingAdminsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  notifyBillingAdmins(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NotifyBillingAdminsMutationResult = NonNullable<Awaited<ReturnType<typeof notifyBillingAdmins>>>
    export type NotifyBillingAdminsMutationBody = BodyType<NotifyBillingAdminsBodyDto>
    export type NotifyBillingAdminsMutationError = ErrorType<unknown>

    /**
 * @summary A rep's "Notify admin" when blocked by credits: emails the billing managers and the owner, at
most once an hour per organization. Any member may call it — no billing permission.
 */
export const useNotifyBillingAdmins = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notifyBillingAdmins>>, TError,{organizationId: string;data: BodyType<NotifyBillingAdminsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notifyBillingAdmins>>,
        TError,
        {organizationId: string;data: BodyType<NotifyBillingAdminsBodyDto>},
        TContext
      > => {
      return useMutation(getNotifyBillingAdminsMutationOptions(options), queryClient);
    }

export type generateBillingTestUsageResponse200 = {
  data: GenerateBillingTestUsageResponseDto
  status: 200
}

export type generateBillingTestUsageResponseSuccess = (generateBillingTestUsageResponse200) & {
  headers: Headers;
};
;

export type generateBillingTestUsageResponse = (generateBillingTestUsageResponseSuccess)

export const getGenerateBillingTestUsageUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/generate-test-usage`
}

export const generateBillingTestUsage = async (organizationId: string,
    generateBillingTestUsageBodyDto: GenerateBillingTestUsageBodyDto, options?: RequestInit): Promise<generateBillingTestUsageResponse> => {

  return axiosInstance<generateBillingTestUsageResponse>(getGenerateBillingTestUsageUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      generateBillingTestUsageBodyDto,)
  }
);}




export const getGenerateBillingTestUsageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBillingTestUsage>>, TError,{organizationId: string;data: BodyType<GenerateBillingTestUsageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateBillingTestUsage>>, TError,{organizationId: string;data: BodyType<GenerateBillingTestUsageBodyDto>}, TContext> => {

const mutationKey = ['generateBillingTestUsage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateBillingTestUsage>>, {organizationId: string;data: BodyType<GenerateBillingTestUsageBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  generateBillingTestUsage(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateBillingTestUsageMutationResult = NonNullable<Awaited<ReturnType<typeof generateBillingTestUsage>>>
    export type GenerateBillingTestUsageMutationBody = BodyType<GenerateBillingTestUsageBodyDto>
    export type GenerateBillingTestUsageMutationError = ErrorType<unknown>

    export const useGenerateBillingTestUsage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateBillingTestUsage>>, TError,{organizationId: string;data: BodyType<GenerateBillingTestUsageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateBillingTestUsage>>,
        TError,
        {organizationId: string;data: BodyType<GenerateBillingTestUsageBodyDto>},
        TContext
      > => {
      return useMutation(getGenerateBillingTestUsageMutationOptions(options), queryClient);
    }

export type createBillingPortalSessionResponse200 = {
  data: CreatePortalSessionResponseDto
  status: 200
}

export type createBillingPortalSessionResponseSuccess = (createBillingPortalSessionResponse200) & {
  headers: Headers;
};
;

export type createBillingPortalSessionResponse = (createBillingPortalSessionResponseSuccess)

export const getCreateBillingPortalSessionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/portal-session`
}

export const createBillingPortalSession = async (organizationId: string, options?: RequestInit): Promise<createBillingPortalSessionResponse> => {

  return axiosInstance<createBillingPortalSessionResponse>(getCreateBillingPortalSessionUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateBillingPortalSessionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['createBillingPortalSession'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBillingPortalSession>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  createBillingPortalSession(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingPortalSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createBillingPortalSession>>>

    export type CreateBillingPortalSessionMutationError = ErrorType<unknown>

    export const useCreateBillingPortalSession = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBillingPortalSession>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBillingPortalSession>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getCreateBillingPortalSessionMutationOptions(options), queryClient);
    }

export type getBillingUpgradePreviewResponse200 = {
  data: GetUpgradePreviewResponseDto
  status: 200
}

export type getBillingUpgradePreviewResponseSuccess = (getBillingUpgradePreviewResponse200) & {
  headers: Headers;
};
;

export type getBillingUpgradePreviewResponse = (getBillingUpgradePreviewResponseSuccess)

export const getGetBillingUpgradePreviewUrl = (organizationId: string,
    params?: GetBillingUpgradePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/billing/upgrade/preview?${stringifiedParams}` : `/organizations/${organizationId}/billing/upgrade/preview`
}

export const getBillingUpgradePreview = async (organizationId: string,
    params?: GetBillingUpgradePreviewParams, options?: RequestInit): Promise<getBillingUpgradePreviewResponse> => {

  return axiosInstance<getBillingUpgradePreviewResponse>(getGetBillingUpgradePreviewUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingUpgradePreviewQueryKey = (organizationId: string,
    params?: GetBillingUpgradePreviewParams,) => {
    return [
    `/organizations/${organizationId}/billing/upgrade/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBillingUpgradePreviewQueryOptions = <TData = Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: GetBillingUpgradePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUpgradePreviewQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingUpgradePreview>>> = ({ signal }) => getBillingUpgradePreview(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUpgradePreviewQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingUpgradePreview>>>
export type GetBillingUpgradePreviewQueryError = ErrorType<unknown>


export function useGetBillingUpgradePreview<TData = Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  GetBillingUpgradePreviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUpgradePreview>>,
          TError,
          Awaited<ReturnType<typeof getBillingUpgradePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUpgradePreview<TData = Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUpgradePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUpgradePreview>>,
          TError,
          Awaited<ReturnType<typeof getBillingUpgradePreview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUpgradePreview<TData = Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUpgradePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUpgradePreview<TData = Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: GetBillingUpgradePreviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingUpgradePreview>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingUpgradePreviewQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type upgradeBillingSubscriptionResponse200 = {
  data: UpgradeSubscriptionResponseDto
  status: 200
}

export type upgradeBillingSubscriptionResponseSuccess = (upgradeBillingSubscriptionResponse200) & {
  headers: Headers;
};
;

export type upgradeBillingSubscriptionResponse = (upgradeBillingSubscriptionResponseSuccess)

export const getUpgradeBillingSubscriptionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/billing/upgrade`
}

export const upgradeBillingSubscription = async (organizationId: string,
    upgradeSubscriptionBodyDto: UpgradeSubscriptionBodyDto, options?: RequestInit): Promise<upgradeBillingSubscriptionResponse> => {

  return axiosInstance<upgradeBillingSubscriptionResponse>(getUpgradeBillingSubscriptionUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upgradeSubscriptionBodyDto,)
  }
);}




export const getUpgradeBillingSubscriptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upgradeBillingSubscription>>, TError,{organizationId: string;data: BodyType<UpgradeSubscriptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof upgradeBillingSubscription>>, TError,{organizationId: string;data: BodyType<UpgradeSubscriptionBodyDto>}, TContext> => {

const mutationKey = ['upgradeBillingSubscription'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upgradeBillingSubscription>>, {organizationId: string;data: BodyType<UpgradeSubscriptionBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  upgradeBillingSubscription(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpgradeBillingSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof upgradeBillingSubscription>>>
    export type UpgradeBillingSubscriptionMutationBody = BodyType<UpgradeSubscriptionBodyDto>
    export type UpgradeBillingSubscriptionMutationError = ErrorType<unknown>

    export const useUpgradeBillingSubscription = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upgradeBillingSubscription>>, TError,{organizationId: string;data: BodyType<UpgradeSubscriptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upgradeBillingSubscription>>,
        TError,
        {organizationId: string;data: BodyType<UpgradeSubscriptionBodyDto>},
        TContext
      > => {
      return useMutation(getUpgradeBillingSubscriptionMutationOptions(options), queryClient);
    }

export type listAiAgentsResponse200 = {
  data: ListAiAgentsResponseDto
  status: 200
}

export type listAiAgentsResponseSuccess = (listAiAgentsResponse200) & {
  headers: Headers;
};
;

export type listAiAgentsResponse = (listAiAgentsResponseSuccess)

export const getListAiAgentsUrl = (organizationId: string,
    params?: ListAiAgentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents`
}

export const listAiAgents = async (organizationId: string,
    params?: ListAiAgentsParams, options?: RequestInit): Promise<listAiAgentsResponse> => {

  return axiosInstance<listAiAgentsResponse>(getListAiAgentsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiAgentsQueryKey = (organizationId: string,
    params?: ListAiAgentsParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAgentsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAgents>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListAiAgentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiAgentsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAgents>>> = ({ signal }) => listAiAgents(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiAgentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAgents>>>
export type ListAiAgentsQueryError = ErrorType<unknown>


export function useListAiAgents<TData = Awaited<ReturnType<typeof listAiAgents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListAiAgentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgents>>,
          TError,
          Awaited<ReturnType<typeof listAiAgents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgents<TData = Awaited<ReturnType<typeof listAiAgents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiAgentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgents>>,
          TError,
          Awaited<ReturnType<typeof listAiAgents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgents<TData = Awaited<ReturnType<typeof listAiAgents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiAgentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiAgents<TData = Awaited<ReturnType<typeof listAiAgents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiAgentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAgentsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createAiAgentResponse201 = {
  data: GetAiAgentResponseDto
  status: 201
}

export type createAiAgentResponseSuccess = (createAiAgentResponse201) & {
  headers: Headers;
};
;

export type createAiAgentResponse = (createAiAgentResponseSuccess)

export const getCreateAiAgentUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/agents`
}

export const createAiAgent = async (organizationId: string,
    createAiAgentBodyDto: CreateAiAgentBodyDto, options?: RequestInit): Promise<createAiAgentResponse> => {

  return axiosInstance<createAiAgentResponse>(getCreateAiAgentUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAiAgentBodyDto,)
  }
);}




export const getCreateAiAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAgent>>, TError,{organizationId: string;data: BodyType<CreateAiAgentBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAiAgent>>, TError,{organizationId: string;data: BodyType<CreateAiAgentBodyDto>}, TContext> => {

const mutationKey = ['createAiAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiAgent>>, {organizationId: string;data: BodyType<CreateAiAgentBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createAiAgent(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiAgentMutationResult = NonNullable<Awaited<ReturnType<typeof createAiAgent>>>
    export type CreateAiAgentMutationBody = BodyType<CreateAiAgentBodyDto>
    export type CreateAiAgentMutationError = ErrorType<unknown>

    export const useCreateAiAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAgent>>, TError,{organizationId: string;data: BodyType<CreateAiAgentBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAiAgent>>,
        TError,
        {organizationId: string;data: BodyType<CreateAiAgentBodyDto>},
        TContext
      > => {
      return useMutation(getCreateAiAgentMutationOptions(options), queryClient);
    }

export type listAgentWebhookSettingsResponse200 = {
  data: ListAgentWebhookSettingsResponseDto
  status: 200
}

export type listAgentWebhookSettingsResponseSuccess = (listAgentWebhookSettingsResponse200) & {
  headers: Headers;
};
;

export type listAgentWebhookSettingsResponse = (listAgentWebhookSettingsResponseSuccess)

export const getListAgentWebhookSettingsUrl = (organizationId: string,
    params?: ListAgentWebhookSettingsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents/webhook-settings?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents/webhook-settings`
}

export const listAgentWebhookSettings = async (organizationId: string,
    params?: ListAgentWebhookSettingsParams, options?: RequestInit): Promise<listAgentWebhookSettingsResponse> => {

  return axiosInstance<listAgentWebhookSettingsResponse>(getListAgentWebhookSettingsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgentWebhookSettingsQueryKey = (organizationId: string,
    params?: ListAgentWebhookSettingsParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents/webhook-settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAgentWebhookSettingsQueryOptions = <TData = Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListAgentWebhookSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentWebhookSettingsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentWebhookSettings>>> = ({ signal }) => listAgentWebhookSettings(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgentWebhookSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentWebhookSettings>>>
export type ListAgentWebhookSettingsQueryError = ErrorType<unknown>


export function useListAgentWebhookSettings<TData = Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListAgentWebhookSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentWebhookSettings>>,
          TError,
          Awaited<ReturnType<typeof listAgentWebhookSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentWebhookSettings<TData = Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAgentWebhookSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentWebhookSettings>>,
          TError,
          Awaited<ReturnType<typeof listAgentWebhookSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentWebhookSettings<TData = Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAgentWebhookSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAgentWebhookSettings<TData = Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAgentWebhookSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgentWebhookSettingsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listLeadAiAgentThreadsResponse200 = {
  data: ListLeadAiAgentThreadsResponseDto
  status: 200
}

export type listLeadAiAgentThreadsResponseSuccess = (listLeadAiAgentThreadsResponse200) & {
  headers: Headers;
};
;

export type listLeadAiAgentThreadsResponse = (listLeadAiAgentThreadsResponseSuccess)

export const getListLeadAiAgentThreadsUrl = (organizationId: string,
    params: ListLeadAiAgentThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents/threads?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents/threads`
}

export const listLeadAiAgentThreads = async (organizationId: string,
    params: ListLeadAiAgentThreadsParams, options?: RequestInit): Promise<listLeadAiAgentThreadsResponse> => {

  return axiosInstance<listLeadAiAgentThreadsResponse>(getListLeadAiAgentThreadsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeadAiAgentThreadsQueryKey = (organizationId: string,
    params?: ListLeadAiAgentThreadsParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeadAiAgentThreadsQueryOptions = <TData = Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError = ErrorType<unknown>>(organizationId: string,
    params: ListLeadAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeadAiAgentThreadsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeadAiAgentThreads>>> = ({ signal }) => listLeadAiAgentThreads(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLeadAiAgentThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listLeadAiAgentThreads>>>
export type ListLeadAiAgentThreadsQueryError = ErrorType<unknown>


export function useListLeadAiAgentThreads<TData = Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListLeadAiAgentThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadAiAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listLeadAiAgentThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeadAiAgentThreads<TData = Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListLeadAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadAiAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listLeadAiAgentThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeadAiAgentThreads<TData = Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListLeadAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLeadAiAgentThreads<TData = Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListLeadAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLeadAiAgentThreadsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAiAgentResponse200 = {
  data: GetAiAgentResponseDto
  status: 200
}

export type getAiAgentResponseSuccess = (getAiAgentResponse200) & {
  headers: Headers;
};
;

export type getAiAgentResponse = (getAiAgentResponseSuccess)

export const getGetAiAgentUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}`
}

export const getAiAgent = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<getAiAgentResponse> => {

  return axiosInstance<getAiAgentResponse>(getGetAiAgentUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiAgentQueryKey = (organizationId: string,
    aiAgentId: string,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}`
    ] as const;
    }


export const getGetAiAgentQueryOptions = <TData = Awaited<ReturnType<typeof getAiAgent>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAgentQueryKey(organizationId,aiAgentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAgent>>> = ({ signal }) => getAiAgent(organizationId,aiAgentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiAgentQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAgent>>>
export type GetAiAgentQueryError = ErrorType<unknown>


export function useGetAiAgent<TData = Awaited<ReturnType<typeof getAiAgent>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAgent>>,
          TError,
          Awaited<ReturnType<typeof getAiAgent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAgent<TData = Awaited<ReturnType<typeof getAiAgent>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAgent>>,
          TError,
          Awaited<ReturnType<typeof getAiAgent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAgent<TData = Awaited<ReturnType<typeof getAiAgent>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiAgent<TData = Awaited<ReturnType<typeof getAiAgent>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgent>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAgentQueryOptions(organizationId,aiAgentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateAiAgentResponse204 = {
  data: void
  status: 204
}

export type updateAiAgentResponseSuccess = (updateAiAgentResponse204) & {
  headers: Headers;
};
;

export type updateAiAgentResponse = (updateAiAgentResponseSuccess)

export const getUpdateAiAgentUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}`
}

export const updateAiAgent = async (organizationId: string,
    aiAgentId: string,
    updateAiAgentBodyDto: UpdateAiAgentBodyDto, options?: RequestInit): Promise<updateAiAgentResponse> => {

  return axiosInstance<updateAiAgentResponse>(getUpdateAiAgentUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAiAgentBodyDto,)
  }
);}




export const getUpdateAiAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAgent>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAiAgentBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAiAgent>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAiAgentBodyDto>}, TContext> => {

const mutationKey = ['updateAiAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiAgent>>, {organizationId: string;aiAgentId: string;data: BodyType<UpdateAiAgentBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,data} = props ?? {};

          return  updateAiAgent(organizationId,aiAgentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiAgentMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiAgent>>>
    export type UpdateAiAgentMutationBody = BodyType<UpdateAiAgentBodyDto>
    export type UpdateAiAgentMutationError = ErrorType<unknown>

    export const useUpdateAiAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiAgent>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAiAgentBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAiAgent>>,
        TError,
        {organizationId: string;aiAgentId: string;data: BodyType<UpdateAiAgentBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateAiAgentMutationOptions(options), queryClient);
    }

export type activateAiAgentResponse204 = {
  data: void
  status: 204
}

export type activateAiAgentResponseSuccess = (activateAiAgentResponse204) & {
  headers: Headers;
};
;

export type activateAiAgentResponse = (activateAiAgentResponseSuccess)

export const getActivateAiAgentUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/activate`
}

export const activateAiAgent = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<activateAiAgentResponse> => {

  return axiosInstance<activateAiAgentResponse>(getActivateAiAgentUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivateAiAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activateAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['activateAiAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateAiAgent>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  activateAiAgent(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateAiAgentMutationResult = NonNullable<Awaited<ReturnType<typeof activateAiAgent>>>

    export type ActivateAiAgentMutationError = ErrorType<unknown>

    export const useActivateAiAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateAiAgent>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getActivateAiAgentMutationOptions(options), queryClient);
    }

export type updateAgentMapperResponse204 = {
  data: void
  status: 204
}

export type updateAgentMapperResponseSuccess = (updateAgentMapperResponse204) & {
  headers: Headers;
};
;

export type updateAgentMapperResponse = (updateAgentMapperResponseSuccess)

export const getUpdateAgentMapperUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/mapper`
}

export const updateAgentMapper = async (organizationId: string,
    aiAgentId: string,
    updateAgentMapperBodyDto: UpdateAgentMapperBodyDto, options?: RequestInit): Promise<updateAgentMapperResponse> => {

  return axiosInstance<updateAgentMapperResponse>(getUpdateAgentMapperUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAgentMapperBodyDto,)
  }
);}




export const getUpdateAgentMapperMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentMapper>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAgentMapperBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAgentMapper>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAgentMapperBodyDto>}, TContext> => {

const mutationKey = ['updateAgentMapper'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgentMapper>>, {organizationId: string;aiAgentId: string;data: BodyType<UpdateAgentMapperBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,data} = props ?? {};

          return  updateAgentMapper(organizationId,aiAgentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentMapperMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgentMapper>>>
    export type UpdateAgentMapperMutationBody = BodyType<UpdateAgentMapperBodyDto>
    export type UpdateAgentMapperMutationError = ErrorType<unknown>

    export const useUpdateAgentMapper = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentMapper>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<UpdateAgentMapperBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAgentMapper>>,
        TError,
        {organizationId: string;aiAgentId: string;data: BodyType<UpdateAgentMapperBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateAgentMapperMutationOptions(options), queryClient);
    }

export type sendStepTestResponse200 = {
  data: SendStepTestResponseDto
  status: 200
}

export type sendStepTestResponseSuccess = (sendStepTestResponse200) & {
  headers: Headers;
};
;

export type sendStepTestResponse = (sendStepTestResponseSuccess)

export const getSendStepTestUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/steps/test`
}

export const sendStepTest = async (organizationId: string,
    aiAgentId: string,
    sendStepTestBodyDto: SendStepTestBodyDto, options?: RequestInit): Promise<sendStepTestResponse> => {

  return axiosInstance<sendStepTestResponse>(getSendStepTestUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendStepTestBodyDto,)
  }
);}




export const getSendStepTestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendStepTest>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<SendStepTestBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendStepTest>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<SendStepTestBodyDto>}, TContext> => {

const mutationKey = ['sendStepTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendStepTest>>, {organizationId: string;aiAgentId: string;data: BodyType<SendStepTestBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,data} = props ?? {};

          return  sendStepTest(organizationId,aiAgentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendStepTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendStepTest>>>
    export type SendStepTestMutationBody = BodyType<SendStepTestBodyDto>
    export type SendStepTestMutationError = ErrorType<unknown>

    export const useSendStepTest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendStepTest>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<SendStepTestBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendStepTest>>,
        TError,
        {organizationId: string;aiAgentId: string;data: BodyType<SendStepTestBodyDto>},
        TContext
      > => {
      return useMutation(getSendStepTestMutationOptions(options), queryClient);
    }

export type sendPushStepTestResponse200 = {
  data: SendPushTestResponseDto
  status: 200
}

export type sendPushStepTestResponseSuccess = (sendPushStepTestResponse200) & {
  headers: Headers;
};
;

export type sendPushStepTestResponse = (sendPushStepTestResponseSuccess)

export const getSendPushStepTestUrl = (organizationId: string,
    aiAgentId: string,
    stepId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/steps/${stepId}/push-test`
}

export const sendPushStepTest = async (organizationId: string,
    aiAgentId: string,
    stepId: string,
    sendPushTestBodyDto: SendPushTestBodyDto, options?: RequestInit): Promise<sendPushStepTestResponse> => {

  return axiosInstance<sendPushStepTestResponse>(getSendPushStepTestUrl(organizationId,aiAgentId,stepId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendPushTestBodyDto,)
  }
);}




export const getSendPushStepTestMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushStepTest>>, TError,{organizationId: string;aiAgentId: string;stepId: string;data: BodyType<SendPushTestBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPushStepTest>>, TError,{organizationId: string;aiAgentId: string;stepId: string;data: BodyType<SendPushTestBodyDto>}, TContext> => {

const mutationKey = ['sendPushStepTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPushStepTest>>, {organizationId: string;aiAgentId: string;stepId: string;data: BodyType<SendPushTestBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,stepId,data} = props ?? {};

          return  sendPushStepTest(organizationId,aiAgentId,stepId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendPushStepTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendPushStepTest>>>
    export type SendPushStepTestMutationBody = BodyType<SendPushTestBodyDto>
    export type SendPushStepTestMutationError = ErrorType<unknown>

    export const useSendPushStepTest = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPushStepTest>>, TError,{organizationId: string;aiAgentId: string;stepId: string;data: BodyType<SendPushTestBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPushStepTest>>,
        TError,
        {organizationId: string;aiAgentId: string;stepId: string;data: BodyType<SendPushTestBodyDto>},
        TContext
      > => {
      return useMutation(getSendPushStepTestMutationOptions(options), queryClient);
    }

export type listAiAgentOutboundDeliveriesResponse200 = {
  data: ListOutboundDeliveriesResponseDto
  status: 200
}

export type listAiAgentOutboundDeliveriesResponseSuccess = (listAiAgentOutboundDeliveriesResponse200) & {
  headers: Headers;
};
;

export type listAiAgentOutboundDeliveriesResponse = (listAiAgentOutboundDeliveriesResponseSuccess)

export const getListAiAgentOutboundDeliveriesUrl = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents/${aiAgentId}/outbound-deliveries?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents/${aiAgentId}/outbound-deliveries`
}

export const listAiAgentOutboundDeliveries = async (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams, options?: RequestInit): Promise<listAiAgentOutboundDeliveriesResponse> => {

  return axiosInstance<listAiAgentOutboundDeliveriesResponse>(getListAiAgentOutboundDeliveriesUrl(organizationId,aiAgentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiAgentOutboundDeliveriesQueryKey = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/outbound-deliveries`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAgentOutboundDeliveriesQueryOptions = <TData = Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiAgentOutboundDeliveriesQueryKey(organizationId,aiAgentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>> = ({ signal }) => listAiAgentOutboundDeliveries(organizationId,aiAgentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiAgentOutboundDeliveriesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>>
export type ListAiAgentOutboundDeliveriesQueryError = ErrorType<unknown>


export function useListAiAgentOutboundDeliveries<TData = Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params: undefined |  ListAiAgentOutboundDeliveriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentOutboundDeliveries<TData = Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentOutboundDeliveries<TData = Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiAgentOutboundDeliveries<TData = Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentOutboundDeliveriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentOutboundDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAgentOutboundDeliveriesQueryOptions(organizationId,aiAgentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type pauseAiAgentResponse204 = {
  data: void
  status: 204
}

export type pauseAiAgentResponseSuccess = (pauseAiAgentResponse204) & {
  headers: Headers;
};
;

export type pauseAiAgentResponse = (pauseAiAgentResponseSuccess)

export const getPauseAiAgentUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/pause`
}

export const pauseAiAgent = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<pauseAiAgentResponse> => {

  return axiosInstance<pauseAiAgentResponse>(getPauseAiAgentUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPauseAiAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pauseAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['pauseAiAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pauseAiAgent>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  pauseAiAgent(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PauseAiAgentMutationResult = NonNullable<Awaited<ReturnType<typeof pauseAiAgent>>>

    export type PauseAiAgentMutationError = ErrorType<unknown>

    export const usePauseAiAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pauseAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pauseAiAgent>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getPauseAiAgentMutationOptions(options), queryClient);
    }

export type archiveAiAgentResponse204 = {
  data: void
  status: 204
}

export type archiveAiAgentResponseSuccess = (archiveAiAgentResponse204) & {
  headers: Headers;
};
;

export type archiveAiAgentResponse = (archiveAiAgentResponseSuccess)

export const getArchiveAiAgentUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/archive`
}

export const archiveAiAgent = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<archiveAiAgentResponse> => {

  return axiosInstance<archiveAiAgentResponse>(getArchiveAiAgentUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveAiAgentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['archiveAiAgent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAiAgent>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  archiveAiAgent(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAiAgentMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAiAgent>>>

    export type ArchiveAiAgentMutationError = ErrorType<unknown>

    export const useArchiveAiAgent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAgent>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveAiAgent>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getArchiveAiAgentMutationOptions(options), queryClient);
    }

export type bulkArchiveAiAgentsResponse200 = {
  data: BulkArchiveAiAgentsResponseDto
  status: 200
}

export type bulkArchiveAiAgentsResponseSuccess = (bulkArchiveAiAgentsResponse200) & {
  headers: Headers;
};
;

export type bulkArchiveAiAgentsResponse = (bulkArchiveAiAgentsResponseSuccess)

export const getBulkArchiveAiAgentsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/agents/bulk-archive`
}

export const bulkArchiveAiAgents = async (organizationId: string,
    bulkArchiveAiAgentsBodyDto: BulkArchiveAiAgentsBodyDto, options?: RequestInit): Promise<bulkArchiveAiAgentsResponse> => {

  return axiosInstance<bulkArchiveAiAgentsResponse>(getBulkArchiveAiAgentsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkArchiveAiAgentsBodyDto,)
  }
);}




export const getBulkArchiveAiAgentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveAiAgents>>, TError,{organizationId: string;data: BodyType<BulkArchiveAiAgentsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveAiAgents>>, TError,{organizationId: string;data: BodyType<BulkArchiveAiAgentsBodyDto>}, TContext> => {

const mutationKey = ['bulkArchiveAiAgents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchiveAiAgents>>, {organizationId: string;data: BodyType<BulkArchiveAiAgentsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkArchiveAiAgents(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveAiAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchiveAiAgents>>>
    export type BulkArchiveAiAgentsMutationBody = BodyType<BulkArchiveAiAgentsBodyDto>
    export type BulkArchiveAiAgentsMutationError = ErrorType<unknown>

    export const useBulkArchiveAiAgents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveAiAgents>>, TError,{organizationId: string;data: BodyType<BulkArchiveAiAgentsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchiveAiAgents>>,
        TError,
        {organizationId: string;data: BodyType<BulkArchiveAiAgentsBodyDto>},
        TContext
      > => {
      return useMutation(getBulkArchiveAiAgentsMutationOptions(options), queryClient);
    }

export type enableAgentWebhookResponse200 = {
  data: void
  status: 200
}

export type enableAgentWebhookResponseSuccess = (enableAgentWebhookResponse200) & {
  headers: Headers;
};
;

export type enableAgentWebhookResponse = (enableAgentWebhookResponseSuccess)

export const getEnableAgentWebhookUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/enable`
}

export const enableAgentWebhook = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<enableAgentWebhookResponse> => {

  return axiosInstance<enableAgentWebhookResponse>(getEnableAgentWebhookUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEnableAgentWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['enableAgentWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableAgentWebhook>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  enableAgentWebhook(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableAgentWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof enableAgentWebhook>>>

    export type EnableAgentWebhookMutationError = ErrorType<unknown>

    export const useEnableAgentWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableAgentWebhook>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getEnableAgentWebhookMutationOptions(options), queryClient);
    }

export type disableAgentWebhookResponse204 = {
  data: void
  status: 204
}

export type disableAgentWebhookResponseSuccess = (disableAgentWebhookResponse204) & {
  headers: Headers;
};
;

export type disableAgentWebhookResponse = (disableAgentWebhookResponseSuccess)

export const getDisableAgentWebhookUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/disable`
}

export const disableAgentWebhook = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<disableAgentWebhookResponse> => {

  return axiosInstance<disableAgentWebhookResponse>(getDisableAgentWebhookUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDisableAgentWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['disableAgentWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableAgentWebhook>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  disableAgentWebhook(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableAgentWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof disableAgentWebhook>>>

    export type DisableAgentWebhookMutationError = ErrorType<unknown>

    export const useDisableAgentWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableAgentWebhook>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableAgentWebhook>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getDisableAgentWebhookMutationOptions(options), queryClient);
    }

export type regenerateAgentWebhookTokenResponse200 = {
  data: void
  status: 200
}

export type regenerateAgentWebhookTokenResponseSuccess = (regenerateAgentWebhookTokenResponse200) & {
  headers: Headers;
};
;

export type regenerateAgentWebhookTokenResponse = (regenerateAgentWebhookTokenResponseSuccess)

export const getRegenerateAgentWebhookTokenUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/regenerate`
}

export const regenerateAgentWebhookToken = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<regenerateAgentWebhookTokenResponse> => {

  return axiosInstance<regenerateAgentWebhookTokenResponse>(getRegenerateAgentWebhookTokenUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRegenerateAgentWebhookTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAgentWebhookToken>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateAgentWebhookToken>>, TError,{organizationId: string;aiAgentId: string}, TContext> => {

const mutationKey = ['regenerateAgentWebhookToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateAgentWebhookToken>>, {organizationId: string;aiAgentId: string}> = (props) => {
          const {organizationId,aiAgentId} = props ?? {};

          return  regenerateAgentWebhookToken(organizationId,aiAgentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateAgentWebhookTokenMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateAgentWebhookToken>>>

    export type RegenerateAgentWebhookTokenMutationError = ErrorType<unknown>

    export const useRegenerateAgentWebhookToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAgentWebhookToken>>, TError,{organizationId: string;aiAgentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateAgentWebhookToken>>,
        TError,
        {organizationId: string;aiAgentId: string},
        TContext
      > => {
      return useMutation(getRegenerateAgentWebhookTokenMutationOptions(options), queryClient);
    }

export type listAgentWebhookDeliveriesResponse200 = {
  data: void
  status: 200
}

export type listAgentWebhookDeliveriesResponseSuccess = (listAgentWebhookDeliveriesResponse200) & {
  headers: Headers;
};
;

export type listAgentWebhookDeliveriesResponse = (listAgentWebhookDeliveriesResponseSuccess)

export const getListAgentWebhookDeliveriesUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/deliveries`
}

export const listAgentWebhookDeliveries = async (organizationId: string,
    aiAgentId: string, options?: RequestInit): Promise<listAgentWebhookDeliveriesResponse> => {

  return axiosInstance<listAgentWebhookDeliveriesResponse>(getListAgentWebhookDeliveriesUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAgentWebhookDeliveriesQueryKey = (organizationId: string,
    aiAgentId: string,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/deliveries`
    ] as const;
    }


export const getListAgentWebhookDeliveriesQueryOptions = <TData = Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentWebhookDeliveriesQueryKey(organizationId,aiAgentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>> = ({ signal }) => listAgentWebhookDeliveries(organizationId,aiAgentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAgentWebhookDeliveriesQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>>
export type ListAgentWebhookDeliveriesQueryError = ErrorType<unknown>


export function useListAgentWebhookDeliveries<TData = Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentWebhookDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listAgentWebhookDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentWebhookDeliveries<TData = Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentWebhookDeliveries>>,
          TError,
          Awaited<ReturnType<typeof listAgentWebhookDeliveries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAgentWebhookDeliveries<TData = Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAgentWebhookDeliveries<TData = Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentWebhookDeliveries>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAgentWebhookDeliveriesQueryOptions(organizationId,aiAgentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAgentWebhookDeliveryResponse200 = {
  data: GetAgentWebhookDeliveryResponseDto
  status: 200
}

export type getAgentWebhookDeliveryResponseSuccess = (getAgentWebhookDeliveryResponse200) & {
  headers: Headers;
};
;

export type getAgentWebhookDeliveryResponse = (getAgentWebhookDeliveryResponseSuccess)

export const getGetAgentWebhookDeliveryUrl = (organizationId: string,
    aiAgentId: string,
    deliveryId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/deliveries/${deliveryId}`
}

export const getAgentWebhookDelivery = async (organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: RequestInit): Promise<getAgentWebhookDeliveryResponse> => {

  return axiosInstance<getAgentWebhookDeliveryResponse>(getGetAgentWebhookDeliveryUrl(organizationId,aiAgentId,deliveryId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgentWebhookDeliveryQueryKey = (organizationId: string,
    aiAgentId: string,
    deliveryId: string,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/deliveries/${deliveryId}`
    ] as const;
    }


export const getGetAgentWebhookDeliveryQueryOptions = <TData = Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentWebhookDeliveryQueryKey(organizationId,aiAgentId,deliveryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentWebhookDelivery>>> = ({ signal }) => getAgentWebhookDelivery(organizationId,aiAgentId,deliveryId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId && deliveryId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgentWebhookDeliveryQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentWebhookDelivery>>>
export type GetAgentWebhookDeliveryQueryError = ErrorType<unknown>


export function useGetAgentWebhookDelivery<TData = Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    deliveryId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentWebhookDelivery>>,
          TError,
          Awaited<ReturnType<typeof getAgentWebhookDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentWebhookDelivery<TData = Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentWebhookDelivery>>,
          TError,
          Awaited<ReturnType<typeof getAgentWebhookDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgentWebhookDelivery<TData = Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAgentWebhookDelivery<TData = Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentWebhookDelivery>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgentWebhookDeliveryQueryOptions(organizationId,aiAgentId,deliveryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type replayAgentWebhookDeliveryResponse200 = {
  data: void
  status: 200
}

export type replayAgentWebhookDeliveryResponseSuccess = (replayAgentWebhookDeliveryResponse200) & {
  headers: Headers;
};
;

export type replayAgentWebhookDeliveryResponse = (replayAgentWebhookDeliveryResponseSuccess)

export const getReplayAgentWebhookDeliveryUrl = (organizationId: string,
    aiAgentId: string,
    deliveryId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/webhook/deliveries/${deliveryId}/replay`
}

export const replayAgentWebhookDelivery = async (organizationId: string,
    aiAgentId: string,
    deliveryId: string, options?: RequestInit): Promise<replayAgentWebhookDeliveryResponse> => {

  return axiosInstance<replayAgentWebhookDeliveryResponse>(getReplayAgentWebhookDeliveryUrl(organizationId,aiAgentId,deliveryId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReplayAgentWebhookDeliveryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replayAgentWebhookDelivery>>, TError,{organizationId: string;aiAgentId: string;deliveryId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replayAgentWebhookDelivery>>, TError,{organizationId: string;aiAgentId: string;deliveryId: string}, TContext> => {

const mutationKey = ['replayAgentWebhookDelivery'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replayAgentWebhookDelivery>>, {organizationId: string;aiAgentId: string;deliveryId: string}> = (props) => {
          const {organizationId,aiAgentId,deliveryId} = props ?? {};

          return  replayAgentWebhookDelivery(organizationId,aiAgentId,deliveryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplayAgentWebhookDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof replayAgentWebhookDelivery>>>

    export type ReplayAgentWebhookDeliveryMutationError = ErrorType<unknown>

    export const useReplayAgentWebhookDelivery = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replayAgentWebhookDelivery>>, TError,{organizationId: string;aiAgentId: string;deliveryId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replayAgentWebhookDelivery>>,
        TError,
        {organizationId: string;aiAgentId: string;deliveryId: string},
        TContext
      > => {
      return useMutation(getReplayAgentWebhookDeliveryMutationOptions(options), queryClient);
    }

export type listAiAgentThreadsResponse200 = {
  data: ListAiAgentThreadsResponseDto
  status: 200
}

export type listAiAgentThreadsResponseSuccess = (listAiAgentThreadsResponse200) & {
  headers: Headers;
};
;

export type listAiAgentThreadsResponse = (listAiAgentThreadsResponseSuccess)

export const getListAiAgentThreadsUrl = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads`
}

export const listAiAgentThreads = async (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams, options?: RequestInit): Promise<listAiAgentThreadsResponse> => {

  return axiosInstance<listAiAgentThreadsResponse>(getListAiAgentThreadsUrl(organizationId,aiAgentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiAgentThreadsQueryKey = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAgentThreadsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAgentThreads>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiAgentThreadsQueryKey(organizationId,aiAgentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAgentThreads>>> = ({ signal }) => listAiAgentThreads(organizationId,aiAgentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiAgentThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAgentThreads>>>
export type ListAiAgentThreadsQueryError = ErrorType<unknown>


export function useListAiAgentThreads<TData = Awaited<ReturnType<typeof listAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params: undefined |  ListAiAgentThreadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentThreads<TData = Awaited<ReturnType<typeof listAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentThreads>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentThreads<TData = Awaited<ReturnType<typeof listAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiAgentThreads<TData = Awaited<ReturnType<typeof listAiAgentThreads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentThreadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAgentThreadsQueryOptions(organizationId,aiAgentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createAiAgentThreadResponse201 = {
  data: void
  status: 201
}

export type createAiAgentThreadResponseSuccess = (createAiAgentThreadResponse201) & {
  headers: Headers;
};
;

export type createAiAgentThreadResponse = (createAiAgentThreadResponseSuccess)

export const getCreateAiAgentThreadUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads`
}

export const createAiAgentThread = async (organizationId: string,
    aiAgentId: string,
    createAiAgentThreadBodyDto: CreateAiAgentThreadBodyDto, options?: RequestInit): Promise<createAiAgentThreadResponse> => {

  return axiosInstance<createAiAgentThreadResponse>(getCreateAiAgentThreadUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAiAgentThreadBodyDto,)
  }
);}




export const getCreateAiAgentThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<CreateAiAgentThreadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<CreateAiAgentThreadBodyDto>}, TContext> => {

const mutationKey = ['createAiAgentThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiAgentThread>>, {organizationId: string;aiAgentId: string;data: BodyType<CreateAiAgentThreadBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,data} = props ?? {};

          return  createAiAgentThread(organizationId,aiAgentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiAgentThreadMutationResult = NonNullable<Awaited<ReturnType<typeof createAiAgentThread>>>
    export type CreateAiAgentThreadMutationBody = BodyType<CreateAiAgentThreadBodyDto>
    export type CreateAiAgentThreadMutationError = ErrorType<unknown>

    export const useCreateAiAgentThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<CreateAiAgentThreadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAiAgentThread>>,
        TError,
        {organizationId: string;aiAgentId: string;data: BodyType<CreateAiAgentThreadBodyDto>},
        TContext
      > => {
      return useMutation(getCreateAiAgentThreadMutationOptions(options), queryClient);
    }

export type listAiAgentRecordsResponse200 = {
  data: ListAiAgentRecordsResponseDto
  status: 200
}

export type listAiAgentRecordsResponseSuccess = (listAiAgentRecordsResponse200) & {
  headers: Headers;
};
;

export type listAiAgentRecordsResponse = (listAiAgentRecordsResponseSuccess)

export const getListAiAgentRecordsUrl = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/agents/${aiAgentId}/records?${stringifiedParams}` : `/organizations/${organizationId}/ai/agents/${aiAgentId}/records`
}

export const listAiAgentRecords = async (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams, options?: RequestInit): Promise<listAiAgentRecordsResponse> => {

  return axiosInstance<listAiAgentRecordsResponse>(getListAiAgentRecordsUrl(organizationId,aiAgentId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiAgentRecordsQueryKey = (organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/records`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiAgentRecordsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAgentRecords>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiAgentRecordsQueryKey(organizationId,aiAgentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAgentRecords>>> = ({ signal }) => listAiAgentRecords(organizationId,aiAgentId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiAgentRecordsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAgentRecords>>>
export type ListAiAgentRecordsQueryError = ErrorType<unknown>


export function useListAiAgentRecords<TData = Awaited<ReturnType<typeof listAiAgentRecords>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params: undefined |  ListAiAgentRecordsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentRecords>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentRecords<TData = Awaited<ReturnType<typeof listAiAgentRecords>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAgentRecords>>,
          TError,
          Awaited<ReturnType<typeof listAiAgentRecords>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAgentRecords<TData = Awaited<ReturnType<typeof listAiAgentRecords>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiAgentRecords<TData = Awaited<ReturnType<typeof listAiAgentRecords>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    params?: ListAiAgentRecordsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAgentRecords>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAgentRecordsQueryOptions(organizationId,aiAgentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type loadAiAgentRecordDetailsResponse200 = {
  data: LoadAiAgentRecordDetailsResponseDto
  status: 200
}

export type loadAiAgentRecordDetailsResponseSuccess = (loadAiAgentRecordDetailsResponse200) & {
  headers: Headers;
};
;

export type loadAiAgentRecordDetailsResponse = (loadAiAgentRecordDetailsResponseSuccess)

export const getLoadAiAgentRecordDetailsUrl = (organizationId: string,
    aiAgentId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/records/details`
}

export const loadAiAgentRecordDetails = async (organizationId: string,
    aiAgentId: string,
    loadAiAgentRecordDetailsBodyDto: LoadAiAgentRecordDetailsBodyDto, options?: RequestInit): Promise<loadAiAgentRecordDetailsResponse> => {

  return axiosInstance<loadAiAgentRecordDetailsResponse>(getLoadAiAgentRecordDetailsUrl(organizationId,aiAgentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loadAiAgentRecordDetailsBodyDto,)
  }
);}




export const getLoadAiAgentRecordDetailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loadAiAgentRecordDetails>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<LoadAiAgentRecordDetailsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof loadAiAgentRecordDetails>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<LoadAiAgentRecordDetailsBodyDto>}, TContext> => {

const mutationKey = ['loadAiAgentRecordDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loadAiAgentRecordDetails>>, {organizationId: string;aiAgentId: string;data: BodyType<LoadAiAgentRecordDetailsBodyDto>}> = (props) => {
          const {organizationId,aiAgentId,data} = props ?? {};

          return  loadAiAgentRecordDetails(organizationId,aiAgentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoadAiAgentRecordDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof loadAiAgentRecordDetails>>>
    export type LoadAiAgentRecordDetailsMutationBody = BodyType<LoadAiAgentRecordDetailsBodyDto>
    export type LoadAiAgentRecordDetailsMutationError = ErrorType<unknown>

    export const useLoadAiAgentRecordDetails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loadAiAgentRecordDetails>>, TError,{organizationId: string;aiAgentId: string;data: BodyType<LoadAiAgentRecordDetailsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loadAiAgentRecordDetails>>,
        TError,
        {organizationId: string;aiAgentId: string;data: BodyType<LoadAiAgentRecordDetailsBodyDto>},
        TContext
      > => {
      return useMutation(getLoadAiAgentRecordDetailsMutationOptions(options), queryClient);
    }

export type getAiAgentThreadResponse200 = {
  data: GetAiAgentThreadResponseDto
  status: 200
}

export type getAiAgentThreadResponseSuccess = (getAiAgentThreadResponse200) & {
  headers: Headers;
};
;

export type getAiAgentThreadResponse = (getAiAgentThreadResponseSuccess)

export const getGetAiAgentThreadUrl = (organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads/${aiAgentThreadId}`
}

export const getAiAgentThread = async (organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: RequestInit): Promise<getAiAgentThreadResponse> => {

  return axiosInstance<getAiAgentThreadResponse>(getGetAiAgentThreadUrl(organizationId,aiAgentId,aiAgentThreadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiAgentThreadQueryKey = (organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string,) => {
    return [
    `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads/${aiAgentThreadId}`
    ] as const;
    }


export const getGetAiAgentThreadQueryOptions = <TData = Awaited<ReturnType<typeof getAiAgentThread>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAgentThreadQueryKey(organizationId,aiAgentId,aiAgentThreadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAgentThread>>> = ({ signal }) => getAiAgentThread(organizationId,aiAgentId,aiAgentThreadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAgentId && aiAgentThreadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiAgentThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAgentThread>>>
export type GetAiAgentThreadQueryError = ErrorType<unknown>


export function useGetAiAgentThread<TData = Awaited<ReturnType<typeof getAiAgentThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAgentThread>>,
          TError,
          Awaited<ReturnType<typeof getAiAgentThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAgentThread<TData = Awaited<ReturnType<typeof getAiAgentThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAgentThread>>,
          TError,
          Awaited<ReturnType<typeof getAiAgentThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAgentThread<TData = Awaited<ReturnType<typeof getAiAgentThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiAgentThread<TData = Awaited<ReturnType<typeof getAiAgentThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAgentThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAgentThreadQueryOptions(organizationId,aiAgentId,aiAgentThreadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type cancelAiAgentThreadResponse204 = {
  data: void
  status: 204
}

export type cancelAiAgentThreadResponseSuccess = (cancelAiAgentThreadResponse204) & {
  headers: Headers;
};
;

export type cancelAiAgentThreadResponse = (cancelAiAgentThreadResponseSuccess)

export const getCancelAiAgentThreadUrl = (organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string,) => {




  return `/organizations/${organizationId}/ai/agents/${aiAgentId}/threads/${aiAgentThreadId}/cancel`
}

export const cancelAiAgentThread = async (organizationId: string,
    aiAgentId: string,
    aiAgentThreadId: string, options?: RequestInit): Promise<cancelAiAgentThreadResponse> => {

  return axiosInstance<cancelAiAgentThreadResponse>(getCancelAiAgentThreadUrl(organizationId,aiAgentId,aiAgentThreadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelAiAgentThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;aiAgentThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;aiAgentThreadId: string}, TContext> => {

const mutationKey = ['cancelAiAgentThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAiAgentThread>>, {organizationId: string;aiAgentId: string;aiAgentThreadId: string}> = (props) => {
          const {organizationId,aiAgentId,aiAgentThreadId} = props ?? {};

          return  cancelAiAgentThread(organizationId,aiAgentId,aiAgentThreadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAiAgentThreadMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAiAgentThread>>>

    export type CancelAiAgentThreadMutationError = ErrorType<unknown>

    export const useCancelAiAgentThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiAgentThread>>, TError,{organizationId: string;aiAgentId: string;aiAgentThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelAiAgentThread>>,
        TError,
        {organizationId: string;aiAgentId: string;aiAgentThreadId: string},
        TContext
      > => {
      return useMutation(getCancelAiAgentThreadMutationOptions(options), queryClient);
    }

export type bulkRunAiAgentsResponse204 = {
  data: void
  status: 204
}

export type bulkRunAiAgentsResponseSuccess = (bulkRunAiAgentsResponse204) & {
  headers: Headers;
};
;

export type bulkRunAiAgentsResponse = (bulkRunAiAgentsResponseSuccess)

export const getBulkRunAiAgentsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/agents/bulk-run`
}

export const bulkRunAiAgents = async (organizationId: string,
    bulkRunAiAgentsBodyDto: BulkRunAiAgentsBodyDto, options?: RequestInit): Promise<bulkRunAiAgentsResponse> => {

  return axiosInstance<bulkRunAiAgentsResponse>(getBulkRunAiAgentsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkRunAiAgentsBodyDto,)
  }
);}




export const getBulkRunAiAgentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRunAiAgents>>, TError,{organizationId: string;data: BodyType<BulkRunAiAgentsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkRunAiAgents>>, TError,{organizationId: string;data: BodyType<BulkRunAiAgentsBodyDto>}, TContext> => {

const mutationKey = ['bulkRunAiAgents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkRunAiAgents>>, {organizationId: string;data: BodyType<BulkRunAiAgentsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkRunAiAgents(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkRunAiAgentsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkRunAiAgents>>>
    export type BulkRunAiAgentsMutationBody = BodyType<BulkRunAiAgentsBodyDto>
    export type BulkRunAiAgentsMutationError = ErrorType<unknown>

    export const useBulkRunAiAgents = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkRunAiAgents>>, TError,{organizationId: string;data: BodyType<BulkRunAiAgentsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkRunAiAgents>>,
        TError,
        {organizationId: string;data: BodyType<BulkRunAiAgentsBodyDto>},
        TContext
      > => {
      return useMutation(getBulkRunAiAgentsMutationOptions(options), queryClient);
    }

export type createAiAssistantThreadResponse201 = {
  data: CreateAiAssistantThreadResponseDto
  status: 201
}

export type createAiAssistantThreadResponseSuccess = (createAiAssistantThreadResponse201) & {
  headers: Headers;
};
;

export type createAiAssistantThreadResponse = (createAiAssistantThreadResponseSuccess)

export const getCreateAiAssistantThreadUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/assistant`
}

export const createAiAssistantThread = async (organizationId: string,
    createAiAssistantThreadRequestDto: CreateAiAssistantThreadRequestDto, options?: RequestInit): Promise<createAiAssistantThreadResponse> => {

  return axiosInstance<createAiAssistantThreadResponse>(getCreateAiAssistantThreadUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAiAssistantThreadRequestDto,)
  }
);}




export const getCreateAiAssistantThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThread>>, TError,{organizationId: string;data: BodyType<CreateAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThread>>, TError,{organizationId: string;data: BodyType<CreateAiAssistantThreadRequestDto>}, TContext> => {

const mutationKey = ['createAiAssistantThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiAssistantThread>>, {organizationId: string;data: BodyType<CreateAiAssistantThreadRequestDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createAiAssistantThread(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiAssistantThreadMutationResult = NonNullable<Awaited<ReturnType<typeof createAiAssistantThread>>>
    export type CreateAiAssistantThreadMutationBody = BodyType<CreateAiAssistantThreadRequestDto>
    export type CreateAiAssistantThreadMutationError = ErrorType<unknown>

    export const useCreateAiAssistantThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThread>>, TError,{organizationId: string;data: BodyType<CreateAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAiAssistantThread>>,
        TError,
        {organizationId: string;data: BodyType<CreateAiAssistantThreadRequestDto>},
        TContext
      > => {
      return useMutation(getCreateAiAssistantThreadMutationOptions(options), queryClient);
    }

export type listAiAssistantThreadsResponse200 = {
  data: ListAiAssistantThreadsResponseDto
  status: 200
}

export type listAiAssistantThreadsResponseSuccess = (listAiAssistantThreadsResponse200) & {
  headers: Headers;
};
;

export type listAiAssistantThreadsResponse = (listAiAssistantThreadsResponseSuccess)

export const getListAiAssistantThreadsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads`
}

export const listAiAssistantThreads = async (organizationId: string, options?: RequestInit): Promise<listAiAssistantThreadsResponse> => {

  return axiosInstance<listAiAssistantThreadsResponse>(getListAiAssistantThreadsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiAssistantThreadsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/ai/assistant/threads`
    ] as const;
    }


export const getListAiAssistantThreadsQueryOptions = <TData = Awaited<ReturnType<typeof listAiAssistantThreads>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiAssistantThreadsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiAssistantThreads>>> = ({ signal }) => listAiAssistantThreads(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiAssistantThreadsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiAssistantThreads>>>
export type ListAiAssistantThreadsQueryError = ErrorType<unknown>


export function useListAiAssistantThreads<TData = Awaited<ReturnType<typeof listAiAssistantThreads>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAssistantThreads>>,
          TError,
          Awaited<ReturnType<typeof listAiAssistantThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAssistantThreads<TData = Awaited<ReturnType<typeof listAiAssistantThreads>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiAssistantThreads>>,
          TError,
          Awaited<ReturnType<typeof listAiAssistantThreads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiAssistantThreads<TData = Awaited<ReturnType<typeof listAiAssistantThreads>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiAssistantThreads<TData = Awaited<ReturnType<typeof listAiAssistantThreads>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiAssistantThreads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiAssistantThreadsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getAiAssistantThreadResponse200 = {
  data: GetAiAssistantThreadResponseDto
  status: 200
}

export type getAiAssistantThreadResponseSuccess = (getAiAssistantThreadResponse200) & {
  headers: Headers;
};
;

export type getAiAssistantThreadResponse = (getAiAssistantThreadResponseSuccess)

export const getGetAiAssistantThreadUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}`
}

export const getAiAssistantThread = async (organizationId: string,
    aiAssistantThreadId: string, options?: RequestInit): Promise<getAiAssistantThreadResponse> => {

  return axiosInstance<getAiAssistantThreadResponse>(getGetAiAssistantThreadUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiAssistantThreadQueryKey = (organizationId: string,
    aiAssistantThreadId: string,) => {
    return [
    `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}`
    ] as const;
    }


export const getGetAiAssistantThreadQueryOptions = <TData = Awaited<ReturnType<typeof getAiAssistantThread>>, TError = ErrorType<unknown>>(organizationId: string,
    aiAssistantThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiAssistantThreadQueryKey(organizationId,aiAssistantThreadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiAssistantThread>>> = ({ signal }) => getAiAssistantThread(organizationId,aiAssistantThreadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiAssistantThreadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiAssistantThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getAiAssistantThread>>>
export type GetAiAssistantThreadQueryError = ErrorType<unknown>


export function useGetAiAssistantThread<TData = Awaited<ReturnType<typeof getAiAssistantThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAssistantThreadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssistantThread>>,
          TError,
          Awaited<ReturnType<typeof getAiAssistantThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAssistantThread<TData = Awaited<ReturnType<typeof getAiAssistantThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAssistantThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiAssistantThread>>,
          TError,
          Awaited<ReturnType<typeof getAiAssistantThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiAssistantThread<TData = Awaited<ReturnType<typeof getAiAssistantThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAssistantThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAiAssistantThread<TData = Awaited<ReturnType<typeof getAiAssistantThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiAssistantThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiAssistantThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiAssistantThreadQueryOptions(organizationId,aiAssistantThreadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type archiveAiAssistantThreadResponse200 = {
  data: void
  status: 200
}

export type archiveAiAssistantThreadResponseSuccess = (archiveAiAssistantThreadResponse200) & {
  headers: Headers;
};
;

export type archiveAiAssistantThreadResponse = (archiveAiAssistantThreadResponseSuccess)

export const getArchiveAiAssistantThreadUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}`
}

export const archiveAiAssistantThread = async (organizationId: string,
    aiAssistantThreadId: string, options?: RequestInit): Promise<archiveAiAssistantThreadResponse> => {

  return axiosInstance<archiveAiAssistantThreadResponse>(getArchiveAiAssistantThreadUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getArchiveAiAssistantThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext> => {

const mutationKey = ['archiveAiAssistantThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveAiAssistantThread>>, {organizationId: string;aiAssistantThreadId: string}> = (props) => {
          const {organizationId,aiAssistantThreadId} = props ?? {};

          return  archiveAiAssistantThread(organizationId,aiAssistantThreadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveAiAssistantThreadMutationResult = NonNullable<Awaited<ReturnType<typeof archiveAiAssistantThread>>>

    export type ArchiveAiAssistantThreadMutationError = ErrorType<unknown>

    export const useArchiveAiAssistantThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveAiAssistantThread>>,
        TError,
        {organizationId: string;aiAssistantThreadId: string},
        TContext
      > => {
      return useMutation(getArchiveAiAssistantThreadMutationOptions(options), queryClient);
    }

export type createAiAssistantThreadNodeResponse201 = {
  data: CreateAiAssistantThreadNodeResponseDto
  status: 201
}

export type createAiAssistantThreadNodeResponseSuccess = (createAiAssistantThreadNodeResponse201) & {
  headers: Headers;
};
;

export type createAiAssistantThreadNodeResponse = (createAiAssistantThreadNodeResponseSuccess)

export const getCreateAiAssistantThreadNodeUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}/nodes`
}

export const createAiAssistantThreadNode = async (organizationId: string,
    aiAssistantThreadId: string,
    createAiAssistantThreadNodeRequestDto: CreateAiAssistantThreadNodeRequestDto, options?: RequestInit): Promise<createAiAssistantThreadNodeResponse> => {

  return axiosInstance<createAiAssistantThreadNodeResponse>(getCreateAiAssistantThreadNodeUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAiAssistantThreadNodeRequestDto,)
  }
);}




export const getCreateAiAssistantThreadNodeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThreadNode>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<CreateAiAssistantThreadNodeRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThreadNode>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<CreateAiAssistantThreadNodeRequestDto>}, TContext> => {

const mutationKey = ['createAiAssistantThreadNode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiAssistantThreadNode>>, {organizationId: string;aiAssistantThreadId: string;data: BodyType<CreateAiAssistantThreadNodeRequestDto>}> = (props) => {
          const {organizationId,aiAssistantThreadId,data} = props ?? {};

          return  createAiAssistantThreadNode(organizationId,aiAssistantThreadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiAssistantThreadNodeMutationResult = NonNullable<Awaited<ReturnType<typeof createAiAssistantThreadNode>>>
    export type CreateAiAssistantThreadNodeMutationBody = BodyType<CreateAiAssistantThreadNodeRequestDto>
    export type CreateAiAssistantThreadNodeMutationError = ErrorType<unknown>

    export const useCreateAiAssistantThreadNode = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiAssistantThreadNode>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<CreateAiAssistantThreadNodeRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAiAssistantThreadNode>>,
        TError,
        {organizationId: string;aiAssistantThreadId: string;data: BodyType<CreateAiAssistantThreadNodeRequestDto>},
        TContext
      > => {
      return useMutation(getCreateAiAssistantThreadNodeMutationOptions(options), queryClient);
    }

export type startAiAssistantThreadResponse200 = {
  data: AiRuntimeEventDto
  status: 200
}

export type startAiAssistantThreadResponseSuccess = (startAiAssistantThreadResponse200) & {
  headers: Headers;
};
;

export type startAiAssistantThreadResponse = (startAiAssistantThreadResponseSuccess)

export const getStartAiAssistantThreadUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}/start`
}

export const startAiAssistantThread = async (organizationId: string,
    aiAssistantThreadId: string,
    startAiAssistantThreadRequestDto: StartAiAssistantThreadRequestDto, options?: RequestInit): Promise<startAiAssistantThreadResponse> => {

  return axiosInstance<startAiAssistantThreadResponse>(getStartAiAssistantThreadUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startAiAssistantThreadRequestDto,)
  }
);}




export const getStartAiAssistantThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<StartAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof startAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<StartAiAssistantThreadRequestDto>}, TContext> => {

const mutationKey = ['startAiAssistantThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startAiAssistantThread>>, {organizationId: string;aiAssistantThreadId: string;data: BodyType<StartAiAssistantThreadRequestDto>}> = (props) => {
          const {organizationId,aiAssistantThreadId,data} = props ?? {};

          return  startAiAssistantThread(organizationId,aiAssistantThreadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartAiAssistantThreadMutationResult = NonNullable<Awaited<ReturnType<typeof startAiAssistantThread>>>
    export type StartAiAssistantThreadMutationBody = BodyType<StartAiAssistantThreadRequestDto>
    export type StartAiAssistantThreadMutationError = ErrorType<unknown>

    export const useStartAiAssistantThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<StartAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startAiAssistantThread>>,
        TError,
        {organizationId: string;aiAssistantThreadId: string;data: BodyType<StartAiAssistantThreadRequestDto>},
        TContext
      > => {
      return useMutation(getStartAiAssistantThreadMutationOptions(options), queryClient);
    }

export type stopAiAssistantThreadResponse200 = {
  data: StopAiAssistantThread200
  status: 200
}

export type stopAiAssistantThreadResponseSuccess = (stopAiAssistantThreadResponse200) & {
  headers: Headers;
};
;

export type stopAiAssistantThreadResponse = (stopAiAssistantThreadResponseSuccess)

export const getStopAiAssistantThreadUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}/stop`
}

export const stopAiAssistantThread = async (organizationId: string,
    aiAssistantThreadId: string, options?: RequestInit): Promise<stopAiAssistantThreadResponse> => {

  return axiosInstance<stopAiAssistantThreadResponse>(getStopAiAssistantThreadUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStopAiAssistantThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof stopAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext> => {

const mutationKey = ['stopAiAssistantThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stopAiAssistantThread>>, {organizationId: string;aiAssistantThreadId: string}> = (props) => {
          const {organizationId,aiAssistantThreadId} = props ?? {};

          return  stopAiAssistantThread(organizationId,aiAssistantThreadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StopAiAssistantThreadMutationResult = NonNullable<Awaited<ReturnType<typeof stopAiAssistantThread>>>

    export type StopAiAssistantThreadMutationError = ErrorType<unknown>

    export const useStopAiAssistantThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stopAiAssistantThread>>,
        TError,
        {organizationId: string;aiAssistantThreadId: string},
        TContext
      > => {
      return useMutation(getStopAiAssistantThreadMutationOptions(options), queryClient);
    }

export type resumeAiAssistantThreadResponse200 = {
  data: AiRuntimeEventDto
  status: 200
}

export type resumeAiAssistantThreadResponseSuccess = (resumeAiAssistantThreadResponse200) & {
  headers: Headers;
};
;

export type resumeAiAssistantThreadResponse = (resumeAiAssistantThreadResponseSuccess)

export const getResumeAiAssistantThreadUrl = (organizationId: string,
    aiAssistantThreadId: string,) => {




  return `/organizations/${organizationId}/ai/assistant/threads/${aiAssistantThreadId}/resume`
}

export const resumeAiAssistantThread = async (organizationId: string,
    aiAssistantThreadId: string,
    resumeAiAssistantThreadRequestDto: ResumeAiAssistantThreadRequestDto, options?: RequestInit): Promise<resumeAiAssistantThreadResponse> => {

  return axiosInstance<resumeAiAssistantThreadResponse>(getResumeAiAssistantThreadUrl(organizationId,aiAssistantThreadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resumeAiAssistantThreadRequestDto,)
  }
);}




export const getResumeAiAssistantThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<ResumeAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<ResumeAiAssistantThreadRequestDto>}, TContext> => {

const mutationKey = ['resumeAiAssistantThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeAiAssistantThread>>, {organizationId: string;aiAssistantThreadId: string;data: BodyType<ResumeAiAssistantThreadRequestDto>}> = (props) => {
          const {organizationId,aiAssistantThreadId,data} = props ?? {};

          return  resumeAiAssistantThread(organizationId,aiAssistantThreadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeAiAssistantThreadMutationResult = NonNullable<Awaited<ReturnType<typeof resumeAiAssistantThread>>>
    export type ResumeAiAssistantThreadMutationBody = BodyType<ResumeAiAssistantThreadRequestDto>
    export type ResumeAiAssistantThreadMutationError = ErrorType<unknown>

    export const useResumeAiAssistantThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeAiAssistantThread>>, TError,{organizationId: string;aiAssistantThreadId: string;data: BodyType<ResumeAiAssistantThreadRequestDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resumeAiAssistantThread>>,
        TError,
        {organizationId: string;aiAssistantThreadId: string;data: BodyType<ResumeAiAssistantThreadRequestDto>},
        TContext
      > => {
      return useMutation(getResumeAiAssistantThreadMutationOptions(options), queryClient);
    }

export type listAiComposeTemplatesResponse200 = {
  data: ListAiComposeTemplatesResponseDto
  status: 200
}

export type listAiComposeTemplatesResponseSuccess = (listAiComposeTemplatesResponse200) & {
  headers: Headers;
};
;

export type listAiComposeTemplatesResponse = (listAiComposeTemplatesResponseSuccess)

export const getListAiComposeTemplatesUrl = (organizationId: string,
    params?: ListAiComposeTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/ai/compose-templates?${stringifiedParams}` : `/organizations/${organizationId}/ai/compose-templates`
}

export const listAiComposeTemplates = async (organizationId: string,
    params?: ListAiComposeTemplatesParams, options?: RequestInit): Promise<listAiComposeTemplatesResponse> => {

  return axiosInstance<listAiComposeTemplatesResponse>(getListAiComposeTemplatesUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiComposeTemplatesQueryKey = (organizationId: string,
    params?: ListAiComposeTemplatesParams,) => {
    return [
    `/organizations/${organizationId}/ai/compose-templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAiComposeTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listAiComposeTemplates>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListAiComposeTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiComposeTemplatesQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiComposeTemplates>>> = ({ signal }) => listAiComposeTemplates(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiComposeTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiComposeTemplates>>>
export type ListAiComposeTemplatesQueryError = ErrorType<unknown>


export function useListAiComposeTemplates<TData = Awaited<ReturnType<typeof listAiComposeTemplates>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListAiComposeTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiComposeTemplates>>,
          TError,
          Awaited<ReturnType<typeof listAiComposeTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiComposeTemplates<TData = Awaited<ReturnType<typeof listAiComposeTemplates>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiComposeTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiComposeTemplates>>,
          TError,
          Awaited<ReturnType<typeof listAiComposeTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiComposeTemplates<TData = Awaited<ReturnType<typeof listAiComposeTemplates>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiComposeTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiComposeTemplates<TData = Awaited<ReturnType<typeof listAiComposeTemplates>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListAiComposeTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplates>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiComposeTemplatesQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createAiComposeTemplateResponse200 = {
  data: AiComposeTemplateResponseDto
  status: 200
}

export type createAiComposeTemplateResponseSuccess = (createAiComposeTemplateResponse200) & {
  headers: Headers;
};
;

export type createAiComposeTemplateResponse = (createAiComposeTemplateResponseSuccess)

export const getCreateAiComposeTemplateUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/compose-templates`
}

export const createAiComposeTemplate = async (organizationId: string,
    createAiComposeTemplateBodyDto: CreateAiComposeTemplateBodyDto, options?: RequestInit): Promise<createAiComposeTemplateResponse> => {

  return axiosInstance<createAiComposeTemplateResponse>(getCreateAiComposeTemplateUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAiComposeTemplateBodyDto,)
  }
);}




export const getCreateAiComposeTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiComposeTemplate>>, TError,{organizationId: string;data: BodyType<CreateAiComposeTemplateBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createAiComposeTemplate>>, TError,{organizationId: string;data: BodyType<CreateAiComposeTemplateBodyDto>}, TContext> => {

const mutationKey = ['createAiComposeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiComposeTemplate>>, {organizationId: string;data: BodyType<CreateAiComposeTemplateBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createAiComposeTemplate(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiComposeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createAiComposeTemplate>>>
    export type CreateAiComposeTemplateMutationBody = BodyType<CreateAiComposeTemplateBodyDto>
    export type CreateAiComposeTemplateMutationError = ErrorType<unknown>

    export const useCreateAiComposeTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiComposeTemplate>>, TError,{organizationId: string;data: BodyType<CreateAiComposeTemplateBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAiComposeTemplate>>,
        TError,
        {organizationId: string;data: BodyType<CreateAiComposeTemplateBodyDto>},
        TContext
      > => {
      return useMutation(getCreateAiComposeTemplateMutationOptions(options), queryClient);
    }

export type listAiComposeTemplateMessagesResponse200 = {
  data: ListAiComposeTemplateMessagesResponseDto
  status: 200
}

export type listAiComposeTemplateMessagesResponseSuccess = (listAiComposeTemplateMessagesResponse200) & {
  headers: Headers;
};
;

export type listAiComposeTemplateMessagesResponse = (listAiComposeTemplateMessagesResponseSuccess)

export const getListAiComposeTemplateMessagesUrl = (organizationId: string,
    aiComposeTemplateId: string,) => {




  return `/organizations/${organizationId}/ai/compose-templates/${aiComposeTemplateId}/messages`
}

export const listAiComposeTemplateMessages = async (organizationId: string,
    aiComposeTemplateId: string, options?: RequestInit): Promise<listAiComposeTemplateMessagesResponse> => {

  return axiosInstance<listAiComposeTemplateMessagesResponse>(getListAiComposeTemplateMessagesUrl(organizationId,aiComposeTemplateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiComposeTemplateMessagesQueryKey = (organizationId: string,
    aiComposeTemplateId: string,) => {
    return [
    `/organizations/${organizationId}/ai/compose-templates/${aiComposeTemplateId}/messages`
    ] as const;
    }


export const getListAiComposeTemplateMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError = ErrorType<unknown>>(organizationId: string,
    aiComposeTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiComposeTemplateMessagesQueryKey(organizationId,aiComposeTemplateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>> = ({ signal }) => listAiComposeTemplateMessages(organizationId,aiComposeTemplateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && aiComposeTemplateId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAiComposeTemplateMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>>
export type ListAiComposeTemplateMessagesQueryError = ErrorType<unknown>


export function useListAiComposeTemplateMessages<TData = Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiComposeTemplateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiComposeTemplateMessages>>,
          TError,
          Awaited<ReturnType<typeof listAiComposeTemplateMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiComposeTemplateMessages<TData = Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiComposeTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAiComposeTemplateMessages>>,
          TError,
          Awaited<ReturnType<typeof listAiComposeTemplateMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAiComposeTemplateMessages<TData = Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiComposeTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAiComposeTemplateMessages<TData = Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    aiComposeTemplateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiComposeTemplateMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiComposeTemplateMessagesQueryOptions(organizationId,aiComposeTemplateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateAiComposeTemplateResponse200 = {
  data: AiComposeTemplateResponseDto
  status: 200
}

export type updateAiComposeTemplateResponseSuccess = (updateAiComposeTemplateResponse200) & {
  headers: Headers;
};
;

export type updateAiComposeTemplateResponse = (updateAiComposeTemplateResponseSuccess)

export const getUpdateAiComposeTemplateUrl = (organizationId: string,
    aiComposeTemplateId: string,) => {




  return `/organizations/${organizationId}/ai/compose-templates/${aiComposeTemplateId}`
}

export const updateAiComposeTemplate = async (organizationId: string,
    aiComposeTemplateId: string,
    updateAiComposeTemplateBodyDto: UpdateAiComposeTemplateBodyDto, options?: RequestInit): Promise<updateAiComposeTemplateResponse> => {

  return axiosInstance<updateAiComposeTemplateResponse>(getUpdateAiComposeTemplateUrl(organizationId,aiComposeTemplateId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAiComposeTemplateBodyDto,)
  }
);}




export const getUpdateAiComposeTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string;data: BodyType<UpdateAiComposeTemplateBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string;data: BodyType<UpdateAiComposeTemplateBodyDto>}, TContext> => {

const mutationKey = ['updateAiComposeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiComposeTemplate>>, {organizationId: string;aiComposeTemplateId: string;data: BodyType<UpdateAiComposeTemplateBodyDto>}> = (props) => {
          const {organizationId,aiComposeTemplateId,data} = props ?? {};

          return  updateAiComposeTemplate(organizationId,aiComposeTemplateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiComposeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiComposeTemplate>>>
    export type UpdateAiComposeTemplateMutationBody = BodyType<UpdateAiComposeTemplateBodyDto>
    export type UpdateAiComposeTemplateMutationError = ErrorType<unknown>

    export const useUpdateAiComposeTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string;data: BodyType<UpdateAiComposeTemplateBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAiComposeTemplate>>,
        TError,
        {organizationId: string;aiComposeTemplateId: string;data: BodyType<UpdateAiComposeTemplateBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateAiComposeTemplateMutationOptions(options), queryClient);
    }

export type deleteAiComposeTemplateResponse204 = {
  data: void
  status: 204
}

export type deleteAiComposeTemplateResponseSuccess = (deleteAiComposeTemplateResponse204) & {
  headers: Headers;
};
;

export type deleteAiComposeTemplateResponse = (deleteAiComposeTemplateResponseSuccess)

export const getDeleteAiComposeTemplateUrl = (organizationId: string,
    aiComposeTemplateId: string,) => {




  return `/organizations/${organizationId}/ai/compose-templates/${aiComposeTemplateId}`
}

export const deleteAiComposeTemplate = async (organizationId: string,
    aiComposeTemplateId: string, options?: RequestInit): Promise<deleteAiComposeTemplateResponse> => {

  return axiosInstance<deleteAiComposeTemplateResponse>(getDeleteAiComposeTemplateUrl(organizationId,aiComposeTemplateId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAiComposeTemplateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string}, TContext> => {

const mutationKey = ['deleteAiComposeTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiComposeTemplate>>, {organizationId: string;aiComposeTemplateId: string}> = (props) => {
          const {organizationId,aiComposeTemplateId} = props ?? {};

          return  deleteAiComposeTemplate(organizationId,aiComposeTemplateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiComposeTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiComposeTemplate>>>

    export type DeleteAiComposeTemplateMutationError = ErrorType<unknown>

    export const useDeleteAiComposeTemplate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiComposeTemplate>>, TError,{organizationId: string;aiComposeTemplateId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAiComposeTemplate>>,
        TError,
        {organizationId: string;aiComposeTemplateId: string},
        TContext
      > => {
      return useMutation(getDeleteAiComposeTemplateMutationOptions(options), queryClient);
    }

export type listOrganizationAiMemoriesResponse200 = {
  data: ListAiMemoriesResponseDto
  status: 200
}

export type listOrganizationAiMemoriesResponseSuccess = (listOrganizationAiMemoriesResponse200) & {
  headers: Headers;
};
;

export type listOrganizationAiMemoriesResponse = (listOrganizationAiMemoriesResponseSuccess)

export const getListOrganizationAiMemoriesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai-memories`
}

export const listOrganizationAiMemories = async (organizationId: string, options?: RequestInit): Promise<listOrganizationAiMemoriesResponse> => {

  return axiosInstance<listOrganizationAiMemoriesResponse>(getListOrganizationAiMemoriesUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationAiMemoriesQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/ai-memories`
    ] as const;
    }


export const getListOrganizationAiMemoriesQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationAiMemoriesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationAiMemories>>> = ({ signal }) => listOrganizationAiMemories(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationAiMemoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationAiMemories>>>
export type ListOrganizationAiMemoriesQueryError = ErrorType<unknown>


export function useListOrganizationAiMemories<TData = Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationAiMemories>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationAiMemories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationAiMemories<TData = Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationAiMemories>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationAiMemories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationAiMemories<TData = Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationAiMemories<TData = Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationAiMemories>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationAiMemoriesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateOrganizationAiMemoryResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationAiMemoryResponseSuccess = (updateOrganizationAiMemoryResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationAiMemoryResponse = (updateOrganizationAiMemoryResponseSuccess)

export const getUpdateOrganizationAiMemoryUrl = (organizationId: string,
    memoryId: string,) => {




  return `/organizations/${organizationId}/ai-memories/${memoryId}`
}

export const updateOrganizationAiMemory = async (organizationId: string,
    memoryId: string,
    updateAiMemoryBodyDto: UpdateAiMemoryBodyDto, options?: RequestInit): Promise<updateOrganizationAiMemoryResponse> => {

  return axiosInstance<updateOrganizationAiMemoryResponse>(getUpdateOrganizationAiMemoryUrl(organizationId,memoryId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAiMemoryBodyDto,)
  }
);}




export const getUpdateOrganizationAiMemoryMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiMemory>>, TError,{organizationId: string;memoryId: string;data: BodyType<UpdateAiMemoryBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiMemory>>, TError,{organizationId: string;memoryId: string;data: BodyType<UpdateAiMemoryBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationAiMemory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationAiMemory>>, {organizationId: string;memoryId: string;data: BodyType<UpdateAiMemoryBodyDto>}> = (props) => {
          const {organizationId,memoryId,data} = props ?? {};

          return  updateOrganizationAiMemory(organizationId,memoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationAiMemoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationAiMemory>>>
    export type UpdateOrganizationAiMemoryMutationBody = BodyType<UpdateAiMemoryBodyDto>
    export type UpdateOrganizationAiMemoryMutationError = ErrorType<unknown>

    export const useUpdateOrganizationAiMemory = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiMemory>>, TError,{organizationId: string;memoryId: string;data: BodyType<UpdateAiMemoryBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationAiMemory>>,
        TError,
        {organizationId: string;memoryId: string;data: BodyType<UpdateAiMemoryBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationAiMemoryMutationOptions(options), queryClient);
    }

export type getAiSuggestionsResponse200 = {
  data: AiSuggestionsResponseDto
  status: 200
}

export type getAiSuggestionsResponseSuccess = (getAiSuggestionsResponse200) & {
  headers: Headers;
};
;

export type getAiSuggestionsResponse = (getAiSuggestionsResponseSuccess)

export const getGetAiSuggestionsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/suggestions`
}

export const getAiSuggestions = async (organizationId: string,
    aiSuggestionsBodyDto: AiSuggestionsBodyDto, options?: RequestInit): Promise<getAiSuggestionsResponse> => {

  return axiosInstance<getAiSuggestionsResponse>(getGetAiSuggestionsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiSuggestionsBodyDto,)
  }
);}




export const getGetAiSuggestionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAiSuggestions>>, TError,{organizationId: string;data: BodyType<AiSuggestionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getAiSuggestions>>, TError,{organizationId: string;data: BodyType<AiSuggestionsBodyDto>}, TContext> => {

const mutationKey = ['getAiSuggestions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAiSuggestions>>, {organizationId: string;data: BodyType<AiSuggestionsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  getAiSuggestions(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAiSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAiSuggestions>>>
    export type GetAiSuggestionsMutationBody = BodyType<AiSuggestionsBodyDto>
    export type GetAiSuggestionsMutationError = ErrorType<unknown>

    export const useGetAiSuggestions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAiSuggestions>>, TError,{organizationId: string;data: BodyType<AiSuggestionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAiSuggestions>>,
        TError,
        {organizationId: string;data: BodyType<AiSuggestionsBodyDto>},
        TContext
      > => {
      return useMutation(getGetAiSuggestionsMutationOptions(options), queryClient);
    }

export type composeAiMessageResponse200 = {
  data: AiComposeResponseDto
  status: 200
}

export type composeAiMessageResponseSuccess = (composeAiMessageResponse200) & {
  headers: Headers;
};
;

export type composeAiMessageResponse = (composeAiMessageResponseSuccess)

export const getComposeAiMessageUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai/suggestions/compose`
}

export const composeAiMessage = async (organizationId: string,
    aiComposeBodyDto: AiComposeBodyDto, options?: RequestInit): Promise<composeAiMessageResponse> => {

  return axiosInstance<composeAiMessageResponse>(getComposeAiMessageUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiComposeBodyDto,)
  }
);}




export const getComposeAiMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeAiMessage>>, TError,{organizationId: string;data: BodyType<AiComposeBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof composeAiMessage>>, TError,{organizationId: string;data: BodyType<AiComposeBodyDto>}, TContext> => {

const mutationKey = ['composeAiMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof composeAiMessage>>, {organizationId: string;data: BodyType<AiComposeBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  composeAiMessage(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ComposeAiMessageMutationResult = NonNullable<Awaited<ReturnType<typeof composeAiMessage>>>
    export type ComposeAiMessageMutationBody = BodyType<AiComposeBodyDto>
    export type ComposeAiMessageMutationError = ErrorType<unknown>

    export const useComposeAiMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof composeAiMessage>>, TError,{organizationId: string;data: BodyType<AiComposeBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof composeAiMessage>>,
        TError,
        {organizationId: string;data: BodyType<AiComposeBodyDto>},
        TContext
      > => {
      return useMutation(getComposeAiMessageMutationOptions(options), queryClient);
    }

export type autocompleteContactsResponse200 = {
  data: AutocompleteContactsResponseDto
  status: 200
}

export type autocompleteContactsResponseSuccess = (autocompleteContactsResponse200) & {
  headers: Headers;
};
;

export type autocompleteContactsResponse = (autocompleteContactsResponseSuccess)

export const getAutocompleteContactsUrl = (organizationId: string,
    params: AutocompleteContactsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/contacts/autocomplete?${stringifiedParams}` : `/organizations/${organizationId}/contacts/autocomplete`
}

export const autocompleteContacts = async (organizationId: string,
    params: AutocompleteContactsParams, options?: RequestInit): Promise<autocompleteContactsResponse> => {

  return axiosInstance<autocompleteContactsResponse>(getAutocompleteContactsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutocompleteContactsQueryKey = (organizationId: string,
    params?: AutocompleteContactsParams,) => {
    return [
    `/organizations/${organizationId}/contacts/autocomplete`, ...(params ? [params] : [])
    ] as const;
    }


export const getAutocompleteContactsQueryOptions = <TData = Awaited<ReturnType<typeof autocompleteContacts>>, TError = ErrorType<unknown>>(organizationId: string,
    params: AutocompleteContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteContactsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocompleteContacts>>> = ({ signal }) => autocompleteContacts(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutocompleteContactsQueryResult = NonNullable<Awaited<ReturnType<typeof autocompleteContacts>>>
export type AutocompleteContactsQueryError = ErrorType<unknown>


export function useAutocompleteContacts<TData = Awaited<ReturnType<typeof autocompleteContacts>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: AutocompleteContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteContacts>>,
          TError,
          Awaited<ReturnType<typeof autocompleteContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteContacts<TData = Awaited<ReturnType<typeof autocompleteContacts>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: AutocompleteContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteContacts>>,
          TError,
          Awaited<ReturnType<typeof autocompleteContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteContacts<TData = Awaited<ReturnType<typeof autocompleteContacts>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: AutocompleteContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAutocompleteContacts<TData = Awaited<ReturnType<typeof autocompleteContacts>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: AutocompleteContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteContacts>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutocompleteContactsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createContactResponse201 = {
  data: void
  status: 201
}

export type createContactResponseSuccess = (createContactResponse201) & {
  headers: Headers;
};
;

export type createContactResponse = (createContactResponseSuccess)

export const getCreateContactUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/contacts`
}

export const createContact = async (organizationId: string,
    createContactBodyDto: CreateContactBodyDto, options?: RequestInit): Promise<createContactResponse> => {

  return axiosInstance<createContactResponse>(getCreateContactUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContactBodyDto,)
  }
);}




export const getCreateContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{organizationId: string;data: BodyType<CreateContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{organizationId: string;data: BodyType<CreateContactBodyDto>}, TContext> => {

const mutationKey = ['createContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContact>>, {organizationId: string;data: BodyType<CreateContactBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createContact(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactMutationResult = NonNullable<Awaited<ReturnType<typeof createContact>>>
    export type CreateContactMutationBody = BodyType<CreateContactBodyDto>
    export type CreateContactMutationError = ErrorType<unknown>

    export const useCreateContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContact>>, TError,{organizationId: string;data: BodyType<CreateContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContact>>,
        TError,
        {organizationId: string;data: BodyType<CreateContactBodyDto>},
        TContext
      > => {
      return useMutation(getCreateContactMutationOptions(options), queryClient);
    }

export type bulkArchiveContactsResponse200 = {
  data: BulkArchiveResponseDto
  status: 200
}

export type bulkArchiveContactsResponseSuccess = (bulkArchiveContactsResponse200) & {
  headers: Headers;
};
;

export type bulkArchiveContactsResponse = (bulkArchiveContactsResponseSuccess)

export const getBulkArchiveContactsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/contacts/bulk-archive`
}

export const bulkArchiveContacts = async (organizationId: string,
    bulkArchiveContactsBodyDto: BulkArchiveContactsBodyDto, options?: RequestInit): Promise<bulkArchiveContactsResponse> => {

  return axiosInstance<bulkArchiveContactsResponse>(getBulkArchiveContactsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkArchiveContactsBodyDto,)
  }
);}




export const getBulkArchiveContactsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveContacts>>, TError,{organizationId: string;data: BodyType<BulkArchiveContactsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveContacts>>, TError,{organizationId: string;data: BodyType<BulkArchiveContactsBodyDto>}, TContext> => {

const mutationKey = ['bulkArchiveContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchiveContacts>>, {organizationId: string;data: BodyType<BulkArchiveContactsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkArchiveContacts(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveContactsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchiveContacts>>>
    export type BulkArchiveContactsMutationBody = BodyType<BulkArchiveContactsBodyDto>
    export type BulkArchiveContactsMutationError = ErrorType<unknown>

    export const useBulkArchiveContacts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveContacts>>, TError,{organizationId: string;data: BodyType<BulkArchiveContactsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchiveContacts>>,
        TError,
        {organizationId: string;data: BodyType<BulkArchiveContactsBodyDto>},
        TContext
      > => {
      return useMutation(getBulkArchiveContactsMutationOptions(options), queryClient);
    }

export type updateContactResponse200 = {
  data: void
  status: 200
}

export type updateContactResponseSuccess = (updateContactResponse200) & {
  headers: Headers;
};
;

export type updateContactResponse = (updateContactResponseSuccess)

export const getUpdateContactUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}`
}

export const updateContact = async (organizationId: string,
    contactId: string,
    updateContactBodyDto: UpdateContactBodyDto, options?: RequestInit): Promise<updateContactResponse> => {

  return axiosInstance<updateContactResponse>(getUpdateContactUrl(organizationId,contactId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContactBodyDto,)
  }
);}




export const getUpdateContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContact>>, TError,{organizationId: string;contactId: string;data: BodyType<UpdateContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContact>>, TError,{organizationId: string;contactId: string;data: BodyType<UpdateContactBodyDto>}, TContext> => {

const mutationKey = ['updateContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContact>>, {organizationId: string;contactId: string;data: BodyType<UpdateContactBodyDto>}> = (props) => {
          const {organizationId,contactId,data} = props ?? {};

          return  updateContact(organizationId,contactId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateContact>>>
    export type UpdateContactMutationBody = BodyType<UpdateContactBodyDto>
    export type UpdateContactMutationError = ErrorType<unknown>

    export const useUpdateContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContact>>, TError,{organizationId: string;contactId: string;data: BodyType<UpdateContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContact>>,
        TError,
        {organizationId: string;contactId: string;data: BodyType<UpdateContactBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateContactMutationOptions(options), queryClient);
    }

export type archiveContactResponse204 = {
  data: void
  status: 204
}

export type archiveContactResponseSuccess = (archiveContactResponse204) & {
  headers: Headers;
};
;

export type archiveContactResponse = (archiveContactResponseSuccess)

export const getArchiveContactUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/archive`
}

export const archiveContact = async (organizationId: string,
    contactId: string, options?: RequestInit): Promise<archiveContactResponse> => {

  return axiosInstance<archiveContactResponse>(getArchiveContactUrl(organizationId,contactId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveContact>>, TError,{organizationId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveContact>>, TError,{organizationId: string;contactId: string}, TContext> => {

const mutationKey = ['archiveContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveContact>>, {organizationId: string;contactId: string}> = (props) => {
          const {organizationId,contactId} = props ?? {};

          return  archiveContact(organizationId,contactId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveContactMutationResult = NonNullable<Awaited<ReturnType<typeof archiveContact>>>

    export type ArchiveContactMutationError = ErrorType<unknown>

    export const useArchiveContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveContact>>, TError,{organizationId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveContact>>,
        TError,
        {organizationId: string;contactId: string},
        TContext
      > => {
      return useMutation(getArchiveContactMutationOptions(options), queryClient);
    }

export type restoreContactResponse204 = {
  data: void
  status: 204
}

export type restoreContactResponseSuccess = (restoreContactResponse204) & {
  headers: Headers;
};
;

export type restoreContactResponse = (restoreContactResponseSuccess)

export const getRestoreContactUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/restore`
}

export const restoreContact = async (organizationId: string,
    contactId: string, options?: RequestInit): Promise<restoreContactResponse> => {

  return axiosInstance<restoreContactResponse>(getRestoreContactUrl(organizationId,contactId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreContact>>, TError,{organizationId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreContact>>, TError,{organizationId: string;contactId: string}, TContext> => {

const mutationKey = ['restoreContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreContact>>, {organizationId: string;contactId: string}> = (props) => {
          const {organizationId,contactId} = props ?? {};

          return  restoreContact(organizationId,contactId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreContactMutationResult = NonNullable<Awaited<ReturnType<typeof restoreContact>>>

    export type RestoreContactMutationError = ErrorType<unknown>

    export const useRestoreContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreContact>>, TError,{organizationId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreContact>>,
        TError,
        {organizationId: string;contactId: string},
        TContext
      > => {
      return useMutation(getRestoreContactMutationOptions(options), queryClient);
    }

export type createContactEmailResponse201 = {
  data: void
  status: 201
}

export type createContactEmailResponseSuccess = (createContactEmailResponse201) & {
  headers: Headers;
};
;

export type createContactEmailResponse = (createContactEmailResponseSuccess)

export const getCreateContactEmailUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/emails`
}

export const createContactEmail = async (organizationId: string,
    contactId: string,
    createContactEmailBodyDto: CreateContactEmailBodyDto, options?: RequestInit): Promise<createContactEmailResponse> => {

  return axiosInstance<createContactEmailResponse>(getCreateContactEmailUrl(organizationId,contactId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContactEmailBodyDto,)
  }
);}




export const getCreateContactEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactEmail>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContactEmail>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactEmailBodyDto>}, TContext> => {

const mutationKey = ['createContactEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactEmail>>, {organizationId: string;contactId: string;data: BodyType<CreateContactEmailBodyDto>}> = (props) => {
          const {organizationId,contactId,data} = props ?? {};

          return  createContactEmail(organizationId,contactId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactEmailMutationResult = NonNullable<Awaited<ReturnType<typeof createContactEmail>>>
    export type CreateContactEmailMutationBody = BodyType<CreateContactEmailBodyDto>
    export type CreateContactEmailMutationError = ErrorType<unknown>

    export const useCreateContactEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactEmail>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContactEmail>>,
        TError,
        {organizationId: string;contactId: string;data: BodyType<CreateContactEmailBodyDto>},
        TContext
      > => {
      return useMutation(getCreateContactEmailMutationOptions(options), queryClient);
    }

export type updateContactEmailResponse200 = {
  data: void
  status: 200
}

export type updateContactEmailResponseSuccess = (updateContactEmailResponse200) & {
  headers: Headers;
};
;

export type updateContactEmailResponse = (updateContactEmailResponseSuccess)

export const getUpdateContactEmailUrl = (organizationId: string,
    contactId: string,
    contactEmailId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/emails/${contactEmailId}`
}

export const updateContactEmail = async (organizationId: string,
    contactId: string,
    contactEmailId: string,
    updateContactEmailBodyDto: UpdateContactEmailBodyDto, options?: RequestInit): Promise<updateContactEmailResponse> => {

  return axiosInstance<updateContactEmailResponse>(getUpdateContactEmailUrl(organizationId,contactId,contactEmailId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContactEmailBodyDto,)
  }
);}




export const getUpdateContactEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string;data: BodyType<UpdateContactEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string;data: BodyType<UpdateContactEmailBodyDto>}, TContext> => {

const mutationKey = ['updateContactEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactEmail>>, {organizationId: string;contactId: string;contactEmailId: string;data: BodyType<UpdateContactEmailBodyDto>}> = (props) => {
          const {organizationId,contactId,contactEmailId,data} = props ?? {};

          return  updateContactEmail(organizationId,contactId,contactEmailId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactEmail>>>
    export type UpdateContactEmailMutationBody = BodyType<UpdateContactEmailBodyDto>
    export type UpdateContactEmailMutationError = ErrorType<unknown>

    export const useUpdateContactEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string;data: BodyType<UpdateContactEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContactEmail>>,
        TError,
        {organizationId: string;contactId: string;contactEmailId: string;data: BodyType<UpdateContactEmailBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateContactEmailMutationOptions(options), queryClient);
    }

export type deleteContactEmailResponse200 = {
  data: void
  status: 200
}

export type deleteContactEmailResponseSuccess = (deleteContactEmailResponse200) & {
  headers: Headers;
};
;

export type deleteContactEmailResponse = (deleteContactEmailResponseSuccess)

export const getDeleteContactEmailUrl = (organizationId: string,
    contactId: string,
    contactEmailId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/emails/${contactEmailId}`
}

export const deleteContactEmail = async (organizationId: string,
    contactId: string,
    contactEmailId: string, options?: RequestInit): Promise<deleteContactEmailResponse> => {

  return axiosInstance<deleteContactEmailResponse>(getDeleteContactEmailUrl(organizationId,contactId,contactEmailId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteContactEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string}, TContext> => {

const mutationKey = ['deleteContactEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactEmail>>, {organizationId: string;contactId: string;contactEmailId: string}> = (props) => {
          const {organizationId,contactId,contactEmailId} = props ?? {};

          return  deleteContactEmail(organizationId,contactId,contactEmailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactEmailMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactEmail>>>

    export type DeleteContactEmailMutationError = ErrorType<unknown>

    export const useDeleteContactEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactEmail>>, TError,{organizationId: string;contactId: string;contactEmailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactEmail>>,
        TError,
        {organizationId: string;contactId: string;contactEmailId: string},
        TContext
      > => {
      return useMutation(getDeleteContactEmailMutationOptions(options), queryClient);
    }

export type createContactPhoneNumberResponse201 = {
  data: void
  status: 201
}

export type createContactPhoneNumberResponseSuccess = (createContactPhoneNumberResponse201) & {
  headers: Headers;
};
;

export type createContactPhoneNumberResponse = (createContactPhoneNumberResponseSuccess)

export const getCreateContactPhoneNumberUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/phone-numbers`
}

export const createContactPhoneNumber = async (organizationId: string,
    contactId: string,
    createContactPhoneNumberBodyDto: CreateContactPhoneNumberBodyDto, options?: RequestInit): Promise<createContactPhoneNumberResponse> => {

  return axiosInstance<createContactPhoneNumberResponse>(getCreateContactPhoneNumberUrl(organizationId,contactId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContactPhoneNumberBodyDto,)
  }
);}




export const getCreateContactPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactPhoneNumber>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContactPhoneNumber>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactPhoneNumberBodyDto>}, TContext> => {

const mutationKey = ['createContactPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactPhoneNumber>>, {organizationId: string;contactId: string;data: BodyType<CreateContactPhoneNumberBodyDto>}> = (props) => {
          const {organizationId,contactId,data} = props ?? {};

          return  createContactPhoneNumber(organizationId,contactId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof createContactPhoneNumber>>>
    export type CreateContactPhoneNumberMutationBody = BodyType<CreateContactPhoneNumberBodyDto>
    export type CreateContactPhoneNumberMutationError = ErrorType<unknown>

    export const useCreateContactPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactPhoneNumber>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContactPhoneNumber>>,
        TError,
        {organizationId: string;contactId: string;data: BodyType<CreateContactPhoneNumberBodyDto>},
        TContext
      > => {
      return useMutation(getCreateContactPhoneNumberMutationOptions(options), queryClient);
    }

export type updateContactPhoneNumberResponse200 = {
  data: void
  status: 200
}

export type updateContactPhoneNumberResponseSuccess = (updateContactPhoneNumberResponse200) & {
  headers: Headers;
};
;

export type updateContactPhoneNumberResponse = (updateContactPhoneNumberResponseSuccess)

export const getUpdateContactPhoneNumberUrl = (organizationId: string,
    contactId: string,
    contactPhoneNumberId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/phone-numbers/${contactPhoneNumberId}`
}

export const updateContactPhoneNumber = async (organizationId: string,
    contactId: string,
    contactPhoneNumberId: string,
    updateContactPhoneNumberBodyDto: UpdateContactPhoneNumberBodyDto, options?: RequestInit): Promise<updateContactPhoneNumberResponse> => {

  return axiosInstance<updateContactPhoneNumberResponse>(getUpdateContactPhoneNumberUrl(organizationId,contactId,contactPhoneNumberId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContactPhoneNumberBodyDto,)
  }
);}




export const getUpdateContactPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string;data: BodyType<UpdateContactPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string;data: BodyType<UpdateContactPhoneNumberBodyDto>}, TContext> => {

const mutationKey = ['updateContactPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactPhoneNumber>>, {organizationId: string;contactId: string;contactPhoneNumberId: string;data: BodyType<UpdateContactPhoneNumberBodyDto>}> = (props) => {
          const {organizationId,contactId,contactPhoneNumberId,data} = props ?? {};

          return  updateContactPhoneNumber(organizationId,contactId,contactPhoneNumberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactPhoneNumber>>>
    export type UpdateContactPhoneNumberMutationBody = BodyType<UpdateContactPhoneNumberBodyDto>
    export type UpdateContactPhoneNumberMutationError = ErrorType<unknown>

    export const useUpdateContactPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string;data: BodyType<UpdateContactPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContactPhoneNumber>>,
        TError,
        {organizationId: string;contactId: string;contactPhoneNumberId: string;data: BodyType<UpdateContactPhoneNumberBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateContactPhoneNumberMutationOptions(options), queryClient);
    }

export type deleteContactPhoneNumberResponse200 = {
  data: void
  status: 200
}

export type deleteContactPhoneNumberResponseSuccess = (deleteContactPhoneNumberResponse200) & {
  headers: Headers;
};
;

export type deleteContactPhoneNumberResponse = (deleteContactPhoneNumberResponseSuccess)

export const getDeleteContactPhoneNumberUrl = (organizationId: string,
    contactId: string,
    contactPhoneNumberId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/phone-numbers/${contactPhoneNumberId}`
}

export const deleteContactPhoneNumber = async (organizationId: string,
    contactId: string,
    contactPhoneNumberId: string, options?: RequestInit): Promise<deleteContactPhoneNumberResponse> => {

  return axiosInstance<deleteContactPhoneNumberResponse>(getDeleteContactPhoneNumberUrl(organizationId,contactId,contactPhoneNumberId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteContactPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string}, TContext> => {

const mutationKey = ['deleteContactPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactPhoneNumber>>, {organizationId: string;contactId: string;contactPhoneNumberId: string}> = (props) => {
          const {organizationId,contactId,contactPhoneNumberId} = props ?? {};

          return  deleteContactPhoneNumber(organizationId,contactId,contactPhoneNumberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactPhoneNumber>>>

    export type DeleteContactPhoneNumberMutationError = ErrorType<unknown>

    export const useDeleteContactPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactPhoneNumber>>, TError,{organizationId: string;contactId: string;contactPhoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactPhoneNumber>>,
        TError,
        {organizationId: string;contactId: string;contactPhoneNumberId: string},
        TContext
      > => {
      return useMutation(getDeleteContactPhoneNumberMutationOptions(options), queryClient);
    }

export type createContactCustomFieldResponse201 = {
  data: void
  status: 201
}

export type createContactCustomFieldResponseSuccess = (createContactCustomFieldResponse201) & {
  headers: Headers;
};
;

export type createContactCustomFieldResponse = (createContactCustomFieldResponseSuccess)

export const getCreateContactCustomFieldUrl = (organizationId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/custom-field`
}

export const createContactCustomField = async (organizationId: string,
    contactId: string,
    createContactCustomFieldBodyDto: CreateContactCustomFieldBodyDto, options?: RequestInit): Promise<createContactCustomFieldResponse> => {

  return axiosInstance<createContactCustomFieldResponse>(getCreateContactCustomFieldUrl(organizationId,contactId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContactCustomFieldBodyDto,)
  }
);}




export const getCreateContactCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactCustomField>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContactCustomField>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactCustomFieldBodyDto>}, TContext> => {

const mutationKey = ['createContactCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactCustomField>>, {organizationId: string;contactId: string;data: BodyType<CreateContactCustomFieldBodyDto>}> = (props) => {
          const {organizationId,contactId,data} = props ?? {};

          return  createContactCustomField(organizationId,contactId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createContactCustomField>>>
    export type CreateContactCustomFieldMutationBody = BodyType<CreateContactCustomFieldBodyDto>
    export type CreateContactCustomFieldMutationError = ErrorType<unknown>

    export const useCreateContactCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactCustomField>>, TError,{organizationId: string;contactId: string;data: BodyType<CreateContactCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContactCustomField>>,
        TError,
        {organizationId: string;contactId: string;data: BodyType<CreateContactCustomFieldBodyDto>},
        TContext
      > => {
      return useMutation(getCreateContactCustomFieldMutationOptions(options), queryClient);
    }

export type updateContactCustomFieldResponse200 = {
  data: void
  status: 200
}

export type updateContactCustomFieldResponseSuccess = (updateContactCustomFieldResponse200) & {
  headers: Headers;
};
;

export type updateContactCustomFieldResponse = (updateContactCustomFieldResponseSuccess)

export const getUpdateContactCustomFieldUrl = (organizationId: string,
    contactId: string,
    contactCustomFieldId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/custom-field/${contactCustomFieldId}`
}

export const updateContactCustomField = async (organizationId: string,
    contactId: string,
    contactCustomFieldId: string,
    updateContactCustomFieldValueBodyDto: UpdateContactCustomFieldValueBodyDto, options?: RequestInit): Promise<updateContactCustomFieldResponse> => {

  return axiosInstance<updateContactCustomFieldResponse>(getUpdateContactCustomFieldUrl(organizationId,contactId,contactCustomFieldId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContactCustomFieldValueBodyDto,)
  }
);}




export const getUpdateContactCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string;data: BodyType<UpdateContactCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string;data: BodyType<UpdateContactCustomFieldValueBodyDto>}, TContext> => {

const mutationKey = ['updateContactCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactCustomField>>, {organizationId: string;contactId: string;contactCustomFieldId: string;data: BodyType<UpdateContactCustomFieldValueBodyDto>}> = (props) => {
          const {organizationId,contactId,contactCustomFieldId,data} = props ?? {};

          return  updateContactCustomField(organizationId,contactId,contactCustomFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactCustomField>>>
    export type UpdateContactCustomFieldMutationBody = BodyType<UpdateContactCustomFieldValueBodyDto>
    export type UpdateContactCustomFieldMutationError = ErrorType<unknown>

    export const useUpdateContactCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string;data: BodyType<UpdateContactCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContactCustomField>>,
        TError,
        {organizationId: string;contactId: string;contactCustomFieldId: string;data: BodyType<UpdateContactCustomFieldValueBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateContactCustomFieldMutationOptions(options), queryClient);
    }

export type deleteContactCustomFieldResponse200 = {
  data: void
  status: 200
}

export type deleteContactCustomFieldResponseSuccess = (deleteContactCustomFieldResponse200) & {
  headers: Headers;
};
;

export type deleteContactCustomFieldResponse = (deleteContactCustomFieldResponseSuccess)

export const getDeleteContactCustomFieldUrl = (organizationId: string,
    contactId: string,
    contactCustomFieldId: string,) => {




  return `/organizations/${organizationId}/contacts/${contactId}/custom-field/${contactCustomFieldId}`
}

export const deleteContactCustomField = async (organizationId: string,
    contactId: string,
    contactCustomFieldId: string, options?: RequestInit): Promise<deleteContactCustomFieldResponse> => {

  return axiosInstance<deleteContactCustomFieldResponse>(getDeleteContactCustomFieldUrl(organizationId,contactId,contactCustomFieldId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteContactCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string}, TContext> => {

const mutationKey = ['deleteContactCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactCustomField>>, {organizationId: string;contactId: string;contactCustomFieldId: string}> = (props) => {
          const {organizationId,contactId,contactCustomFieldId} = props ?? {};

          return  deleteContactCustomField(organizationId,contactId,contactCustomFieldId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactCustomField>>>

    export type DeleteContactCustomFieldMutationError = ErrorType<unknown>

    export const useDeleteContactCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactCustomField>>, TError,{organizationId: string;contactId: string;contactCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactCustomField>>,
        TError,
        {organizationId: string;contactId: string;contactCustomFieldId: string},
        TContext
      > => {
      return useMutation(getDeleteContactCustomFieldMutationOptions(options), queryClient);
    }

export type listContactFieldLabelsResponse200 = {
  data: ListContactFieldLabelsResponseDto
  status: 200
}

export type listContactFieldLabelsResponseSuccess = (listContactFieldLabelsResponse200) & {
  headers: Headers;
};
;

export type listContactFieldLabelsResponse = (listContactFieldLabelsResponseSuccess)

export const getListContactFieldLabelsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/contact-field-labels`
}

export const listContactFieldLabels = async (organizationId: string, options?: RequestInit): Promise<listContactFieldLabelsResponse> => {

  return axiosInstance<listContactFieldLabelsResponse>(getListContactFieldLabelsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListContactFieldLabelsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/contact-field-labels`
    ] as const;
    }


export const getListContactFieldLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listContactFieldLabels>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContactFieldLabelsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContactFieldLabels>>> = ({ signal }) => listContactFieldLabels(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListContactFieldLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listContactFieldLabels>>>
export type ListContactFieldLabelsQueryError = ErrorType<unknown>


export function useListContactFieldLabels<TData = Awaited<ReturnType<typeof listContactFieldLabels>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactFieldLabels>>,
          TError,
          Awaited<ReturnType<typeof listContactFieldLabels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContactFieldLabels<TData = Awaited<ReturnType<typeof listContactFieldLabels>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactFieldLabels>>,
          TError,
          Awaited<ReturnType<typeof listContactFieldLabels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContactFieldLabels<TData = Awaited<ReturnType<typeof listContactFieldLabels>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListContactFieldLabels<TData = Awaited<ReturnType<typeof listContactFieldLabels>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContactFieldLabels>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListContactFieldLabelsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createContactFieldLabelResponse201 = {
  data: void
  status: 201
}

export type createContactFieldLabelResponseSuccess = (createContactFieldLabelResponse201) & {
  headers: Headers;
};
;

export type createContactFieldLabelResponse = (createContactFieldLabelResponseSuccess)

export const getCreateContactFieldLabelUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/contact-field-labels`
}

export const createContactFieldLabel = async (organizationId: string,
    createContactFieldLabelBodyDto: CreateContactFieldLabelBodyDto, options?: RequestInit): Promise<createContactFieldLabelResponse> => {

  return axiosInstance<createContactFieldLabelResponse>(getCreateContactFieldLabelUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContactFieldLabelBodyDto,)
  }
);}




export const getCreateContactFieldLabelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactFieldLabel>>, TError,{organizationId: string;data: BodyType<CreateContactFieldLabelBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createContactFieldLabel>>, TError,{organizationId: string;data: BodyType<CreateContactFieldLabelBodyDto>}, TContext> => {

const mutationKey = ['createContactFieldLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContactFieldLabel>>, {organizationId: string;data: BodyType<CreateContactFieldLabelBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createContactFieldLabel(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateContactFieldLabelMutationResult = NonNullable<Awaited<ReturnType<typeof createContactFieldLabel>>>
    export type CreateContactFieldLabelMutationBody = BodyType<CreateContactFieldLabelBodyDto>
    export type CreateContactFieldLabelMutationError = ErrorType<unknown>

    export const useCreateContactFieldLabel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContactFieldLabel>>, TError,{organizationId: string;data: BodyType<CreateContactFieldLabelBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContactFieldLabel>>,
        TError,
        {organizationId: string;data: BodyType<CreateContactFieldLabelBodyDto>},
        TContext
      > => {
      return useMutation(getCreateContactFieldLabelMutationOptions(options), queryClient);
    }

export type updateContactFieldLabelResponse200 = {
  data: void
  status: 200
}

export type updateContactFieldLabelResponseSuccess = (updateContactFieldLabelResponse200) & {
  headers: Headers;
};
;

export type updateContactFieldLabelResponse = (updateContactFieldLabelResponseSuccess)

export const getUpdateContactFieldLabelUrl = (organizationId: string,
    contactFieldLabelId: string,) => {




  return `/organizations/${organizationId}/contact-field-labels/${contactFieldLabelId}`
}

export const updateContactFieldLabel = async (organizationId: string,
    contactFieldLabelId: string,
    updateContactFieldLabelBodyDto: UpdateContactFieldLabelBodyDto, options?: RequestInit): Promise<updateContactFieldLabelResponse> => {

  return axiosInstance<updateContactFieldLabelResponse>(getUpdateContactFieldLabelUrl(organizationId,contactFieldLabelId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateContactFieldLabelBodyDto,)
  }
);}




export const getUpdateContactFieldLabelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string;data: BodyType<UpdateContactFieldLabelBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string;data: BodyType<UpdateContactFieldLabelBodyDto>}, TContext> => {

const mutationKey = ['updateContactFieldLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContactFieldLabel>>, {organizationId: string;contactFieldLabelId: string;data: BodyType<UpdateContactFieldLabelBodyDto>}> = (props) => {
          const {organizationId,contactFieldLabelId,data} = props ?? {};

          return  updateContactFieldLabel(organizationId,contactFieldLabelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateContactFieldLabelMutationResult = NonNullable<Awaited<ReturnType<typeof updateContactFieldLabel>>>
    export type UpdateContactFieldLabelMutationBody = BodyType<UpdateContactFieldLabelBodyDto>
    export type UpdateContactFieldLabelMutationError = ErrorType<unknown>

    export const useUpdateContactFieldLabel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string;data: BodyType<UpdateContactFieldLabelBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContactFieldLabel>>,
        TError,
        {organizationId: string;contactFieldLabelId: string;data: BodyType<UpdateContactFieldLabelBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateContactFieldLabelMutationOptions(options), queryClient);
    }

export type deleteContactFieldLabelResponse204 = {
  data: void
  status: 204
}

export type deleteContactFieldLabelResponseSuccess = (deleteContactFieldLabelResponse204) & {
  headers: Headers;
};
;

export type deleteContactFieldLabelResponse = (deleteContactFieldLabelResponseSuccess)

export const getDeleteContactFieldLabelUrl = (organizationId: string,
    contactFieldLabelId: string,) => {




  return `/organizations/${organizationId}/contact-field-labels/${contactFieldLabelId}`
}

export const deleteContactFieldLabel = async (organizationId: string,
    contactFieldLabelId: string, options?: RequestInit): Promise<deleteContactFieldLabelResponse> => {

  return axiosInstance<deleteContactFieldLabelResponse>(getDeleteContactFieldLabelUrl(organizationId,contactFieldLabelId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteContactFieldLabelMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string}, TContext> => {

const mutationKey = ['deleteContactFieldLabel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactFieldLabel>>, {organizationId: string;contactFieldLabelId: string}> = (props) => {
          const {organizationId,contactFieldLabelId} = props ?? {};

          return  deleteContactFieldLabel(organizationId,contactFieldLabelId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactFieldLabelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactFieldLabel>>>

    export type DeleteContactFieldLabelMutationError = ErrorType<unknown>

    export const useDeleteContactFieldLabel = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactFieldLabel>>, TError,{organizationId: string;contactFieldLabelId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactFieldLabel>>,
        TError,
        {organizationId: string;contactFieldLabelId: string},
        TContext
      > => {
      return useMutation(getDeleteContactFieldLabelMutationOptions(options), queryClient);
    }

export type listCustomFieldsResponse200 = {
  data: ListCustomFieldsResponseDto
  status: 200
}

export type listCustomFieldsResponseSuccess = (listCustomFieldsResponse200) & {
  headers: Headers;
};
;

export type listCustomFieldsResponse = (listCustomFieldsResponseSuccess)

export const getListCustomFieldsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/custom-fields`
}

export const listCustomFields = async (organizationId: string, options?: RequestInit): Promise<listCustomFieldsResponse> => {

  return axiosInstance<listCustomFieldsResponse>(getListCustomFieldsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomFieldsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/custom-fields`
    ] as const;
    }


export const getListCustomFieldsQueryOptions = <TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomFieldsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomFields>>> = ({ signal }) => listCustomFields(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCustomFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomFields>>>
export type ListCustomFieldsQueryError = ErrorType<unknown>


export function useListCustomFields<TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomFields>>,
          TError,
          Awaited<ReturnType<typeof listCustomFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomFields<TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomFields>>,
          TError,
          Awaited<ReturnType<typeof listCustomFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCustomFields<TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCustomFields<TData = Awaited<ReturnType<typeof listCustomFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCustomFieldsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createCustomFieldResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type createCustomFieldResponseSuccess = (createCustomFieldResponse200) & {
  headers: Headers;
};
;

export type createCustomFieldResponse = (createCustomFieldResponseSuccess)

export const getCreateCustomFieldUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/custom-fields`
}

export const createCustomField = async (organizationId: string,
    createCustomFieldBodyDto: CreateCustomFieldBodyDto, options?: RequestInit): Promise<createCustomFieldResponse> => {

  return axiosInstance<createCustomFieldResponse>(getCreateCustomFieldUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCustomFieldBodyDto,)
  }
);}




export const getCreateCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{organizationId: string;data: BodyType<CreateCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{organizationId: string;data: BodyType<CreateCustomFieldBodyDto>}, TContext> => {

const mutationKey = ['createCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomField>>, {organizationId: string;data: BodyType<CreateCustomFieldBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createCustomField(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomField>>>
    export type CreateCustomFieldMutationBody = BodyType<CreateCustomFieldBodyDto>
    export type CreateCustomFieldMutationError = ErrorType<unknown>

    export const useCreateCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomField>>, TError,{organizationId: string;data: BodyType<CreateCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomField>>,
        TError,
        {organizationId: string;data: BodyType<CreateCustomFieldBodyDto>},
        TContext
      > => {
      return useMutation(getCreateCustomFieldMutationOptions(options), queryClient);
    }

export type bulkArchiveCustomFieldsResponse204 = {
  data: void
  status: 204
}

export type bulkArchiveCustomFieldsResponseSuccess = (bulkArchiveCustomFieldsResponse204) & {
  headers: Headers;
};
;

export type bulkArchiveCustomFieldsResponse = (bulkArchiveCustomFieldsResponseSuccess)

export const getBulkArchiveCustomFieldsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/custom-fields/bulk-archive`
}

export const bulkArchiveCustomFields = async (organizationId: string,
    bulkArchiveCustomFieldsBodyDto: BulkArchiveCustomFieldsBodyDto, options?: RequestInit): Promise<bulkArchiveCustomFieldsResponse> => {

  return axiosInstance<bulkArchiveCustomFieldsResponse>(getBulkArchiveCustomFieldsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkArchiveCustomFieldsBodyDto,)
  }
);}




export const getBulkArchiveCustomFieldsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveCustomFields>>, TError,{organizationId: string;data: BodyType<BulkArchiveCustomFieldsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveCustomFields>>, TError,{organizationId: string;data: BodyType<BulkArchiveCustomFieldsBodyDto>}, TContext> => {

const mutationKey = ['bulkArchiveCustomFields'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchiveCustomFields>>, {organizationId: string;data: BodyType<BulkArchiveCustomFieldsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkArchiveCustomFields(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveCustomFieldsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchiveCustomFields>>>
    export type BulkArchiveCustomFieldsMutationBody = BodyType<BulkArchiveCustomFieldsBodyDto>
    export type BulkArchiveCustomFieldsMutationError = ErrorType<unknown>

    export const useBulkArchiveCustomFields = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveCustomFields>>, TError,{organizationId: string;data: BodyType<BulkArchiveCustomFieldsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchiveCustomFields>>,
        TError,
        {organizationId: string;data: BodyType<BulkArchiveCustomFieldsBodyDto>},
        TContext
      > => {
      return useMutation(getBulkArchiveCustomFieldsMutationOptions(options), queryClient);
    }

export type updateCustomFieldResponse200 = {
  data: void
  status: 200
}

export type updateCustomFieldResponseSuccess = (updateCustomFieldResponse200) & {
  headers: Headers;
};
;

export type updateCustomFieldResponse = (updateCustomFieldResponseSuccess)

export const getUpdateCustomFieldUrl = (organizationId: string,
    customFieldId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}`
}

export const updateCustomField = async (organizationId: string,
    customFieldId: string,
    updateCustomFieldBodyDto: UpdateCustomFieldBodyDto, options?: RequestInit): Promise<updateCustomFieldResponse> => {

  return axiosInstance<updateCustomFieldResponse>(getUpdateCustomFieldUrl(organizationId,customFieldId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomFieldBodyDto,)
  }
);}




export const getUpdateCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{organizationId: string;customFieldId: string;data: BodyType<UpdateCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{organizationId: string;customFieldId: string;data: BodyType<UpdateCustomFieldBodyDto>}, TContext> => {

const mutationKey = ['updateCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomField>>, {organizationId: string;customFieldId: string;data: BodyType<UpdateCustomFieldBodyDto>}> = (props) => {
          const {organizationId,customFieldId,data} = props ?? {};

          return  updateCustomField(organizationId,customFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomField>>>
    export type UpdateCustomFieldMutationBody = BodyType<UpdateCustomFieldBodyDto>
    export type UpdateCustomFieldMutationError = ErrorType<unknown>

    export const useUpdateCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomField>>, TError,{organizationId: string;customFieldId: string;data: BodyType<UpdateCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomField>>,
        TError,
        {organizationId: string;customFieldId: string;data: BodyType<UpdateCustomFieldBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateCustomFieldMutationOptions(options), queryClient);
    }

export type addCustomFieldOptionResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type addCustomFieldOptionResponseSuccess = (addCustomFieldOptionResponse200) & {
  headers: Headers;
};
;

export type addCustomFieldOptionResponse = (addCustomFieldOptionResponseSuccess)

export const getAddCustomFieldOptionUrl = (organizationId: string,
    customFieldId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/options`
}

export const addCustomFieldOption = async (organizationId: string,
    customFieldId: string,
    addCustomFieldOptionBodyDto: AddCustomFieldOptionBodyDto, options?: RequestInit): Promise<addCustomFieldOptionResponse> => {

  return axiosInstance<addCustomFieldOptionResponse>(getAddCustomFieldOptionUrl(organizationId,customFieldId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addCustomFieldOptionBodyDto,)
  }
);}




export const getAddCustomFieldOptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;data: BodyType<AddCustomFieldOptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;data: BodyType<AddCustomFieldOptionBodyDto>}, TContext> => {

const mutationKey = ['addCustomFieldOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCustomFieldOption>>, {organizationId: string;customFieldId: string;data: BodyType<AddCustomFieldOptionBodyDto>}> = (props) => {
          const {organizationId,customFieldId,data} = props ?? {};

          return  addCustomFieldOption(organizationId,customFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCustomFieldOptionMutationResult = NonNullable<Awaited<ReturnType<typeof addCustomFieldOption>>>
    export type AddCustomFieldOptionMutationBody = BodyType<AddCustomFieldOptionBodyDto>
    export type AddCustomFieldOptionMutationError = ErrorType<unknown>

    export const useAddCustomFieldOption = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;data: BodyType<AddCustomFieldOptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCustomFieldOption>>,
        TError,
        {organizationId: string;customFieldId: string;data: BodyType<AddCustomFieldOptionBodyDto>},
        TContext
      > => {
      return useMutation(getAddCustomFieldOptionMutationOptions(options), queryClient);
    }

export type replaceCustomFieldOptionsResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type replaceCustomFieldOptionsResponseSuccess = (replaceCustomFieldOptionsResponse200) & {
  headers: Headers;
};
;

export type replaceCustomFieldOptionsResponse = (replaceCustomFieldOptionsResponseSuccess)

export const getReplaceCustomFieldOptionsUrl = (organizationId: string,
    customFieldId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/options`
}

export const replaceCustomFieldOptions = async (organizationId: string,
    customFieldId: string,
    replaceCustomFieldOptionsBodyDto: ReplaceCustomFieldOptionsBodyDto, options?: RequestInit): Promise<replaceCustomFieldOptionsResponse> => {

  return axiosInstance<replaceCustomFieldOptionsResponse>(getReplaceCustomFieldOptionsUrl(organizationId,customFieldId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      replaceCustomFieldOptionsBodyDto,)
  }
);}




export const getReplaceCustomFieldOptionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReplaceCustomFieldOptionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReplaceCustomFieldOptionsBodyDto>}, TContext> => {

const mutationKey = ['replaceCustomFieldOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceCustomFieldOptions>>, {organizationId: string;customFieldId: string;data: BodyType<ReplaceCustomFieldOptionsBodyDto>}> = (props) => {
          const {organizationId,customFieldId,data} = props ?? {};

          return  replaceCustomFieldOptions(organizationId,customFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceCustomFieldOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof replaceCustomFieldOptions>>>
    export type ReplaceCustomFieldOptionsMutationBody = BodyType<ReplaceCustomFieldOptionsBodyDto>
    export type ReplaceCustomFieldOptionsMutationError = ErrorType<unknown>

    export const useReplaceCustomFieldOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReplaceCustomFieldOptionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceCustomFieldOptions>>,
        TError,
        {organizationId: string;customFieldId: string;data: BodyType<ReplaceCustomFieldOptionsBodyDto>},
        TContext
      > => {
      return useMutation(getReplaceCustomFieldOptionsMutationOptions(options), queryClient);
    }

export type reorderCustomFieldOptionsResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type reorderCustomFieldOptionsResponseSuccess = (reorderCustomFieldOptionsResponse200) & {
  headers: Headers;
};
;

export type reorderCustomFieldOptionsResponse = (reorderCustomFieldOptionsResponseSuccess)

export const getReorderCustomFieldOptionsUrl = (organizationId: string,
    customFieldId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/options/reorder`
}

export const reorderCustomFieldOptions = async (organizationId: string,
    customFieldId: string,
    reorderCustomFieldOptionsBodyDto: ReorderCustomFieldOptionsBodyDto, options?: RequestInit): Promise<reorderCustomFieldOptionsResponse> => {

  return axiosInstance<reorderCustomFieldOptionsResponse>(getReorderCustomFieldOptionsUrl(organizationId,customFieldId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderCustomFieldOptionsBodyDto,)
  }
);}




export const getReorderCustomFieldOptionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReorderCustomFieldOptionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReorderCustomFieldOptionsBodyDto>}, TContext> => {

const mutationKey = ['reorderCustomFieldOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderCustomFieldOptions>>, {organizationId: string;customFieldId: string;data: BodyType<ReorderCustomFieldOptionsBodyDto>}> = (props) => {
          const {organizationId,customFieldId,data} = props ?? {};

          return  reorderCustomFieldOptions(organizationId,customFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderCustomFieldOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderCustomFieldOptions>>>
    export type ReorderCustomFieldOptionsMutationBody = BodyType<ReorderCustomFieldOptionsBodyDto>
    export type ReorderCustomFieldOptionsMutationError = ErrorType<unknown>

    export const useReorderCustomFieldOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderCustomFieldOptions>>, TError,{organizationId: string;customFieldId: string;data: BodyType<ReorderCustomFieldOptionsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderCustomFieldOptions>>,
        TError,
        {organizationId: string;customFieldId: string;data: BodyType<ReorderCustomFieldOptionsBodyDto>},
        TContext
      > => {
      return useMutation(getReorderCustomFieldOptionsMutationOptions(options), queryClient);
    }

export type updateCustomFieldOptionResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type updateCustomFieldOptionResponseSuccess = (updateCustomFieldOptionResponse200) & {
  headers: Headers;
};
;

export type updateCustomFieldOptionResponse = (updateCustomFieldOptionResponseSuccess)

export const getUpdateCustomFieldOptionUrl = (organizationId: string,
    customFieldId: string,
    optionId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/options/${optionId}`
}

export const updateCustomFieldOption = async (organizationId: string,
    customFieldId: string,
    optionId: string,
    updateCustomFieldOptionBodyDto: UpdateCustomFieldOptionBodyDto, options?: RequestInit): Promise<updateCustomFieldOptionResponse> => {

  return axiosInstance<updateCustomFieldOptionResponse>(getUpdateCustomFieldOptionUrl(organizationId,customFieldId,optionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomFieldOptionBodyDto,)
  }
);}




export const getUpdateCustomFieldOptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string;data: BodyType<UpdateCustomFieldOptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string;data: BodyType<UpdateCustomFieldOptionBodyDto>}, TContext> => {

const mutationKey = ['updateCustomFieldOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomFieldOption>>, {organizationId: string;customFieldId: string;optionId: string;data: BodyType<UpdateCustomFieldOptionBodyDto>}> = (props) => {
          const {organizationId,customFieldId,optionId,data} = props ?? {};

          return  updateCustomFieldOption(organizationId,customFieldId,optionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomFieldOptionMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomFieldOption>>>
    export type UpdateCustomFieldOptionMutationBody = BodyType<UpdateCustomFieldOptionBodyDto>
    export type UpdateCustomFieldOptionMutationError = ErrorType<unknown>

    export const useUpdateCustomFieldOption = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string;data: BodyType<UpdateCustomFieldOptionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomFieldOption>>,
        TError,
        {organizationId: string;customFieldId: string;optionId: string;data: BodyType<UpdateCustomFieldOptionBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateCustomFieldOptionMutationOptions(options), queryClient);
    }

export type deleteCustomFieldOptionResponse200 = {
  data: CustomFieldResponseDto
  status: 200
}

export type deleteCustomFieldOptionResponseSuccess = (deleteCustomFieldOptionResponse200) & {
  headers: Headers;
};
;

export type deleteCustomFieldOptionResponse = (deleteCustomFieldOptionResponseSuccess)

export const getDeleteCustomFieldOptionUrl = (organizationId: string,
    customFieldId: string,
    optionId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/options/${optionId}`
}

export const deleteCustomFieldOption = async (organizationId: string,
    customFieldId: string,
    optionId: string, options?: RequestInit): Promise<deleteCustomFieldOptionResponse> => {

  return axiosInstance<deleteCustomFieldOptionResponse>(getDeleteCustomFieldOptionUrl(organizationId,customFieldId,optionId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomFieldOptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string}, TContext> => {

const mutationKey = ['deleteCustomFieldOption'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomFieldOption>>, {organizationId: string;customFieldId: string;optionId: string}> = (props) => {
          const {organizationId,customFieldId,optionId} = props ?? {};

          return  deleteCustomFieldOption(organizationId,customFieldId,optionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomFieldOptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomFieldOption>>>

    export type DeleteCustomFieldOptionMutationError = ErrorType<unknown>

    export const useDeleteCustomFieldOption = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomFieldOption>>, TError,{organizationId: string;customFieldId: string;optionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomFieldOption>>,
        TError,
        {organizationId: string;customFieldId: string;optionId: string},
        TContext
      > => {
      return useMutation(getDeleteCustomFieldOptionMutationOptions(options), queryClient);
    }

export type archiveCustomFieldResponse204 = {
  data: void
  status: 204
}

export type archiveCustomFieldResponseSuccess = (archiveCustomFieldResponse204) & {
  headers: Headers;
};
;

export type archiveCustomFieldResponse = (archiveCustomFieldResponseSuccess)

export const getArchiveCustomFieldUrl = (organizationId: string,
    customFieldId: string,) => {




  return `/organizations/${organizationId}/custom-fields/${customFieldId}/archive`
}

export const archiveCustomField = async (organizationId: string,
    customFieldId: string, options?: RequestInit): Promise<archiveCustomFieldResponse> => {

  return axiosInstance<archiveCustomFieldResponse>(getArchiveCustomFieldUrl(organizationId,customFieldId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCustomField>>, TError,{organizationId: string;customFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveCustomField>>, TError,{organizationId: string;customFieldId: string}, TContext> => {

const mutationKey = ['archiveCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveCustomField>>, {organizationId: string;customFieldId: string}> = (props) => {
          const {organizationId,customFieldId} = props ?? {};

          return  archiveCustomField(organizationId,customFieldId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof archiveCustomField>>>

    export type ArchiveCustomFieldMutationError = ErrorType<unknown>

    export const useArchiveCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveCustomField>>, TError,{organizationId: string;customFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveCustomField>>,
        TError,
        {organizationId: string;customFieldId: string},
        TContext
      > => {
      return useMutation(getArchiveCustomFieldMutationOptions(options), queryClient);
    }

export type getDatabaseFiltersResponse200 = {
  data: DatabaseFiltersResponseDto
  status: 200
}

export type getDatabaseFiltersResponseSuccess = (getDatabaseFiltersResponse200) & {
  headers: Headers;
};
;

export type getDatabaseFiltersResponse = (getDatabaseFiltersResponseSuccess)

export const getGetDatabaseFiltersUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/filters`
}

export const getDatabaseFilters = async (organizationId: string, options?: RequestInit): Promise<getDatabaseFiltersResponse> => {

  return axiosInstance<getDatabaseFiltersResponse>(getGetDatabaseFiltersUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDatabaseFiltersQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/database/filters`
    ] as const;
    }


export const getGetDatabaseFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseFilters>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseFiltersQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseFilters>>> = ({ signal }) => getDatabaseFilters(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseFilters>>>
export type GetDatabaseFiltersQueryError = ErrorType<unknown>


export function useGetDatabaseFilters<TData = Awaited<ReturnType<typeof getDatabaseFilters>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseFilters>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseFilters<TData = Awaited<ReturnType<typeof getDatabaseFilters>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseFilters>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseFilters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseFilters<TData = Awaited<ReturnType<typeof getDatabaseFilters>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseFilters<TData = Awaited<ReturnType<typeof getDatabaseFilters>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseFilters>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseFiltersQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchDatabaseOptionsResponse200 = {
  data: DatabaseOptionsResponseDto
  status: 200
}

export type searchDatabaseOptionsResponseSuccess = (searchDatabaseOptionsResponse200) & {
  headers: Headers;
};
;

export type searchDatabaseOptionsResponse = (searchDatabaseOptionsResponseSuccess)

export const getSearchDatabaseOptionsUrl = (organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/database/options/${key}?${stringifiedParams}` : `/organizations/${organizationId}/database/options/${key}`
}

export const searchDatabaseOptions = async (organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options?: RequestInit): Promise<searchDatabaseOptionsResponse> => {

  return axiosInstance<searchDatabaseOptionsResponse>(getSearchDatabaseOptionsUrl(organizationId,key,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchDatabaseOptionsQueryKey = (organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params?: SearchDatabaseOptionsParams,) => {
    return [
    `/organizations/${organizationId}/database/options/${key}`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchDatabaseOptionsQueryOptions = <TData = Awaited<ReturnType<typeof searchDatabaseOptions>>, TError = ErrorType<unknown>>(organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchDatabaseOptionsQueryKey(organizationId,key,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDatabaseOptions>>> = ({ signal }) => searchDatabaseOptions(organizationId,key,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && key), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchDatabaseOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof searchDatabaseOptions>>>
export type SearchDatabaseOptionsQueryError = ErrorType<unknown>


export function useSearchDatabaseOptions<TData = Awaited<ReturnType<typeof searchDatabaseOptions>>, TError = ErrorType<unknown>>(
 organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDatabaseOptions>>,
          TError,
          Awaited<ReturnType<typeof searchDatabaseOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDatabaseOptions<TData = Awaited<ReturnType<typeof searchDatabaseOptions>>, TError = ErrorType<unknown>>(
 organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDatabaseOptions>>,
          TError,
          Awaited<ReturnType<typeof searchDatabaseOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDatabaseOptions<TData = Awaited<ReturnType<typeof searchDatabaseOptions>>, TError = ErrorType<unknown>>(
 organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchDatabaseOptions<TData = Awaited<ReturnType<typeof searchDatabaseOptions>>, TError = ErrorType<unknown>>(
 organizationId: string,
    key: 'searchTitle' | 'searchRegion' | 'searchZipCode' | 'searchAreaCode' | 'searchIndustryLinkedinKeywords' | 'searchTechnology',
    params: SearchDatabaseOptionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDatabaseOptions>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchDatabaseOptionsQueryOptions(organizationId,key,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchDatabasePeopleResponse200 = {
  data: DatabaseSearchResponseDto
  status: 200
}

export type searchDatabasePeopleResponseSuccess = (searchDatabasePeopleResponse200) & {
  headers: Headers;
};
;

export type searchDatabasePeopleResponse = (searchDatabasePeopleResponseSuccess)

export const getSearchDatabasePeopleUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/search/people`
}

export const searchDatabasePeople = async (organizationId: string,
    databaseSearchBodyDto: DatabaseSearchBodyDto, options?: RequestInit): Promise<searchDatabasePeopleResponse> => {

  return axiosInstance<searchDatabasePeopleResponse>(getSearchDatabasePeopleUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      databaseSearchBodyDto,)
  }
);}




export const getSearchDatabasePeopleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabasePeople>>, TError,{organizationId: string;data: BodyType<DatabaseSearchBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchDatabasePeople>>, TError,{organizationId: string;data: BodyType<DatabaseSearchBodyDto>}, TContext> => {

const mutationKey = ['searchDatabasePeople'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchDatabasePeople>>, {organizationId: string;data: BodyType<DatabaseSearchBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  searchDatabasePeople(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchDatabasePeopleMutationResult = NonNullable<Awaited<ReturnType<typeof searchDatabasePeople>>>
    export type SearchDatabasePeopleMutationBody = BodyType<DatabaseSearchBodyDto>
    export type SearchDatabasePeopleMutationError = ErrorType<unknown>

    export const useSearchDatabasePeople = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabasePeople>>, TError,{organizationId: string;data: BodyType<DatabaseSearchBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchDatabasePeople>>,
        TError,
        {organizationId: string;data: BodyType<DatabaseSearchBodyDto>},
        TContext
      > => {
      return useMutation(getSearchDatabasePeopleMutationOptions(options), queryClient);
    }

export type searchDatabaseCompaniesResponse200 = {
  data: DatabaseSearchCompaniesResponseDto
  status: 200
}

export type searchDatabaseCompaniesResponseSuccess = (searchDatabaseCompaniesResponse200) & {
  headers: Headers;
};
;

export type searchDatabaseCompaniesResponse = (searchDatabaseCompaniesResponseSuccess)

export const getSearchDatabaseCompaniesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/search/companies`
}

export const searchDatabaseCompanies = async (organizationId: string,
    databaseSearchCompaniesBodyDto: DatabaseSearchCompaniesBodyDto, options?: RequestInit): Promise<searchDatabaseCompaniesResponse> => {

  return axiosInstance<searchDatabaseCompaniesResponse>(getSearchDatabaseCompaniesUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      databaseSearchCompaniesBodyDto,)
  }
);}




export const getSearchDatabaseCompaniesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanies>>, TError,{organizationId: string;data: BodyType<DatabaseSearchCompaniesBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanies>>, TError,{organizationId: string;data: BodyType<DatabaseSearchCompaniesBodyDto>}, TContext> => {

const mutationKey = ['searchDatabaseCompanies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchDatabaseCompanies>>, {organizationId: string;data: BodyType<DatabaseSearchCompaniesBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  searchDatabaseCompanies(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchDatabaseCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof searchDatabaseCompanies>>>
    export type SearchDatabaseCompaniesMutationBody = BodyType<DatabaseSearchCompaniesBodyDto>
    export type SearchDatabaseCompaniesMutationError = ErrorType<unknown>

    export const useSearchDatabaseCompanies = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanies>>, TError,{organizationId: string;data: BodyType<DatabaseSearchCompaniesBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchDatabaseCompanies>>,
        TError,
        {organizationId: string;data: BodyType<DatabaseSearchCompaniesBodyDto>},
        TContext
      > => {
      return useMutation(getSearchDatabaseCompaniesMutationOptions(options), queryClient);
    }

export type countDatabaseMatchesResponse200 = {
  data: DatabaseCountResponseDto
  status: 200
}

export type countDatabaseMatchesResponseSuccess = (countDatabaseMatchesResponse200) & {
  headers: Headers;
};
;

export type countDatabaseMatchesResponse = (countDatabaseMatchesResponseSuccess)

export const getCountDatabaseMatchesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/count`
}

export const countDatabaseMatches = async (organizationId: string,
    databaseCountBodyDto: DatabaseCountBodyDto, options?: RequestInit): Promise<countDatabaseMatchesResponse> => {

  return axiosInstance<countDatabaseMatchesResponse>(getCountDatabaseMatchesUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      databaseCountBodyDto,)
  }
);}




export const getCountDatabaseMatchesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countDatabaseMatches>>, TError,{organizationId: string;data: BodyType<DatabaseCountBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof countDatabaseMatches>>, TError,{organizationId: string;data: BodyType<DatabaseCountBodyDto>}, TContext> => {

const mutationKey = ['countDatabaseMatches'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countDatabaseMatches>>, {organizationId: string;data: BodyType<DatabaseCountBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  countDatabaseMatches(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CountDatabaseMatchesMutationResult = NonNullable<Awaited<ReturnType<typeof countDatabaseMatches>>>
    export type CountDatabaseMatchesMutationBody = BodyType<DatabaseCountBodyDto>
    export type CountDatabaseMatchesMutationError = ErrorType<unknown>

    export const useCountDatabaseMatches = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countDatabaseMatches>>, TError,{organizationId: string;data: BodyType<DatabaseCountBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof countDatabaseMatches>>,
        TError,
        {organizationId: string;data: BodyType<DatabaseCountBodyDto>},
        TContext
      > => {
      return useMutation(getCountDatabaseMatchesMutationOptions(options), queryClient);
    }

export type listDatabaseSearchTabsResponse200 = {
  data: ListDatabaseSearchTabsResponseDto
  status: 200
}

export type listDatabaseSearchTabsResponseSuccess = (listDatabaseSearchTabsResponse200) & {
  headers: Headers;
};
;

export type listDatabaseSearchTabsResponse = (listDatabaseSearchTabsResponseSuccess)

export const getListDatabaseSearchTabsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/searches`
}

export const listDatabaseSearchTabs = async (organizationId: string, options?: RequestInit): Promise<listDatabaseSearchTabsResponse> => {

  return axiosInstance<listDatabaseSearchTabsResponse>(getListDatabaseSearchTabsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDatabaseSearchTabsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/database/searches`
    ] as const;
    }


export const getListDatabaseSearchTabsQueryOptions = <TData = Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDatabaseSearchTabsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDatabaseSearchTabs>>> = ({ signal }) => listDatabaseSearchTabs(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDatabaseSearchTabsQueryResult = NonNullable<Awaited<ReturnType<typeof listDatabaseSearchTabs>>>
export type ListDatabaseSearchTabsQueryError = ErrorType<unknown>


export function useListDatabaseSearchTabs<TData = Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatabaseSearchTabs>>,
          TError,
          Awaited<ReturnType<typeof listDatabaseSearchTabs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDatabaseSearchTabs<TData = Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatabaseSearchTabs>>,
          TError,
          Awaited<ReturnType<typeof listDatabaseSearchTabs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDatabaseSearchTabs<TData = Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListDatabaseSearchTabs<TData = Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseSearchTabs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDatabaseSearchTabsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createDatabaseSearchTabResponse201 = {
  data: CreateDatabaseSearchTabResponseDto
  status: 201
}

export type createDatabaseSearchTabResponseSuccess = (createDatabaseSearchTabResponse201) & {
  headers: Headers;
};
;

export type createDatabaseSearchTabResponse = (createDatabaseSearchTabResponseSuccess)

export const getCreateDatabaseSearchTabUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/searches`
}

export const createDatabaseSearchTab = async (organizationId: string,
    createDatabaseSearchTabBodyDto: CreateDatabaseSearchTabBodyDto, options?: RequestInit): Promise<createDatabaseSearchTabResponse> => {

  return axiosInstance<createDatabaseSearchTabResponse>(getCreateDatabaseSearchTabUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDatabaseSearchTabBodyDto,)
  }
);}




export const getCreateDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDatabaseSearchTab>>, TError,{organizationId: string;data: BodyType<CreateDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDatabaseSearchTab>>, TError,{organizationId: string;data: BodyType<CreateDatabaseSearchTabBodyDto>}, TContext> => {

const mutationKey = ['createDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDatabaseSearchTab>>, {organizationId: string;data: BodyType<CreateDatabaseSearchTabBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createDatabaseSearchTab(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof createDatabaseSearchTab>>>
    export type CreateDatabaseSearchTabMutationBody = BodyType<CreateDatabaseSearchTabBodyDto>
    export type CreateDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useCreateDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDatabaseSearchTab>>, TError,{organizationId: string;data: BodyType<CreateDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDatabaseSearchTab>>,
        TError,
        {organizationId: string;data: BodyType<CreateDatabaseSearchTabBodyDto>},
        TContext
      > => {
      return useMutation(getCreateDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type getDatabaseSearchTabResponse200 = {
  data: DatabaseSearchTabDto
  status: 200
}

export type getDatabaseSearchTabResponseSuccess = (getDatabaseSearchTabResponse200) & {
  headers: Headers;
};
;

export type getDatabaseSearchTabResponse = (getDatabaseSearchTabResponseSuccess)

export const getGetDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}`
}

export const getDatabaseSearchTab = async (organizationId: string,
    searchId: string, options?: RequestInit): Promise<getDatabaseSearchTabResponse> => {

  return axiosInstance<getDatabaseSearchTabResponse>(getGetDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDatabaseSearchTabQueryKey = (organizationId: string,
    searchId: string,) => {
    return [
    `/organizations/${organizationId}/database/searches/${searchId}`
    ] as const;
    }


export const getGetDatabaseSearchTabQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError = ErrorType<unknown>>(organizationId: string,
    searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseSearchTabQueryKey(organizationId,searchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseSearchTab>>> = ({ signal }) => getDatabaseSearchTab(organizationId,searchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && searchId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseSearchTabQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseSearchTab>>>
export type GetDatabaseSearchTabQueryError = ErrorType<unknown>


export function useGetDatabaseSearchTab<TData = Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError = ErrorType<unknown>>(
 organizationId: string,
    searchId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseSearchTab>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseSearchTab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseSearchTab<TData = Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError = ErrorType<unknown>>(
 organizationId: string,
    searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseSearchTab>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseSearchTab>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseSearchTab<TData = Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError = ErrorType<unknown>>(
 organizationId: string,
    searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseSearchTab<TData = Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError = ErrorType<unknown>>(
 organizationId: string,
    searchId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseSearchTab>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseSearchTabQueryOptions(organizationId,searchId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateDatabaseSearchTabResponse200 = {
  data: DatabaseSearchTabDto
  status: 200
}

export type updateDatabaseSearchTabResponseSuccess = (updateDatabaseSearchTabResponse200) & {
  headers: Headers;
};
;

export type updateDatabaseSearchTabResponse = (updateDatabaseSearchTabResponseSuccess)

export const getUpdateDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}`
}

export const updateDatabaseSearchTab = async (organizationId: string,
    searchId: string,
    updateDatabaseSearchTabBodyDto: UpdateDatabaseSearchTabBodyDto, options?: RequestInit): Promise<updateDatabaseSearchTabResponse> => {

  return axiosInstance<updateDatabaseSearchTabResponse>(getUpdateDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDatabaseSearchTabBodyDto,)
  }
);}




export const getUpdateDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<UpdateDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<UpdateDatabaseSearchTabBodyDto>}, TContext> => {

const mutationKey = ['updateDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDatabaseSearchTab>>, {organizationId: string;searchId: string;data: BodyType<UpdateDatabaseSearchTabBodyDto>}> = (props) => {
          const {organizationId,searchId,data} = props ?? {};

          return  updateDatabaseSearchTab(organizationId,searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof updateDatabaseSearchTab>>>
    export type UpdateDatabaseSearchTabMutationBody = BodyType<UpdateDatabaseSearchTabBodyDto>
    export type UpdateDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useUpdateDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<UpdateDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string;data: BodyType<UpdateDatabaseSearchTabBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type deleteDatabaseSearchTabResponse204 = {
  data: void
  status: 204
}

export type deleteDatabaseSearchTabResponseSuccess = (deleteDatabaseSearchTabResponse204) & {
  headers: Headers;
};
;

export type deleteDatabaseSearchTabResponse = (deleteDatabaseSearchTabResponseSuccess)

export const getDeleteDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}`
}

export const deleteDatabaseSearchTab = async (organizationId: string,
    searchId: string, options?: RequestInit): Promise<deleteDatabaseSearchTabResponse> => {

  return axiosInstance<deleteDatabaseSearchTabResponse>(getDeleteDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext> => {

const mutationKey = ['deleteDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDatabaseSearchTab>>, {organizationId: string;searchId: string}> = (props) => {
          const {organizationId,searchId} = props ?? {};

          return  deleteDatabaseSearchTab(organizationId,searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDatabaseSearchTab>>>

    export type DeleteDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useDeleteDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string},
        TContext
      > => {
      return useMutation(getDeleteDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type touchDatabaseSearchTabResponse200 = {
  data: DatabaseSearchTabDto
  status: 200
}

export type touchDatabaseSearchTabResponseSuccess = (touchDatabaseSearchTabResponse200) & {
  headers: Headers;
};
;

export type touchDatabaseSearchTabResponse = (touchDatabaseSearchTabResponseSuccess)

export const getTouchDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}/touch`
}

export const touchDatabaseSearchTab = async (organizationId: string,
    searchId: string,
    touchDatabaseSearchTabBodyDto: TouchDatabaseSearchTabBodyDto, options?: RequestInit): Promise<touchDatabaseSearchTabResponse> => {

  return axiosInstance<touchDatabaseSearchTabResponse>(getTouchDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      touchDatabaseSearchTabBodyDto,)
  }
);}




export const getTouchDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof touchDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<TouchDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof touchDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<TouchDatabaseSearchTabBodyDto>}, TContext> => {

const mutationKey = ['touchDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof touchDatabaseSearchTab>>, {organizationId: string;searchId: string;data: BodyType<TouchDatabaseSearchTabBodyDto>}> = (props) => {
          const {organizationId,searchId,data} = props ?? {};

          return  touchDatabaseSearchTab(organizationId,searchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TouchDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof touchDatabaseSearchTab>>>
    export type TouchDatabaseSearchTabMutationBody = BodyType<TouchDatabaseSearchTabBodyDto>
    export type TouchDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useTouchDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof touchDatabaseSearchTab>>, TError,{organizationId: string;searchId: string;data: BodyType<TouchDatabaseSearchTabBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof touchDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string;data: BodyType<TouchDatabaseSearchTabBodyDto>},
        TContext
      > => {
      return useMutation(getTouchDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type closeDatabaseSearchTabResponse200 = {
  data: DatabaseSearchTabDto
  status: 200
}

export type closeDatabaseSearchTabResponseSuccess = (closeDatabaseSearchTabResponse200) & {
  headers: Headers;
};
;

export type closeDatabaseSearchTabResponse = (closeDatabaseSearchTabResponseSuccess)

export const getCloseDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}/close`
}

export const closeDatabaseSearchTab = async (organizationId: string,
    searchId: string, options?: RequestInit): Promise<closeDatabaseSearchTabResponse> => {

  return axiosInstance<closeDatabaseSearchTabResponse>(getCloseDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCloseDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext> => {

const mutationKey = ['closeDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeDatabaseSearchTab>>, {organizationId: string;searchId: string}> = (props) => {
          const {organizationId,searchId} = props ?? {};

          return  closeDatabaseSearchTab(organizationId,searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof closeDatabaseSearchTab>>>

    export type CloseDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useCloseDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string},
        TContext
      > => {
      return useMutation(getCloseDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type reopenDatabaseSearchTabResponse200 = {
  data: DatabaseSearchTabDto
  status: 200
}

export type reopenDatabaseSearchTabResponseSuccess = (reopenDatabaseSearchTabResponse200) & {
  headers: Headers;
};
;

export type reopenDatabaseSearchTabResponse = (reopenDatabaseSearchTabResponseSuccess)

export const getReopenDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}/reopen`
}

export const reopenDatabaseSearchTab = async (organizationId: string,
    searchId: string, options?: RequestInit): Promise<reopenDatabaseSearchTabResponse> => {

  return axiosInstance<reopenDatabaseSearchTabResponse>(getReopenDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReopenDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reopenDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext> => {

const mutationKey = ['reopenDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reopenDatabaseSearchTab>>, {organizationId: string;searchId: string}> = (props) => {
          const {organizationId,searchId} = props ?? {};

          return  reopenDatabaseSearchTab(organizationId,searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReopenDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof reopenDatabaseSearchTab>>>

    export type ReopenDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useReopenDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reopenDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reopenDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string},
        TContext
      > => {
      return useMutation(getReopenDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type duplicateDatabaseSearchTabResponse201 = {
  data: DatabaseSearchTabDto
  status: 201
}

export type duplicateDatabaseSearchTabResponseSuccess = (duplicateDatabaseSearchTabResponse201) & {
  headers: Headers;
};
;

export type duplicateDatabaseSearchTabResponse = (duplicateDatabaseSearchTabResponseSuccess)

export const getDuplicateDatabaseSearchTabUrl = (organizationId: string,
    searchId: string,) => {




  return `/organizations/${organizationId}/database/searches/${searchId}/duplicate`
}

export const duplicateDatabaseSearchTab = async (organizationId: string,
    searchId: string, options?: RequestInit): Promise<duplicateDatabaseSearchTabResponse> => {

  return axiosInstance<duplicateDatabaseSearchTabResponse>(getDuplicateDatabaseSearchTabUrl(organizationId,searchId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDuplicateDatabaseSearchTabMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext> => {

const mutationKey = ['duplicateDatabaseSearchTab'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>, {organizationId: string;searchId: string}> = (props) => {
          const {organizationId,searchId} = props ?? {};

          return  duplicateDatabaseSearchTab(organizationId,searchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateDatabaseSearchTabMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>>

    export type DuplicateDatabaseSearchTabMutationError = ErrorType<unknown>

    export const useDuplicateDatabaseSearchTab = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>, TError,{organizationId: string;searchId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateDatabaseSearchTab>>,
        TError,
        {organizationId: string;searchId: string},
        TContext
      > => {
      return useMutation(getDuplicateDatabaseSearchTabMutationOptions(options), queryClient);
    }

export type estimateDatabaseRevealResponse200 = {
  data: RevealEstimateResponseDto
  status: 200
}

export type estimateDatabaseRevealResponseSuccess = (estimateDatabaseRevealResponse200) & {
  headers: Headers;
};
;

export type estimateDatabaseRevealResponse = (estimateDatabaseRevealResponseSuccess)

export const getEstimateDatabaseRevealUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/reveals/estimate`
}

export const estimateDatabaseReveal = async (organizationId: string,
    revealIdsSelectionDtoRevealFiltersSelectionDto: RevealIdsSelectionDto | RevealFiltersSelectionDto, options?: RequestInit): Promise<estimateDatabaseRevealResponse> => {

  return axiosInstance<estimateDatabaseRevealResponse>(getEstimateDatabaseRevealUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      revealIdsSelectionDtoRevealFiltersSelectionDto,)
  }
);}




export const getEstimateDatabaseRevealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof estimateDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext> => {

const mutationKey = ['estimateDatabaseReveal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof estimateDatabaseReveal>>, {organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  estimateDatabaseReveal(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EstimateDatabaseRevealMutationResult = NonNullable<Awaited<ReturnType<typeof estimateDatabaseReveal>>>
    export type EstimateDatabaseRevealMutationBody = BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>
    export type EstimateDatabaseRevealMutationError = ErrorType<unknown>

    export const useEstimateDatabaseReveal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof estimateDatabaseReveal>>,
        TError,
        {organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>},
        TContext
      > => {
      return useMutation(getEstimateDatabaseRevealMutationOptions(options), queryClient);
    }

export type createDatabaseRevealResponse201 = {
  data: CreateRevealSyncResponseDto | CreateRevealAsyncResponseDto
  status: 201
}

export type createDatabaseRevealResponse202 = {
  data: CreateRevealSyncResponseDto | CreateRevealAsyncResponseDto
  status: 202
}

export type createDatabaseRevealResponseSuccess = (createDatabaseRevealResponse201 | createDatabaseRevealResponse202) & {
  headers: Headers;
};
;

export type createDatabaseRevealResponse = (createDatabaseRevealResponseSuccess)

export const getCreateDatabaseRevealUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/database/reveals`
}

export const createDatabaseReveal = async (organizationId: string,
    revealIdsSelectionDtoRevealFiltersSelectionDto: RevealIdsSelectionDto | RevealFiltersSelectionDto, options?: RequestInit): Promise<createDatabaseRevealResponse> => {

  return axiosInstance<createDatabaseRevealResponse>(getCreateDatabaseRevealUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      revealIdsSelectionDtoRevealFiltersSelectionDto,)
  }
);}




export const getCreateDatabaseRevealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext> => {

const mutationKey = ['createDatabaseReveal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDatabaseReveal>>, {organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createDatabaseReveal(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDatabaseRevealMutationResult = NonNullable<Awaited<ReturnType<typeof createDatabaseReveal>>>
    export type CreateDatabaseRevealMutationBody = BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>
    export type CreateDatabaseRevealMutationError = ErrorType<unknown>

    export const useCreateDatabaseReveal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDatabaseReveal>>, TError,{organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDatabaseReveal>>,
        TError,
        {organizationId: string;data: BodyType<RevealIdsSelectionDto | RevealFiltersSelectionDto>},
        TContext
      > => {
      return useMutation(getCreateDatabaseRevealMutationOptions(options), queryClient);
    }

export type getDatabaseCompanyResponse200 = {
  data: DatabaseCompanyResponseDto
  status: 200
}

export type getDatabaseCompanyResponseSuccess = (getDatabaseCompanyResponse200) & {
  headers: Headers;
};
;

export type getDatabaseCompanyResponse = (getDatabaseCompanyResponseSuccess)

export const getGetDatabaseCompanyUrl = (organizationId: string,
    companyId: string,) => {




  return `/organizations/${organizationId}/database/companies/${companyId}`
}

export const getDatabaseCompany = async (organizationId: string,
    companyId: string, options?: RequestInit): Promise<getDatabaseCompanyResponse> => {

  return axiosInstance<getDatabaseCompanyResponse>(getGetDatabaseCompanyUrl(organizationId,companyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDatabaseCompanyQueryKey = (organizationId: string,
    companyId: string,) => {
    return [
    `/organizations/${organizationId}/database/companies/${companyId}`
    ] as const;
    }


export const getGetDatabaseCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseCompany>>, TError = ErrorType<unknown>>(organizationId: string,
    companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseCompanyQueryKey(organizationId,companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseCompany>>> = ({ signal }) => getDatabaseCompany(organizationId,companyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && companyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseCompany>>>
export type GetDatabaseCompanyQueryError = ErrorType<unknown>


export function useGetDatabaseCompany<TData = Awaited<ReturnType<typeof getDatabaseCompany>>, TError = ErrorType<unknown>>(
 organizationId: string,
    companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseCompany>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseCompany<TData = Awaited<ReturnType<typeof getDatabaseCompany>>, TError = ErrorType<unknown>>(
 organizationId: string,
    companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseCompany>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseCompany<TData = Awaited<ReturnType<typeof getDatabaseCompany>>, TError = ErrorType<unknown>>(
 organizationId: string,
    companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseCompany<TData = Awaited<ReturnType<typeof getDatabaseCompany>>, TError = ErrorType<unknown>>(
 organizationId: string,
    companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseCompany>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseCompanyQueryOptions(organizationId,companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type searchDatabaseCompanyPeopleResponse200 = {
  data: DatabaseSearchResponseDto
  status: 200
}

export type searchDatabaseCompanyPeopleResponseSuccess = (searchDatabaseCompanyPeopleResponse200) & {
  headers: Headers;
};
;

export type searchDatabaseCompanyPeopleResponse = (searchDatabaseCompanyPeopleResponseSuccess)

export const getSearchDatabaseCompanyPeopleUrl = (organizationId: string,
    companyId: string,) => {




  return `/organizations/${organizationId}/database/companies/${companyId}/people`
}

export const searchDatabaseCompanyPeople = async (organizationId: string,
    companyId: string,
    databaseCompanyPeopleBodyDto: DatabaseCompanyPeopleBodyDto, options?: RequestInit): Promise<searchDatabaseCompanyPeopleResponse> => {

  return axiosInstance<searchDatabaseCompanyPeopleResponse>(getSearchDatabaseCompanyPeopleUrl(organizationId,companyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      databaseCompanyPeopleBodyDto,)
  }
);}




export const getSearchDatabaseCompanyPeopleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>, TError,{organizationId: string;companyId: string;data: BodyType<DatabaseCompanyPeopleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>, TError,{organizationId: string;companyId: string;data: BodyType<DatabaseCompanyPeopleBodyDto>}, TContext> => {

const mutationKey = ['searchDatabaseCompanyPeople'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>, {organizationId: string;companyId: string;data: BodyType<DatabaseCompanyPeopleBodyDto>}> = (props) => {
          const {organizationId,companyId,data} = props ?? {};

          return  searchDatabaseCompanyPeople(organizationId,companyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchDatabaseCompanyPeopleMutationResult = NonNullable<Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>>
    export type SearchDatabaseCompanyPeopleMutationBody = BodyType<DatabaseCompanyPeopleBodyDto>
    export type SearchDatabaseCompanyPeopleMutationError = ErrorType<unknown>

    export const useSearchDatabaseCompanyPeople = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>, TError,{organizationId: string;companyId: string;data: BodyType<DatabaseCompanyPeopleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchDatabaseCompanyPeople>>,
        TError,
        {organizationId: string;companyId: string;data: BodyType<DatabaseCompanyPeopleBodyDto>},
        TContext
      > => {
      return useMutation(getSearchDatabaseCompanyPeopleMutationOptions(options), queryClient);
    }

export type addDatabaseCompanyAsLeadResponse201 = {
  data: AddCompanyAsLeadResponseDto
  status: 201
}

export type addDatabaseCompanyAsLeadResponseSuccess = (addDatabaseCompanyAsLeadResponse201) & {
  headers: Headers;
};
;

export type addDatabaseCompanyAsLeadResponse = (addDatabaseCompanyAsLeadResponseSuccess)

export const getAddDatabaseCompanyAsLeadUrl = (organizationId: string,
    companyId: string,) => {




  return `/organizations/${organizationId}/database/companies/${companyId}/lead`
}

export const addDatabaseCompanyAsLead = async (organizationId: string,
    companyId: string, options?: RequestInit): Promise<addDatabaseCompanyAsLeadResponse> => {

  return axiosInstance<addDatabaseCompanyAsLeadResponse>(getAddDatabaseCompanyAsLeadUrl(organizationId,companyId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAddDatabaseCompanyAsLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>, TError,{organizationId: string;companyId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>, TError,{organizationId: string;companyId: string}, TContext> => {

const mutationKey = ['addDatabaseCompanyAsLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>, {organizationId: string;companyId: string}> = (props) => {
          const {organizationId,companyId} = props ?? {};

          return  addDatabaseCompanyAsLead(organizationId,companyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddDatabaseCompanyAsLeadMutationResult = NonNullable<Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>>

    export type AddDatabaseCompanyAsLeadMutationError = ErrorType<unknown>

    export const useAddDatabaseCompanyAsLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>, TError,{organizationId: string;companyId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addDatabaseCompanyAsLead>>,
        TError,
        {organizationId: string;companyId: string},
        TContext
      > => {
      return useMutation(getAddDatabaseCompanyAsLeadMutationOptions(options), queryClient);
    }

export type listDatabaseRevealJobsResponse200 = {
  data: ListRevealJobsResponseDto
  status: 200
}

export type listDatabaseRevealJobsResponseSuccess = (listDatabaseRevealJobsResponse200) & {
  headers: Headers;
};
;

export type listDatabaseRevealJobsResponse = (listDatabaseRevealJobsResponseSuccess)

export const getListDatabaseRevealJobsUrl = (organizationId: string,
    params?: ListDatabaseRevealJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/database/reveal-jobs?${stringifiedParams}` : `/organizations/${organizationId}/database/reveal-jobs`
}

export const listDatabaseRevealJobs = async (organizationId: string,
    params?: ListDatabaseRevealJobsParams, options?: RequestInit): Promise<listDatabaseRevealJobsResponse> => {

  return axiosInstance<listDatabaseRevealJobsResponse>(getListDatabaseRevealJobsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDatabaseRevealJobsQueryKey = (organizationId: string,
    params?: ListDatabaseRevealJobsParams,) => {
    return [
    `/organizations/${organizationId}/database/reveal-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDatabaseRevealJobsQueryOptions = <TData = Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListDatabaseRevealJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDatabaseRevealJobsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDatabaseRevealJobs>>> = ({ signal }) => listDatabaseRevealJobs(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDatabaseRevealJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listDatabaseRevealJobs>>>
export type ListDatabaseRevealJobsQueryError = ErrorType<unknown>


export function useListDatabaseRevealJobs<TData = Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListDatabaseRevealJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatabaseRevealJobs>>,
          TError,
          Awaited<ReturnType<typeof listDatabaseRevealJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDatabaseRevealJobs<TData = Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListDatabaseRevealJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDatabaseRevealJobs>>,
          TError,
          Awaited<ReturnType<typeof listDatabaseRevealJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDatabaseRevealJobs<TData = Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListDatabaseRevealJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListDatabaseRevealJobs<TData = Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListDatabaseRevealJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDatabaseRevealJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDatabaseRevealJobsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getDatabaseRevealJobResponse200 = {
  data: RevealJobWithResultsResponseDto
  status: 200
}

export type getDatabaseRevealJobResponseSuccess = (getDatabaseRevealJobResponse200) & {
  headers: Headers;
};
;

export type getDatabaseRevealJobResponse = (getDatabaseRevealJobResponseSuccess)

export const getGetDatabaseRevealJobUrl = (organizationId: string,
    revealJobId: string,) => {




  return `/organizations/${organizationId}/database/reveal-jobs/${revealJobId}`
}

export const getDatabaseRevealJob = async (organizationId: string,
    revealJobId: string, options?: RequestInit): Promise<getDatabaseRevealJobResponse> => {

  return axiosInstance<getDatabaseRevealJobResponse>(getGetDatabaseRevealJobUrl(organizationId,revealJobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDatabaseRevealJobQueryKey = (organizationId: string,
    revealJobId: string,) => {
    return [
    `/organizations/${organizationId}/database/reveal-jobs/${revealJobId}`
    ] as const;
    }


export const getGetDatabaseRevealJobQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError = ErrorType<unknown>>(organizationId: string,
    revealJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseRevealJobQueryKey(organizationId,revealJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseRevealJob>>> = ({ signal }) => getDatabaseRevealJob(organizationId,revealJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && revealJobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDatabaseRevealJobQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseRevealJob>>>
export type GetDatabaseRevealJobQueryError = ErrorType<unknown>


export function useGetDatabaseRevealJob<TData = Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    revealJobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRevealJob>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRevealJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRevealJob<TData = Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    revealJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRevealJob>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRevealJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDatabaseRevealJob<TData = Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    revealJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDatabaseRevealJob<TData = Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    revealJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRevealJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDatabaseRevealJobQueryOptions(organizationId,revealJobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type cancelDatabaseRevealJobResponse200 = {
  data: RevealJobResponseDto
  status: 200
}

export type cancelDatabaseRevealJobResponseSuccess = (cancelDatabaseRevealJobResponse200) & {
  headers: Headers;
};
;

export type cancelDatabaseRevealJobResponse = (cancelDatabaseRevealJobResponseSuccess)

export const getCancelDatabaseRevealJobUrl = (organizationId: string,
    revealJobId: string,) => {




  return `/organizations/${organizationId}/database/reveal-jobs/${revealJobId}/cancel`
}

export const cancelDatabaseRevealJob = async (organizationId: string,
    revealJobId: string, options?: RequestInit): Promise<cancelDatabaseRevealJobResponse> => {

  return axiosInstance<cancelDatabaseRevealJobResponse>(getCancelDatabaseRevealJobUrl(organizationId,revealJobId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCancelDatabaseRevealJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext> => {

const mutationKey = ['cancelDatabaseRevealJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDatabaseRevealJob>>, {organizationId: string;revealJobId: string}> = (props) => {
          const {organizationId,revealJobId} = props ?? {};

          return  cancelDatabaseRevealJob(organizationId,revealJobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelDatabaseRevealJobMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDatabaseRevealJob>>>

    export type CancelDatabaseRevealJobMutationError = ErrorType<unknown>

    export const useCancelDatabaseRevealJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelDatabaseRevealJob>>,
        TError,
        {organizationId: string;revealJobId: string},
        TContext
      > => {
      return useMutation(getCancelDatabaseRevealJobMutationOptions(options), queryClient);
    }

export type dismissDatabaseRevealJobResponse200 = {
  data: RevealJobResponseDto
  status: 200
}

export type dismissDatabaseRevealJobResponseSuccess = (dismissDatabaseRevealJobResponse200) & {
  headers: Headers;
};
;

export type dismissDatabaseRevealJobResponse = (dismissDatabaseRevealJobResponseSuccess)

export const getDismissDatabaseRevealJobUrl = (organizationId: string,
    revealJobId: string,) => {




  return `/organizations/${organizationId}/database/reveal-jobs/${revealJobId}/dismiss`
}

export const dismissDatabaseRevealJob = async (organizationId: string,
    revealJobId: string, options?: RequestInit): Promise<dismissDatabaseRevealJobResponse> => {

  return axiosInstance<dismissDatabaseRevealJobResponse>(getDismissDatabaseRevealJobUrl(organizationId,revealJobId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDismissDatabaseRevealJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext> => {

const mutationKey = ['dismissDatabaseRevealJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissDatabaseRevealJob>>, {organizationId: string;revealJobId: string}> = (props) => {
          const {organizationId,revealJobId} = props ?? {};

          return  dismissDatabaseRevealJob(organizationId,revealJobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissDatabaseRevealJobMutationResult = NonNullable<Awaited<ReturnType<typeof dismissDatabaseRevealJob>>>

    export type DismissDatabaseRevealJobMutationError = ErrorType<unknown>

    export const useDismissDatabaseRevealJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissDatabaseRevealJob>>, TError,{organizationId: string;revealJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissDatabaseRevealJob>>,
        TError,
        {organizationId: string;revealJobId: string},
        TContext
      > => {
      return useMutation(getDismissDatabaseRevealJobMutationOptions(options), queryClient);
    }

export type createDealResponse201 = {
  data: void
  status: 201
}

export type createDealResponseSuccess = (createDealResponse201) & {
  headers: Headers;
};
;

export type createDealResponse = (createDealResponseSuccess)

export const getCreateDealUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deals`
}

export const createDeal = async (organizationId: string,
    createDealBodyDto: CreateDealBodyDto, options?: RequestInit): Promise<createDealResponse> => {

  return axiosInstance<createDealResponse>(getCreateDealUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDealBodyDto,)
  }
);}




export const getCreateDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeal>>, TError,{organizationId: string;data: BodyType<CreateDealBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDeal>>, TError,{organizationId: string;data: BodyType<CreateDealBodyDto>}, TContext> => {

const mutationKey = ['createDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDeal>>, {organizationId: string;data: BodyType<CreateDealBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createDeal(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDealMutationResult = NonNullable<Awaited<ReturnType<typeof createDeal>>>
    export type CreateDealMutationBody = BodyType<CreateDealBodyDto>
    export type CreateDealMutationError = ErrorType<unknown>

    export const useCreateDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDeal>>, TError,{organizationId: string;data: BodyType<CreateDealBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDeal>>,
        TError,
        {organizationId: string;data: BodyType<CreateDealBodyDto>},
        TContext
      > => {
      return useMutation(getCreateDealMutationOptions(options), queryClient);
    }

export type listDealsResponse200 = {
  data: ListDealsResponseDto
  status: 200
}

export type listDealsResponseSuccess = (listDealsResponse200) & {
  headers: Headers;
};
;

export type listDealsResponse = (listDealsResponseSuccess)

export const getListDealsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deals`
}

export const listDeals = async (organizationId: string, options?: RequestInit): Promise<listDealsResponse> => {

  return axiosInstance<listDealsResponse>(getListDealsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDealsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/deals`
    ] as const;
    }


export const getListDealsQueryOptions = <TData = Awaited<ReturnType<typeof listDeals>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDealsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDeals>>> = ({ signal }) => listDeals(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDealsQueryResult = NonNullable<Awaited<ReturnType<typeof listDeals>>>
export type ListDealsQueryError = ErrorType<unknown>


export function useListDeals<TData = Awaited<ReturnType<typeof listDeals>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDeals>>,
          TError,
          Awaited<ReturnType<typeof listDeals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDeals<TData = Awaited<ReturnType<typeof listDeals>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDeals>>,
          TError,
          Awaited<ReturnType<typeof listDeals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDeals<TData = Awaited<ReturnType<typeof listDeals>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListDeals<TData = Awaited<ReturnType<typeof listDeals>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDeals>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDealsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateDealResponse200 = {
  data: void
  status: 200
}

export type updateDealResponseSuccess = (updateDealResponse200) & {
  headers: Headers;
};
;

export type updateDealResponse = (updateDealResponseSuccess)

export const getUpdateDealUrl = (organizationId: string,
    dealId: string,) => {




  return `/organizations/${organizationId}/deals/${dealId}`
}

export const updateDeal = async (organizationId: string,
    dealId: string,
    updateDealBodyDto: UpdateDealBodyDto, options?: RequestInit): Promise<updateDealResponse> => {

  return axiosInstance<updateDealResponse>(getUpdateDealUrl(organizationId,dealId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDealBodyDto,)
  }
);}




export const getUpdateDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{organizationId: string;dealId: string;data: BodyType<UpdateDealBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{organizationId: string;dealId: string;data: BodyType<UpdateDealBodyDto>}, TContext> => {

const mutationKey = ['updateDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDeal>>, {organizationId: string;dealId: string;data: BodyType<UpdateDealBodyDto>}> = (props) => {
          const {organizationId,dealId,data} = props ?? {};

          return  updateDeal(organizationId,dealId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDealMutationResult = NonNullable<Awaited<ReturnType<typeof updateDeal>>>
    export type UpdateDealMutationBody = BodyType<UpdateDealBodyDto>
    export type UpdateDealMutationError = ErrorType<unknown>

    export const useUpdateDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDeal>>, TError,{organizationId: string;dealId: string;data: BodyType<UpdateDealBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDeal>>,
        TError,
        {organizationId: string;dealId: string;data: BodyType<UpdateDealBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateDealMutationOptions(options), queryClient);
    }

export type listDealBoardColumnResponse200 = {
  data: ListDealBoardColumnResponseDto
  status: 200
}

export type listDealBoardColumnResponseSuccess = (listDealBoardColumnResponse200) & {
  headers: Headers;
};
;

export type listDealBoardColumnResponse = (listDealBoardColumnResponseSuccess)

export const getListDealBoardColumnUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deals/board/column`
}

export const listDealBoardColumn = async (organizationId: string,
    listDealBoardColumnBodyDto: ListDealBoardColumnBodyDto, options?: RequestInit): Promise<listDealBoardColumnResponse> => {

  return axiosInstance<listDealBoardColumnResponse>(getListDealBoardColumnUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listDealBoardColumnBodyDto,)
  }
);}




export const getListDealBoardColumnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listDealBoardColumn>>, TError,{organizationId: string;data: BodyType<ListDealBoardColumnBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof listDealBoardColumn>>, TError,{organizationId: string;data: BodyType<ListDealBoardColumnBodyDto>}, TContext> => {

const mutationKey = ['listDealBoardColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listDealBoardColumn>>, {organizationId: string;data: BodyType<ListDealBoardColumnBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  listDealBoardColumn(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListDealBoardColumnMutationResult = NonNullable<Awaited<ReturnType<typeof listDealBoardColumn>>>
    export type ListDealBoardColumnMutationBody = BodyType<ListDealBoardColumnBodyDto>
    export type ListDealBoardColumnMutationError = ErrorType<unknown>

    export const useListDealBoardColumn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listDealBoardColumn>>, TError,{organizationId: string;data: BodyType<ListDealBoardColumnBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listDealBoardColumn>>,
        TError,
        {organizationId: string;data: BodyType<ListDealBoardColumnBodyDto>},
        TContext
      > => {
      return useMutation(getListDealBoardColumnMutationOptions(options), queryClient);
    }

export type archiveDealResponse204 = {
  data: void
  status: 204
}

export type archiveDealResponseSuccess = (archiveDealResponse204) & {
  headers: Headers;
};
;

export type archiveDealResponse = (archiveDealResponseSuccess)

export const getArchiveDealUrl = (organizationId: string,
    dealId: string,) => {




  return `/organizations/${organizationId}/deals/${dealId}/archive`
}

export const archiveDeal = async (organizationId: string,
    dealId: string, options?: RequestInit): Promise<archiveDealResponse> => {

  return axiosInstance<archiveDealResponse>(getArchiveDealUrl(organizationId,dealId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveDealMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDeal>>, TError,{organizationId: string;dealId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveDeal>>, TError,{organizationId: string;dealId: string}, TContext> => {

const mutationKey = ['archiveDeal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveDeal>>, {organizationId: string;dealId: string}> = (props) => {
          const {organizationId,dealId} = props ?? {};

          return  archiveDeal(organizationId,dealId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveDealMutationResult = NonNullable<Awaited<ReturnType<typeof archiveDeal>>>

    export type ArchiveDealMutationError = ErrorType<unknown>

    export const useArchiveDeal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDeal>>, TError,{organizationId: string;dealId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveDeal>>,
        TError,
        {organizationId: string;dealId: string},
        TContext
      > => {
      return useMutation(getArchiveDealMutationOptions(options), queryClient);
    }

export type createDealCustomFieldResponse201 = {
  data: void
  status: 201
}

export type createDealCustomFieldResponseSuccess = (createDealCustomFieldResponse201) & {
  headers: Headers;
};
;

export type createDealCustomFieldResponse = (createDealCustomFieldResponseSuccess)

export const getCreateDealCustomFieldUrl = (organizationId: string,
    dealId: string,) => {




  return `/organizations/${organizationId}/deals/${dealId}/custom-field`
}

export const createDealCustomField = async (organizationId: string,
    dealId: string,
    createDealCustomFieldBodyDto: CreateDealCustomFieldBodyDto, options?: RequestInit): Promise<createDealCustomFieldResponse> => {

  return axiosInstance<createDealCustomFieldResponse>(getCreateDealCustomFieldUrl(organizationId,dealId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDealCustomFieldBodyDto,)
  }
);}




export const getCreateDealCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDealCustomField>>, TError,{organizationId: string;dealId: string;data: BodyType<CreateDealCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDealCustomField>>, TError,{organizationId: string;dealId: string;data: BodyType<CreateDealCustomFieldBodyDto>}, TContext> => {

const mutationKey = ['createDealCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDealCustomField>>, {organizationId: string;dealId: string;data: BodyType<CreateDealCustomFieldBodyDto>}> = (props) => {
          const {organizationId,dealId,data} = props ?? {};

          return  createDealCustomField(organizationId,dealId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDealCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createDealCustomField>>>
    export type CreateDealCustomFieldMutationBody = BodyType<CreateDealCustomFieldBodyDto>
    export type CreateDealCustomFieldMutationError = ErrorType<unknown>

    export const useCreateDealCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDealCustomField>>, TError,{organizationId: string;dealId: string;data: BodyType<CreateDealCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDealCustomField>>,
        TError,
        {organizationId: string;dealId: string;data: BodyType<CreateDealCustomFieldBodyDto>},
        TContext
      > => {
      return useMutation(getCreateDealCustomFieldMutationOptions(options), queryClient);
    }

export type updateDealCustomFieldResponse200 = {
  data: void
  status: 200
}

export type updateDealCustomFieldResponseSuccess = (updateDealCustomFieldResponse200) & {
  headers: Headers;
};
;

export type updateDealCustomFieldResponse = (updateDealCustomFieldResponseSuccess)

export const getUpdateDealCustomFieldUrl = (organizationId: string,
    dealId: string,
    dealCustomFieldId: string,) => {




  return `/organizations/${organizationId}/deals/${dealId}/custom-field/${dealCustomFieldId}`
}

export const updateDealCustomField = async (organizationId: string,
    dealId: string,
    dealCustomFieldId: string,
    updateDealCustomFieldValueBodyDto: UpdateDealCustomFieldValueBodyDto, options?: RequestInit): Promise<updateDealCustomFieldResponse> => {

  return axiosInstance<updateDealCustomFieldResponse>(getUpdateDealCustomFieldUrl(organizationId,dealId,dealCustomFieldId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDealCustomFieldValueBodyDto,)
  }
);}




export const getUpdateDealCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string;data: BodyType<UpdateDealCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string;data: BodyType<UpdateDealCustomFieldValueBodyDto>}, TContext> => {

const mutationKey = ['updateDealCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDealCustomField>>, {organizationId: string;dealId: string;dealCustomFieldId: string;data: BodyType<UpdateDealCustomFieldValueBodyDto>}> = (props) => {
          const {organizationId,dealId,dealCustomFieldId,data} = props ?? {};

          return  updateDealCustomField(organizationId,dealId,dealCustomFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDealCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateDealCustomField>>>
    export type UpdateDealCustomFieldMutationBody = BodyType<UpdateDealCustomFieldValueBodyDto>
    export type UpdateDealCustomFieldMutationError = ErrorType<unknown>

    export const useUpdateDealCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string;data: BodyType<UpdateDealCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDealCustomField>>,
        TError,
        {organizationId: string;dealId: string;dealCustomFieldId: string;data: BodyType<UpdateDealCustomFieldValueBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateDealCustomFieldMutationOptions(options), queryClient);
    }

export type deleteDealCustomFieldResponse200 = {
  data: void
  status: 200
}

export type deleteDealCustomFieldResponseSuccess = (deleteDealCustomFieldResponse200) & {
  headers: Headers;
};
;

export type deleteDealCustomFieldResponse = (deleteDealCustomFieldResponseSuccess)

export const getDeleteDealCustomFieldUrl = (organizationId: string,
    dealId: string,
    dealCustomFieldId: string,) => {




  return `/organizations/${organizationId}/deals/${dealId}/custom-field/${dealCustomFieldId}`
}

export const deleteDealCustomField = async (organizationId: string,
    dealId: string,
    dealCustomFieldId: string, options?: RequestInit): Promise<deleteDealCustomFieldResponse> => {

  return axiosInstance<deleteDealCustomFieldResponse>(getDeleteDealCustomFieldUrl(organizationId,dealId,dealCustomFieldId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDealCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string}, TContext> => {

const mutationKey = ['deleteDealCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDealCustomField>>, {organizationId: string;dealId: string;dealCustomFieldId: string}> = (props) => {
          const {organizationId,dealId,dealCustomFieldId} = props ?? {};

          return  deleteDealCustomField(organizationId,dealId,dealCustomFieldId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDealCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDealCustomField>>>

    export type DeleteDealCustomFieldMutationError = ErrorType<unknown>

    export const useDeleteDealCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDealCustomField>>, TError,{organizationId: string;dealId: string;dealCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDealCustomField>>,
        TError,
        {organizationId: string;dealId: string;dealCustomFieldId: string},
        TContext
      > => {
      return useMutation(getDeleteDealCustomFieldMutationOptions(options), queryClient);
    }

export type createDealStageResponse201 = {
  data: void
  status: 201
}

export type createDealStageResponseSuccess = (createDealStageResponse201) & {
  headers: Headers;
};
;

export type createDealStageResponse = (createDealStageResponseSuccess)

export const getCreateDealStageUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deal-stages`
}

export const createDealStage = async (organizationId: string,
    createDealStageBodyDto: CreateDealStageBodyDto, options?: RequestInit): Promise<createDealStageResponse> => {

  return axiosInstance<createDealStageResponse>(getCreateDealStageUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDealStageBodyDto,)
  }
);}




export const getCreateDealStageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDealStage>>, TError,{organizationId: string;data: BodyType<CreateDealStageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDealStage>>, TError,{organizationId: string;data: BodyType<CreateDealStageBodyDto>}, TContext> => {

const mutationKey = ['createDealStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDealStage>>, {organizationId: string;data: BodyType<CreateDealStageBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createDealStage(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDealStageMutationResult = NonNullable<Awaited<ReturnType<typeof createDealStage>>>
    export type CreateDealStageMutationBody = BodyType<CreateDealStageBodyDto>
    export type CreateDealStageMutationError = ErrorType<unknown>

    export const useCreateDealStage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDealStage>>, TError,{organizationId: string;data: BodyType<CreateDealStageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDealStage>>,
        TError,
        {organizationId: string;data: BodyType<CreateDealStageBodyDto>},
        TContext
      > => {
      return useMutation(getCreateDealStageMutationOptions(options), queryClient);
    }

export type replaceDealStagesResponse200 = {
  data: ListDealStagesResponseDto
  status: 200
}

export type replaceDealStagesResponseSuccess = (replaceDealStagesResponse200) & {
  headers: Headers;
};
;

export type replaceDealStagesResponse = (replaceDealStagesResponseSuccess)

export const getReplaceDealStagesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deal-stages`
}

export const replaceDealStages = async (organizationId: string,
    replaceDealStagesBodyDto: ReplaceDealStagesBodyDto, options?: RequestInit): Promise<replaceDealStagesResponse> => {

  return axiosInstance<replaceDealStagesResponse>(getReplaceDealStagesUrl(organizationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      replaceDealStagesBodyDto,)
  }
);}




export const getReplaceDealStagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceDealStages>>, TError,{organizationId: string;data: BodyType<ReplaceDealStagesBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceDealStages>>, TError,{organizationId: string;data: BodyType<ReplaceDealStagesBodyDto>}, TContext> => {

const mutationKey = ['replaceDealStages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceDealStages>>, {organizationId: string;data: BodyType<ReplaceDealStagesBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  replaceDealStages(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceDealStagesMutationResult = NonNullable<Awaited<ReturnType<typeof replaceDealStages>>>
    export type ReplaceDealStagesMutationBody = BodyType<ReplaceDealStagesBodyDto>
    export type ReplaceDealStagesMutationError = ErrorType<unknown>

    export const useReplaceDealStages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceDealStages>>, TError,{organizationId: string;data: BodyType<ReplaceDealStagesBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceDealStages>>,
        TError,
        {organizationId: string;data: BodyType<ReplaceDealStagesBodyDto>},
        TContext
      > => {
      return useMutation(getReplaceDealStagesMutationOptions(options), queryClient);
    }

export type listDealStagesResponse200 = {
  data: ListDealStagesResponseDto
  status: 200
}

export type listDealStagesResponseSuccess = (listDealStagesResponse200) & {
  headers: Headers;
};
;

export type listDealStagesResponse = (listDealStagesResponseSuccess)

export const getListDealStagesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/deal-stages`
}

export const listDealStages = async (organizationId: string, options?: RequestInit): Promise<listDealStagesResponse> => {

  return axiosInstance<listDealStagesResponse>(getListDealStagesUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDealStagesQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/deal-stages`
    ] as const;
    }


export const getListDealStagesQueryOptions = <TData = Awaited<ReturnType<typeof listDealStages>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDealStagesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDealStages>>> = ({ signal }) => listDealStages(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDealStagesQueryResult = NonNullable<Awaited<ReturnType<typeof listDealStages>>>
export type ListDealStagesQueryError = ErrorType<unknown>


export function useListDealStages<TData = Awaited<ReturnType<typeof listDealStages>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDealStages>>,
          TError,
          Awaited<ReturnType<typeof listDealStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDealStages<TData = Awaited<ReturnType<typeof listDealStages>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDealStages>>,
          TError,
          Awaited<ReturnType<typeof listDealStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDealStages<TData = Awaited<ReturnType<typeof listDealStages>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListDealStages<TData = Awaited<ReturnType<typeof listDealStages>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDealStages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDealStagesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateDealStageResponse200 = {
  data: void
  status: 200
}

export type updateDealStageResponseSuccess = (updateDealStageResponse200) & {
  headers: Headers;
};
;

export type updateDealStageResponse = (updateDealStageResponseSuccess)

export const getUpdateDealStageUrl = (organizationId: string,
    dealStageId: string,) => {




  return `/organizations/${organizationId}/deal-stages/${dealStageId}`
}

export const updateDealStage = async (organizationId: string,
    dealStageId: string,
    updateDealStageBodyDto: UpdateDealStageBodyDto, options?: RequestInit): Promise<updateDealStageResponse> => {

  return axiosInstance<updateDealStageResponse>(getUpdateDealStageUrl(organizationId,dealStageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDealStageBodyDto,)
  }
);}




export const getUpdateDealStageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDealStage>>, TError,{organizationId: string;dealStageId: string;data: BodyType<UpdateDealStageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDealStage>>, TError,{organizationId: string;dealStageId: string;data: BodyType<UpdateDealStageBodyDto>}, TContext> => {

const mutationKey = ['updateDealStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDealStage>>, {organizationId: string;dealStageId: string;data: BodyType<UpdateDealStageBodyDto>}> = (props) => {
          const {organizationId,dealStageId,data} = props ?? {};

          return  updateDealStage(organizationId,dealStageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDealStageMutationResult = NonNullable<Awaited<ReturnType<typeof updateDealStage>>>
    export type UpdateDealStageMutationBody = BodyType<UpdateDealStageBodyDto>
    export type UpdateDealStageMutationError = ErrorType<unknown>

    export const useUpdateDealStage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDealStage>>, TError,{organizationId: string;dealStageId: string;data: BodyType<UpdateDealStageBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDealStage>>,
        TError,
        {organizationId: string;dealStageId: string;data: BodyType<UpdateDealStageBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateDealStageMutationOptions(options), queryClient);
    }

export type archiveDealStageResponse204 = {
  data: void
  status: 204
}

export type archiveDealStageResponseSuccess = (archiveDealStageResponse204) & {
  headers: Headers;
};
;

export type archiveDealStageResponse = (archiveDealStageResponseSuccess)

export const getArchiveDealStageUrl = (organizationId: string,
    dealStageId: string,) => {




  return `/organizations/${organizationId}/deal-stages/${dealStageId}/archive`
}

export const archiveDealStage = async (organizationId: string,
    dealStageId: string, options?: RequestInit): Promise<archiveDealStageResponse> => {

  return axiosInstance<archiveDealStageResponse>(getArchiveDealStageUrl(organizationId,dealStageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveDealStageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDealStage>>, TError,{organizationId: string;dealStageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveDealStage>>, TError,{organizationId: string;dealStageId: string}, TContext> => {

const mutationKey = ['archiveDealStage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveDealStage>>, {organizationId: string;dealStageId: string}> = (props) => {
          const {organizationId,dealStageId} = props ?? {};

          return  archiveDealStage(organizationId,dealStageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveDealStageMutationResult = NonNullable<Awaited<ReturnType<typeof archiveDealStage>>>

    export type ArchiveDealStageMutationError = ErrorType<unknown>

    export const useArchiveDealStage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveDealStage>>, TError,{organizationId: string;dealStageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveDealStage>>,
        TError,
        {organizationId: string;dealStageId: string},
        TContext
      > => {
      return useMutation(getArchiveDealStageMutationOptions(options), queryClient);
    }

export type getLeadFeedResponse200 = {
  data: GetLeadFeedResponseDto
  status: 200
}

export type getLeadFeedResponseSuccess = (getLeadFeedResponse200) & {
  headers: Headers;
};
;

export type getLeadFeedResponse = (getLeadFeedResponseSuccess)

export const getGetLeadFeedUrl = (organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/leads/${leadId}/feed?${stringifiedParams}` : `/organizations/${organizationId}/leads/${leadId}/feed`
}

export const getLeadFeed = async (organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams, options?: RequestInit): Promise<getLeadFeedResponse> => {

  return axiosInstance<getLeadFeedResponse>(getGetLeadFeedUrl(organizationId,leadId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadFeedQueryKey = (organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams,) => {
    return [
    `/organizations/${organizationId}/leads/${leadId}/feed`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeadFeedQueryOptions = <TData = Awaited<ReturnType<typeof getLeadFeed>>, TError = ErrorType<unknown>>(organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadFeedQueryKey(organizationId,leadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadFeed>>> = ({ signal }) => getLeadFeed(organizationId,leadId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && leadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadFeedQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadFeed>>>
export type GetLeadFeedQueryError = ErrorType<unknown>


export function useGetLeadFeed<TData = Awaited<ReturnType<typeof getLeadFeed>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params: undefined |  GetLeadFeedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadFeed>>,
          TError,
          Awaited<ReturnType<typeof getLeadFeed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadFeed<TData = Awaited<ReturnType<typeof getLeadFeed>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadFeed>>,
          TError,
          Awaited<ReturnType<typeof getLeadFeed>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadFeed<TData = Awaited<ReturnType<typeof getLeadFeed>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLeadFeed<TData = Awaited<ReturnType<typeof getLeadFeed>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: GetLeadFeedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFeed>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadFeedQueryOptions(organizationId,leadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type hideActivityEventResponse204 = {
  data: void
  status: 204
}

export type hideActivityEventResponseSuccess = (hideActivityEventResponse204) & {
  headers: Headers;
};
;

export type hideActivityEventResponse = (hideActivityEventResponseSuccess)

export const getHideActivityEventUrl = (organizationId: string,
    activityEventId: string,) => {




  return `/organizations/${organizationId}/activity-events/${activityEventId}/hide`
}

export const hideActivityEvent = async (organizationId: string,
    activityEventId: string, options?: RequestInit): Promise<hideActivityEventResponse> => {

  return axiosInstance<hideActivityEventResponse>(getHideActivityEventUrl(organizationId,activityEventId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideActivityEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext> => {

const mutationKey = ['hideActivityEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideActivityEvent>>, {organizationId: string;activityEventId: string}> = (props) => {
          const {organizationId,activityEventId} = props ?? {};

          return  hideActivityEvent(organizationId,activityEventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideActivityEventMutationResult = NonNullable<Awaited<ReturnType<typeof hideActivityEvent>>>

    export type HideActivityEventMutationError = ErrorType<unknown>

    export const useHideActivityEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideActivityEvent>>,
        TError,
        {organizationId: string;activityEventId: string},
        TContext
      > => {
      return useMutation(getHideActivityEventMutationOptions(options), queryClient);
    }

export type unhideActivityEventResponse204 = {
  data: void
  status: 204
}

export type unhideActivityEventResponseSuccess = (unhideActivityEventResponse204) & {
  headers: Headers;
};
;

export type unhideActivityEventResponse = (unhideActivityEventResponseSuccess)

export const getUnhideActivityEventUrl = (organizationId: string,
    activityEventId: string,) => {




  return `/organizations/${organizationId}/activity-events/${activityEventId}/unhide`
}

export const unhideActivityEvent = async (organizationId: string,
    activityEventId: string, options?: RequestInit): Promise<unhideActivityEventResponse> => {

  return axiosInstance<unhideActivityEventResponse>(getUnhideActivityEventUrl(organizationId,activityEventId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideActivityEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext> => {

const mutationKey = ['unhideActivityEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideActivityEvent>>, {organizationId: string;activityEventId: string}> = (props) => {
          const {organizationId,activityEventId} = props ?? {};

          return  unhideActivityEvent(organizationId,activityEventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideActivityEventMutationResult = NonNullable<Awaited<ReturnType<typeof unhideActivityEvent>>>

    export type UnhideActivityEventMutationError = ErrorType<unknown>

    export const useUnhideActivityEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideActivityEvent>>, TError,{organizationId: string;activityEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideActivityEvent>>,
        TError,
        {organizationId: string;activityEventId: string},
        TContext
      > => {
      return useMutation(getUnhideActivityEventMutationOptions(options), queryClient);
    }

export type createLeadContactResponse200 = {
  data: CreateLeadContactResponseDto
  status: 200
}

export type createLeadContactResponseSuccess = (createLeadContactResponse200) & {
  headers: Headers;
};
;

export type createLeadContactResponse = (createLeadContactResponseSuccess)

export const getCreateLeadContactUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/contacts`
}

export const createLeadContact = async (organizationId: string,
    leadId: string,
    createLeadContactBodyDto: CreateLeadContactBodyDto, options?: RequestInit): Promise<createLeadContactResponse> => {

  return axiosInstance<createLeadContactResponse>(getCreateLeadContactUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadContactBodyDto,)
  }
);}




export const getCreateLeadContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadContact>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeadContact>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadContactBodyDto>}, TContext> => {

const mutationKey = ['createLeadContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeadContact>>, {organizationId: string;leadId: string;data: BodyType<CreateLeadContactBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  createLeadContact(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadContactMutationResult = NonNullable<Awaited<ReturnType<typeof createLeadContact>>>
    export type CreateLeadContactMutationBody = BodyType<CreateLeadContactBodyDto>
    export type CreateLeadContactMutationError = ErrorType<unknown>

    export const useCreateLeadContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadContact>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLeadContact>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<CreateLeadContactBodyDto>},
        TContext
      > => {
      return useMutation(getCreateLeadContactMutationOptions(options), queryClient);
    }

export type linkLeadContactResponse200 = {
  data: CreateLeadContactResponseDto
  status: 200
}

export type linkLeadContactResponseSuccess = (linkLeadContactResponse200) & {
  headers: Headers;
};
;

export type linkLeadContactResponse = (linkLeadContactResponseSuccess)

export const getLinkLeadContactUrl = (organizationId: string,
    leadId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/contacts/${contactId}`
}

export const linkLeadContact = async (organizationId: string,
    leadId: string,
    contactId: string, options?: RequestInit): Promise<linkLeadContactResponse> => {

  return axiosInstance<linkLeadContactResponse>(getLinkLeadContactUrl(organizationId,leadId,contactId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLinkLeadContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext> => {

const mutationKey = ['linkLeadContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkLeadContact>>, {organizationId: string;leadId: string;contactId: string}> = (props) => {
          const {organizationId,leadId,contactId} = props ?? {};

          return  linkLeadContact(organizationId,leadId,contactId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkLeadContactMutationResult = NonNullable<Awaited<ReturnType<typeof linkLeadContact>>>

    export type LinkLeadContactMutationError = ErrorType<unknown>

    export const useLinkLeadContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkLeadContact>>,
        TError,
        {organizationId: string;leadId: string;contactId: string},
        TContext
      > => {
      return useMutation(getLinkLeadContactMutationOptions(options), queryClient);
    }

export type unlinkLeadContactResponse200 = {
  data: void
  status: 200
}

export type unlinkLeadContactResponseSuccess = (unlinkLeadContactResponse200) & {
  headers: Headers;
};
;

export type unlinkLeadContactResponse = (unlinkLeadContactResponseSuccess)

export const getUnlinkLeadContactUrl = (organizationId: string,
    leadId: string,
    contactId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/contacts/${contactId}`
}

export const unlinkLeadContact = async (organizationId: string,
    leadId: string,
    contactId: string, options?: RequestInit): Promise<unlinkLeadContactResponse> => {

  return axiosInstance<unlinkLeadContactResponse>(getUnlinkLeadContactUrl(organizationId,leadId,contactId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUnlinkLeadContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unlinkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext> => {

const mutationKey = ['unlinkLeadContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkLeadContact>>, {organizationId: string;leadId: string;contactId: string}> = (props) => {
          const {organizationId,leadId,contactId} = props ?? {};

          return  unlinkLeadContact(organizationId,leadId,contactId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkLeadContactMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkLeadContact>>>

    export type UnlinkLeadContactMutationError = ErrorType<unknown>

    export const useUnlinkLeadContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkLeadContact>>, TError,{organizationId: string;leadId: string;contactId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkLeadContact>>,
        TError,
        {organizationId: string;leadId: string;contactId: string},
        TContext
      > => {
      return useMutation(getUnlinkLeadContactMutationOptions(options), queryClient);
    }

export type createLeadResponse201 = {
  data: CreateLeadResponseDto
  status: 201
}

export type createLeadResponseSuccess = (createLeadResponse201) & {
  headers: Headers;
};
;

export type createLeadResponse = (createLeadResponseSuccess)

export const getCreateLeadUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/leads`
}

export const createLead = async (organizationId: string,
    createLeadBodyDto: CreateLeadBodyDto, options?: RequestInit): Promise<createLeadResponse> => {

  return axiosInstance<createLeadResponse>(getCreateLeadUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadBodyDto,)
  }
);}




export const getCreateLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{organizationId: string;data: BodyType<CreateLeadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{organizationId: string;data: BodyType<CreateLeadBodyDto>}, TContext> => {

const mutationKey = ['createLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLead>>, {organizationId: string;data: BodyType<CreateLeadBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createLead(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof createLead>>>
    export type CreateLeadMutationBody = BodyType<CreateLeadBodyDto>
    export type CreateLeadMutationError = ErrorType<unknown>

    export const useCreateLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLead>>, TError,{organizationId: string;data: BodyType<CreateLeadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLead>>,
        TError,
        {organizationId: string;data: BodyType<CreateLeadBodyDto>},
        TContext
      > => {
      return useMutation(getCreateLeadMutationOptions(options), queryClient);
    }

export type autocompleteLeadsResponse200 = {
  data: AutocompleteLeadsResponseDto
  status: 200
}

export type autocompleteLeadsResponseSuccess = (autocompleteLeadsResponse200) & {
  headers: Headers;
};
;

export type autocompleteLeadsResponse = (autocompleteLeadsResponseSuccess)

export const getAutocompleteLeadsUrl = (organizationId: string,
    params?: AutocompleteLeadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/leads/autocomplete?${stringifiedParams}` : `/organizations/${organizationId}/leads/autocomplete`
}

export const autocompleteLeads = async (organizationId: string,
    params?: AutocompleteLeadsParams, options?: RequestInit): Promise<autocompleteLeadsResponse> => {

  return axiosInstance<autocompleteLeadsResponse>(getAutocompleteLeadsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAutocompleteLeadsQueryKey = (organizationId: string,
    params?: AutocompleteLeadsParams,) => {
    return [
    `/organizations/${organizationId}/leads/autocomplete`, ...(params ? [params] : [])
    ] as const;
    }


export const getAutocompleteLeadsQueryOptions = <TData = Awaited<ReturnType<typeof autocompleteLeads>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: AutocompleteLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAutocompleteLeadsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof autocompleteLeads>>> = ({ signal }) => autocompleteLeads(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AutocompleteLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof autocompleteLeads>>>
export type AutocompleteLeadsQueryError = ErrorType<unknown>


export function useAutocompleteLeads<TData = Awaited<ReturnType<typeof autocompleteLeads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  AutocompleteLeadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteLeads>>,
          TError,
          Awaited<ReturnType<typeof autocompleteLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteLeads<TData = Awaited<ReturnType<typeof autocompleteLeads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: AutocompleteLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof autocompleteLeads>>,
          TError,
          Awaited<ReturnType<typeof autocompleteLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAutocompleteLeads<TData = Awaited<ReturnType<typeof autocompleteLeads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: AutocompleteLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAutocompleteLeads<TData = Awaited<ReturnType<typeof autocompleteLeads>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: AutocompleteLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof autocompleteLeads>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAutocompleteLeadsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type mergeLeadsResponse204 = {
  data: void
  status: 204
}

export type mergeLeadsResponseSuccess = (mergeLeadsResponse204) & {
  headers: Headers;
};
;

export type mergeLeadsResponse = (mergeLeadsResponseSuccess)

export const getMergeLeadsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/leads/merge`
}

export const mergeLeads = async (organizationId: string,
    mergeLeadsBodyDto: MergeLeadsBodyDto, options?: RequestInit): Promise<mergeLeadsResponse> => {

  return axiosInstance<mergeLeadsResponse>(getMergeLeadsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      mergeLeadsBodyDto,)
  }
);}




export const getMergeLeadsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeLeads>>, TError,{organizationId: string;data: BodyType<MergeLeadsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeLeads>>, TError,{organizationId: string;data: BodyType<MergeLeadsBodyDto>}, TContext> => {

const mutationKey = ['mergeLeads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeLeads>>, {organizationId: string;data: BodyType<MergeLeadsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  mergeLeads(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeLeadsMutationResult = NonNullable<Awaited<ReturnType<typeof mergeLeads>>>
    export type MergeLeadsMutationBody = BodyType<MergeLeadsBodyDto>
    export type MergeLeadsMutationError = ErrorType<unknown>

    export const useMergeLeads = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeLeads>>, TError,{organizationId: string;data: BodyType<MergeLeadsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mergeLeads>>,
        TError,
        {organizationId: string;data: BodyType<MergeLeadsBodyDto>},
        TContext
      > => {
      return useMutation(getMergeLeadsMutationOptions(options), queryClient);
    }

export type bulkArchiveLeadsResponse200 = {
  data: BulkArchiveResponseDto
  status: 200
}

export type bulkArchiveLeadsResponseSuccess = (bulkArchiveLeadsResponse200) & {
  headers: Headers;
};
;

export type bulkArchiveLeadsResponse = (bulkArchiveLeadsResponseSuccess)

export const getBulkArchiveLeadsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/leads/bulk-archive`
}

export const bulkArchiveLeads = async (organizationId: string,
    bulkArchiveLeadsBodyDto: BulkArchiveLeadsBodyDto, options?: RequestInit): Promise<bulkArchiveLeadsResponse> => {

  return axiosInstance<bulkArchiveLeadsResponse>(getBulkArchiveLeadsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkArchiveLeadsBodyDto,)
  }
);}




export const getBulkArchiveLeadsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveLeads>>, TError,{organizationId: string;data: BodyType<BulkArchiveLeadsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveLeads>>, TError,{organizationId: string;data: BodyType<BulkArchiveLeadsBodyDto>}, TContext> => {

const mutationKey = ['bulkArchiveLeads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkArchiveLeads>>, {organizationId: string;data: BodyType<BulkArchiveLeadsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkArchiveLeads(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkArchiveLeadsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkArchiveLeads>>>
    export type BulkArchiveLeadsMutationBody = BodyType<BulkArchiveLeadsBodyDto>
    export type BulkArchiveLeadsMutationError = ErrorType<unknown>

    export const useBulkArchiveLeads = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkArchiveLeads>>, TError,{organizationId: string;data: BodyType<BulkArchiveLeadsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkArchiveLeads>>,
        TError,
        {organizationId: string;data: BodyType<BulkArchiveLeadsBodyDto>},
        TContext
      > => {
      return useMutation(getBulkArchiveLeadsMutationOptions(options), queryClient);
    }

export type bulkAssignLeadOwnersResponse204 = {
  data: void
  status: 204
}

export type bulkAssignLeadOwnersResponseSuccess = (bulkAssignLeadOwnersResponse204) & {
  headers: Headers;
};
;

export type bulkAssignLeadOwnersResponse = (bulkAssignLeadOwnersResponseSuccess)

export const getBulkAssignLeadOwnersUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/leads/bulk-assign-owners`
}

export const bulkAssignLeadOwners = async (organizationId: string,
    bulkAssignLeadOwnersBodyDto: BulkAssignLeadOwnersBodyDto, options?: RequestInit): Promise<bulkAssignLeadOwnersResponse> => {

  return axiosInstance<bulkAssignLeadOwnersResponse>(getBulkAssignLeadOwnersUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkAssignLeadOwnersBodyDto,)
  }
);}




export const getBulkAssignLeadOwnersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignLeadOwners>>, TError,{organizationId: string;data: BodyType<BulkAssignLeadOwnersBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkAssignLeadOwners>>, TError,{organizationId: string;data: BodyType<BulkAssignLeadOwnersBodyDto>}, TContext> => {

const mutationKey = ['bulkAssignLeadOwners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkAssignLeadOwners>>, {organizationId: string;data: BodyType<BulkAssignLeadOwnersBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  bulkAssignLeadOwners(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkAssignLeadOwnersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkAssignLeadOwners>>>
    export type BulkAssignLeadOwnersMutationBody = BodyType<BulkAssignLeadOwnersBodyDto>
    export type BulkAssignLeadOwnersMutationError = ErrorType<unknown>

    export const useBulkAssignLeadOwners = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkAssignLeadOwners>>, TError,{organizationId: string;data: BodyType<BulkAssignLeadOwnersBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkAssignLeadOwners>>,
        TError,
        {organizationId: string;data: BodyType<BulkAssignLeadOwnersBodyDto>},
        TContext
      > => {
      return useMutation(getBulkAssignLeadOwnersMutationOptions(options), queryClient);
    }

export type updateLeadOwnersResponse204 = {
  data: void
  status: 204
}

export type updateLeadOwnersResponseSuccess = (updateLeadOwnersResponse204) & {
  headers: Headers;
};
;

export type updateLeadOwnersResponse = (updateLeadOwnersResponseSuccess)

export const getUpdateLeadOwnersUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/owners`
}

export const updateLeadOwners = async (organizationId: string,
    leadId: string,
    updateLeadOwnersBodyDto: UpdateLeadOwnersBodyDto, options?: RequestInit): Promise<updateLeadOwnersResponse> => {

  return axiosInstance<updateLeadOwnersResponse>(getUpdateLeadOwnersUrl(organizationId,leadId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadOwnersBodyDto,)
  }
);}




export const getUpdateLeadOwnersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadOwners>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadOwnersBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeadOwners>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadOwnersBodyDto>}, TContext> => {

const mutationKey = ['updateLeadOwners'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeadOwners>>, {organizationId: string;leadId: string;data: BodyType<UpdateLeadOwnersBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  updateLeadOwners(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadOwnersMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeadOwners>>>
    export type UpdateLeadOwnersMutationBody = BodyType<UpdateLeadOwnersBodyDto>
    export type UpdateLeadOwnersMutationError = ErrorType<unknown>

    export const useUpdateLeadOwners = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadOwners>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadOwnersBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLeadOwners>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<UpdateLeadOwnersBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateLeadOwnersMutationOptions(options), queryClient);
    }

export type setLeadPrimaryContactResponse204 = {
  data: void
  status: 204
}

export type setLeadPrimaryContactResponseSuccess = (setLeadPrimaryContactResponse204) & {
  headers: Headers;
};
;

export type setLeadPrimaryContactResponse = (setLeadPrimaryContactResponseSuccess)

export const getSetLeadPrimaryContactUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/primary-contact`
}

export const setLeadPrimaryContact = async (organizationId: string,
    leadId: string,
    setLeadPrimaryContactBodyDto: SetLeadPrimaryContactBodyDto, options?: RequestInit): Promise<setLeadPrimaryContactResponse> => {

  return axiosInstance<setLeadPrimaryContactResponse>(getSetLeadPrimaryContactUrl(organizationId,leadId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setLeadPrimaryContactBodyDto,)
  }
);}




export const getSetLeadPrimaryContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeadPrimaryContact>>, TError,{organizationId: string;leadId: string;data: BodyType<SetLeadPrimaryContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setLeadPrimaryContact>>, TError,{organizationId: string;leadId: string;data: BodyType<SetLeadPrimaryContactBodyDto>}, TContext> => {

const mutationKey = ['setLeadPrimaryContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLeadPrimaryContact>>, {organizationId: string;leadId: string;data: BodyType<SetLeadPrimaryContactBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  setLeadPrimaryContact(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLeadPrimaryContactMutationResult = NonNullable<Awaited<ReturnType<typeof setLeadPrimaryContact>>>
    export type SetLeadPrimaryContactMutationBody = BodyType<SetLeadPrimaryContactBodyDto>
    export type SetLeadPrimaryContactMutationError = ErrorType<unknown>

    export const useSetLeadPrimaryContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLeadPrimaryContact>>, TError,{organizationId: string;leadId: string;data: BodyType<SetLeadPrimaryContactBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLeadPrimaryContact>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<SetLeadPrimaryContactBodyDto>},
        TContext
      > => {
      return useMutation(getSetLeadPrimaryContactMutationOptions(options), queryClient);
    }

export type getLeadResponse200 = {
  data: GetLeadResponseDto
  status: 200
}

export type getLeadResponseSuccess = (getLeadResponse200) & {
  headers: Headers;
};
;

export type getLeadResponse = (getLeadResponseSuccess)

export const getGetLeadUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}`
}

export const getLead = async (organizationId: string,
    leadId: string, options?: RequestInit): Promise<getLeadResponse> => {

  return axiosInstance<getLeadResponse>(getGetLeadUrl(organizationId,leadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadQueryKey = (organizationId: string,
    leadId: string,) => {
    return [
    `/organizations/${organizationId}/leads/${leadId}`
    ] as const;
    }


export const getGetLeadQueryOptions = <TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(organizationId: string,
    leadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadQueryKey(organizationId,leadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLead>>> = ({ signal }) => getLead(organizationId,leadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && leadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadQueryResult = NonNullable<Awaited<ReturnType<typeof getLead>>>
export type GetLeadQueryError = ErrorType<unknown>


export function useGetLead<TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLead>>,
          TError,
          Awaited<ReturnType<typeof getLead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLead<TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLead>>,
          TError,
          Awaited<ReturnType<typeof getLead>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLead<TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLead<TData = Awaited<ReturnType<typeof getLead>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLead>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadQueryOptions(organizationId,leadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateLeadResponse200 = {
  data: void
  status: 200
}

export type updateLeadResponseSuccess = (updateLeadResponse200) & {
  headers: Headers;
};
;

export type updateLeadResponse = (updateLeadResponseSuccess)

export const getUpdateLeadUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}`
}

export const updateLead = async (organizationId: string,
    leadId: string,
    updateLeadBodyDto: UpdateLeadBodyDto, options?: RequestInit): Promise<updateLeadResponse> => {

  return axiosInstance<updateLeadResponse>(getUpdateLeadUrl(organizationId,leadId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadBodyDto,)
  }
);}




export const getUpdateLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadBodyDto>}, TContext> => {

const mutationKey = ['updateLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLead>>, {organizationId: string;leadId: string;data: BodyType<UpdateLeadBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  updateLead(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadMutationResult = NonNullable<Awaited<ReturnType<typeof updateLead>>>
    export type UpdateLeadMutationBody = BodyType<UpdateLeadBodyDto>
    export type UpdateLeadMutationError = ErrorType<unknown>

    export const useUpdateLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLead>>, TError,{organizationId: string;leadId: string;data: BodyType<UpdateLeadBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLead>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<UpdateLeadBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateLeadMutationOptions(options), queryClient);
    }

export type archiveLeadResponse204 = {
  data: void
  status: 204
}

export type archiveLeadResponseSuccess = (archiveLeadResponse204) & {
  headers: Headers;
};
;

export type archiveLeadResponse = (archiveLeadResponseSuccess)

export const getArchiveLeadUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/archive`
}

export const archiveLead = async (organizationId: string,
    leadId: string, options?: RequestInit): Promise<archiveLeadResponse> => {

  return axiosInstance<archiveLeadResponse>(getArchiveLeadUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveLead>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveLead>>, TError,{organizationId: string;leadId: string}, TContext> => {

const mutationKey = ['archiveLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveLead>>, {organizationId: string;leadId: string}> = (props) => {
          const {organizationId,leadId} = props ?? {};

          return  archiveLead(organizationId,leadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveLeadMutationResult = NonNullable<Awaited<ReturnType<typeof archiveLead>>>

    export type ArchiveLeadMutationError = ErrorType<unknown>

    export const useArchiveLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveLead>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveLead>>,
        TError,
        {organizationId: string;leadId: string},
        TContext
      > => {
      return useMutation(getArchiveLeadMutationOptions(options), queryClient);
    }

export type restoreLeadResponse204 = {
  data: void
  status: 204
}

export type restoreLeadResponseSuccess = (restoreLeadResponse204) & {
  headers: Headers;
};
;

export type restoreLeadResponse = (restoreLeadResponseSuccess)

export const getRestoreLeadUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/restore`
}

export const restoreLead = async (organizationId: string,
    leadId: string, options?: RequestInit): Promise<restoreLeadResponse> => {

  return axiosInstance<restoreLeadResponse>(getRestoreLeadUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreLeadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreLead>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreLead>>, TError,{organizationId: string;leadId: string}, TContext> => {

const mutationKey = ['restoreLead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreLead>>, {organizationId: string;leadId: string}> = (props) => {
          const {organizationId,leadId} = props ?? {};

          return  restoreLead(organizationId,leadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreLeadMutationResult = NonNullable<Awaited<ReturnType<typeof restoreLead>>>

    export type RestoreLeadMutationError = ErrorType<unknown>

    export const useRestoreLead = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreLead>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreLead>>,
        TError,
        {organizationId: string;leadId: string},
        TContext
      > => {
      return useMutation(getRestoreLeadMutationOptions(options), queryClient);
    }

export type createLeadWebsiteResponse201 = {
  data: void
  status: 201
}

export type createLeadWebsiteResponseSuccess = (createLeadWebsiteResponse201) & {
  headers: Headers;
};
;

export type createLeadWebsiteResponse = (createLeadWebsiteResponseSuccess)

export const getCreateLeadWebsiteUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/websites`
}

export const createLeadWebsite = async (organizationId: string,
    leadId: string,
    createLeadWebsiteBodyDto: CreateLeadWebsiteBodyDto, options?: RequestInit): Promise<createLeadWebsiteResponse> => {

  return axiosInstance<createLeadWebsiteResponse>(getCreateLeadWebsiteUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadWebsiteBodyDto,)
  }
);}




export const getCreateLeadWebsiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadWebsite>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeadWebsite>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext> => {

const mutationKey = ['createLeadWebsite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeadWebsite>>, {organizationId: string;leadId: string;data: BodyType<CreateLeadWebsiteBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  createLeadWebsite(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadWebsiteMutationResult = NonNullable<Awaited<ReturnType<typeof createLeadWebsite>>>
    export type CreateLeadWebsiteMutationBody = BodyType<CreateLeadWebsiteBodyDto>
    export type CreateLeadWebsiteMutationError = ErrorType<unknown>

    export const useCreateLeadWebsite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadWebsite>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLeadWebsite>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<CreateLeadWebsiteBodyDto>},
        TContext
      > => {
      return useMutation(getCreateLeadWebsiteMutationOptions(options), queryClient);
    }

export type updateLeadWebsiteResponse200 = {
  data: void
  status: 200
}

export type updateLeadWebsiteResponseSuccess = (updateLeadWebsiteResponse200) & {
  headers: Headers;
};
;

export type updateLeadWebsiteResponse = (updateLeadWebsiteResponseSuccess)

export const getUpdateLeadWebsiteUrl = (organizationId: string,
    leadId: string,
    leadWebsiteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/websites/${leadWebsiteId}`
}

export const updateLeadWebsite = async (organizationId: string,
    leadId: string,
    leadWebsiteId: string,
    createLeadWebsiteBodyDto: CreateLeadWebsiteBodyDto, options?: RequestInit): Promise<updateLeadWebsiteResponse> => {

  return axiosInstance<updateLeadWebsiteResponse>(getUpdateLeadWebsiteUrl(organizationId,leadId,leadWebsiteId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadWebsiteBodyDto,)
  }
);}




export const getUpdateLeadWebsiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext> => {

const mutationKey = ['updateLeadWebsite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeadWebsite>>, {organizationId: string;leadId: string;leadWebsiteId: string;data: BodyType<CreateLeadWebsiteBodyDto>}> = (props) => {
          const {organizationId,leadId,leadWebsiteId,data} = props ?? {};

          return  updateLeadWebsite(organizationId,leadId,leadWebsiteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadWebsiteMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeadWebsite>>>
    export type UpdateLeadWebsiteMutationBody = BodyType<CreateLeadWebsiteBodyDto>
    export type UpdateLeadWebsiteMutationError = ErrorType<unknown>

    export const useUpdateLeadWebsite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string;data: BodyType<CreateLeadWebsiteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLeadWebsite>>,
        TError,
        {organizationId: string;leadId: string;leadWebsiteId: string;data: BodyType<CreateLeadWebsiteBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateLeadWebsiteMutationOptions(options), queryClient);
    }

export type deleteLeadWebsiteResponse200 = {
  data: void
  status: 200
}

export type deleteLeadWebsiteResponseSuccess = (deleteLeadWebsiteResponse200) & {
  headers: Headers;
};
;

export type deleteLeadWebsiteResponse = (deleteLeadWebsiteResponseSuccess)

export const getDeleteLeadWebsiteUrl = (organizationId: string,
    leadId: string,
    leadWebsiteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/websites/${leadWebsiteId}`
}

export const deleteLeadWebsite = async (organizationId: string,
    leadId: string,
    leadWebsiteId: string, options?: RequestInit): Promise<deleteLeadWebsiteResponse> => {

  return axiosInstance<deleteLeadWebsiteResponse>(getDeleteLeadWebsiteUrl(organizationId,leadId,leadWebsiteId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLeadWebsiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string}, TContext> => {

const mutationKey = ['deleteLeadWebsite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeadWebsite>>, {organizationId: string;leadId: string;leadWebsiteId: string}> = (props) => {
          const {organizationId,leadId,leadWebsiteId} = props ?? {};

          return  deleteLeadWebsite(organizationId,leadId,leadWebsiteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeadWebsiteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeadWebsite>>>

    export type DeleteLeadWebsiteMutationError = ErrorType<unknown>

    export const useDeleteLeadWebsite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadWebsite>>, TError,{organizationId: string;leadId: string;leadWebsiteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeadWebsite>>,
        TError,
        {organizationId: string;leadId: string;leadWebsiteId: string},
        TContext
      > => {
      return useMutation(getDeleteLeadWebsiteMutationOptions(options), queryClient);
    }

export type createLeadCustomFieldResponse201 = {
  data: void
  status: 201
}

export type createLeadCustomFieldResponseSuccess = (createLeadCustomFieldResponse201) & {
  headers: Headers;
};
;

export type createLeadCustomFieldResponse = (createLeadCustomFieldResponseSuccess)

export const getCreateLeadCustomFieldUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/custom-field`
}

export const createLeadCustomField = async (organizationId: string,
    leadId: string,
    createLeadCustomFieldBodyDto: CreateLeadCustomFieldBodyDto, options?: RequestInit): Promise<createLeadCustomFieldResponse> => {

  return axiosInstance<createLeadCustomFieldResponse>(getCreateLeadCustomFieldUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadCustomFieldBodyDto,)
  }
);}




export const getCreateLeadCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadCustomField>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeadCustomField>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadCustomFieldBodyDto>}, TContext> => {

const mutationKey = ['createLeadCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeadCustomField>>, {organizationId: string;leadId: string;data: BodyType<CreateLeadCustomFieldBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  createLeadCustomField(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof createLeadCustomField>>>
    export type CreateLeadCustomFieldMutationBody = BodyType<CreateLeadCustomFieldBodyDto>
    export type CreateLeadCustomFieldMutationError = ErrorType<unknown>

    export const useCreateLeadCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadCustomField>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadCustomFieldBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLeadCustomField>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<CreateLeadCustomFieldBodyDto>},
        TContext
      > => {
      return useMutation(getCreateLeadCustomFieldMutationOptions(options), queryClient);
    }

export type updateLeadCustomFieldResponse200 = {
  data: void
  status: 200
}

export type updateLeadCustomFieldResponseSuccess = (updateLeadCustomFieldResponse200) & {
  headers: Headers;
};
;

export type updateLeadCustomFieldResponse = (updateLeadCustomFieldResponseSuccess)

export const getUpdateLeadCustomFieldUrl = (organizationId: string,
    leadId: string,
    leadCustomFieldId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/custom-field/${leadCustomFieldId}`
}

export const updateLeadCustomField = async (organizationId: string,
    leadId: string,
    leadCustomFieldId: string,
    updateLeadCustomFieldValueBodyDto: UpdateLeadCustomFieldValueBodyDto, options?: RequestInit): Promise<updateLeadCustomFieldResponse> => {

  return axiosInstance<updateLeadCustomFieldResponse>(getUpdateLeadCustomFieldUrl(organizationId,leadId,leadCustomFieldId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadCustomFieldValueBodyDto,)
  }
);}




export const getUpdateLeadCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string;data: BodyType<UpdateLeadCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string;data: BodyType<UpdateLeadCustomFieldValueBodyDto>}, TContext> => {

const mutationKey = ['updateLeadCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeadCustomField>>, {organizationId: string;leadId: string;leadCustomFieldId: string;data: BodyType<UpdateLeadCustomFieldValueBodyDto>}> = (props) => {
          const {organizationId,leadId,leadCustomFieldId,data} = props ?? {};

          return  updateLeadCustomField(organizationId,leadId,leadCustomFieldId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeadCustomField>>>
    export type UpdateLeadCustomFieldMutationBody = BodyType<UpdateLeadCustomFieldValueBodyDto>
    export type UpdateLeadCustomFieldMutationError = ErrorType<unknown>

    export const useUpdateLeadCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string;data: BodyType<UpdateLeadCustomFieldValueBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLeadCustomField>>,
        TError,
        {organizationId: string;leadId: string;leadCustomFieldId: string;data: BodyType<UpdateLeadCustomFieldValueBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateLeadCustomFieldMutationOptions(options), queryClient);
    }

export type deleteLeadCustomFieldResponse200 = {
  data: void
  status: 200
}

export type deleteLeadCustomFieldResponseSuccess = (deleteLeadCustomFieldResponse200) & {
  headers: Headers;
};
;

export type deleteLeadCustomFieldResponse = (deleteLeadCustomFieldResponseSuccess)

export const getDeleteLeadCustomFieldUrl = (organizationId: string,
    leadId: string,
    leadCustomFieldId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/custom-field/${leadCustomFieldId}`
}

export const deleteLeadCustomField = async (organizationId: string,
    leadId: string,
    leadCustomFieldId: string, options?: RequestInit): Promise<deleteLeadCustomFieldResponse> => {

  return axiosInstance<deleteLeadCustomFieldResponse>(getDeleteLeadCustomFieldUrl(organizationId,leadId,leadCustomFieldId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLeadCustomFieldMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string}, TContext> => {

const mutationKey = ['deleteLeadCustomField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeadCustomField>>, {organizationId: string;leadId: string;leadCustomFieldId: string}> = (props) => {
          const {organizationId,leadId,leadCustomFieldId} = props ?? {};

          return  deleteLeadCustomField(organizationId,leadId,leadCustomFieldId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeadCustomFieldMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeadCustomField>>>

    export type DeleteLeadCustomFieldMutationError = ErrorType<unknown>

    export const useDeleteLeadCustomField = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadCustomField>>, TError,{organizationId: string;leadId: string;leadCustomFieldId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeadCustomField>>,
        TError,
        {organizationId: string;leadId: string;leadCustomFieldId: string},
        TContext
      > => {
      return useMutation(getDeleteLeadCustomFieldMutationOptions(options), queryClient);
    }

export type uploadLeadFileResponse201 = {
  data: UploadLeadFileResponseDto
  status: 201
}

export type uploadLeadFileResponseSuccess = (uploadLeadFileResponse201) & {
  headers: Headers;
};
;

export type uploadLeadFileResponse = (uploadLeadFileResponseSuccess)

export const getUploadLeadFileUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/files`
}

export const uploadLeadFile = async (organizationId: string,
    leadId: string, options?: RequestInit): Promise<uploadLeadFileResponse> => {

  return axiosInstance<uploadLeadFileResponse>(getUploadLeadFileUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUploadLeadFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLeadFile>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadLeadFile>>, TError,{organizationId: string;leadId: string}, TContext> => {

const mutationKey = ['uploadLeadFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadLeadFile>>, {organizationId: string;leadId: string}> = (props) => {
          const {organizationId,leadId} = props ?? {};

          return  uploadLeadFile(organizationId,leadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadLeadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadLeadFile>>>

    export type UploadLeadFileMutationError = ErrorType<unknown>

    export const useUploadLeadFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadLeadFile>>, TError,{organizationId: string;leadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadLeadFile>>,
        TError,
        {organizationId: string;leadId: string},
        TContext
      > => {
      return useMutation(getUploadLeadFileMutationOptions(options), queryClient);
    }

export type listLeadFilesResponse200 = {
  data: ListLeadFilesResponseDto
  status: 200
}

export type listLeadFilesResponseSuccess = (listLeadFilesResponse200) & {
  headers: Headers;
};
;

export type listLeadFilesResponse = (listLeadFilesResponseSuccess)

export const getListLeadFilesUrl = (organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/leads/${leadId}/files?${stringifiedParams}` : `/organizations/${organizationId}/leads/${leadId}/files`
}

export const listLeadFiles = async (organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams, options?: RequestInit): Promise<listLeadFilesResponse> => {

  return axiosInstance<listLeadFilesResponse>(getListLeadFilesUrl(organizationId,leadId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLeadFilesQueryKey = (organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams,) => {
    return [
    `/organizations/${organizationId}/leads/${leadId}/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLeadFilesQueryOptions = <TData = Awaited<ReturnType<typeof listLeadFiles>>, TError = ErrorType<unknown>>(organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLeadFilesQueryKey(organizationId,leadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeadFiles>>> = ({ signal }) => listLeadFiles(organizationId,leadId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && leadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLeadFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listLeadFiles>>>
export type ListLeadFilesQueryError = ErrorType<unknown>


export function useListLeadFiles<TData = Awaited<ReturnType<typeof listLeadFiles>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params: undefined |  ListLeadFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadFiles>>,
          TError,
          Awaited<ReturnType<typeof listLeadFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeadFiles<TData = Awaited<ReturnType<typeof listLeadFiles>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLeadFiles>>,
          TError,
          Awaited<ReturnType<typeof listLeadFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLeadFiles<TData = Awaited<ReturnType<typeof listLeadFiles>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLeadFiles<TData = Awaited<ReturnType<typeof listLeadFiles>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    params?: ListLeadFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLeadFiles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLeadFilesQueryOptions(organizationId,leadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getLeadFileDownloadUrlResponse200 = {
  data: GetLeadFileDownloadUrlResponseDto
  status: 200
}

export type getLeadFileDownloadUrlResponseSuccess = (getLeadFileDownloadUrlResponse200) & {
  headers: Headers;
};
;

export type getLeadFileDownloadUrlResponse = (getLeadFileDownloadUrlResponseSuccess)

export const getGetLeadFileDownloadUrlUrl = (organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/leads/${leadId}/files/${leadFileId}/download?${stringifiedParams}` : `/organizations/${organizationId}/leads/${leadId}/files/${leadFileId}/download`
}

export const getLeadFileDownloadUrl = async (organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams, options?: RequestInit): Promise<getLeadFileDownloadUrlResponse> => {

  return axiosInstance<getLeadFileDownloadUrlResponse>(getGetLeadFileDownloadUrlUrl(organizationId,leadId,leadFileId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeadFileDownloadUrlQueryKey = (organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams,) => {
    return [
    `/organizations/${organizationId}/leads/${leadId}/files/${leadFileId}/download`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeadFileDownloadUrlQueryOptions = <TData = Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError = ErrorType<unknown>>(organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeadFileDownloadUrlQueryKey(organizationId,leadId,leadFileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>> = ({ signal }) => getLeadFileDownloadUrl(organizationId,leadId,leadFileId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && leadId && leadFileId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeadFileDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>>
export type GetLeadFileDownloadUrlQueryError = ErrorType<unknown>


export function useGetLeadFileDownloadUrl<TData = Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    leadFileId: string,
    params: undefined |  GetLeadFileDownloadUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadFileDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getLeadFileDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadFileDownloadUrl<TData = Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeadFileDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getLeadFileDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeadFileDownloadUrl<TData = Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLeadFileDownloadUrl<TData = Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError = ErrorType<unknown>>(
 organizationId: string,
    leadId: string,
    leadFileId: string,
    params?: GetLeadFileDownloadUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeadFileDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeadFileDownloadUrlQueryOptions(organizationId,leadId,leadFileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type deleteLeadFileResponse204 = {
  data: void
  status: 204
}

export type deleteLeadFileResponseSuccess = (deleteLeadFileResponse204) & {
  headers: Headers;
};
;

export type deleteLeadFileResponse = (deleteLeadFileResponseSuccess)

export const getDeleteLeadFileUrl = (organizationId: string,
    leadId: string,
    leadFileId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/files/${leadFileId}`
}

export const deleteLeadFile = async (organizationId: string,
    leadId: string,
    leadFileId: string, options?: RequestInit): Promise<deleteLeadFileResponse> => {

  return axiosInstance<deleteLeadFileResponse>(getDeleteLeadFileUrl(organizationId,leadId,leadFileId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLeadFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadFile>>, TError,{organizationId: string;leadId: string;leadFileId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeadFile>>, TError,{organizationId: string;leadId: string;leadFileId: string}, TContext> => {

const mutationKey = ['deleteLeadFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeadFile>>, {organizationId: string;leadId: string;leadFileId: string}> = (props) => {
          const {organizationId,leadId,leadFileId} = props ?? {};

          return  deleteLeadFile(organizationId,leadId,leadFileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeadFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeadFile>>>

    export type DeleteLeadFileMutationError = ErrorType<unknown>

    export const useDeleteLeadFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadFile>>, TError,{organizationId: string;leadId: string;leadFileId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeadFile>>,
        TError,
        {organizationId: string;leadId: string;leadFileId: string},
        TContext
      > => {
      return useMutation(getDeleteLeadFileMutationOptions(options), queryClient);
    }

export type createLeadNoteResponse200 = {
  data: LeadNoteResponseDto
  status: 200
}

export type createLeadNoteResponseSuccess = (createLeadNoteResponse200) & {
  headers: Headers;
};
;

export type createLeadNoteResponse = (createLeadNoteResponseSuccess)

export const getCreateLeadNoteUrl = (organizationId: string,
    leadId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/notes`
}

export const createLeadNote = async (organizationId: string,
    leadId: string,
    createLeadNoteBodyDto: CreateLeadNoteBodyDto, options?: RequestInit): Promise<createLeadNoteResponse> => {

  return axiosInstance<createLeadNoteResponse>(getCreateLeadNoteUrl(organizationId,leadId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createLeadNoteBodyDto,)
  }
);}




export const getCreateLeadNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadNote>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadNoteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createLeadNote>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadNoteBodyDto>}, TContext> => {

const mutationKey = ['createLeadNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLeadNote>>, {organizationId: string;leadId: string;data: BodyType<CreateLeadNoteBodyDto>}> = (props) => {
          const {organizationId,leadId,data} = props ?? {};

          return  createLeadNote(organizationId,leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof createLeadNote>>>
    export type CreateLeadNoteMutationBody = BodyType<CreateLeadNoteBodyDto>
    export type CreateLeadNoteMutationError = ErrorType<unknown>

    export const useCreateLeadNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLeadNote>>, TError,{organizationId: string;leadId: string;data: BodyType<CreateLeadNoteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLeadNote>>,
        TError,
        {organizationId: string;leadId: string;data: BodyType<CreateLeadNoteBodyDto>},
        TContext
      > => {
      return useMutation(getCreateLeadNoteMutationOptions(options), queryClient);
    }

export type updateLeadNoteResponse200 = {
  data: LeadNoteResponseDto
  status: 200
}

export type updateLeadNoteResponseSuccess = (updateLeadNoteResponse200) & {
  headers: Headers;
};
;

export type updateLeadNoteResponse = (updateLeadNoteResponseSuccess)

export const getUpdateLeadNoteUrl = (organizationId: string,
    leadId: string,
    leadNoteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/notes/${leadNoteId}`
}

export const updateLeadNote = async (organizationId: string,
    leadId: string,
    leadNoteId: string,
    updateLeadNoteBodyDto: UpdateLeadNoteBodyDto, options?: RequestInit): Promise<updateLeadNoteResponse> => {

  return axiosInstance<updateLeadNoteResponse>(getUpdateLeadNoteUrl(organizationId,leadId,leadNoteId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateLeadNoteBodyDto,)
  }
);}




export const getUpdateLeadNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string;data: BodyType<UpdateLeadNoteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string;data: BodyType<UpdateLeadNoteBodyDto>}, TContext> => {

const mutationKey = ['updateLeadNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLeadNote>>, {organizationId: string;leadId: string;leadNoteId: string;data: BodyType<UpdateLeadNoteBodyDto>}> = (props) => {
          const {organizationId,leadId,leadNoteId,data} = props ?? {};

          return  updateLeadNote(organizationId,leadId,leadNoteId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateLeadNote>>>
    export type UpdateLeadNoteMutationBody = BodyType<UpdateLeadNoteBodyDto>
    export type UpdateLeadNoteMutationError = ErrorType<unknown>

    export const useUpdateLeadNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string;data: BodyType<UpdateLeadNoteBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLeadNote>>,
        TError,
        {organizationId: string;leadId: string;leadNoteId: string;data: BodyType<UpdateLeadNoteBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateLeadNoteMutationOptions(options), queryClient);
    }

export type deleteLeadNoteResponse204 = {
  data: void
  status: 204
}

export type deleteLeadNoteResponseSuccess = (deleteLeadNoteResponse204) & {
  headers: Headers;
};
;

export type deleteLeadNoteResponse = (deleteLeadNoteResponseSuccess)

export const getDeleteLeadNoteUrl = (organizationId: string,
    leadId: string,
    leadNoteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/notes/${leadNoteId}`
}

export const deleteLeadNote = async (organizationId: string,
    leadId: string,
    leadNoteId: string, options?: RequestInit): Promise<deleteLeadNoteResponse> => {

  return axiosInstance<deleteLeadNoteResponse>(getDeleteLeadNoteUrl(organizationId,leadId,leadNoteId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLeadNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext> => {

const mutationKey = ['deleteLeadNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLeadNote>>, {organizationId: string;leadId: string;leadNoteId: string}> = (props) => {
          const {organizationId,leadId,leadNoteId} = props ?? {};

          return  deleteLeadNote(organizationId,leadId,leadNoteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLeadNote>>>

    export type DeleteLeadNoteMutationError = ErrorType<unknown>

    export const useDeleteLeadNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLeadNote>>,
        TError,
        {organizationId: string;leadId: string;leadNoteId: string},
        TContext
      > => {
      return useMutation(getDeleteLeadNoteMutationOptions(options), queryClient);
    }

export type hideLeadNoteResponse204 = {
  data: void
  status: 204
}

export type hideLeadNoteResponseSuccess = (hideLeadNoteResponse204) & {
  headers: Headers;
};
;

export type hideLeadNoteResponse = (hideLeadNoteResponseSuccess)

export const getHideLeadNoteUrl = (organizationId: string,
    leadId: string,
    leadNoteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/notes/${leadNoteId}/hide`
}

export const hideLeadNote = async (organizationId: string,
    leadId: string,
    leadNoteId: string, options?: RequestInit): Promise<hideLeadNoteResponse> => {

  return axiosInstance<hideLeadNoteResponse>(getHideLeadNoteUrl(organizationId,leadId,leadNoteId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideLeadNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext> => {

const mutationKey = ['hideLeadNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideLeadNote>>, {organizationId: string;leadId: string;leadNoteId: string}> = (props) => {
          const {organizationId,leadId,leadNoteId} = props ?? {};

          return  hideLeadNote(organizationId,leadId,leadNoteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof hideLeadNote>>>

    export type HideLeadNoteMutationError = ErrorType<unknown>

    export const useHideLeadNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideLeadNote>>,
        TError,
        {organizationId: string;leadId: string;leadNoteId: string},
        TContext
      > => {
      return useMutation(getHideLeadNoteMutationOptions(options), queryClient);
    }

export type unhideLeadNoteResponse204 = {
  data: void
  status: 204
}

export type unhideLeadNoteResponseSuccess = (unhideLeadNoteResponse204) & {
  headers: Headers;
};
;

export type unhideLeadNoteResponse = (unhideLeadNoteResponseSuccess)

export const getUnhideLeadNoteUrl = (organizationId: string,
    leadId: string,
    leadNoteId: string,) => {




  return `/organizations/${organizationId}/leads/${leadId}/notes/${leadNoteId}/unhide`
}

export const unhideLeadNote = async (organizationId: string,
    leadId: string,
    leadNoteId: string, options?: RequestInit): Promise<unhideLeadNoteResponse> => {

  return axiosInstance<unhideLeadNoteResponse>(getUnhideLeadNoteUrl(organizationId,leadId,leadNoteId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideLeadNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext> => {

const mutationKey = ['unhideLeadNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideLeadNote>>, {organizationId: string;leadId: string;leadNoteId: string}> = (props) => {
          const {organizationId,leadId,leadNoteId} = props ?? {};

          return  unhideLeadNote(organizationId,leadId,leadNoteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideLeadNoteMutationResult = NonNullable<Awaited<ReturnType<typeof unhideLeadNote>>>

    export type UnhideLeadNoteMutationError = ErrorType<unknown>

    export const useUnhideLeadNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideLeadNote>>, TError,{organizationId: string;leadId: string;leadNoteId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideLeadNote>>,
        TError,
        {organizationId: string;leadId: string;leadNoteId: string},
        TContext
      > => {
      return useMutation(getUnhideLeadNoteMutationOptions(options), queryClient);
    }

export type listConnectionsResponse200 = {
  data: ListConnectionsResponseDto
  status: 200
}

export type listConnectionsResponseSuccess = (listConnectionsResponse200) & {
  headers: Headers;
};
;

export type listConnectionsResponse = (listConnectionsResponseSuccess)

export const getListConnectionsUrl = (organizationId: string,
    params?: ListConnectionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/connections?${stringifiedParams}` : `/organizations/${organizationId}/connections`
}

export const listConnections = async (organizationId: string,
    params?: ListConnectionsParams, options?: RequestInit): Promise<listConnectionsResponse> => {

  return axiosInstance<listConnectionsResponse>(getListConnectionsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConnectionsQueryKey = (organizationId: string,
    params?: ListConnectionsParams,) => {
    return [
    `/organizations/${organizationId}/connections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectionsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnections>>> = ({ signal }) => listConnections(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnections>>>
export type ListConnectionsQueryError = ErrorType<unknown>


export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListConnectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnections>>,
          TError,
          Awaited<ReturnType<typeof listConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListConnections<TData = Awaited<ReturnType<typeof listConnections>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListConnectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnections>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConnectionsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSendingMailboxesResponse200 = {
  data: ListSendingMailboxesResponseDto
  status: 200
}

export type listSendingMailboxesResponseSuccess = (listSendingMailboxesResponse200) & {
  headers: Headers;
};
;

export type listSendingMailboxesResponse = (listSendingMailboxesResponseSuccess)

export const getListSendingMailboxesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/senders`
}

export const listSendingMailboxes = async (organizationId: string, options?: RequestInit): Promise<listSendingMailboxesResponse> => {

  return axiosInstance<listSendingMailboxesResponse>(getListSendingMailboxesUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSendingMailboxesQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/connections/senders`
    ] as const;
    }


export const getListSendingMailboxesQueryOptions = <TData = Awaited<ReturnType<typeof listSendingMailboxes>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSendingMailboxesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSendingMailboxes>>> = ({ signal }) => listSendingMailboxes(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSendingMailboxesQueryResult = NonNullable<Awaited<ReturnType<typeof listSendingMailboxes>>>
export type ListSendingMailboxesQueryError = ErrorType<unknown>


export function useListSendingMailboxes<TData = Awaited<ReturnType<typeof listSendingMailboxes>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSendingMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listSendingMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSendingMailboxes<TData = Awaited<ReturnType<typeof listSendingMailboxes>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSendingMailboxes>>,
          TError,
          Awaited<ReturnType<typeof listSendingMailboxes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSendingMailboxes<TData = Awaited<ReturnType<typeof listSendingMailboxes>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSendingMailboxes<TData = Awaited<ReturnType<typeof listSendingMailboxes>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSendingMailboxes>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSendingMailboxesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type authorizeGoogleConnectionResponse200 = {
  data: AuthorizeGoogleConnectionResponseDto
  status: 200
}

export type authorizeGoogleConnectionResponseSuccess = (authorizeGoogleConnectionResponse200) & {
  headers: Headers;
};
;

export type authorizeGoogleConnectionResponse = (authorizeGoogleConnectionResponseSuccess)

export const getAuthorizeGoogleConnectionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/google/authorize`
}

export const authorizeGoogleConnection = async (organizationId: string, options?: RequestInit): Promise<authorizeGoogleConnectionResponse> => {

  return axiosInstance<authorizeGoogleConnectionResponse>(getAuthorizeGoogleConnectionUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAuthorizeGoogleConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeGoogleConnection>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authorizeGoogleConnection>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['authorizeGoogleConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorizeGoogleConnection>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  authorizeGoogleConnection(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorizeGoogleConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof authorizeGoogleConnection>>>

    export type AuthorizeGoogleConnectionMutationError = ErrorType<unknown>

    export const useAuthorizeGoogleConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeGoogleConnection>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authorizeGoogleConnection>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getAuthorizeGoogleConnectionMutationOptions(options), queryClient);
    }

export type createGoogleConnectionResponse201 = {
  data: void
  status: 201
}

export type createGoogleConnectionResponseSuccess = (createGoogleConnectionResponse201) & {
  headers: Headers;
};
;

export type createGoogleConnectionResponse = (createGoogleConnectionResponseSuccess)

export const getCreateGoogleConnectionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/google`
}

export const createGoogleConnection = async (organizationId: string,
    createGoogleConnectionBodyDto: CreateGoogleConnectionBodyDto, options?: RequestInit): Promise<createGoogleConnectionResponse> => {

  return axiosInstance<createGoogleConnectionResponse>(getCreateGoogleConnectionUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createGoogleConnectionBodyDto,)
  }
);}




export const getCreateGoogleConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGoogleConnection>>, TError,{organizationId: string;data: BodyType<CreateGoogleConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGoogleConnection>>, TError,{organizationId: string;data: BodyType<CreateGoogleConnectionBodyDto>}, TContext> => {

const mutationKey = ['createGoogleConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGoogleConnection>>, {organizationId: string;data: BodyType<CreateGoogleConnectionBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createGoogleConnection(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGoogleConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createGoogleConnection>>>
    export type CreateGoogleConnectionMutationBody = BodyType<CreateGoogleConnectionBodyDto>
    export type CreateGoogleConnectionMutationError = ErrorType<unknown>

    export const useCreateGoogleConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGoogleConnection>>, TError,{organizationId: string;data: BodyType<CreateGoogleConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGoogleConnection>>,
        TError,
        {organizationId: string;data: BodyType<CreateGoogleConnectionBodyDto>},
        TContext
      > => {
      return useMutation(getCreateGoogleConnectionMutationOptions(options), queryClient);
    }

export type authorizeMicrosoftConnectionResponse200 = {
  data: AuthorizeMicrosoftConnectionResponseDto
  status: 200
}

export type authorizeMicrosoftConnectionResponseSuccess = (authorizeMicrosoftConnectionResponse200) & {
  headers: Headers;
};
;

export type authorizeMicrosoftConnectionResponse = (authorizeMicrosoftConnectionResponseSuccess)

export const getAuthorizeMicrosoftConnectionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/microsoft/authorize`
}

export const authorizeMicrosoftConnection = async (organizationId: string, options?: RequestInit): Promise<authorizeMicrosoftConnectionResponse> => {

  return axiosInstance<authorizeMicrosoftConnectionResponse>(getAuthorizeMicrosoftConnectionUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAuthorizeMicrosoftConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeMicrosoftConnection>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authorizeMicrosoftConnection>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['authorizeMicrosoftConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorizeMicrosoftConnection>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  authorizeMicrosoftConnection(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorizeMicrosoftConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof authorizeMicrosoftConnection>>>

    export type AuthorizeMicrosoftConnectionMutationError = ErrorType<unknown>

    export const useAuthorizeMicrosoftConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizeMicrosoftConnection>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authorizeMicrosoftConnection>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getAuthorizeMicrosoftConnectionMutationOptions(options), queryClient);
    }

export type createMicrosoftConnectionResponse201 = {
  data: void
  status: 201
}

export type createMicrosoftConnectionResponseSuccess = (createMicrosoftConnectionResponse201) & {
  headers: Headers;
};
;

export type createMicrosoftConnectionResponse = (createMicrosoftConnectionResponseSuccess)

export const getCreateMicrosoftConnectionUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/microsoft`
}

export const createMicrosoftConnection = async (organizationId: string,
    createMicrosoftConnectionBodyDto: CreateMicrosoftConnectionBodyDto, options?: RequestInit): Promise<createMicrosoftConnectionResponse> => {

  return axiosInstance<createMicrosoftConnectionResponse>(getCreateMicrosoftConnectionUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMicrosoftConnectionBodyDto,)
  }
);}




export const getCreateMicrosoftConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMicrosoftConnection>>, TError,{organizationId: string;data: BodyType<CreateMicrosoftConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createMicrosoftConnection>>, TError,{organizationId: string;data: BodyType<CreateMicrosoftConnectionBodyDto>}, TContext> => {

const mutationKey = ['createMicrosoftConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMicrosoftConnection>>, {organizationId: string;data: BodyType<CreateMicrosoftConnectionBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createMicrosoftConnection(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMicrosoftConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof createMicrosoftConnection>>>
    export type CreateMicrosoftConnectionMutationBody = BodyType<CreateMicrosoftConnectionBodyDto>
    export type CreateMicrosoftConnectionMutationError = ErrorType<unknown>

    export const useCreateMicrosoftConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMicrosoftConnection>>, TError,{organizationId: string;data: BodyType<CreateMicrosoftConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMicrosoftConnection>>,
        TError,
        {organizationId: string;data: BodyType<CreateMicrosoftConnectionBodyDto>},
        TContext
      > => {
      return useMutation(getCreateMicrosoftConnectionMutationOptions(options), queryClient);
    }

export type clearConnectionDataResponse200 = {
  data: void
  status: 200
}

export type clearConnectionDataResponseSuccess = (clearConnectionDataResponse200) & {
  headers: Headers;
};
;

export type clearConnectionDataResponse = (clearConnectionDataResponseSuccess)

export const getClearConnectionDataUrl = (organizationId: string,
    connectionId: string,) => {




  return `/organizations/${organizationId}/connections/${connectionId}/clear-data`
}

export const clearConnectionData = async (organizationId: string,
    connectionId: string,
    clearConnectionDataBodyDto: ClearConnectionDataBodyDto, options?: RequestInit): Promise<clearConnectionDataResponse> => {

  return axiosInstance<clearConnectionDataResponse>(getClearConnectionDataUrl(organizationId,connectionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      clearConnectionDataBodyDto,)
  }
);}




export const getClearConnectionDataMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConnectionData>>, TError,{organizationId: string;connectionId: string;data: BodyType<ClearConnectionDataBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof clearConnectionData>>, TError,{organizationId: string;connectionId: string;data: BodyType<ClearConnectionDataBodyDto>}, TContext> => {

const mutationKey = ['clearConnectionData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearConnectionData>>, {organizationId: string;connectionId: string;data: BodyType<ClearConnectionDataBodyDto>}> = (props) => {
          const {organizationId,connectionId,data} = props ?? {};

          return  clearConnectionData(organizationId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearConnectionDataMutationResult = NonNullable<Awaited<ReturnType<typeof clearConnectionData>>>
    export type ClearConnectionDataMutationBody = BodyType<ClearConnectionDataBodyDto>
    export type ClearConnectionDataMutationError = ErrorType<unknown>

    export const useClearConnectionData = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearConnectionData>>, TError,{organizationId: string;connectionId: string;data: BodyType<ClearConnectionDataBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof clearConnectionData>>,
        TError,
        {organizationId: string;connectionId: string;data: BodyType<ClearConnectionDataBodyDto>},
        TContext
      > => {
      return useMutation(getClearConnectionDataMutationOptions(options), queryClient);
    }

export type forceSyncConnectionResponse200 = {
  data: void
  status: 200
}

export type forceSyncConnectionResponseSuccess = (forceSyncConnectionResponse200) & {
  headers: Headers;
};
;

export type forceSyncConnectionResponse = (forceSyncConnectionResponseSuccess)

export const getForceSyncConnectionUrl = (organizationId: string,
    connectionId: string,) => {




  return `/organizations/${organizationId}/connections/${connectionId}/force-sync`
}

export const forceSyncConnection = async (organizationId: string,
    connectionId: string, options?: RequestInit): Promise<forceSyncConnectionResponse> => {

  return axiosInstance<forceSyncConnectionResponse>(getForceSyncConnectionUrl(organizationId,connectionId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getForceSyncConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceSyncConnection>>, TError,{organizationId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof forceSyncConnection>>, TError,{organizationId: string;connectionId: string}, TContext> => {

const mutationKey = ['forceSyncConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forceSyncConnection>>, {organizationId: string;connectionId: string}> = (props) => {
          const {organizationId,connectionId} = props ?? {};

          return  forceSyncConnection(organizationId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ForceSyncConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof forceSyncConnection>>>

    export type ForceSyncConnectionMutationError = ErrorType<unknown>

    export const useForceSyncConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forceSyncConnection>>, TError,{organizationId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forceSyncConnection>>,
        TError,
        {organizationId: string;connectionId: string},
        TContext
      > => {
      return useMutation(getForceSyncConnectionMutationOptions(options), queryClient);
    }

export type updateConnectionSignatureResponse204 = {
  data: void
  status: 204
}

export type updateConnectionSignatureResponseSuccess = (updateConnectionSignatureResponse204) & {
  headers: Headers;
};
;

export type updateConnectionSignatureResponse = (updateConnectionSignatureResponseSuccess)

export const getUpdateConnectionSignatureUrl = (organizationId: string,
    connectionId: string,) => {




  return `/organizations/${organizationId}/connections/${connectionId}/signature`
}

export const updateConnectionSignature = async (organizationId: string,
    connectionId: string,
    updateConnectionSignatureBodyDto: UpdateConnectionSignatureBodyDto, options?: RequestInit): Promise<updateConnectionSignatureResponse> => {

  return axiosInstance<updateConnectionSignatureResponse>(getUpdateConnectionSignatureUrl(organizationId,connectionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateConnectionSignatureBodyDto,)
  }
);}




export const getUpdateConnectionSignatureMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectionSignature>>, TError,{organizationId: string;connectionId: string;data: BodyType<UpdateConnectionSignatureBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConnectionSignature>>, TError,{organizationId: string;connectionId: string;data: BodyType<UpdateConnectionSignatureBodyDto>}, TContext> => {

const mutationKey = ['updateConnectionSignature'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConnectionSignature>>, {organizationId: string;connectionId: string;data: BodyType<UpdateConnectionSignatureBodyDto>}> = (props) => {
          const {organizationId,connectionId,data} = props ?? {};

          return  updateConnectionSignature(organizationId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConnectionSignatureMutationResult = NonNullable<Awaited<ReturnType<typeof updateConnectionSignature>>>
    export type UpdateConnectionSignatureMutationBody = BodyType<UpdateConnectionSignatureBodyDto>
    export type UpdateConnectionSignatureMutationError = ErrorType<unknown>

    export const useUpdateConnectionSignature = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectionSignature>>, TError,{organizationId: string;connectionId: string;data: BodyType<UpdateConnectionSignatureBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConnectionSignature>>,
        TError,
        {organizationId: string;connectionId: string;data: BodyType<UpdateConnectionSignatureBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateConnectionSignatureMutationOptions(options), queryClient);
    }

export type setDefaultConnectionResponse204 = {
  data: void
  status: 204
}

export type setDefaultConnectionResponseSuccess = (setDefaultConnectionResponse204) & {
  headers: Headers;
};
;

export type setDefaultConnectionResponse = (setDefaultConnectionResponseSuccess)

export const getSetDefaultConnectionUrl = (organizationId: string,
    connectionId: string,) => {




  return `/organizations/${organizationId}/connections/${connectionId}/default`
}

export const setDefaultConnection = async (organizationId: string,
    connectionId: string, options?: RequestInit): Promise<setDefaultConnectionResponse> => {

  return axiosInstance<setDefaultConnectionResponse>(getSetDefaultConnectionUrl(organizationId,connectionId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getSetDefaultConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultConnection>>, TError,{organizationId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultConnection>>, TError,{organizationId: string;connectionId: string}, TContext> => {

const mutationKey = ['setDefaultConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultConnection>>, {organizationId: string;connectionId: string}> = (props) => {
          const {organizationId,connectionId} = props ?? {};

          return  setDefaultConnection(organizationId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultConnection>>>

    export type SetDefaultConnectionMutationError = ErrorType<unknown>

    export const useSetDefaultConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultConnection>>, TError,{organizationId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultConnection>>,
        TError,
        {organizationId: string;connectionId: string},
        TContext
      > => {
      return useMutation(getSetDefaultConnectionMutationOptions(options), queryClient);
    }

export type deleteConnectionResponse200 = {
  data: DeleteConnectionResponseDto
  status: 200
}

export type deleteConnectionResponseSuccess = (deleteConnectionResponse200) & {
  headers: Headers;
};
;

export type deleteConnectionResponse = (deleteConnectionResponseSuccess)

export const getDeleteConnectionUrl = (organizationId: string,
    connectionId: string,) => {




  return `/organizations/${organizationId}/connections/${connectionId}`
}

export const deleteConnection = async (organizationId: string,
    connectionId: string,
    deleteConnectionBodyDto: DeleteConnectionBodyDto, options?: RequestInit): Promise<deleteConnectionResponse> => {

  return axiosInstance<deleteConnectionResponse>(getDeleteConnectionUrl(organizationId,connectionId),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteConnectionBodyDto,)
  }
);}




export const getDeleteConnectionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnection>>, TError,{organizationId: string;connectionId: string;data: BodyType<DeleteConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConnection>>, TError,{organizationId: string;connectionId: string;data: BodyType<DeleteConnectionBodyDto>}, TContext> => {

const mutationKey = ['deleteConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConnection>>, {organizationId: string;connectionId: string;data: BodyType<DeleteConnectionBodyDto>}> = (props) => {
          const {organizationId,connectionId,data} = props ?? {};

          return  deleteConnection(organizationId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConnection>>>
    export type DeleteConnectionMutationBody = BodyType<DeleteConnectionBodyDto>
    export type DeleteConnectionMutationError = ErrorType<unknown>

    export const useDeleteConnection = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnection>>, TError,{organizationId: string;connectionId: string;data: BodyType<DeleteConnectionBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConnection>>,
        TError,
        {organizationId: string;connectionId: string;data: BodyType<DeleteConnectionBodyDto>},
        TContext
      > => {
      return useMutation(getDeleteConnectionMutationOptions(options), queryClient);
    }

export type uploadEmailAttachmentResponse201 = {
  data: void
  status: 201
}

export type uploadEmailAttachmentResponseSuccess = (uploadEmailAttachmentResponse201) & {
  headers: Headers;
};
;

export type uploadEmailAttachmentResponse = (uploadEmailAttachmentResponseSuccess)

export const getUploadEmailAttachmentUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/email-attachments`
}

export const uploadEmailAttachment = async (organizationId: string, options?: RequestInit): Promise<uploadEmailAttachmentResponse> => {

  return axiosInstance<uploadEmailAttachmentResponse>(getUploadEmailAttachmentUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUploadEmailAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmailAttachment>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadEmailAttachment>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['uploadEmailAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadEmailAttachment>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  uploadEmailAttachment(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadEmailAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadEmailAttachment>>>

    export type UploadEmailAttachmentMutationError = ErrorType<unknown>

    export const useUploadEmailAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEmailAttachment>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadEmailAttachment>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getUploadEmailAttachmentMutationOptions(options), queryClient);
    }

export type deleteEmailAttachmentResponse204 = {
  data: void
  status: 204
}

export type deleteEmailAttachmentResponseSuccess = (deleteEmailAttachmentResponse204) & {
  headers: Headers;
};
;

export type deleteEmailAttachmentResponse = (deleteEmailAttachmentResponseSuccess)

export const getDeleteEmailAttachmentUrl = (organizationId: string,
    attachmentId: string,) => {




  return `/organizations/${organizationId}/connections/email-attachments/${attachmentId}`
}

export const deleteEmailAttachment = async (organizationId: string,
    attachmentId: string, options?: RequestInit): Promise<deleteEmailAttachmentResponse> => {

  return axiosInstance<deleteEmailAttachmentResponse>(getDeleteEmailAttachmentUrl(organizationId,attachmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmailAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailAttachment>>, TError,{organizationId: string;attachmentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmailAttachment>>, TError,{organizationId: string;attachmentId: string}, TContext> => {

const mutationKey = ['deleteEmailAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmailAttachment>>, {organizationId: string;attachmentId: string}> = (props) => {
          const {organizationId,attachmentId} = props ?? {};

          return  deleteEmailAttachment(organizationId,attachmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmailAttachment>>>

    export type DeleteEmailAttachmentMutationError = ErrorType<unknown>

    export const useDeleteEmailAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmailAttachment>>, TError,{organizationId: string;attachmentId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmailAttachment>>,
        TError,
        {organizationId: string;attachmentId: string},
        TContext
      > => {
      return useMutation(getDeleteEmailAttachmentMutationOptions(options), queryClient);
    }

export type createEmailResponse201 = {
  data: EmailResponseDto
  status: 201
}

export type createEmailResponseSuccess = (createEmailResponse201) & {
  headers: Headers;
};
;

export type createEmailResponse = (createEmailResponseSuccess)

export const getCreateEmailUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/emails`
}

export const createEmail = async (organizationId: string,
    createEmailBodyDto: CreateEmailBodyDto, options?: RequestInit): Promise<createEmailResponse> => {

  return axiosInstance<createEmailResponse>(getCreateEmailUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createEmailBodyDto,)
  }
);}




export const getCreateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmail>>, TError,{organizationId: string;data: BodyType<CreateEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createEmail>>, TError,{organizationId: string;data: BodyType<CreateEmailBodyDto>}, TContext> => {

const mutationKey = ['createEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEmail>>, {organizationId: string;data: BodyType<CreateEmailBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createEmail(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof createEmail>>>
    export type CreateEmailMutationBody = BodyType<CreateEmailBodyDto>
    export type CreateEmailMutationError = ErrorType<unknown>

    export const useCreateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEmail>>, TError,{organizationId: string;data: BodyType<CreateEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEmail>>,
        TError,
        {organizationId: string;data: BodyType<CreateEmailBodyDto>},
        TContext
      > => {
      return useMutation(getCreateEmailMutationOptions(options), queryClient);
    }

export type listEmailsResponse200 = {
  data: ListEmailsResponseDto
  status: 200
}

export type listEmailsResponseSuccess = (listEmailsResponse200) & {
  headers: Headers;
};
;

export type listEmailsResponse = (listEmailsResponseSuccess)

export const getListEmailsUrl = (organizationId: string,
    params?: ListEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/connections/emails?${stringifiedParams}` : `/organizations/${organizationId}/connections/emails`
}

export const listEmails = async (organizationId: string,
    params?: ListEmailsParams, options?: RequestInit): Promise<listEmailsResponse> => {

  return axiosInstance<listEmailsResponse>(getListEmailsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEmailsQueryKey = (organizationId: string,
    params?: ListEmailsParams,) => {
    return [
    `/organizations/${organizationId}/connections/emails`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEmailsQueryOptions = <TData = Awaited<ReturnType<typeof listEmails>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEmailsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEmails>>> = ({ signal }) => listEmails(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof listEmails>>>
export type ListEmailsQueryError = ErrorType<unknown>


export function useListEmails<TData = Awaited<ReturnType<typeof listEmails>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmails>>,
          TError,
          Awaited<ReturnType<typeof listEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmails<TData = Awaited<ReturnType<typeof listEmails>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEmails>>,
          TError,
          Awaited<ReturnType<typeof listEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEmails<TData = Awaited<ReturnType<typeof listEmails>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEmails<TData = Awaited<ReturnType<typeof listEmails>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEmails>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEmailsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type previewBulkEmailRecipientsResponse200 = {
  data: BulkRecipientsResponseDto
  status: 200
}

export type previewBulkEmailRecipientsResponseSuccess = (previewBulkEmailRecipientsResponse200) & {
  headers: Headers;
};
;

export type previewBulkEmailRecipientsResponse = (previewBulkEmailRecipientsResponseSuccess)

export const getPreviewBulkEmailRecipientsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/emails/bulk/recipients`
}

export const previewBulkEmailRecipients = async (organizationId: string,
    bulkRecipientsBodyDto: BulkRecipientsBodyDto, options?: RequestInit): Promise<previewBulkEmailRecipientsResponse> => {

  return axiosInstance<previewBulkEmailRecipientsResponse>(getPreviewBulkEmailRecipientsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkRecipientsBodyDto,)
  }
);}




export const getPreviewBulkEmailRecipientsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkEmailRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewBulkEmailRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext> => {

const mutationKey = ['previewBulkEmailRecipients'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewBulkEmailRecipients>>, {organizationId: string;data: BodyType<BulkRecipientsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  previewBulkEmailRecipients(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewBulkEmailRecipientsMutationResult = NonNullable<Awaited<ReturnType<typeof previewBulkEmailRecipients>>>
    export type PreviewBulkEmailRecipientsMutationBody = BodyType<BulkRecipientsBodyDto>
    export type PreviewBulkEmailRecipientsMutationError = ErrorType<unknown>

    export const usePreviewBulkEmailRecipients = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkEmailRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewBulkEmailRecipients>>,
        TError,
        {organizationId: string;data: BodyType<BulkRecipientsBodyDto>},
        TContext
      > => {
      return useMutation(getPreviewBulkEmailRecipientsMutationOptions(options), queryClient);
    }

export type createBulkEmailResponse200 = {
  data: BulkSendResponseDto
  status: 200
}

export type createBulkEmailResponseSuccess = (createBulkEmailResponse200) & {
  headers: Headers;
};
;

export type createBulkEmailResponse = (createBulkEmailResponseSuccess)

export const getCreateBulkEmailUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/emails/bulk`
}

export const createBulkEmail = async (organizationId: string,
    createBulkEmailBodyDto: CreateBulkEmailBodyDto, options?: RequestInit): Promise<createBulkEmailResponse> => {

  return axiosInstance<createBulkEmailResponse>(getCreateBulkEmailUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBulkEmailBodyDto,)
  }
);}




export const getCreateBulkEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkEmail>>, TError,{organizationId: string;data: BodyType<CreateBulkEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkEmail>>, TError,{organizationId: string;data: BodyType<CreateBulkEmailBodyDto>}, TContext> => {

const mutationKey = ['createBulkEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkEmail>>, {organizationId: string;data: BodyType<CreateBulkEmailBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createBulkEmail(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkEmailMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkEmail>>>
    export type CreateBulkEmailMutationBody = BodyType<CreateBulkEmailBodyDto>
    export type CreateBulkEmailMutationError = ErrorType<unknown>

    export const useCreateBulkEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkEmail>>, TError,{organizationId: string;data: BodyType<CreateBulkEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkEmail>>,
        TError,
        {organizationId: string;data: BodyType<CreateBulkEmailBodyDto>},
        TContext
      > => {
      return useMutation(getCreateBulkEmailMutationOptions(options), queryClient);
    }

export type updateEmailResponse200 = {
  data: EmailResponseDto
  status: 200
}

export type updateEmailResponseSuccess = (updateEmailResponse200) & {
  headers: Headers;
};
;

export type updateEmailResponse = (updateEmailResponseSuccess)

export const getUpdateEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}`
}

export const updateEmail = async (organizationId: string,
    emailId: string,
    updateEmailBodyDto: UpdateEmailBodyDto, options?: RequestInit): Promise<updateEmailResponse> => {

  return axiosInstance<updateEmailResponse>(getUpdateEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEmailBodyDto,)
  }
);}




export const getUpdateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,{organizationId: string;emailId: string;data: BodyType<UpdateEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,{organizationId: string;emailId: string;data: BodyType<UpdateEmailBodyDto>}, TContext> => {

const mutationKey = ['updateEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEmail>>, {organizationId: string;emailId: string;data: BodyType<UpdateEmailBodyDto>}> = (props) => {
          const {organizationId,emailId,data} = props ?? {};

          return  updateEmail(organizationId,emailId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof updateEmail>>>
    export type UpdateEmailMutationBody = BodyType<UpdateEmailBodyDto>
    export type UpdateEmailMutationError = ErrorType<unknown>

    export const useUpdateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEmail>>, TError,{organizationId: string;emailId: string;data: BodyType<UpdateEmailBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEmail>>,
        TError,
        {organizationId: string;emailId: string;data: BodyType<UpdateEmailBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateEmailMutationOptions(options), queryClient);
    }

export type deleteEmailResponse204 = {
  data: void
  status: 204
}

export type deleteEmailResponseSuccess = (deleteEmailResponse204) & {
  headers: Headers;
};
;

export type deleteEmailResponse = (deleteEmailResponseSuccess)

export const getDeleteEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}`
}

export const deleteEmail = async (organizationId: string,
    emailId: string, options?: RequestInit): Promise<deleteEmailResponse> => {

  return axiosInstance<deleteEmailResponse>(getDeleteEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEmail>>, TError,{organizationId: string;emailId: string}, TContext> => {

const mutationKey = ['deleteEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEmail>>, {organizationId: string;emailId: string}> = (props) => {
          const {organizationId,emailId} = props ?? {};

          return  deleteEmail(organizationId,emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEmailMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEmail>>>

    export type DeleteEmailMutationError = ErrorType<unknown>

    export const useDeleteEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEmail>>,
        TError,
        {organizationId: string;emailId: string},
        TContext
      > => {
      return useMutation(getDeleteEmailMutationOptions(options), queryClient);
    }

export type hideEmailResponse204 = {
  data: void
  status: 204
}

export type hideEmailResponseSuccess = (hideEmailResponse204) & {
  headers: Headers;
};
;

export type hideEmailResponse = (hideEmailResponseSuccess)

export const getHideEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}/hide`
}

export const hideEmail = async (organizationId: string,
    emailId: string, options?: RequestInit): Promise<hideEmailResponse> => {

  return axiosInstance<hideEmailResponse>(getHideEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideEmail>>, TError,{organizationId: string;emailId: string}, TContext> => {

const mutationKey = ['hideEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideEmail>>, {organizationId: string;emailId: string}> = (props) => {
          const {organizationId,emailId} = props ?? {};

          return  hideEmail(organizationId,emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideEmailMutationResult = NonNullable<Awaited<ReturnType<typeof hideEmail>>>

    export type HideEmailMutationError = ErrorType<unknown>

    export const useHideEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideEmail>>,
        TError,
        {organizationId: string;emailId: string},
        TContext
      > => {
      return useMutation(getHideEmailMutationOptions(options), queryClient);
    }

export type unhideEmailResponse204 = {
  data: void
  status: 204
}

export type unhideEmailResponseSuccess = (unhideEmailResponse204) & {
  headers: Headers;
};
;

export type unhideEmailResponse = (unhideEmailResponseSuccess)

export const getUnhideEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}/unhide`
}

export const unhideEmail = async (organizationId: string,
    emailId: string, options?: RequestInit): Promise<unhideEmailResponse> => {

  return axiosInstance<unhideEmailResponse>(getUnhideEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideEmail>>, TError,{organizationId: string;emailId: string}, TContext> => {

const mutationKey = ['unhideEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideEmail>>, {organizationId: string;emailId: string}> = (props) => {
          const {organizationId,emailId} = props ?? {};

          return  unhideEmail(organizationId,emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideEmailMutationResult = NonNullable<Awaited<ReturnType<typeof unhideEmail>>>

    export type UnhideEmailMutationError = ErrorType<unknown>

    export const useUnhideEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideEmail>>,
        TError,
        {organizationId: string;emailId: string},
        TContext
      > => {
      return useMutation(getUnhideEmailMutationOptions(options), queryClient);
    }

export type hideEmailThreadResponse204 = {
  data: void
  status: 204
}

export type hideEmailThreadResponseSuccess = (hideEmailThreadResponse204) & {
  headers: Headers;
};
;

export type hideEmailThreadResponse = (hideEmailThreadResponseSuccess)

export const getHideEmailThreadUrl = (organizationId: string,
    providerThreadId: string,) => {




  return `/organizations/${organizationId}/connections/emails/thread/${providerThreadId}/hide`
}

export const hideEmailThread = async (organizationId: string,
    providerThreadId: string, options?: RequestInit): Promise<hideEmailThreadResponse> => {

  return axiosInstance<hideEmailThreadResponse>(getHideEmailThreadUrl(organizationId,providerThreadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideEmailThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext> => {

const mutationKey = ['hideEmailThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideEmailThread>>, {organizationId: string;providerThreadId: string}> = (props) => {
          const {organizationId,providerThreadId} = props ?? {};

          return  hideEmailThread(organizationId,providerThreadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideEmailThreadMutationResult = NonNullable<Awaited<ReturnType<typeof hideEmailThread>>>

    export type HideEmailThreadMutationError = ErrorType<unknown>

    export const useHideEmailThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideEmailThread>>,
        TError,
        {organizationId: string;providerThreadId: string},
        TContext
      > => {
      return useMutation(getHideEmailThreadMutationOptions(options), queryClient);
    }

export type unhideEmailThreadResponse204 = {
  data: void
  status: 204
}

export type unhideEmailThreadResponseSuccess = (unhideEmailThreadResponse204) & {
  headers: Headers;
};
;

export type unhideEmailThreadResponse = (unhideEmailThreadResponseSuccess)

export const getUnhideEmailThreadUrl = (organizationId: string,
    providerThreadId: string,) => {




  return `/organizations/${organizationId}/connections/emails/thread/${providerThreadId}/unhide`
}

export const unhideEmailThread = async (organizationId: string,
    providerThreadId: string, options?: RequestInit): Promise<unhideEmailThreadResponse> => {

  return axiosInstance<unhideEmailThreadResponse>(getUnhideEmailThreadUrl(organizationId,providerThreadId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideEmailThreadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext> => {

const mutationKey = ['unhideEmailThread'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideEmailThread>>, {organizationId: string;providerThreadId: string}> = (props) => {
          const {organizationId,providerThreadId} = props ?? {};

          return  unhideEmailThread(organizationId,providerThreadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideEmailThreadMutationResult = NonNullable<Awaited<ReturnType<typeof unhideEmailThread>>>

    export type UnhideEmailThreadMutationError = ErrorType<unknown>

    export const useUnhideEmailThread = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideEmailThread>>, TError,{organizationId: string;providerThreadId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideEmailThread>>,
        TError,
        {organizationId: string;providerThreadId: string},
        TContext
      > => {
      return useMutation(getUnhideEmailThreadMutationOptions(options), queryClient);
    }

export type sendEmailResponse200 = {
  data: EmailResponseDto
  status: 200
}

export type sendEmailResponseSuccess = (sendEmailResponse200) & {
  headers: Headers;
};
;

export type sendEmailResponse = (sendEmailResponseSuccess)

export const getSendEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}/send`
}

export const sendEmail = async (organizationId: string,
    emailId: string, options?: RequestInit): Promise<sendEmailResponse> => {

  return axiosInstance<sendEmailResponse>(getSendEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{organizationId: string;emailId: string}, TContext> => {

const mutationKey = ['sendEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendEmail>>, {organizationId: string;emailId: string}> = (props) => {
          const {organizationId,emailId} = props ?? {};

          return  sendEmail(organizationId,emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendEmail>>>

    export type SendEmailMutationError = ErrorType<unknown>

    export const useSendEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendEmail>>,
        TError,
        {organizationId: string;emailId: string},
        TContext
      > => {
      return useMutation(getSendEmailMutationOptions(options), queryClient);
    }

export type approveEmailResponse200 = {
  data: EmailResponseDto
  status: 200
}

export type approveEmailResponseSuccess = (approveEmailResponse200) & {
  headers: Headers;
};
;

export type approveEmailResponse = (approveEmailResponseSuccess)

export const getApproveEmailUrl = (organizationId: string,
    emailId: string,) => {




  return `/organizations/${organizationId}/connections/emails/${emailId}/approve`
}

export const approveEmail = async (organizationId: string,
    emailId: string, options?: RequestInit): Promise<approveEmailResponse> => {

  return axiosInstance<approveEmailResponse>(getApproveEmailUrl(organizationId,emailId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveEmail>>, TError,{organizationId: string;emailId: string}, TContext> => {

const mutationKey = ['approveEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveEmail>>, {organizationId: string;emailId: string}> = (props) => {
          const {organizationId,emailId} = props ?? {};

          return  approveEmail(organizationId,emailId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveEmailMutationResult = NonNullable<Awaited<ReturnType<typeof approveEmail>>>

    export type ApproveEmailMutationError = ErrorType<unknown>

    export const useApproveEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveEmail>>, TError,{organizationId: string;emailId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveEmail>>,
        TError,
        {organizationId: string;emailId: string},
        TContext
      > => {
      return useMutation(getApproveEmailMutationOptions(options), queryClient);
    }

export type getEmailThreadResponse200 = {
  data: GetEmailThreadResponseDto
  status: 200
}

export type getEmailThreadResponseSuccess = (getEmailThreadResponse200) & {
  headers: Headers;
};
;

export type getEmailThreadResponse = (getEmailThreadResponseSuccess)

export const getGetEmailThreadUrl = (organizationId: string,
    providerThreadId: string,) => {




  return `/organizations/${organizationId}/connections/emails/thread/${providerThreadId}`
}

export const getEmailThread = async (organizationId: string,
    providerThreadId: string, options?: RequestInit): Promise<getEmailThreadResponse> => {

  return axiosInstance<getEmailThreadResponse>(getGetEmailThreadUrl(organizationId,providerThreadId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEmailThreadQueryKey = (organizationId: string,
    providerThreadId: string,) => {
    return [
    `/organizations/${organizationId}/connections/emails/thread/${providerThreadId}`
    ] as const;
    }


export const getGetEmailThreadQueryOptions = <TData = Awaited<ReturnType<typeof getEmailThread>>, TError = ErrorType<unknown>>(organizationId: string,
    providerThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailThreadQueryKey(organizationId,providerThreadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailThread>>> = ({ signal }) => getEmailThread(organizationId,providerThreadId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && providerThreadId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailThreadQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailThread>>>
export type GetEmailThreadQueryError = ErrorType<unknown>


export function useGetEmailThread<TData = Awaited<ReturnType<typeof getEmailThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    providerThreadId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThread>>,
          TError,
          Awaited<ReturnType<typeof getEmailThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailThread<TData = Awaited<ReturnType<typeof getEmailThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    providerThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailThread>>,
          TError,
          Awaited<ReturnType<typeof getEmailThread>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailThread<TData = Awaited<ReturnType<typeof getEmailThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    providerThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEmailThread<TData = Awaited<ReturnType<typeof getEmailThread>>, TError = ErrorType<unknown>>(
 organizationId: string,
    providerThreadId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailThread>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailThreadQueryOptions(organizationId,providerThreadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createCalendarEventResponse201 = {
  data: CreateCalendarEventResponseDto
  status: 201
}

export type createCalendarEventResponseSuccess = (createCalendarEventResponse201) & {
  headers: Headers;
};
;

export type createCalendarEventResponse = (createCalendarEventResponseSuccess)

export const getCreateCalendarEventUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connections/calendar/events`
}

export const createCalendarEvent = async (organizationId: string,
    createCalendarEventBodyDto: CreateCalendarEventBodyDto, options?: RequestInit): Promise<createCalendarEventResponse> => {

  return axiosInstance<createCalendarEventResponse>(getCreateCalendarEventUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCalendarEventBodyDto,)
  }
);}




export const getCreateCalendarEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{organizationId: string;data: BodyType<CreateCalendarEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{organizationId: string;data: BodyType<CreateCalendarEventBodyDto>}, TContext> => {

const mutationKey = ['createCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCalendarEvent>>, {organizationId: string;data: BodyType<CreateCalendarEventBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createCalendarEvent(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof createCalendarEvent>>>
    export type CreateCalendarEventMutationBody = BodyType<CreateCalendarEventBodyDto>
    export type CreateCalendarEventMutationError = ErrorType<unknown>

    export const useCreateCalendarEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCalendarEvent>>, TError,{organizationId: string;data: BodyType<CreateCalendarEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCalendarEvent>>,
        TError,
        {organizationId: string;data: BodyType<CreateCalendarEventBodyDto>},
        TContext
      > => {
      return useMutation(getCreateCalendarEventMutationOptions(options), queryClient);
    }

export type listCalendarEventsResponse200 = {
  data: ListCalendarEventsResponseDto
  status: 200
}

export type listCalendarEventsResponseSuccess = (listCalendarEventsResponse200) & {
  headers: Headers;
};
;

export type listCalendarEventsResponse = (listCalendarEventsResponseSuccess)

export const getListCalendarEventsUrl = (organizationId: string,
    params?: ListCalendarEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/connections/calendar/events?${stringifiedParams}` : `/organizations/${organizationId}/connections/calendar/events`
}

export const listCalendarEvents = async (organizationId: string,
    params?: ListCalendarEventsParams, options?: RequestInit): Promise<listCalendarEventsResponse> => {

  return axiosInstance<listCalendarEventsResponse>(getListCalendarEventsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarEventsQueryKey = (organizationId: string,
    params?: ListCalendarEventsParams,) => {
    return [
    `/organizations/${organizationId}/connections/calendar/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCalendarEventsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListCalendarEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarEventsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarEvents>>> = ({ signal }) => listCalendarEvents(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCalendarEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarEvents>>>
export type ListCalendarEventsQueryError = ErrorType<unknown>


export function useListCalendarEvents<TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListCalendarEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof listCalendarEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarEvents<TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListCalendarEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCalendarEvents>>,
          TError,
          Awaited<ReturnType<typeof listCalendarEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCalendarEvents<TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListCalendarEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCalendarEvents<TData = Awaited<ReturnType<typeof listCalendarEvents>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListCalendarEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCalendarEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCalendarEventsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateCalendarEventResponse200 = {
  data: CreateCalendarEventResponseDto
  status: 200
}

export type updateCalendarEventResponseSuccess = (updateCalendarEventResponse200) & {
  headers: Headers;
};
;

export type updateCalendarEventResponse = (updateCalendarEventResponseSuccess)

export const getUpdateCalendarEventUrl = (organizationId: string,
    eventId: string,) => {




  return `/organizations/${organizationId}/connections/calendar/events/${eventId}`
}

export const updateCalendarEvent = async (organizationId: string,
    eventId: string,
    updateCalendarEventBodyDto: UpdateCalendarEventBodyDto, options?: RequestInit): Promise<updateCalendarEventResponse> => {

  return axiosInstance<updateCalendarEventResponse>(getUpdateCalendarEventUrl(organizationId,eventId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCalendarEventBodyDto,)
  }
);}




export const getUpdateCalendarEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarEvent>>, TError,{organizationId: string;eventId: string;data: BodyType<UpdateCalendarEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCalendarEvent>>, TError,{organizationId: string;eventId: string;data: BodyType<UpdateCalendarEventBodyDto>}, TContext> => {

const mutationKey = ['updateCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCalendarEvent>>, {organizationId: string;eventId: string;data: BodyType<UpdateCalendarEventBodyDto>}> = (props) => {
          const {organizationId,eventId,data} = props ?? {};

          return  updateCalendarEvent(organizationId,eventId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateCalendarEvent>>>
    export type UpdateCalendarEventMutationBody = BodyType<UpdateCalendarEventBodyDto>
    export type UpdateCalendarEventMutationError = ErrorType<unknown>

    export const useUpdateCalendarEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCalendarEvent>>, TError,{organizationId: string;eventId: string;data: BodyType<UpdateCalendarEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCalendarEvent>>,
        TError,
        {organizationId: string;eventId: string;data: BodyType<UpdateCalendarEventBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateCalendarEventMutationOptions(options), queryClient);
    }

export type deleteCalendarEventResponse204 = {
  data: void
  status: 204
}

export type deleteCalendarEventResponseSuccess = (deleteCalendarEventResponse204) & {
  headers: Headers;
};
;

export type deleteCalendarEventResponse = (deleteCalendarEventResponseSuccess)

export const getDeleteCalendarEventUrl = (organizationId: string,
    eventId: string,
    params?: DeleteCalendarEventParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/connections/calendar/events/${eventId}?${stringifiedParams}` : `/organizations/${organizationId}/connections/calendar/events/${eventId}`
}

export const deleteCalendarEvent = async (organizationId: string,
    eventId: string,
    params?: DeleteCalendarEventParams, options?: RequestInit): Promise<deleteCalendarEventResponse> => {

  return axiosInstance<deleteCalendarEventResponse>(getDeleteCalendarEventUrl(organizationId,eventId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCalendarEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent>>, TError,{organizationId: string;eventId: string;params?: DeleteCalendarEventParams}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent>>, TError,{organizationId: string;eventId: string;params?: DeleteCalendarEventParams}, TContext> => {

const mutationKey = ['deleteCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCalendarEvent>>, {organizationId: string;eventId: string;params?: DeleteCalendarEventParams}> = (props) => {
          const {organizationId,eventId,params} = props ?? {};

          return  deleteCalendarEvent(organizationId,eventId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCalendarEvent>>>

    export type DeleteCalendarEventMutationError = ErrorType<unknown>

    export const useDeleteCalendarEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCalendarEvent>>, TError,{organizationId: string;eventId: string;params?: DeleteCalendarEventParams}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCalendarEvent>>,
        TError,
        {organizationId: string;eventId: string;params?: DeleteCalendarEventParams},
        TContext
      > => {
      return useMutation(getDeleteCalendarEventMutationOptions(options), queryClient);
    }

export type hideCalendarEventResponse204 = {
  data: void
  status: 204
}

export type hideCalendarEventResponseSuccess = (hideCalendarEventResponse204) & {
  headers: Headers;
};
;

export type hideCalendarEventResponse = (hideCalendarEventResponseSuccess)

export const getHideCalendarEventUrl = (organizationId: string,
    eventId: string,) => {




  return `/organizations/${organizationId}/connections/calendar/events/${eventId}/hide`
}

export const hideCalendarEvent = async (organizationId: string,
    eventId: string, options?: RequestInit): Promise<hideCalendarEventResponse> => {

  return axiosInstance<hideCalendarEventResponse>(getHideCalendarEventUrl(organizationId,eventId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideCalendarEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext> => {

const mutationKey = ['hideCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideCalendarEvent>>, {organizationId: string;eventId: string}> = (props) => {
          const {organizationId,eventId} = props ?? {};

          return  hideCalendarEvent(organizationId,eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof hideCalendarEvent>>>

    export type HideCalendarEventMutationError = ErrorType<unknown>

    export const useHideCalendarEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideCalendarEvent>>,
        TError,
        {organizationId: string;eventId: string},
        TContext
      > => {
      return useMutation(getHideCalendarEventMutationOptions(options), queryClient);
    }

export type unhideCalendarEventResponse204 = {
  data: void
  status: 204
}

export type unhideCalendarEventResponseSuccess = (unhideCalendarEventResponse204) & {
  headers: Headers;
};
;

export type unhideCalendarEventResponse = (unhideCalendarEventResponseSuccess)

export const getUnhideCalendarEventUrl = (organizationId: string,
    eventId: string,) => {




  return `/organizations/${organizationId}/connections/calendar/events/${eventId}/unhide`
}

export const unhideCalendarEvent = async (organizationId: string,
    eventId: string, options?: RequestInit): Promise<unhideCalendarEventResponse> => {

  return axiosInstance<unhideCalendarEventResponse>(getUnhideCalendarEventUrl(organizationId,eventId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideCalendarEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext> => {

const mutationKey = ['unhideCalendarEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideCalendarEvent>>, {organizationId: string;eventId: string}> = (props) => {
          const {organizationId,eventId} = props ?? {};

          return  unhideCalendarEvent(organizationId,eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideCalendarEventMutationResult = NonNullable<Awaited<ReturnType<typeof unhideCalendarEvent>>>

    export type UnhideCalendarEventMutationError = ErrorType<unknown>

    export const useUnhideCalendarEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideCalendarEvent>>, TError,{organizationId: string;eventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideCalendarEvent>>,
        TError,
        {organizationId: string;eventId: string},
        TContext
      > => {
      return useMutation(getUnhideCalendarEventMutationOptions(options), queryClient);
    }

export type getOrganizationAiSettingsResponse200 = {
  data: GetOrganizationAiSettingsResponseDto
  status: 200
}

export type getOrganizationAiSettingsResponseSuccess = (getOrganizationAiSettingsResponse200) & {
  headers: Headers;
};
;

export type getOrganizationAiSettingsResponse = (getOrganizationAiSettingsResponseSuccess)

export const getGetOrganizationAiSettingsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai-settings`
}

export const getOrganizationAiSettings = async (organizationId: string, options?: RequestInit): Promise<getOrganizationAiSettingsResponse> => {

  return axiosInstance<getOrganizationAiSettingsResponse>(getGetOrganizationAiSettingsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationAiSettingsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/ai-settings`
    ] as const;
    }


export const getGetOrganizationAiSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationAiSettingsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationAiSettings>>> = ({ signal }) => getOrganizationAiSettings(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationAiSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationAiSettings>>>
export type GetOrganizationAiSettingsQueryError = ErrorType<unknown>


export function useGetOrganizationAiSettings<TData = Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAiSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAiSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationAiSettings<TData = Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationAiSettings>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationAiSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationAiSettings<TData = Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationAiSettings<TData = Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationAiSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationAiSettingsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateOrganizationAiSettingsResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationAiSettingsResponseSuccess = (updateOrganizationAiSettingsResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationAiSettingsResponse = (updateOrganizationAiSettingsResponseSuccess)

export const getUpdateOrganizationAiSettingsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/ai-settings`
}

export const updateOrganizationAiSettings = async (organizationId: string,
    updateOrganizationAiSettingsBodyDto: UpdateOrganizationAiSettingsBodyDto, options?: RequestInit): Promise<updateOrganizationAiSettingsResponse> => {

  return axiosInstance<updateOrganizationAiSettingsResponse>(getUpdateOrganizationAiSettingsUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationAiSettingsBodyDto,)
  }
);}




export const getUpdateOrganizationAiSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiSettings>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationAiSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiSettings>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationAiSettingsBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationAiSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationAiSettings>>, {organizationId: string;data: BodyType<UpdateOrganizationAiSettingsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateOrganizationAiSettings(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationAiSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationAiSettings>>>
    export type UpdateOrganizationAiSettingsMutationBody = BodyType<UpdateOrganizationAiSettingsBodyDto>
    export type UpdateOrganizationAiSettingsMutationError = ErrorType<unknown>

    export const useUpdateOrganizationAiSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationAiSettings>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationAiSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationAiSettings>>,
        TError,
        {organizationId: string;data: BodyType<UpdateOrganizationAiSettingsBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationAiSettingsMutationOptions(options), queryClient);
    }

export type createOrganizationResponse201 = {
  data: void
  status: 201
}

export type createOrganizationResponseSuccess = (createOrganizationResponse201) & {
  headers: Headers;
};
;

export type createOrganizationResponse = (createOrganizationResponseSuccess)

export const getCreateOrganizationUrl = () => {




  return `/organizations`
}

export const createOrganization = async (createOrganizationBodyDto: CreateOrganizationBodyDto, options?: RequestInit): Promise<createOrganizationResponse> => {

  return axiosInstance<createOrganizationResponse>(getCreateOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationBodyDto,)
  }
);}




export const getCreateOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<CreateOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<CreateOrganizationBodyDto>}, TContext> => {

const mutationKey = ['createOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganization>>, {data: BodyType<CreateOrganizationBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  createOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganization>>>
    export type CreateOrganizationMutationBody = BodyType<CreateOrganizationBodyDto>
    export type CreateOrganizationMutationError = ErrorType<unknown>

    export const useCreateOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganization>>, TError,{data: BodyType<CreateOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganization>>,
        TError,
        {data: BodyType<CreateOrganizationBodyDto>},
        TContext
      > => {
      return useMutation(getCreateOrganizationMutationOptions(options), queryClient);
    }

export type getOrganizationResponse200 = {
  data: GetOrganizationResponseDto
  status: 200
}

export type getOrganizationResponseSuccess = (getOrganizationResponse200) & {
  headers: Headers;
};
;

export type getOrganizationResponse = (getOrganizationResponseSuccess)

export const getGetOrganizationUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}`
}

export const getOrganization = async (organizationId: string, options?: RequestInit): Promise<getOrganizationResponse> => {

  return axiosInstance<getOrganizationResponse>(getGetOrganizationUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}`
    ] as const;
    }


export const getGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({ signal }) => getOrganization(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganization>>>
export type GetOrganizationQueryError = ErrorType<unknown>


export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganization<TData = Awaited<ReturnType<typeof getOrganization>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganization>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateOrganizationProfileResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationProfileResponseSuccess = (updateOrganizationProfileResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationProfileResponse = (updateOrganizationProfileResponseSuccess)

export const getUpdateOrganizationProfileUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/profile`
}

export const updateOrganizationProfile = async (organizationId: string,
    updateOrganizationProfileBodyDto: UpdateOrganizationProfileBodyDto, options?: RequestInit): Promise<updateOrganizationProfileResponse> => {

  return axiosInstance<updateOrganizationProfileResponse>(getUpdateOrganizationProfileUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationProfileBodyDto,)
  }
);}




export const getUpdateOrganizationProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationProfileBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationProfile>>, {organizationId: string;data: BodyType<UpdateOrganizationProfileBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateOrganizationProfile(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationProfile>>>
    export type UpdateOrganizationProfileMutationBody = BodyType<UpdateOrganizationProfileBodyDto>
    export type UpdateOrganizationProfileMutationError = ErrorType<unknown>

    export const useUpdateOrganizationProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationProfile>>,
        TError,
        {organizationId: string;data: BodyType<UpdateOrganizationProfileBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationProfileMutationOptions(options), queryClient);
    }

export type archiveOrganizationResponse204 = {
  data: void
  status: 204
}

export type archiveOrganizationResponseSuccess = (archiveOrganizationResponse204) & {
  headers: Headers;
};
;

export type archiveOrganizationResponse = (archiveOrganizationResponseSuccess)

export const getArchiveOrganizationUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/archive`
}

export const archiveOrganization = async (organizationId: string, options?: RequestInit): Promise<archiveOrganizationResponse> => {

  return axiosInstance<archiveOrganizationResponse>(getArchiveOrganizationUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveOrganization>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['archiveOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveOrganization>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  archiveOrganization(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveOrganization>>>

    export type ArchiveOrganizationMutationError = ErrorType<unknown>

    export const useArchiveOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveOrganization>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getArchiveOrganizationMutationOptions(options), queryClient);
    }

export type listConnectedAppsResponse200 = {
  data: ListConnectedAppsResponseDto
  status: 200
}

export type listConnectedAppsResponseSuccess = (listConnectedAppsResponse200) & {
  headers: Headers;
};
;

export type listConnectedAppsResponse = (listConnectedAppsResponseSuccess)

export const getListConnectedAppsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connected-apps`
}

export const listConnectedApps = async (organizationId: string, options?: RequestInit): Promise<listConnectedAppsResponse> => {

  return axiosInstance<listConnectedAppsResponse>(getListConnectedAppsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListConnectedAppsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/connected-apps`
    ] as const;
    }


export const getListConnectedAppsQueryOptions = <TData = Awaited<ReturnType<typeof listConnectedApps>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectedAppsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnectedApps>>> = ({ signal }) => listConnectedApps(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConnectedAppsQueryResult = NonNullable<Awaited<ReturnType<typeof listConnectedApps>>>
export type ListConnectedAppsQueryError = ErrorType<unknown>


export function useListConnectedApps<TData = Awaited<ReturnType<typeof listConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectedApps>>,
          TError,
          Awaited<ReturnType<typeof listConnectedApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnectedApps<TData = Awaited<ReturnType<typeof listConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectedApps>>,
          TError,
          Awaited<ReturnType<typeof listConnectedApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnectedApps<TData = Awaited<ReturnType<typeof listConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListConnectedApps<TData = Awaited<ReturnType<typeof listConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConnectedAppsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listMyConnectedAppsResponse200 = {
  data: ListConnectedAppsResponseDto
  status: 200
}

export type listMyConnectedAppsResponseSuccess = (listMyConnectedAppsResponse200) & {
  headers: Headers;
};
;

export type listMyConnectedAppsResponse = (listMyConnectedAppsResponseSuccess)

export const getListMyConnectedAppsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/connected-apps/mine`
}

export const listMyConnectedApps = async (organizationId: string, options?: RequestInit): Promise<listMyConnectedAppsResponse> => {

  return axiosInstance<listMyConnectedAppsResponse>(getListMyConnectedAppsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMyConnectedAppsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/connected-apps/mine`
    ] as const;
    }


export const getListMyConnectedAppsQueryOptions = <TData = Awaited<ReturnType<typeof listMyConnectedApps>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyConnectedAppsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyConnectedApps>>> = ({ signal }) => listMyConnectedApps(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyConnectedAppsQueryResult = NonNullable<Awaited<ReturnType<typeof listMyConnectedApps>>>
export type ListMyConnectedAppsQueryError = ErrorType<unknown>


export function useListMyConnectedApps<TData = Awaited<ReturnType<typeof listMyConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyConnectedApps>>,
          TError,
          Awaited<ReturnType<typeof listMyConnectedApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyConnectedApps<TData = Awaited<ReturnType<typeof listMyConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyConnectedApps>>,
          TError,
          Awaited<ReturnType<typeof listMyConnectedApps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyConnectedApps<TData = Awaited<ReturnType<typeof listMyConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMyConnectedApps<TData = Awaited<ReturnType<typeof listMyConnectedApps>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyConnectedApps>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyConnectedAppsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type revokeConnectedAppResponse204 = {
  data: void
  status: 204
}

export type revokeConnectedAppResponseSuccess = (revokeConnectedAppResponse204) & {
  headers: Headers;
};
;

export type revokeConnectedAppResponse = (revokeConnectedAppResponseSuccess)

export const getRevokeConnectedAppUrl = (organizationId: string,
    grantId: string,) => {




  return `/organizations/${organizationId}/connected-apps/${grantId}`
}

export const revokeConnectedApp = async (organizationId: string,
    grantId: string, options?: RequestInit): Promise<revokeConnectedAppResponse> => {

  return axiosInstance<revokeConnectedAppResponse>(getRevokeConnectedAppUrl(organizationId,grantId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeConnectedAppMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnectedApp>>, TError,{organizationId: string;grantId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeConnectedApp>>, TError,{organizationId: string;grantId: string}, TContext> => {

const mutationKey = ['revokeConnectedApp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeConnectedApp>>, {organizationId: string;grantId: string}> = (props) => {
          const {organizationId,grantId} = props ?? {};

          return  revokeConnectedApp(organizationId,grantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeConnectedAppMutationResult = NonNullable<Awaited<ReturnType<typeof revokeConnectedApp>>>

    export type RevokeConnectedAppMutationError = ErrorType<unknown>

    export const useRevokeConnectedApp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeConnectedApp>>, TError,{organizationId: string;grantId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeConnectedApp>>,
        TError,
        {organizationId: string;grantId: string},
        TContext
      > => {
      return useMutation(getRevokeConnectedAppMutationOptions(options), queryClient);
    }

export type listOrganizationMembershipsResponse200 = {
  data: ListOrganizationMembershipsResponseDto
  status: 200
}

export type listOrganizationMembershipsResponseSuccess = (listOrganizationMembershipsResponse200) & {
  headers: Headers;
};
;

export type listOrganizationMembershipsResponse = (listOrganizationMembershipsResponseSuccess)

export const getListOrganizationMembershipsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/memberships`
}

export const listOrganizationMemberships = async (organizationId: string, options?: RequestInit): Promise<listOrganizationMembershipsResponse> => {

  return axiosInstance<listOrganizationMembershipsResponse>(getListOrganizationMembershipsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationMembershipsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/memberships`
    ] as const;
    }


export const getListOrganizationMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationMemberships>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationMembershipsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationMemberships>>> = ({ signal }) => listOrganizationMemberships(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationMemberships>>>
export type ListOrganizationMembershipsQueryError = ErrorType<unknown>


export function useListOrganizationMemberships<TData = Awaited<ReturnType<typeof listOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationMemberships>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationMemberships<TData = Awaited<ReturnType<typeof listOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationMemberships>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationMemberships<TData = Awaited<ReturnType<typeof listOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationMemberships<TData = Awaited<ReturnType<typeof listOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationMembershipsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listInvitationsResponse200 = {
  data: ListOrganizationMembershipInvitationsResponseDto
  status: 200
}

export type listInvitationsResponseSuccess = (listInvitationsResponse200) & {
  headers: Headers;
};
;

export type listInvitationsResponse = (listInvitationsResponseSuccess)

export const getListInvitationsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/memberships/invitations`
}

export const listInvitations = async (organizationId: string, options?: RequestInit): Promise<listInvitationsResponse> => {

  return axiosInstance<listInvitationsResponse>(getListInvitationsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvitationsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/memberships/invitations`
    ] as const;
    }


export const getListInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvitationsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({ signal }) => listInvitations(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvitations>>>
export type ListInvitationsQueryError = ErrorType<unknown>


export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitations>>,
          TError,
          Awaited<ReturnType<typeof listInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInvitations<TData = Awaited<ReturnType<typeof listInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInvitationsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createInvitationResponse201 = {
  data: void
  status: 201
}

export type createInvitationResponseSuccess = (createInvitationResponse201) & {
  headers: Headers;
};
;

export type createInvitationResponse = (createInvitationResponseSuccess)

export const getCreateInvitationUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/memberships/invitations`
}

export const createInvitation = async (organizationId: string,
    createOrganizationMembershipInvitationBodyDto: CreateOrganizationMembershipInvitationBodyDto, options?: RequestInit): Promise<createInvitationResponse> => {

  return axiosInstance<createInvitationResponse>(getCreateInvitationUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationMembershipInvitationBodyDto,)
  }
);}




export const getCreateInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext> => {

const mutationKey = ['createInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvitation>>, {organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createInvitation(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createInvitation>>>
    export type CreateInvitationMutationBody = BodyType<CreateOrganizationMembershipInvitationBodyDto>
    export type CreateInvitationMutationError = ErrorType<unknown>

    export const useCreateInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInvitation>>,
        TError,
        {organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>},
        TContext
      > => {
      return useMutation(getCreateInvitationMutationOptions(options), queryClient);
    }

export type disableOrganizationMembershipResponse204 = {
  data: void
  status: 204
}

export type disableOrganizationMembershipResponseSuccess = (disableOrganizationMembershipResponse204) & {
  headers: Headers;
};
;

export type disableOrganizationMembershipResponse = (disableOrganizationMembershipResponseSuccess)

export const getDisableOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/disable`
}

export const disableOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<disableOrganizationMembershipResponse> => {

  return axiosInstance<disableOrganizationMembershipResponse>(getDisableOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDisableOrganizationMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext> => {

const mutationKey = ['disableOrganizationMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableOrganizationMembership>>, {organizationId: string;organizationMembershipId: string}> = (props) => {
          const {organizationId,organizationMembershipId} = props ?? {};

          return  disableOrganizationMembership(organizationId,organizationMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableOrganizationMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof disableOrganizationMembership>>>

    export type DisableOrganizationMembershipMutationError = ErrorType<unknown>

    export const useDisableOrganizationMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableOrganizationMembership>>,
        TError,
        {organizationId: string;organizationMembershipId: string},
        TContext
      > => {
      return useMutation(getDisableOrganizationMembershipMutationOptions(options), queryClient);
    }

export type enableOrganizationMembershipResponse204 = {
  data: void
  status: 204
}

export type enableOrganizationMembershipResponseSuccess = (enableOrganizationMembershipResponse204) & {
  headers: Headers;
};
;

export type enableOrganizationMembershipResponse = (enableOrganizationMembershipResponseSuccess)

export const getEnableOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/enable`
}

export const enableOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<enableOrganizationMembershipResponse> => {

  return axiosInstance<enableOrganizationMembershipResponse>(getEnableOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getEnableOrganizationMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof enableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext> => {

const mutationKey = ['enableOrganizationMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof enableOrganizationMembership>>, {organizationId: string;organizationMembershipId: string}> = (props) => {
          const {organizationId,organizationMembershipId} = props ?? {};

          return  enableOrganizationMembership(organizationId,organizationMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EnableOrganizationMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof enableOrganizationMembership>>>

    export type EnableOrganizationMembershipMutationError = ErrorType<unknown>

    export const useEnableOrganizationMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof enableOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof enableOrganizationMembership>>,
        TError,
        {organizationId: string;organizationMembershipId: string},
        TContext
      > => {
      return useMutation(getEnableOrganizationMembershipMutationOptions(options), queryClient);
    }

export type getOrganizationMembershipResponse200 = {
  data: GetOrganizationMembershipResponseDto
  status: 200
}

export type getOrganizationMembershipResponseSuccess = (getOrganizationMembershipResponse200) & {
  headers: Headers;
};
;

export type getOrganizationMembershipResponse = (getOrganizationMembershipResponseSuccess)

export const getGetOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}`
}

export const getOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<getOrganizationMembershipResponse> => {

  return axiosInstance<getOrganizationMembershipResponse>(getGetOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationMembershipQueryKey = (organizationId: string,
    organizationMembershipId: string,) => {
    return [
    `/organizations/${organizationId}/memberships/${organizationMembershipId}`
    ] as const;
    }


export const getGetOrganizationMembershipQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationMembership>>, TError = ErrorType<unknown>>(organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationMembershipQueryKey(organizationId,organizationMembershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationMembership>>> = ({ signal }) => getOrganizationMembership(organizationId,organizationMembershipId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && organizationMembershipId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationMembershipQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationMembership>>>
export type GetOrganizationMembershipQueryError = ErrorType<unknown>


export function useGetOrganizationMembership<TData = Awaited<ReturnType<typeof getOrganizationMembership>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMembership>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationMembership<TData = Awaited<ReturnType<typeof getOrganizationMembership>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationMembership>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationMembership>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationMembership<TData = Awaited<ReturnType<typeof getOrganizationMembership>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationMembership<TData = Awaited<ReturnType<typeof getOrganizationMembership>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationMembership>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationMembershipQueryOptions(organizationId,organizationMembershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateOrganizationMembershipResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationMembershipResponseSuccess = (updateOrganizationMembershipResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationMembershipResponse = (updateOrganizationMembershipResponseSuccess)

export const getUpdateOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}`
}

export const updateOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string,
    updateOrganizationMembershipBodyDto: UpdateOrganizationMembershipBodyDto, options?: RequestInit): Promise<updateOrganizationMembershipResponse> => {

  return axiosInstance<updateOrganizationMembershipResponse>(getUpdateOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationMembershipBodyDto,)
  }
);}




export const getUpdateOrganizationMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationMembership>>, {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipBodyDto>}> = (props) => {
          const {organizationId,organizationMembershipId,data} = props ?? {};

          return  updateOrganizationMembership(organizationId,organizationMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationMembership>>>
    export type UpdateOrganizationMembershipMutationBody = BodyType<UpdateOrganizationMembershipBodyDto>
    export type UpdateOrganizationMembershipMutationError = ErrorType<unknown>

    export const useUpdateOrganizationMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationMembership>>,
        TError,
        {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationMembershipMutationOptions(options), queryClient);
    }

export type deleteOrganizationMembershipResponse204 = {
  data: void
  status: 204
}

export type deleteOrganizationMembershipResponseSuccess = (deleteOrganizationMembershipResponse204) & {
  headers: Headers;
};
;

export type deleteOrganizationMembershipResponse = (deleteOrganizationMembershipResponseSuccess)

export const getDeleteOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}`
}

export const deleteOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<deleteOrganizationMembershipResponse> => {

  return axiosInstance<deleteOrganizationMembershipResponse>(getDeleteOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOrganizationMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext> => {

const mutationKey = ['deleteOrganizationMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationMembership>>, {organizationId: string;organizationMembershipId: string}> = (props) => {
          const {organizationId,organizationMembershipId} = props ?? {};

          return  deleteOrganizationMembership(organizationId,organizationMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationMembership>>>

    export type DeleteOrganizationMembershipMutationError = ErrorType<unknown>

    export const useDeleteOrganizationMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationMembership>>,
        TError,
        {organizationId: string;organizationMembershipId: string},
        TContext
      > => {
      return useMutation(getDeleteOrganizationMembershipMutationOptions(options), queryClient);
    }

export type updateOrganizationMembershipProfileResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationMembershipProfileResponseSuccess = (updateOrganizationMembershipProfileResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationMembershipProfileResponse = (updateOrganizationMembershipProfileResponseSuccess)

export const getUpdateOrganizationMembershipProfileUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/profile`
}

export const updateOrganizationMembershipProfile = async (organizationId: string,
    organizationMembershipId: string,
    updateOrganizationMembershipProfileBodyDto: UpdateOrganizationMembershipProfileBodyDto, options?: RequestInit): Promise<updateOrganizationMembershipProfileResponse> => {

  return axiosInstance<updateOrganizationMembershipProfileResponse>(getUpdateOrganizationMembershipProfileUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationMembershipProfileBodyDto,)
  }
);}




export const getUpdateOrganizationMembershipProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipProfileBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationMembershipProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>, {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipProfileBodyDto>}> = (props) => {
          const {organizationId,organizationMembershipId,data} = props ?? {};

          return  updateOrganizationMembershipProfile(organizationId,organizationMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationMembershipProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>>
    export type UpdateOrganizationMembershipProfileMutationBody = BodyType<UpdateOrganizationMembershipProfileBodyDto>
    export type UpdateOrganizationMembershipProfileMutationError = ErrorType<unknown>

    export const useUpdateOrganizationMembershipProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationMembershipProfile>>,
        TError,
        {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateOrganizationMembershipProfileBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationMembershipProfileMutationOptions(options), queryClient);
    }

export type leaveOrganizationMembershipResponse204 = {
  data: void
  status: 204
}

export type leaveOrganizationMembershipResponseSuccess = (leaveOrganizationMembershipResponse204) & {
  headers: Headers;
};
;

export type leaveOrganizationMembershipResponse = (leaveOrganizationMembershipResponseSuccess)

export const getLeaveOrganizationMembershipUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/leave`
}

export const leaveOrganizationMembership = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<leaveOrganizationMembershipResponse> => {

  return axiosInstance<leaveOrganizationMembershipResponse>(getLeaveOrganizationMembershipUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLeaveOrganizationMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext> => {

const mutationKey = ['leaveOrganizationMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveOrganizationMembership>>, {organizationId: string;organizationMembershipId: string}> = (props) => {
          const {organizationId,organizationMembershipId} = props ?? {};

          return  leaveOrganizationMembership(organizationId,organizationMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveOrganizationMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof leaveOrganizationMembership>>>

    export type LeaveOrganizationMembershipMutationError = ErrorType<unknown>

    export const useLeaveOrganizationMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveOrganizationMembership>>, TError,{organizationId: string;organizationMembershipId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leaveOrganizationMembership>>,
        TError,
        {organizationId: string;organizationMembershipId: string},
        TContext
      > => {
      return useMutation(getLeaveOrganizationMembershipMutationOptions(options), queryClient);
    }

export type resendInvitationResponse201 = {
  data: void
  status: 201
}

export type resendInvitationResponseSuccess = (resendInvitationResponse201) & {
  headers: Headers;
};
;

export type resendInvitationResponse = (resendInvitationResponseSuccess)

export const getResendInvitationUrl = (organizationId: string,
    organizationMembershipInvitationId: string,) => {




  return `/organizations/${organizationId}/memberships/invitations/${organizationMembershipInvitationId}/resend`
}

export const resendInvitation = async (organizationId: string,
    organizationMembershipInvitationId: string, options?: RequestInit): Promise<resendInvitationResponse> => {

  return axiosInstance<resendInvitationResponse>(getResendInvitationUrl(organizationId,organizationMembershipInvitationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext> => {

const mutationKey = ['resendInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendInvitation>>, {organizationId: string;organizationMembershipInvitationId: string}> = (props) => {
          const {organizationId,organizationMembershipInvitationId} = props ?? {};

          return  resendInvitation(organizationId,organizationMembershipInvitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendInvitation>>>

    export type ResendInvitationMutationError = ErrorType<unknown>

    export const useResendInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendInvitation>>,
        TError,
        {organizationId: string;organizationMembershipInvitationId: string},
        TContext
      > => {
      return useMutation(getResendInvitationMutationOptions(options), queryClient);
    }

export type revokeInvitationResponse204 = {
  data: void
  status: 204
}

export type revokeInvitationResponseSuccess = (revokeInvitationResponse204) & {
  headers: Headers;
};
;

export type revokeInvitationResponse = (revokeInvitationResponseSuccess)

export const getRevokeInvitationUrl = (organizationId: string,
    organizationMembershipInvitationId: string,) => {




  return `/organizations/${organizationId}/memberships/invitations/${organizationMembershipInvitationId}`
}

export const revokeInvitation = async (organizationId: string,
    organizationMembershipInvitationId: string, options?: RequestInit): Promise<revokeInvitationResponse> => {

  return axiosInstance<revokeInvitationResponse>(getRevokeInvitationUrl(organizationId,organizationMembershipInvitationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext> => {

const mutationKey = ['revokeInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeInvitation>>, {organizationId: string;organizationMembershipInvitationId: string}> = (props) => {
          const {organizationId,organizationMembershipInvitationId} = props ?? {};

          return  revokeInvitation(organizationId,organizationMembershipInvitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof revokeInvitation>>>

    export type RevokeInvitationMutationError = ErrorType<unknown>

    export const useRevokeInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeInvitation>>,
        TError,
        {organizationId: string;organizationMembershipInvitationId: string},
        TContext
      > => {
      return useMutation(getRevokeInvitationMutationOptions(options), queryClient);
    }

export type getNotificationSettingsResponse200 = {
  data: GetNotificationSettingsResponseDto
  status: 200
}

export type getNotificationSettingsResponseSuccess = (getNotificationSettingsResponse200) & {
  headers: Headers;
};
;

export type getNotificationSettingsResponse = (getNotificationSettingsResponseSuccess)

export const getGetNotificationSettingsUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/notification-settings`
}

export const getNotificationSettings = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<getNotificationSettingsResponse> => {

  return axiosInstance<getNotificationSettingsResponse>(getGetNotificationSettingsUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetNotificationSettingsQueryKey = (organizationId: string,
    organizationMembershipId: string,) => {
    return [
    `/organizations/${organizationId}/memberships/${organizationMembershipId}/notification-settings`
    ] as const;
    }


export const getGetNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey(organizationId,organizationMembershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSettings>>> = ({ signal }) => getNotificationSettings(organizationId,organizationMembershipId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && organizationMembershipId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationSettings>>>
export type GetNotificationSettingsQueryError = ErrorType<unknown>


export function useGetNotificationSettings<TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationSettings<TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationSettings<TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetNotificationSettings<TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationSettingsQueryOptions(organizationId,organizationMembershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateNotificationSettingsResponse200 = {
  data: GetNotificationSettingsResponseDto
  status: 200
}

export type updateNotificationSettingsResponseSuccess = (updateNotificationSettingsResponse200) & {
  headers: Headers;
};
;

export type updateNotificationSettingsResponse = (updateNotificationSettingsResponseSuccess)

export const getUpdateNotificationSettingsUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/notification-settings`
}

export const updateNotificationSettings = async (organizationId: string,
    organizationMembershipId: string,
    updateNotificationSettingsBodyDto: UpdateNotificationSettingsBodyDto, options?: RequestInit): Promise<updateNotificationSettingsResponse> => {

  return axiosInstance<updateNotificationSettingsResponse>(getUpdateNotificationSettingsUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateNotificationSettingsBodyDto,)
  }
);}




export const getUpdateNotificationSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateNotificationSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateNotificationSettingsBodyDto>}, TContext> => {

const mutationKey = ['updateNotificationSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationSettings>>, {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateNotificationSettingsBodyDto>}> = (props) => {
          const {organizationId,organizationMembershipId,data} = props ?? {};

          return  updateNotificationSettings(organizationId,organizationMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationSettings>>>
    export type UpdateNotificationSettingsMutationBody = BodyType<UpdateNotificationSettingsBodyDto>
    export type UpdateNotificationSettingsMutationError = ErrorType<unknown>

    export const useUpdateNotificationSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateNotificationSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationSettings>>,
        TError,
        {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateNotificationSettingsBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateNotificationSettingsMutationOptions(options), queryClient);
    }

export type updateOrganizationOnboardingResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationOnboardingResponseSuccess = (updateOrganizationOnboardingResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationOnboardingResponse = (updateOrganizationOnboardingResponseSuccess)

export const getUpdateOrganizationOnboardingUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/onboarding`
}

export const updateOrganizationOnboarding = async (organizationId: string,
    updateOrganizationOnboardingBodyDto: UpdateOrganizationOnboardingBodyDto, options?: RequestInit): Promise<updateOrganizationOnboardingResponse> => {

  return axiosInstance<updateOrganizationOnboardingResponse>(getUpdateOrganizationOnboardingUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationOnboardingBodyDto,)
  }
);}




export const getUpdateOrganizationOnboardingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationOnboarding>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationOnboardingBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationOnboarding>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationOnboardingBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationOnboarding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationOnboarding>>, {organizationId: string;data: BodyType<UpdateOrganizationOnboardingBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateOrganizationOnboarding(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationOnboardingMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationOnboarding>>>
    export type UpdateOrganizationOnboardingMutationBody = BodyType<UpdateOrganizationOnboardingBodyDto>
    export type UpdateOrganizationOnboardingMutationError = ErrorType<unknown>

    export const useUpdateOrganizationOnboarding = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationOnboarding>>, TError,{organizationId: string;data: BodyType<UpdateOrganizationOnboardingBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationOnboarding>>,
        TError,
        {organizationId: string;data: BodyType<UpdateOrganizationOnboardingBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationOnboardingMutationOptions(options), queryClient);
    }

export type getSettingsResponse200 = {
  data: GetSettingsResponseDto
  status: 200
}

export type getSettingsResponseSuccess = (getSettingsResponse200) & {
  headers: Headers;
};
;

export type getSettingsResponse = (getSettingsResponseSuccess)

export const getGetSettingsUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/settings`
}

export const getSettings = async (organizationId: string,
    organizationMembershipId: string, options?: RequestInit): Promise<getSettingsResponse> => {

  return axiosInstance<getSettingsResponse>(getGetSettingsUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = (organizationId: string,
    organizationMembershipId: string,) => {
    return [
    `/organizations/${organizationId}/memberships/${organizationMembershipId}/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey(organizationId,organizationMembershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(organizationId,organizationMembershipId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && organizationMembershipId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<unknown>


export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettings>>,
          TError,
          Awaited<ReturnType<typeof getSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationMembershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsQueryOptions(organizationId,organizationMembershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateSettingsResponse200 = {
  data: GetSettingsResponseDto
  status: 200
}

export type updateSettingsResponseSuccess = (updateSettingsResponse200) & {
  headers: Headers;
};
;

export type updateSettingsResponse = (updateSettingsResponseSuccess)

export const getUpdateSettingsUrl = (organizationId: string,
    organizationMembershipId: string,) => {




  return `/organizations/${organizationId}/memberships/${organizationMembershipId}/settings`
}

export const updateSettings = async (organizationId: string,
    organizationMembershipId: string,
    updateSettingsBodyDto: UpdateSettingsBodyDto, options?: RequestInit): Promise<updateSettingsResponse> => {

  return axiosInstance<updateSettingsResponse>(getUpdateSettingsUrl(organizationId,organizationMembershipId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSettingsBodyDto,)
  }
);}




export const getUpdateSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateSettingsBodyDto>}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateSettingsBodyDto>}> = (props) => {
          const {organizationId,organizationMembershipId,data} = props ?? {};

          return  updateSettings(organizationId,organizationMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = BodyType<UpdateSettingsBodyDto>
    export type UpdateSettingsMutationError = ErrorType<unknown>

    export const useUpdateSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{organizationId: string;organizationMembershipId: string;data: BodyType<UpdateSettingsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {organizationId: string;organizationMembershipId: string;data: BodyType<UpdateSettingsBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options), queryClient);
    }

export type listOrganizationRolesResponse200 = {
  data: ListOrganizationRolesResponseDto
  status: 200
}

export type listOrganizationRolesResponseSuccess = (listOrganizationRolesResponse200) & {
  headers: Headers;
};
;

export type listOrganizationRolesResponse = (listOrganizationRolesResponseSuccess)

export const getListOrganizationRolesUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/roles`
}

export const listOrganizationRoles = async (organizationId: string, options?: RequestInit): Promise<listOrganizationRolesResponse> => {

  return axiosInstance<listOrganizationRolesResponse>(getListOrganizationRolesUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationRolesQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/roles`
    ] as const;
    }


export const getListOrganizationRolesQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationRoles>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationRolesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationRoles>>> = ({ signal }) => listOrganizationRoles(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationRoles>>>
export type ListOrganizationRolesQueryError = ErrorType<unknown>


export function useListOrganizationRoles<TData = Awaited<ReturnType<typeof listOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationRoles<TData = Awaited<ReturnType<typeof listOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationRoles<TData = Awaited<ReturnType<typeof listOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationRoles<TData = Awaited<ReturnType<typeof listOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationRolesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createOrganizationRoleResponse201 = {
  data: void
  status: 201
}

export type createOrganizationRoleResponseSuccess = (createOrganizationRoleResponse201) & {
  headers: Headers;
};
;

export type createOrganizationRoleResponse = (createOrganizationRoleResponseSuccess)

export const getCreateOrganizationRoleUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/roles`
}

export const createOrganizationRole = async (organizationId: string,
    createOrganizationRoleBodyDto: CreateOrganizationRoleBodyDto, options?: RequestInit): Promise<createOrganizationRoleResponse> => {

  return axiosInstance<createOrganizationRoleResponse>(getCreateOrganizationRoleUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationRoleBodyDto,)
  }
);}




export const getCreateOrganizationRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationRole>>, TError,{organizationId: string;data: BodyType<CreateOrganizationRoleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganizationRole>>, TError,{organizationId: string;data: BodyType<CreateOrganizationRoleBodyDto>}, TContext> => {

const mutationKey = ['createOrganizationRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganizationRole>>, {organizationId: string;data: BodyType<CreateOrganizationRoleBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createOrganizationRole(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganizationRole>>>
    export type CreateOrganizationRoleMutationBody = BodyType<CreateOrganizationRoleBodyDto>
    export type CreateOrganizationRoleMutationError = ErrorType<unknown>

    export const useCreateOrganizationRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationRole>>, TError,{organizationId: string;data: BodyType<CreateOrganizationRoleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganizationRole>>,
        TError,
        {organizationId: string;data: BodyType<CreateOrganizationRoleBodyDto>},
        TContext
      > => {
      return useMutation(getCreateOrganizationRoleMutationOptions(options), queryClient);
    }

export type getOrganizationRoleResponse200 = {
  data: GetOrganizationRoleResponseDto
  status: 200
}

export type getOrganizationRoleResponseSuccess = (getOrganizationRoleResponse200) & {
  headers: Headers;
};
;

export type getOrganizationRoleResponse = (getOrganizationRoleResponseSuccess)

export const getGetOrganizationRoleUrl = (organizationId: string,
    organizationRoleId: string,) => {




  return `/organizations/${organizationId}/roles/${organizationRoleId}`
}

export const getOrganizationRole = async (organizationId: string,
    organizationRoleId: string, options?: RequestInit): Promise<getOrganizationRoleResponse> => {

  return axiosInstance<getOrganizationRoleResponse>(getGetOrganizationRoleUrl(organizationId,organizationRoleId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrganizationRoleQueryKey = (organizationId: string,
    organizationRoleId: string,) => {
    return [
    `/organizations/${organizationId}/roles/${organizationRoleId}`
    ] as const;
    }


export const getGetOrganizationRoleQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ErrorType<unknown>>(organizationId: string,
    organizationRoleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationRoleQueryKey(organizationId,organizationRoleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationRole>>> = ({ signal }) => getOrganizationRole(organizationId,organizationRoleId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && organizationRoleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationRole>>>
export type GetOrganizationRoleQueryError = ErrorType<unknown>


export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationRoleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationRoleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationRole>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationRoleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganizationRole<TData = Awaited<ReturnType<typeof getOrganizationRole>>, TError = ErrorType<unknown>>(
 organizationId: string,
    organizationRoleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationRole>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationRoleQueryOptions(organizationId,organizationRoleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateOrganizationRoleResponse204 = {
  data: void
  status: 204
}

export type updateOrganizationRoleResponseSuccess = (updateOrganizationRoleResponse204) & {
  headers: Headers;
};
;

export type updateOrganizationRoleResponse = (updateOrganizationRoleResponseSuccess)

export const getUpdateOrganizationRoleUrl = (organizationId: string,
    organizationRoleId: string,) => {




  return `/organizations/${organizationId}/roles/${organizationRoleId}`
}

export const updateOrganizationRole = async (organizationId: string,
    organizationRoleId: string,
    updateOrganizationRoleBodyDto: UpdateOrganizationRoleBodyDto, options?: RequestInit): Promise<updateOrganizationRoleResponse> => {

  return axiosInstance<updateOrganizationRoleResponse>(getUpdateOrganizationRoleUrl(organizationId,organizationRoleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrganizationRoleBodyDto,)
  }
);}




export const getUpdateOrganizationRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string;data: BodyType<UpdateOrganizationRoleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string;data: BodyType<UpdateOrganizationRoleBodyDto>}, TContext> => {

const mutationKey = ['updateOrganizationRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrganizationRole>>, {organizationId: string;organizationRoleId: string;data: BodyType<UpdateOrganizationRoleBodyDto>}> = (props) => {
          const {organizationId,organizationRoleId,data} = props ?? {};

          return  updateOrganizationRole(organizationId,organizationRoleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrganizationRole>>>
    export type UpdateOrganizationRoleMutationBody = BodyType<UpdateOrganizationRoleBodyDto>
    export type UpdateOrganizationRoleMutationError = ErrorType<unknown>

    export const useUpdateOrganizationRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string;data: BodyType<UpdateOrganizationRoleBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrganizationRole>>,
        TError,
        {organizationId: string;organizationRoleId: string;data: BodyType<UpdateOrganizationRoleBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateOrganizationRoleMutationOptions(options), queryClient);
    }

export type deleteOrganizationRoleResponse204 = {
  data: void
  status: 204
}

export type deleteOrganizationRoleResponseSuccess = (deleteOrganizationRoleResponse204) & {
  headers: Headers;
};
;

export type deleteOrganizationRoleResponse = (deleteOrganizationRoleResponseSuccess)

export const getDeleteOrganizationRoleUrl = (organizationId: string,
    organizationRoleId: string,) => {




  return `/organizations/${organizationId}/roles/${organizationRoleId}`
}

export const deleteOrganizationRole = async (organizationId: string,
    organizationRoleId: string, options?: RequestInit): Promise<deleteOrganizationRoleResponse> => {

  return axiosInstance<deleteOrganizationRoleResponse>(getDeleteOrganizationRoleUrl(organizationId,organizationRoleId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOrganizationRoleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string}, TContext> => {

const mutationKey = ['deleteOrganizationRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationRole>>, {organizationId: string;organizationRoleId: string}> = (props) => {
          const {organizationId,organizationRoleId} = props ?? {};

          return  deleteOrganizationRole(organizationId,organizationRoleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationRole>>>

    export type DeleteOrganizationRoleMutationError = ErrorType<unknown>

    export const useDeleteOrganizationRole = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationRole>>, TError,{organizationId: string;organizationRoleId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationRole>>,
        TError,
        {organizationId: string;organizationRoleId: string},
        TContext
      > => {
      return useMutation(getDeleteOrganizationRoleMutationOptions(options), queryClient);
    }

export type globalSearchResponse200 = {
  data: GlobalSearchResponseDto
  status: 200
}

export type globalSearchResponseSuccess = (globalSearchResponse200) & {
  headers: Headers;
};
;

export type globalSearchResponse = (globalSearchResponseSuccess)

export const getGlobalSearchUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/global-search`
}

export const globalSearch = async (organizationId: string,
    globalSearchBodyDto: GlobalSearchBodyDto, options?: RequestInit): Promise<globalSearchResponse> => {

  return axiosInstance<globalSearchResponse>(getGlobalSearchUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      globalSearchBodyDto,)
  }
);}




export const getGlobalSearchMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalSearch>>, TError,{organizationId: string;data: BodyType<GlobalSearchBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof globalSearch>>, TError,{organizationId: string;data: BodyType<GlobalSearchBodyDto>}, TContext> => {

const mutationKey = ['globalSearch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof globalSearch>>, {organizationId: string;data: BodyType<GlobalSearchBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  globalSearch(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GlobalSearchMutationResult = NonNullable<Awaited<ReturnType<typeof globalSearch>>>
    export type GlobalSearchMutationBody = BodyType<GlobalSearchBodyDto>
    export type GlobalSearchMutationError = ErrorType<unknown>

    export const useGlobalSearch = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof globalSearch>>, TError,{organizationId: string;data: BodyType<GlobalSearchBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof globalSearch>>,
        TError,
        {organizationId: string;data: BodyType<GlobalSearchBodyDto>},
        TContext
      > => {
      return useMutation(getGlobalSearchMutationOptions(options), queryClient);
    }

export type createImportUploadUrlResponse201 = {
  data: ImportUploadTargetResponseDto
  status: 201
}

export type createImportUploadUrlResponseSuccess = (createImportUploadUrlResponse201) & {
  headers: Headers;
};
;

export type createImportUploadUrlResponse = (createImportUploadUrlResponseSuccess)

export const getCreateImportUploadUrlUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/imports/upload-url`
}

export const createImportUploadUrl = async (organizationId: string,
    createImportUploadUrlDto: CreateImportUploadUrlDto, options?: RequestInit): Promise<createImportUploadUrlResponse> => {

  return axiosInstance<createImportUploadUrlResponse>(getCreateImportUploadUrlUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createImportUploadUrlDto,)
  }
);}




export const getCreateImportUploadUrlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportUploadUrl>>, TError,{organizationId: string;data: BodyType<CreateImportUploadUrlDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createImportUploadUrl>>, TError,{organizationId: string;data: BodyType<CreateImportUploadUrlDto>}, TContext> => {

const mutationKey = ['createImportUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImportUploadUrl>>, {organizationId: string;data: BodyType<CreateImportUploadUrlDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createImportUploadUrl(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImportUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof createImportUploadUrl>>>
    export type CreateImportUploadUrlMutationBody = BodyType<CreateImportUploadUrlDto>
    export type CreateImportUploadUrlMutationError = ErrorType<unknown>

    export const useCreateImportUploadUrl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportUploadUrl>>, TError,{organizationId: string;data: BodyType<CreateImportUploadUrlDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImportUploadUrl>>,
        TError,
        {organizationId: string;data: BodyType<CreateImportUploadUrlDto>},
        TContext
      > => {
      return useMutation(getCreateImportUploadUrlMutationOptions(options), queryClient);
    }

export type createImportJobResponse201 = {
  data: ImportJobResponseDto
  status: 201
}

export type createImportJobResponseSuccess = (createImportJobResponse201) & {
  headers: Headers;
};
;

export type createImportJobResponse = (createImportJobResponseSuccess)

export const getCreateImportJobUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/imports`
}

export const createImportJob = async (organizationId: string,
    createImportJobDto: CreateImportJobDto, options?: RequestInit): Promise<createImportJobResponse> => {

  return axiosInstance<createImportJobResponse>(getCreateImportJobUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createImportJobDto,)
  }
);}




export const getCreateImportJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportJob>>, TError,{organizationId: string;data: BodyType<CreateImportJobDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createImportJob>>, TError,{organizationId: string;data: BodyType<CreateImportJobDto>}, TContext> => {

const mutationKey = ['createImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImportJob>>, {organizationId: string;data: BodyType<CreateImportJobDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createImportJob(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof createImportJob>>>
    export type CreateImportJobMutationBody = BodyType<CreateImportJobDto>
    export type CreateImportJobMutationError = ErrorType<unknown>

    export const useCreateImportJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImportJob>>, TError,{organizationId: string;data: BodyType<CreateImportJobDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImportJob>>,
        TError,
        {organizationId: string;data: BodyType<CreateImportJobDto>},
        TContext
      > => {
      return useMutation(getCreateImportJobMutationOptions(options), queryClient);
    }

export type listImportJobsResponse200 = {
  data: ListImportJobsResponseDto
  status: 200
}

export type listImportJobsResponseSuccess = (listImportJobsResponse200) & {
  headers: Headers;
};
;

export type listImportJobsResponse = (listImportJobsResponseSuccess)

export const getListImportJobsUrl = (organizationId: string,
    params?: ListImportJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/imports?${stringifiedParams}` : `/organizations/${organizationId}/imports`
}

export const listImportJobs = async (organizationId: string,
    params?: ListImportJobsParams, options?: RequestInit): Promise<listImportJobsResponse> => {

  return axiosInstance<listImportJobsResponse>(getListImportJobsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListImportJobsQueryKey = (organizationId: string,
    params?: ListImportJobsParams,) => {
    return [
    `/organizations/${organizationId}/imports`, ...(params ? [params] : [])
    ] as const;
    }


export const getListImportJobsQueryOptions = <TData = Awaited<ReturnType<typeof listImportJobs>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListImportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImportJobsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImportJobs>>> = ({ signal }) => listImportJobs(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImportJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listImportJobs>>>
export type ListImportJobsQueryError = ErrorType<unknown>


export function useListImportJobs<TData = Awaited<ReturnType<typeof listImportJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListImportJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImportJobs>>,
          TError,
          Awaited<ReturnType<typeof listImportJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImportJobs<TData = Awaited<ReturnType<typeof listImportJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListImportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImportJobs>>,
          TError,
          Awaited<ReturnType<typeof listImportJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImportJobs<TData = Awaited<ReturnType<typeof listImportJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListImportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListImportJobs<TData = Awaited<ReturnType<typeof listImportJobs>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListImportJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImportJobs>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImportJobsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getImportJobResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type getImportJobResponseSuccess = (getImportJobResponse200) & {
  headers: Headers;
};
;

export type getImportJobResponse = (getImportJobResponseSuccess)

export const getGetImportJobUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}`
}

export const getImportJob = async (organizationId: string,
    importJobId: string, options?: RequestInit): Promise<getImportJobResponse> => {

  return axiosInstance<getImportJobResponse>(getGetImportJobUrl(organizationId,importJobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetImportJobQueryKey = (organizationId: string,
    importJobId: string,) => {
    return [
    `/organizations/${organizationId}/imports/${importJobId}`
    ] as const;
    }


export const getGetImportJobQueryOptions = <TData = Awaited<ReturnType<typeof getImportJob>>, TError = ErrorType<unknown>>(organizationId: string,
    importJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportJobQueryKey(organizationId,importJobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportJob>>> = ({ signal }) => getImportJob(organizationId,importJobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && importJobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImportJobQueryResult = NonNullable<Awaited<ReturnType<typeof getImportJob>>>
export type GetImportJobQueryError = ErrorType<unknown>


export function useGetImportJob<TData = Awaited<ReturnType<typeof getImportJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    importJobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportJob>>,
          TError,
          Awaited<ReturnType<typeof getImportJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportJob<TData = Awaited<ReturnType<typeof getImportJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    importJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportJob>>,
          TError,
          Awaited<ReturnType<typeof getImportJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportJob<TData = Awaited<ReturnType<typeof getImportJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    importJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetImportJob<TData = Awaited<ReturnType<typeof getImportJob>>, TError = ErrorType<unknown>>(
 organizationId: string,
    importJobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportJob>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImportJobQueryOptions(organizationId,importJobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateImportMappingResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type updateImportMappingResponseSuccess = (updateImportMappingResponse200) & {
  headers: Headers;
};
;

export type updateImportMappingResponse = (updateImportMappingResponseSuccess)

export const getUpdateImportMappingUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}/mapping`
}

export const updateImportMapping = async (organizationId: string,
    importJobId: string,
    updateImportMappingDto: UpdateImportMappingDto, options?: RequestInit): Promise<updateImportMappingResponse> => {

  return axiosInstance<updateImportMappingResponse>(getUpdateImportMappingUrl(organizationId,importJobId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateImportMappingDto,)
  }
);}




export const getUpdateImportMappingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImportMapping>>, TError,{organizationId: string;importJobId: string;data: BodyType<UpdateImportMappingDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateImportMapping>>, TError,{organizationId: string;importJobId: string;data: BodyType<UpdateImportMappingDto>}, TContext> => {

const mutationKey = ['updateImportMapping'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateImportMapping>>, {organizationId: string;importJobId: string;data: BodyType<UpdateImportMappingDto>}> = (props) => {
          const {organizationId,importJobId,data} = props ?? {};

          return  updateImportMapping(organizationId,importJobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateImportMappingMutationResult = NonNullable<Awaited<ReturnType<typeof updateImportMapping>>>
    export type UpdateImportMappingMutationBody = BodyType<UpdateImportMappingDto>
    export type UpdateImportMappingMutationError = ErrorType<unknown>

    export const useUpdateImportMapping = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImportMapping>>, TError,{organizationId: string;importJobId: string;data: BodyType<UpdateImportMappingDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateImportMapping>>,
        TError,
        {organizationId: string;importJobId: string;data: BodyType<UpdateImportMappingDto>},
        TContext
      > => {
      return useMutation(getUpdateImportMappingMutationOptions(options), queryClient);
    }

export type validateImportJobResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type validateImportJobResponseSuccess = (validateImportJobResponse200) & {
  headers: Headers;
};
;

export type validateImportJobResponse = (validateImportJobResponseSuccess)

export const getValidateImportJobUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}/validate`
}

export const validateImportJob = async (organizationId: string,
    importJobId: string,
    validateImportDto: ValidateImportDto, options?: RequestInit): Promise<validateImportJobResponse> => {

  return axiosInstance<validateImportJobResponse>(getValidateImportJobUrl(organizationId,importJobId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      validateImportDto,)
  }
);}




export const getValidateImportJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateImportJob>>, TError,{organizationId: string;importJobId: string;data: BodyType<ValidateImportDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateImportJob>>, TError,{organizationId: string;importJobId: string;data: BodyType<ValidateImportDto>}, TContext> => {

const mutationKey = ['validateImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateImportJob>>, {organizationId: string;importJobId: string;data: BodyType<ValidateImportDto>}> = (props) => {
          const {organizationId,importJobId,data} = props ?? {};

          return  validateImportJob(organizationId,importJobId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof validateImportJob>>>
    export type ValidateImportJobMutationBody = BodyType<ValidateImportDto>
    export type ValidateImportJobMutationError = ErrorType<unknown>

    export const useValidateImportJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateImportJob>>, TError,{organizationId: string;importJobId: string;data: BodyType<ValidateImportDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateImportJob>>,
        TError,
        {organizationId: string;importJobId: string;data: BodyType<ValidateImportDto>},
        TContext
      > => {
      return useMutation(getValidateImportJobMutationOptions(options), queryClient);
    }

export type executeImportJobResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type executeImportJobResponseSuccess = (executeImportJobResponse200) & {
  headers: Headers;
};
;

export type executeImportJobResponse = (executeImportJobResponseSuccess)

export const getExecuteImportJobUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}/execute`
}

export const executeImportJob = async (organizationId: string,
    importJobId: string, options?: RequestInit): Promise<executeImportJobResponse> => {

  return axiosInstance<executeImportJobResponse>(getExecuteImportJobUrl(organizationId,importJobId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getExecuteImportJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof executeImportJob>>, TError,{organizationId: string;importJobId: string}, TContext> => {

const mutationKey = ['executeImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof executeImportJob>>, {organizationId: string;importJobId: string}> = (props) => {
          const {organizationId,importJobId} = props ?? {};

          return  executeImportJob(organizationId,importJobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExecuteImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof executeImportJob>>>

    export type ExecuteImportJobMutationError = ErrorType<unknown>

    export const useExecuteImportJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof executeImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof executeImportJob>>,
        TError,
        {organizationId: string;importJobId: string},
        TContext
      > => {
      return useMutation(getExecuteImportJobMutationOptions(options), queryClient);
    }

export type rollbackImportJobResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type rollbackImportJobResponseSuccess = (rollbackImportJobResponse200) & {
  headers: Headers;
};
;

export type rollbackImportJobResponse = (rollbackImportJobResponseSuccess)

export const getRollbackImportJobUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}/rollback`
}

export const rollbackImportJob = async (organizationId: string,
    importJobId: string, options?: RequestInit): Promise<rollbackImportJobResponse> => {

  return axiosInstance<rollbackImportJobResponse>(getRollbackImportJobUrl(organizationId,importJobId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRollbackImportJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rollbackImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof rollbackImportJob>>, TError,{organizationId: string;importJobId: string}, TContext> => {

const mutationKey = ['rollbackImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rollbackImportJob>>, {organizationId: string;importJobId: string}> = (props) => {
          const {organizationId,importJobId} = props ?? {};

          return  rollbackImportJob(organizationId,importJobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RollbackImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof rollbackImportJob>>>

    export type RollbackImportJobMutationError = ErrorType<unknown>

    export const useRollbackImportJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rollbackImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rollbackImportJob>>,
        TError,
        {organizationId: string;importJobId: string},
        TContext
      > => {
      return useMutation(getRollbackImportJobMutationOptions(options), queryClient);
    }

export type dismissImportJobResponse200 = {
  data: ImportJobResponseDto
  status: 200
}

export type dismissImportJobResponseSuccess = (dismissImportJobResponse200) & {
  headers: Headers;
};
;

export type dismissImportJobResponse = (dismissImportJobResponseSuccess)

export const getDismissImportJobUrl = (organizationId: string,
    importJobId: string,) => {




  return `/organizations/${organizationId}/imports/${importJobId}/dismiss`
}

export const dismissImportJob = async (organizationId: string,
    importJobId: string, options?: RequestInit): Promise<dismissImportJobResponse> => {

  return axiosInstance<dismissImportJobResponse>(getDismissImportJobUrl(organizationId,importJobId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDismissImportJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissImportJob>>, TError,{organizationId: string;importJobId: string}, TContext> => {

const mutationKey = ['dismissImportJob'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissImportJob>>, {organizationId: string;importJobId: string}> = (props) => {
          const {organizationId,importJobId} = props ?? {};

          return  dismissImportJob(organizationId,importJobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissImportJobMutationResult = NonNullable<Awaited<ReturnType<typeof dismissImportJob>>>

    export type DismissImportJobMutationError = ErrorType<unknown>

    export const useDismissImportJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissImportJob>>, TError,{organizationId: string;importJobId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissImportJob>>,
        TError,
        {organizationId: string;importJobId: string},
        TContext
      > => {
      return useMutation(getDismissImportJobMutationOptions(options), queryClient);
    }

export type searchRecordsResponse200 = {
  data: SearchRecordsResponseDto
  status: 200
}

export type searchRecordsResponseSuccess = (searchRecordsResponse200) & {
  headers: Headers;
};
;

export type searchRecordsResponse = (searchRecordsResponseSuccess)

export const getSearchRecordsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/records/search`
}

export const searchRecords = async (organizationId: string,
    searchRecordsBodyDto: SearchRecordsBodyDto, options?: RequestInit): Promise<searchRecordsResponse> => {

  return axiosInstance<searchRecordsResponse>(getSearchRecordsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      searchRecordsBodyDto,)
  }
);}




export const getSearchRecordsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchRecords>>, TError,{organizationId: string;data: BodyType<SearchRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof searchRecords>>, TError,{organizationId: string;data: BodyType<SearchRecordsBodyDto>}, TContext> => {

const mutationKey = ['searchRecords'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchRecords>>, {organizationId: string;data: BodyType<SearchRecordsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  searchRecords(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SearchRecordsMutationResult = NonNullable<Awaited<ReturnType<typeof searchRecords>>>
    export type SearchRecordsMutationBody = BodyType<SearchRecordsBodyDto>
    export type SearchRecordsMutationError = ErrorType<unknown>

    export const useSearchRecords = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchRecords>>, TError,{organizationId: string;data: BodyType<SearchRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchRecords>>,
        TError,
        {organizationId: string;data: BodyType<SearchRecordsBodyDto>},
        TContext
      > => {
      return useMutation(getSearchRecordsMutationOptions(options), queryClient);
    }

export type loadRecordDetailsResponse200 = {
  data: LoadRecordDetailsResponseDto
  status: 200
}

export type loadRecordDetailsResponseSuccess = (loadRecordDetailsResponse200) & {
  headers: Headers;
};
;

export type loadRecordDetailsResponse = (loadRecordDetailsResponseSuccess)

export const getLoadRecordDetailsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/records/details`
}

export const loadRecordDetails = async (organizationId: string,
    loadRecordDetailsBodyDto: LoadRecordDetailsBodyDto, options?: RequestInit): Promise<loadRecordDetailsResponse> => {

  return axiosInstance<loadRecordDetailsResponse>(getLoadRecordDetailsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loadRecordDetailsBodyDto,)
  }
);}




export const getLoadRecordDetailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loadRecordDetails>>, TError,{organizationId: string;data: BodyType<LoadRecordDetailsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof loadRecordDetails>>, TError,{organizationId: string;data: BodyType<LoadRecordDetailsBodyDto>}, TContext> => {

const mutationKey = ['loadRecordDetails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loadRecordDetails>>, {organizationId: string;data: BodyType<LoadRecordDetailsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  loadRecordDetails(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoadRecordDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof loadRecordDetails>>>
    export type LoadRecordDetailsMutationBody = BodyType<LoadRecordDetailsBodyDto>
    export type LoadRecordDetailsMutationError = ErrorType<unknown>

    export const useLoadRecordDetails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loadRecordDetails>>, TError,{organizationId: string;data: BodyType<LoadRecordDetailsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loadRecordDetails>>,
        TError,
        {organizationId: string;data: BodyType<LoadRecordDetailsBodyDto>},
        TContext
      > => {
      return useMutation(getLoadRecordDetailsMutationOptions(options), queryClient);
    }

export type countRecordsResponse200 = {
  data: CountRecordsResponseDto
  status: 200
}

export type countRecordsResponseSuccess = (countRecordsResponse200) & {
  headers: Headers;
};
;

export type countRecordsResponse = (countRecordsResponseSuccess)

export const getCountRecordsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/records/count`
}

export const countRecords = async (organizationId: string,
    countRecordsBodyDto: CountRecordsBodyDto, options?: RequestInit): Promise<countRecordsResponse> => {

  return axiosInstance<countRecordsResponse>(getCountRecordsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      countRecordsBodyDto,)
  }
);}




export const getCountRecordsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countRecords>>, TError,{organizationId: string;data: BodyType<CountRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof countRecords>>, TError,{organizationId: string;data: BodyType<CountRecordsBodyDto>}, TContext> => {

const mutationKey = ['countRecords'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countRecords>>, {organizationId: string;data: BodyType<CountRecordsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  countRecords(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CountRecordsMutationResult = NonNullable<Awaited<ReturnType<typeof countRecords>>>
    export type CountRecordsMutationBody = BodyType<CountRecordsBodyDto>
    export type CountRecordsMutationError = ErrorType<unknown>

    export const useCountRecords = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countRecords>>, TError,{organizationId: string;data: BodyType<CountRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof countRecords>>,
        TError,
        {organizationId: string;data: BodyType<CountRecordsBodyDto>},
        TContext
      > => {
      return useMutation(getCountRecordsMutationOptions(options), queryClient);
    }

export type countSmartViewRecordsResponse200 = {
  data: CountSmartViewRecordsResponseDto
  status: 200
}

export type countSmartViewRecordsResponseSuccess = (countSmartViewRecordsResponse200) & {
  headers: Headers;
};
;

export type countSmartViewRecordsResponse = (countSmartViewRecordsResponseSuccess)

export const getCountSmartViewRecordsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/records/smart-view-counts`
}

export const countSmartViewRecords = async (organizationId: string,
    countSmartViewRecordsBodyDto: CountSmartViewRecordsBodyDto, options?: RequestInit): Promise<countSmartViewRecordsResponse> => {

  return axiosInstance<countSmartViewRecordsResponse>(getCountSmartViewRecordsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      countSmartViewRecordsBodyDto,)
  }
);}




export const getCountSmartViewRecordsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countSmartViewRecords>>, TError,{organizationId: string;data: BodyType<CountSmartViewRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof countSmartViewRecords>>, TError,{organizationId: string;data: BodyType<CountSmartViewRecordsBodyDto>}, TContext> => {

const mutationKey = ['countSmartViewRecords'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof countSmartViewRecords>>, {organizationId: string;data: BodyType<CountSmartViewRecordsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  countSmartViewRecords(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CountSmartViewRecordsMutationResult = NonNullable<Awaited<ReturnType<typeof countSmartViewRecords>>>
    export type CountSmartViewRecordsMutationBody = BodyType<CountSmartViewRecordsBodyDto>
    export type CountSmartViewRecordsMutationError = ErrorType<unknown>

    export const useCountSmartViewRecords = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof countSmartViewRecords>>, TError,{organizationId: string;data: BodyType<CountSmartViewRecordsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof countSmartViewRecords>>,
        TError,
        {organizationId: string;data: BodyType<CountSmartViewRecordsBodyDto>},
        TContext
      > => {
      return useMutation(getCountSmartViewRecordsMutationOptions(options), queryClient);
    }

export type listRecordBoardColumnResponse200 = {
  data: SearchRecordsResponseDto
  status: 200
}

export type listRecordBoardColumnResponseSuccess = (listRecordBoardColumnResponse200) & {
  headers: Headers;
};
;

export type listRecordBoardColumnResponse = (listRecordBoardColumnResponseSuccess)

export const getListRecordBoardColumnUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/records/board/column`
}

export const listRecordBoardColumn = async (organizationId: string,
    listRecordBoardColumnBodyDto: ListRecordBoardColumnBodyDto, options?: RequestInit): Promise<listRecordBoardColumnResponse> => {

  return axiosInstance<listRecordBoardColumnResponse>(getListRecordBoardColumnUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listRecordBoardColumnBodyDto,)
  }
);}




export const getListRecordBoardColumnMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listRecordBoardColumn>>, TError,{organizationId: string;data: BodyType<ListRecordBoardColumnBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof listRecordBoardColumn>>, TError,{organizationId: string;data: BodyType<ListRecordBoardColumnBodyDto>}, TContext> => {

const mutationKey = ['listRecordBoardColumn'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof listRecordBoardColumn>>, {organizationId: string;data: BodyType<ListRecordBoardColumnBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  listRecordBoardColumn(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ListRecordBoardColumnMutationResult = NonNullable<Awaited<ReturnType<typeof listRecordBoardColumn>>>
    export type ListRecordBoardColumnMutationBody = BodyType<ListRecordBoardColumnBodyDto>
    export type ListRecordBoardColumnMutationError = ErrorType<unknown>

    export const useListRecordBoardColumn = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof listRecordBoardColumn>>, TError,{organizationId: string;data: BodyType<ListRecordBoardColumnBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof listRecordBoardColumn>>,
        TError,
        {organizationId: string;data: BodyType<ListRecordBoardColumnBodyDto>},
        TContext
      > => {
      return useMutation(getListRecordBoardColumnMutationOptions(options), queryClient);
    }

export type listSmartViewsResponse200 = {
  data: ListSmartViewsResponseDto
  status: 200
}

export type listSmartViewsResponseSuccess = (listSmartViewsResponse200) & {
  headers: Headers;
};
;

export type listSmartViewsResponse = (listSmartViewsResponseSuccess)

export const getListSmartViewsUrl = (organizationId: string,
    params: ListSmartViewsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/smart-views?${stringifiedParams}` : `/organizations/${organizationId}/smart-views`
}

export const listSmartViews = async (organizationId: string,
    params: ListSmartViewsParams, options?: RequestInit): Promise<listSmartViewsResponse> => {

  return axiosInstance<listSmartViewsResponse>(getListSmartViewsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSmartViewsQueryKey = (organizationId: string,
    params?: ListSmartViewsParams,) => {
    return [
    `/organizations/${organizationId}/smart-views`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSmartViewsQueryOptions = <TData = Awaited<ReturnType<typeof listSmartViews>>, TError = ErrorType<unknown>>(organizationId: string,
    params: ListSmartViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSmartViewsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSmartViews>>> = ({ signal }) => listSmartViews(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSmartViewsQueryResult = NonNullable<Awaited<ReturnType<typeof listSmartViews>>>
export type ListSmartViewsQueryError = ErrorType<unknown>


export function useListSmartViews<TData = Awaited<ReturnType<typeof listSmartViews>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListSmartViewsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartViews>>,
          TError,
          Awaited<ReturnType<typeof listSmartViews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartViews<TData = Awaited<ReturnType<typeof listSmartViews>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListSmartViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartViews>>,
          TError,
          Awaited<ReturnType<typeof listSmartViews>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartViews<TData = Awaited<ReturnType<typeof listSmartViews>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListSmartViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSmartViews<TData = Awaited<ReturnType<typeof listSmartViews>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: ListSmartViewsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViews>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSmartViewsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSmartViewResponse201 = {
  data: CreateSmartViewResponseDto
  status: 201
}

export type createSmartViewResponseSuccess = (createSmartViewResponse201) & {
  headers: Headers;
};
;

export type createSmartViewResponse = (createSmartViewResponseSuccess)

export const getCreateSmartViewUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/smart-views`
}

export const createSmartView = async (organizationId: string,
    createSmartViewBodyDto: CreateSmartViewBodyDto, options?: RequestInit): Promise<createSmartViewResponse> => {

  return axiosInstance<createSmartViewResponse>(getCreateSmartViewUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSmartViewBodyDto,)
  }
);}




export const getCreateSmartViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSmartView>>, TError,{organizationId: string;data: BodyType<CreateSmartViewBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSmartView>>, TError,{organizationId: string;data: BodyType<CreateSmartViewBodyDto>}, TContext> => {

const mutationKey = ['createSmartView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSmartView>>, {organizationId: string;data: BodyType<CreateSmartViewBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createSmartView(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSmartViewMutationResult = NonNullable<Awaited<ReturnType<typeof createSmartView>>>
    export type CreateSmartViewMutationBody = BodyType<CreateSmartViewBodyDto>
    export type CreateSmartViewMutationError = ErrorType<unknown>

    export const useCreateSmartView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSmartView>>, TError,{organizationId: string;data: BodyType<CreateSmartViewBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSmartView>>,
        TError,
        {organizationId: string;data: BodyType<CreateSmartViewBodyDto>},
        TContext
      > => {
      return useMutation(getCreateSmartViewMutationOptions(options), queryClient);
    }

export type listSmartViewAvailableFieldsResponse200 = {
  data: ListSmartViewAvailableFieldsResponseDto
  status: 200
}

export type listSmartViewAvailableFieldsResponseSuccess = (listSmartViewAvailableFieldsResponse200) & {
  headers: Headers;
};
;

export type listSmartViewAvailableFieldsResponse = (listSmartViewAvailableFieldsResponseSuccess)

export const getListSmartViewAvailableFieldsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/smart-views/fields`
}

export const listSmartViewAvailableFields = async (organizationId: string, options?: RequestInit): Promise<listSmartViewAvailableFieldsResponse> => {

  return axiosInstance<listSmartViewAvailableFieldsResponse>(getListSmartViewAvailableFieldsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSmartViewAvailableFieldsQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/smart-views/fields`
    ] as const;
    }


export const getListSmartViewAvailableFieldsQueryOptions = <TData = Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSmartViewAvailableFieldsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSmartViewAvailableFields>>> = ({ signal }) => listSmartViewAvailableFields(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSmartViewAvailableFieldsQueryResult = NonNullable<Awaited<ReturnType<typeof listSmartViewAvailableFields>>>
export type ListSmartViewAvailableFieldsQueryError = ErrorType<unknown>


export function useListSmartViewAvailableFields<TData = Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartViewAvailableFields>>,
          TError,
          Awaited<ReturnType<typeof listSmartViewAvailableFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartViewAvailableFields<TData = Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSmartViewAvailableFields>>,
          TError,
          Awaited<ReturnType<typeof listSmartViewAvailableFields>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSmartViewAvailableFields<TData = Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSmartViewAvailableFields<TData = Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSmartViewAvailableFields>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSmartViewAvailableFieldsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type reorderSmartViewsResponse201 = {
  data: void
  status: 201
}

export type reorderSmartViewsResponseSuccess = (reorderSmartViewsResponse201) & {
  headers: Headers;
};
;

export type reorderSmartViewsResponse = (reorderSmartViewsResponseSuccess)

export const getReorderSmartViewsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/smart-views/reorder`
}

export const reorderSmartViews = async (organizationId: string,
    reorderSmartViewsBodyDto: ReorderSmartViewsBodyDto, options?: RequestInit): Promise<reorderSmartViewsResponse> => {

  return axiosInstance<reorderSmartViewsResponse>(getReorderSmartViewsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reorderSmartViewsBodyDto,)
  }
);}




export const getReorderSmartViewsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSmartViews>>, TError,{organizationId: string;data: BodyType<ReorderSmartViewsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderSmartViews>>, TError,{organizationId: string;data: BodyType<ReorderSmartViewsBodyDto>}, TContext> => {

const mutationKey = ['reorderSmartViews'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderSmartViews>>, {organizationId: string;data: BodyType<ReorderSmartViewsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  reorderSmartViews(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderSmartViewsMutationResult = NonNullable<Awaited<ReturnType<typeof reorderSmartViews>>>
    export type ReorderSmartViewsMutationBody = BodyType<ReorderSmartViewsBodyDto>
    export type ReorderSmartViewsMutationError = ErrorType<unknown>

    export const useReorderSmartViews = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderSmartViews>>, TError,{organizationId: string;data: BodyType<ReorderSmartViewsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderSmartViews>>,
        TError,
        {organizationId: string;data: BodyType<ReorderSmartViewsBodyDto>},
        TContext
      > => {
      return useMutation(getReorderSmartViewsMutationOptions(options), queryClient);
    }

export type updateSmartViewResponse200 = {
  data: void
  status: 200
}

export type updateSmartViewResponseSuccess = (updateSmartViewResponse200) & {
  headers: Headers;
};
;

export type updateSmartViewResponse = (updateSmartViewResponseSuccess)

export const getUpdateSmartViewUrl = (organizationId: string,
    smartViewId: string,) => {




  return `/organizations/${organizationId}/smart-views/${smartViewId}`
}

export const updateSmartView = async (organizationId: string,
    smartViewId: string,
    updateSmartViewBodyDto: UpdateSmartViewBodyDto, options?: RequestInit): Promise<updateSmartViewResponse> => {

  return axiosInstance<updateSmartViewResponse>(getUpdateSmartViewUrl(organizationId,smartViewId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSmartViewBodyDto,)
  }
);}




export const getUpdateSmartViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSmartView>>, TError,{organizationId: string;smartViewId: string;data: BodyType<UpdateSmartViewBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSmartView>>, TError,{organizationId: string;smartViewId: string;data: BodyType<UpdateSmartViewBodyDto>}, TContext> => {

const mutationKey = ['updateSmartView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSmartView>>, {organizationId: string;smartViewId: string;data: BodyType<UpdateSmartViewBodyDto>}> = (props) => {
          const {organizationId,smartViewId,data} = props ?? {};

          return  updateSmartView(organizationId,smartViewId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSmartViewMutationResult = NonNullable<Awaited<ReturnType<typeof updateSmartView>>>
    export type UpdateSmartViewMutationBody = BodyType<UpdateSmartViewBodyDto>
    export type UpdateSmartViewMutationError = ErrorType<unknown>

    export const useUpdateSmartView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSmartView>>, TError,{organizationId: string;smartViewId: string;data: BodyType<UpdateSmartViewBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSmartView>>,
        TError,
        {organizationId: string;smartViewId: string;data: BodyType<UpdateSmartViewBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateSmartViewMutationOptions(options), queryClient);
    }

export type deleteSmartViewResponse204 = {
  data: void
  status: 204
}

export type deleteSmartViewResponseSuccess = (deleteSmartViewResponse204) & {
  headers: Headers;
};
;

export type deleteSmartViewResponse = (deleteSmartViewResponseSuccess)

export const getDeleteSmartViewUrl = (organizationId: string,
    smartViewId: string,) => {




  return `/organizations/${organizationId}/smart-views/${smartViewId}`
}

export const deleteSmartView = async (organizationId: string,
    smartViewId: string, options?: RequestInit): Promise<deleteSmartViewResponse> => {

  return axiosInstance<deleteSmartViewResponse>(getDeleteSmartViewUrl(organizationId,smartViewId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSmartViewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmartView>>, TError,{organizationId: string;smartViewId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSmartView>>, TError,{organizationId: string;smartViewId: string}, TContext> => {

const mutationKey = ['deleteSmartView'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSmartView>>, {organizationId: string;smartViewId: string}> = (props) => {
          const {organizationId,smartViewId} = props ?? {};

          return  deleteSmartView(organizationId,smartViewId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSmartViewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSmartView>>>

    export type DeleteSmartViewMutationError = ErrorType<unknown>

    export const useDeleteSmartView = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSmartView>>, TError,{organizationId: string;smartViewId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSmartView>>,
        TError,
        {organizationId: string;smartViewId: string},
        TContext
      > => {
      return useMutation(getDeleteSmartViewMutationOptions(options), queryClient);
    }

export type listSuperadminOrganizationMembershipsResponse200 = {
  data: ListOrganizationMembershipsResponseDto
  status: 200
}

export type listSuperadminOrganizationMembershipsResponseSuccess = (listSuperadminOrganizationMembershipsResponse200) & {
  headers: Headers;
};
;

export type listSuperadminOrganizationMembershipsResponse = (listSuperadminOrganizationMembershipsResponseSuccess)

export const getListSuperadminOrganizationMembershipsUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/memberships`
}

export const listSuperadminOrganizationMemberships = async (organizationId: string, options?: RequestInit): Promise<listSuperadminOrganizationMembershipsResponse> => {

  return axiosInstance<listSuperadminOrganizationMembershipsResponse>(getListSuperadminOrganizationMembershipsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminOrganizationMembershipsQueryKey = (organizationId: string,) => {
    return [
    `/superadmin/organizations/${organizationId}/memberships`
    ] as const;
    }


export const getListSuperadminOrganizationMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminOrganizationMembershipsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>> = ({ signal }) => listSuperadminOrganizationMemberships(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminOrganizationMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>>
export type ListSuperadminOrganizationMembershipsQueryError = ErrorType<unknown>


export function useListSuperadminOrganizationMemberships<TData = Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizationMemberships<TData = Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizationMemberships<TData = Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminOrganizationMemberships<TData = Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationMemberships>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminOrganizationMembershipsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSuperadminInvitationsResponse200 = {
  data: ListOrganizationMembershipInvitationsResponseDto
  status: 200
}

export type listSuperadminInvitationsResponseSuccess = (listSuperadminInvitationsResponse200) & {
  headers: Headers;
};
;

export type listSuperadminInvitationsResponse = (listSuperadminInvitationsResponseSuccess)

export const getListSuperadminInvitationsUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/memberships/invitations`
}

export const listSuperadminInvitations = async (organizationId: string, options?: RequestInit): Promise<listSuperadminInvitationsResponse> => {

  return axiosInstance<listSuperadminInvitationsResponse>(getListSuperadminInvitationsUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminInvitationsQueryKey = (organizationId: string,) => {
    return [
    `/superadmin/organizations/${organizationId}/memberships/invitations`
    ] as const;
    }


export const getListSuperadminInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminInvitations>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminInvitationsQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminInvitations>>> = ({ signal }) => listSuperadminInvitations(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminInvitations>>>
export type ListSuperadminInvitationsQueryError = ErrorType<unknown>


export function useListSuperadminInvitations<TData = Awaited<ReturnType<typeof listSuperadminInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminInvitations>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminInvitations<TData = Awaited<ReturnType<typeof listSuperadminInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminInvitations>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminInvitations<TData = Awaited<ReturnType<typeof listSuperadminInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminInvitations<TData = Awaited<ReturnType<typeof listSuperadminInvitations>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminInvitations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminInvitationsQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSuperadminInvitationResponse201 = {
  data: void
  status: 201
}

export type createSuperadminInvitationResponseSuccess = (createSuperadminInvitationResponse201) & {
  headers: Headers;
};
;

export type createSuperadminInvitationResponse = (createSuperadminInvitationResponseSuccess)

export const getCreateSuperadminInvitationUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/memberships/invitations`
}

export const createSuperadminInvitation = async (organizationId: string,
    createOrganizationMembershipInvitationBodyDto: CreateOrganizationMembershipInvitationBodyDto, options?: RequestInit): Promise<createSuperadminInvitationResponse> => {

  return axiosInstance<createSuperadminInvitationResponse>(getCreateSuperadminInvitationUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrganizationMembershipInvitationBodyDto,)
  }
);}




export const getCreateSuperadminInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSuperadminInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext> => {

const mutationKey = ['createSuperadminInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSuperadminInvitation>>, {organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createSuperadminInvitation(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSuperadminInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof createSuperadminInvitation>>>
    export type CreateSuperadminInvitationMutationBody = BodyType<CreateOrganizationMembershipInvitationBodyDto>
    export type CreateSuperadminInvitationMutationError = ErrorType<unknown>

    export const useCreateSuperadminInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminInvitation>>, TError,{organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSuperadminInvitation>>,
        TError,
        {organizationId: string;data: BodyType<CreateOrganizationMembershipInvitationBodyDto>},
        TContext
      > => {
      return useMutation(getCreateSuperadminInvitationMutationOptions(options), queryClient);
    }

export type listSuperadminOrganizationRolesResponse200 = {
  data: ListOrganizationRolesResponseDto
  status: 200
}

export type listSuperadminOrganizationRolesResponseSuccess = (listSuperadminOrganizationRolesResponse200) & {
  headers: Headers;
};
;

export type listSuperadminOrganizationRolesResponse = (listSuperadminOrganizationRolesResponseSuccess)

export const getListSuperadminOrganizationRolesUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/roles`
}

export const listSuperadminOrganizationRoles = async (organizationId: string, options?: RequestInit): Promise<listSuperadminOrganizationRolesResponse> => {

  return axiosInstance<listSuperadminOrganizationRolesResponse>(getListSuperadminOrganizationRolesUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminOrganizationRolesQueryKey = (organizationId: string,) => {
    return [
    `/superadmin/organizations/${organizationId}/roles`
    ] as const;
    }


export const getListSuperadminOrganizationRolesQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminOrganizationRolesQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>> = ({ signal }) => listSuperadminOrganizationRoles(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminOrganizationRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>>
export type ListSuperadminOrganizationRolesQueryError = ErrorType<unknown>


export function useListSuperadminOrganizationRoles<TData = Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizationRoles<TData = Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizationRoles<TData = Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminOrganizationRoles<TData = Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizationRoles>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminOrganizationRolesQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type resendSuperadminInvitationResponse201 = {
  data: void
  status: 201
}

export type resendSuperadminInvitationResponseSuccess = (resendSuperadminInvitationResponse201) & {
  headers: Headers;
};
;

export type resendSuperadminInvitationResponse = (resendSuperadminInvitationResponseSuccess)

export const getResendSuperadminInvitationUrl = (organizationId: string,
    organizationMembershipInvitationId: string,) => {




  return `/superadmin/organizations/${organizationId}/memberships/invitations/${organizationMembershipInvitationId}/resend`
}

export const resendSuperadminInvitation = async (organizationId: string,
    organizationMembershipInvitationId: string, options?: RequestInit): Promise<resendSuperadminInvitationResponse> => {

  return axiosInstance<resendSuperadminInvitationResponse>(getResendSuperadminInvitationUrl(organizationId,organizationMembershipInvitationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResendSuperadminInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSuperadminInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resendSuperadminInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext> => {

const mutationKey = ['resendSuperadminInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendSuperadminInvitation>>, {organizationId: string;organizationMembershipInvitationId: string}> = (props) => {
          const {organizationId,organizationMembershipInvitationId} = props ?? {};

          return  resendSuperadminInvitation(organizationId,organizationMembershipInvitationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResendSuperadminInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof resendSuperadminInvitation>>>

    export type ResendSuperadminInvitationMutationError = ErrorType<unknown>

    export const useResendSuperadminInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendSuperadminInvitation>>, TError,{organizationId: string;organizationMembershipInvitationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendSuperadminInvitation>>,
        TError,
        {organizationId: string;organizationMembershipInvitationId: string},
        TContext
      > => {
      return useMutation(getResendSuperadminInvitationMutationOptions(options), queryClient);
    }

export type listSuperadminOrganizationsResponse200 = {
  data: ListSuperadminOrganizationsResponseDto
  status: 200
}

export type listSuperadminOrganizationsResponseSuccess = (listSuperadminOrganizationsResponse200) & {
  headers: Headers;
};
;

export type listSuperadminOrganizationsResponse = (listSuperadminOrganizationsResponseSuccess)

export const getListSuperadminOrganizationsUrl = (params?: ListSuperadminOrganizationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/organizations?${stringifiedParams}` : `/superadmin/organizations`
}

export const listSuperadminOrganizations = async (params?: ListSuperadminOrganizationsParams, options?: RequestInit): Promise<listSuperadminOrganizationsResponse> => {

  return axiosInstance<listSuperadminOrganizationsResponse>(getListSuperadminOrganizationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminOrganizationsQueryKey = (params?: ListSuperadminOrganizationsParams,) => {
    return [
    `/superadmin/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSuperadminOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError = ErrorType<unknown>>(params?: ListSuperadminOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminOrganizationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminOrganizations>>> = ({ signal }) => listSuperadminOrganizations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminOrganizations>>>
export type ListSuperadminOrganizationsQueryError = ErrorType<unknown>


export function useListSuperadminOrganizations<TData = Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError = ErrorType<unknown>>(
 params: undefined |  ListSuperadminOrganizationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizations<TData = Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminOrganizations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminOrganizations<TData = Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminOrganizations<TData = Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminOrganizationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminOrganizations>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSuperadminOrganizationResponse201 = {
  data: void
  status: 201
}

export type createSuperadminOrganizationResponseSuccess = (createSuperadminOrganizationResponse201) & {
  headers: Headers;
};
;

export type createSuperadminOrganizationResponse = (createSuperadminOrganizationResponseSuccess)

export const getCreateSuperadminOrganizationUrl = () => {




  return `/superadmin/organizations`
}

export const createSuperadminOrganization = async (createSuperadminOrganizationBodyDto: CreateSuperadminOrganizationBodyDto, options?: RequestInit): Promise<createSuperadminOrganizationResponse> => {

  return axiosInstance<createSuperadminOrganizationResponse>(getCreateSuperadminOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSuperadminOrganizationBodyDto,)
  }
);}




export const getCreateSuperadminOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminOrganization>>, TError,{data: BodyType<CreateSuperadminOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSuperadminOrganization>>, TError,{data: BodyType<CreateSuperadminOrganizationBodyDto>}, TContext> => {

const mutationKey = ['createSuperadminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSuperadminOrganization>>, {data: BodyType<CreateSuperadminOrganizationBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  createSuperadminOrganization(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSuperadminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof createSuperadminOrganization>>>
    export type CreateSuperadminOrganizationMutationBody = BodyType<CreateSuperadminOrganizationBodyDto>
    export type CreateSuperadminOrganizationMutationError = ErrorType<unknown>

    export const useCreateSuperadminOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminOrganization>>, TError,{data: BodyType<CreateSuperadminOrganizationBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSuperadminOrganization>>,
        TError,
        {data: BodyType<CreateSuperadminOrganizationBodyDto>},
        TContext
      > => {
      return useMutation(getCreateSuperadminOrganizationMutationOptions(options), queryClient);
    }

export type getSuperadminPriceTiersResponse200 = {
  data: PriceTiersResponseDto
  status: 200
}

export type getSuperadminPriceTiersResponseSuccess = (getSuperadminPriceTiersResponse200) & {
  headers: Headers;
};
;

export type getSuperadminPriceTiersResponse = (getSuperadminPriceTiersResponseSuccess)

export const getGetSuperadminPriceTiersUrl = () => {




  return `/superadmin/organizations/price-tiers`
}

export const getSuperadminPriceTiers = async ( options?: RequestInit): Promise<getSuperadminPriceTiersResponse> => {

  return axiosInstance<getSuperadminPriceTiersResponse>(getGetSuperadminPriceTiersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSuperadminPriceTiersQueryKey = () => {
    return [
    `/superadmin/organizations/price-tiers`
    ] as const;
    }


export const getGetSuperadminPriceTiersQueryOptions = <TData = Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperadminPriceTiersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperadminPriceTiers>>> = ({ signal }) => getSuperadminPriceTiers({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperadminPriceTiersQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperadminPriceTiers>>>
export type GetSuperadminPriceTiersQueryError = ErrorType<unknown>


export function useGetSuperadminPriceTiers<TData = Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminPriceTiers>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminPriceTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminPriceTiers<TData = Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminPriceTiers>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminPriceTiers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminPriceTiers<TData = Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuperadminPriceTiers<TData = Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminPriceTiers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperadminPriceTiersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type updateSuperadminOrganizationProfileResponse204 = {
  data: void
  status: 204
}

export type updateSuperadminOrganizationProfileResponseSuccess = (updateSuperadminOrganizationProfileResponse204) & {
  headers: Headers;
};
;

export type updateSuperadminOrganizationProfileResponse = (updateSuperadminOrganizationProfileResponseSuccess)

export const getUpdateSuperadminOrganizationProfileUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/profile`
}

export const updateSuperadminOrganizationProfile = async (organizationId: string,
    updateSuperadminOrganizationProfileBodyDto: UpdateSuperadminOrganizationProfileBodyDto, options?: RequestInit): Promise<updateSuperadminOrganizationProfileResponse> => {

  return axiosInstance<updateSuperadminOrganizationProfileResponse>(getUpdateSuperadminOrganizationProfileUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSuperadminOrganizationProfileBodyDto,)
  }
);}




export const getUpdateSuperadminOrganizationProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateSuperadminOrganizationProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateSuperadminOrganizationProfileBodyDto>}, TContext> => {

const mutationKey = ['updateSuperadminOrganizationProfile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>, {organizationId: string;data: BodyType<UpdateSuperadminOrganizationProfileBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  updateSuperadminOrganizationProfile(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSuperadminOrganizationProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>>
    export type UpdateSuperadminOrganizationProfileMutationBody = BodyType<UpdateSuperadminOrganizationProfileBodyDto>
    export type UpdateSuperadminOrganizationProfileMutationError = ErrorType<unknown>

    export const useUpdateSuperadminOrganizationProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>, TError,{organizationId: string;data: BodyType<UpdateSuperadminOrganizationProfileBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSuperadminOrganizationProfile>>,
        TError,
        {organizationId: string;data: BodyType<UpdateSuperadminOrganizationProfileBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateSuperadminOrganizationProfileMutationOptions(options), queryClient);
    }

export type archiveSuperadminOrganizationResponse204 = {
  data: void
  status: 204
}

export type archiveSuperadminOrganizationResponseSuccess = (archiveSuperadminOrganizationResponse204) & {
  headers: Headers;
};
;

export type archiveSuperadminOrganizationResponse = (archiveSuperadminOrganizationResponseSuccess)

export const getArchiveSuperadminOrganizationUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/archive`
}

export const archiveSuperadminOrganization = async (organizationId: string, options?: RequestInit): Promise<archiveSuperadminOrganizationResponse> => {

  return axiosInstance<archiveSuperadminOrganizationResponse>(getArchiveSuperadminOrganizationUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveSuperadminOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveSuperadminOrganization>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['archiveSuperadminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveSuperadminOrganization>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  archiveSuperadminOrganization(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveSuperadminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof archiveSuperadminOrganization>>>

    export type ArchiveSuperadminOrganizationMutationError = ErrorType<unknown>

    export const useArchiveSuperadminOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveSuperadminOrganization>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getArchiveSuperadminOrganizationMutationOptions(options), queryClient);
    }

export type restoreSuperadminOrganizationResponse204 = {
  data: void
  status: 204
}

export type restoreSuperadminOrganizationResponseSuccess = (restoreSuperadminOrganizationResponse204) & {
  headers: Headers;
};
;

export type restoreSuperadminOrganizationResponse = (restoreSuperadminOrganizationResponseSuccess)

export const getRestoreSuperadminOrganizationUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/restore`
}

export const restoreSuperadminOrganization = async (organizationId: string, options?: RequestInit): Promise<restoreSuperadminOrganizationResponse> => {

  return axiosInstance<restoreSuperadminOrganizationResponse>(getRestoreSuperadminOrganizationUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreSuperadminOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreSuperadminOrganization>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['restoreSuperadminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreSuperadminOrganization>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  restoreSuperadminOrganization(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreSuperadminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof restoreSuperadminOrganization>>>

    export type RestoreSuperadminOrganizationMutationError = ErrorType<unknown>

    export const useRestoreSuperadminOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreSuperadminOrganization>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getRestoreSuperadminOrganizationMutationOptions(options), queryClient);
    }

export type changeSuperadminOrganizationPriceResponse204 = {
  data: void
  status: 204
}

export type changeSuperadminOrganizationPriceResponseSuccess = (changeSuperadminOrganizationPriceResponse204) & {
  headers: Headers;
};
;

export type changeSuperadminOrganizationPriceResponse = (changeSuperadminOrganizationPriceResponseSuccess)

export const getChangeSuperadminOrganizationPriceUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/change-price`
}

export const changeSuperadminOrganizationPrice = async (organizationId: string,
    changeOrganizationPriceBodyDto: ChangeOrganizationPriceBodyDto, options?: RequestInit): Promise<changeSuperadminOrganizationPriceResponse> => {

  return axiosInstance<changeSuperadminOrganizationPriceResponse>(getChangeSuperadminOrganizationPriceUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeOrganizationPriceBodyDto,)
  }
);}




export const getChangeSuperadminOrganizationPriceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>, TError,{organizationId: string;data: BodyType<ChangeOrganizationPriceBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>, TError,{organizationId: string;data: BodyType<ChangeOrganizationPriceBodyDto>}, TContext> => {

const mutationKey = ['changeSuperadminOrganizationPrice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>, {organizationId: string;data: BodyType<ChangeOrganizationPriceBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  changeSuperadminOrganizationPrice(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeSuperadminOrganizationPriceMutationResult = NonNullable<Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>>
    export type ChangeSuperadminOrganizationPriceMutationBody = BodyType<ChangeOrganizationPriceBodyDto>
    export type ChangeSuperadminOrganizationPriceMutationError = ErrorType<unknown>

    export const useChangeSuperadminOrganizationPrice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>, TError,{organizationId: string;data: BodyType<ChangeOrganizationPriceBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeSuperadminOrganizationPrice>>,
        TError,
        {organizationId: string;data: BodyType<ChangeOrganizationPriceBodyDto>},
        TContext
      > => {
      return useMutation(getChangeSuperadminOrganizationPriceMutationOptions(options), queryClient);
    }

export type hardDeleteSuperadminOrganizationResponse204 = {
  data: void
  status: 204
}

export type hardDeleteSuperadminOrganizationResponseSuccess = (hardDeleteSuperadminOrganizationResponse204) & {
  headers: Headers;
};
;

export type hardDeleteSuperadminOrganizationResponse = (hardDeleteSuperadminOrganizationResponseSuccess)

export const getHardDeleteSuperadminOrganizationUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}`
}

export const hardDeleteSuperadminOrganization = async (organizationId: string, options?: RequestInit): Promise<hardDeleteSuperadminOrganizationResponse> => {

  return axiosInstance<hardDeleteSuperadminOrganizationResponse>(getHardDeleteSuperadminOrganizationUrl(organizationId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getHardDeleteSuperadminOrganizationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['hardDeleteSuperadminOrganization'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  hardDeleteSuperadminOrganization(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HardDeleteSuperadminOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>>

    export type HardDeleteSuperadminOrganizationMutationError = ErrorType<unknown>

    export const useHardDeleteSuperadminOrganization = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hardDeleteSuperadminOrganization>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getHardDeleteSuperadminOrganizationMutationOptions(options), queryClient);
    }

export type listSuperadminActivityResponse200 = {
  data: ListActivityEventsResponseDto
  status: 200
}

export type listSuperadminActivityResponseSuccess = (listSuperadminActivityResponse200) & {
  headers: Headers;
};
;

export type listSuperadminActivityResponse = (listSuperadminActivityResponseSuccess)

export const getListSuperadminActivityUrl = (params?: ListSuperadminActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/activity?${stringifiedParams}` : `/superadmin/activity`
}

export const listSuperadminActivity = async (params?: ListSuperadminActivityParams, options?: RequestInit): Promise<listSuperadminActivityResponse> => {

  return axiosInstance<listSuperadminActivityResponse>(getListSuperadminActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminActivityQueryKey = (params?: ListSuperadminActivityParams,) => {
    return [
    `/superadmin/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSuperadminActivityQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminActivity>>, TError = ErrorType<unknown>>(params?: ListSuperadminActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminActivity>>> = ({ signal }) => listSuperadminActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminActivity>>>
export type ListSuperadminActivityQueryError = ErrorType<unknown>


export function useListSuperadminActivity<TData = Awaited<ReturnType<typeof listSuperadminActivity>>, TError = ErrorType<unknown>>(
 params: undefined |  ListSuperadminActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminActivity>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminActivity<TData = Awaited<ReturnType<typeof listSuperadminActivity>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminActivity>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminActivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminActivity<TData = Awaited<ReturnType<typeof listSuperadminActivity>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminActivity<TData = Awaited<ReturnType<typeof listSuperadminActivity>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminActivity>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminActivityQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getSuperadminActivityEventDetailResponse200 = {
  data: SuperadminActivityEventDetailResponseDto
  status: 200
}

export type getSuperadminActivityEventDetailResponseSuccess = (getSuperadminActivityEventDetailResponse200) & {
  headers: Headers;
};
;

export type getSuperadminActivityEventDetailResponse = (getSuperadminActivityEventDetailResponseSuccess)

export const getGetSuperadminActivityEventDetailUrl = (activityEventId: string,) => {




  return `/superadmin/activity/${activityEventId}`
}

export const getSuperadminActivityEventDetail = async (activityEventId: string, options?: RequestInit): Promise<getSuperadminActivityEventDetailResponse> => {

  return axiosInstance<getSuperadminActivityEventDetailResponse>(getGetSuperadminActivityEventDetailUrl(activityEventId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSuperadminActivityEventDetailQueryKey = (activityEventId: string,) => {
    return [
    `/superadmin/activity/${activityEventId}`
    ] as const;
    }


export const getGetSuperadminActivityEventDetailQueryOptions = <TData = Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError = ErrorType<unknown>>(activityEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperadminActivityEventDetailQueryKey(activityEventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>> = ({ signal }) => getSuperadminActivityEventDetail(activityEventId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(activityEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperadminActivityEventDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>>
export type GetSuperadminActivityEventDetailQueryError = ErrorType<unknown>


export function useGetSuperadminActivityEventDetail<TData = Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError = ErrorType<unknown>>(
 activityEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminActivityEventDetail<TData = Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError = ErrorType<unknown>>(
 activityEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminActivityEventDetail<TData = Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError = ErrorType<unknown>>(
 activityEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuperadminActivityEventDetail<TData = Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError = ErrorType<unknown>>(
 activityEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminActivityEventDetail>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperadminActivityEventDetailQueryOptions(activityEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getSuperadminAnalyticsResponse200 = {
  data: GetSuperadminAnalyticsResponseDto
  status: 200
}

export type getSuperadminAnalyticsResponseSuccess = (getSuperadminAnalyticsResponse200) & {
  headers: Headers;
};
;

export type getSuperadminAnalyticsResponse = (getSuperadminAnalyticsResponseSuccess)

export const getGetSuperadminAnalyticsUrl = (params: GetSuperadminAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/analytics?${stringifiedParams}` : `/superadmin/analytics`
}

export const getSuperadminAnalytics = async (params: GetSuperadminAnalyticsParams, options?: RequestInit): Promise<getSuperadminAnalyticsResponse> => {

  return axiosInstance<getSuperadminAnalyticsResponse>(getGetSuperadminAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSuperadminAnalyticsQueryKey = (params?: GetSuperadminAnalyticsParams,) => {
    return [
    `/superadmin/analytics`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSuperadminAnalyticsQueryOptions = <TData = Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError = ErrorType<unknown>>(params: GetSuperadminAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperadminAnalyticsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperadminAnalytics>>> = ({ signal }) => getSuperadminAnalytics(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperadminAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperadminAnalytics>>>
export type GetSuperadminAnalyticsQueryError = ErrorType<unknown>


export function useGetSuperadminAnalytics<TData = Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError = ErrorType<unknown>>(
 params: GetSuperadminAnalyticsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminAnalytics<TData = Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError = ErrorType<unknown>>(
 params: GetSuperadminAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminAnalytics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminAnalytics<TData = Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError = ErrorType<unknown>>(
 params: GetSuperadminAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuperadminAnalytics<TData = Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError = ErrorType<unknown>>(
 params: GetSuperadminAnalyticsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminAnalytics>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperadminAnalyticsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getSuperadminOrganizationBillingResponse200 = {
  data: GetSuperadminOrganizationBillingResponseDto
  status: 200
}

export type getSuperadminOrganizationBillingResponseSuccess = (getSuperadminOrganizationBillingResponse200) & {
  headers: Headers;
};
;

export type getSuperadminOrganizationBillingResponse = (getSuperadminOrganizationBillingResponseSuccess)

export const getGetSuperadminOrganizationBillingUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing`
}

export const getSuperadminOrganizationBilling = async (organizationId: string, options?: RequestInit): Promise<getSuperadminOrganizationBillingResponse> => {

  return axiosInstance<getSuperadminOrganizationBillingResponse>(getGetSuperadminOrganizationBillingUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSuperadminOrganizationBillingQueryKey = (organizationId: string,) => {
    return [
    `/superadmin/organizations/${organizationId}/billing`
    ] as const;
    }


export const getGetSuperadminOrganizationBillingQueryOptions = <TData = Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperadminOrganizationBillingQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>> = ({ signal }) => getSuperadminOrganizationBilling(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperadminOrganizationBillingQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>>
export type GetSuperadminOrganizationBillingQueryError = ErrorType<unknown>


export function useGetSuperadminOrganizationBilling<TData = Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminOrganizationBilling<TData = Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminOrganizationBilling<TData = Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuperadminOrganizationBilling<TData = Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminOrganizationBilling>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperadminOrganizationBillingQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type addSuperadminOrganizationCreditsResponse200 = {
  data: AddSuperadminCreditsResponseDto
  status: 200
}

export type addSuperadminOrganizationCreditsResponseSuccess = (addSuperadminOrganizationCreditsResponse200) & {
  headers: Headers;
};
;

export type addSuperadminOrganizationCreditsResponse = (addSuperadminOrganizationCreditsResponseSuccess)

export const getAddSuperadminOrganizationCreditsUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/credit-adjustments`
}

export const addSuperadminOrganizationCredits = async (organizationId: string,
    addSuperadminCreditsBodyDto: AddSuperadminCreditsBodyDto, options?: RequestInit): Promise<addSuperadminOrganizationCreditsResponse> => {

  return axiosInstance<addSuperadminOrganizationCreditsResponse>(getAddSuperadminOrganizationCreditsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addSuperadminCreditsBodyDto,)
  }
);}




export const getAddSuperadminOrganizationCreditsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>, TError,{organizationId: string;data: BodyType<AddSuperadminCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>, TError,{organizationId: string;data: BodyType<AddSuperadminCreditsBodyDto>}, TContext> => {

const mutationKey = ['addSuperadminOrganizationCredits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>, {organizationId: string;data: BodyType<AddSuperadminCreditsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  addSuperadminOrganizationCredits(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddSuperadminOrganizationCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>>
    export type AddSuperadminOrganizationCreditsMutationBody = BodyType<AddSuperadminCreditsBodyDto>
    export type AddSuperadminOrganizationCreditsMutationError = ErrorType<unknown>

    export const useAddSuperadminOrganizationCredits = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>, TError,{organizationId: string;data: BodyType<AddSuperadminCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addSuperadminOrganizationCredits>>,
        TError,
        {organizationId: string;data: BodyType<AddSuperadminCreditsBodyDto>},
        TContext
      > => {
      return useMutation(getAddSuperadminOrganizationCreditsMutationOptions(options), queryClient);
    }

export type removeSuperadminOrganizationCreditsResponse200 = {
  data: RemoveSuperadminCreditsResponseDto
  status: 200
}

export type removeSuperadminOrganizationCreditsResponseSuccess = (removeSuperadminOrganizationCreditsResponse200) & {
  headers: Headers;
};
;

export type removeSuperadminOrganizationCreditsResponse = (removeSuperadminOrganizationCreditsResponseSuccess)

export const getRemoveSuperadminOrganizationCreditsUrl = (organizationId: string,
    grantId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/grants/${grantId}/remove-credits`
}

export const removeSuperadminOrganizationCredits = async (organizationId: string,
    grantId: string,
    removeSuperadminCreditsBodyDto: RemoveSuperadminCreditsBodyDto, options?: RequestInit): Promise<removeSuperadminOrganizationCreditsResponse> => {

  return axiosInstance<removeSuperadminOrganizationCreditsResponse>(getRemoveSuperadminOrganizationCreditsUrl(organizationId,grantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      removeSuperadminCreditsBodyDto,)
  }
);}




export const getRemoveSuperadminOrganizationCreditsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>, TError,{organizationId: string;grantId: string;data: BodyType<RemoveSuperadminCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>, TError,{organizationId: string;grantId: string;data: BodyType<RemoveSuperadminCreditsBodyDto>}, TContext> => {

const mutationKey = ['removeSuperadminOrganizationCredits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>, {organizationId: string;grantId: string;data: BodyType<RemoveSuperadminCreditsBodyDto>}> = (props) => {
          const {organizationId,grantId,data} = props ?? {};

          return  removeSuperadminOrganizationCredits(organizationId,grantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveSuperadminOrganizationCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>>
    export type RemoveSuperadminOrganizationCreditsMutationBody = BodyType<RemoveSuperadminCreditsBodyDto>
    export type RemoveSuperadminOrganizationCreditsMutationError = ErrorType<unknown>

    export const useRemoveSuperadminOrganizationCredits = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>, TError,{organizationId: string;grantId: string;data: BodyType<RemoveSuperadminCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeSuperadminOrganizationCredits>>,
        TError,
        {organizationId: string;grantId: string;data: BodyType<RemoveSuperadminCreditsBodyDto>},
        TContext
      > => {
      return useMutation(getRemoveSuperadminOrganizationCreditsMutationOptions(options), queryClient);
    }

export type refundSuperadminOrganizationTopUpResponse200 = {
  data: RefundSuperadminTopUpResponseDto
  status: 200
}

export type refundSuperadminOrganizationTopUpResponseSuccess = (refundSuperadminOrganizationTopUpResponse200) & {
  headers: Headers;
};
;

export type refundSuperadminOrganizationTopUpResponse = (refundSuperadminOrganizationTopUpResponseSuccess)

export const getRefundSuperadminOrganizationTopUpUrl = (organizationId: string,
    grantId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/grants/${grantId}/refund`
}

export const refundSuperadminOrganizationTopUp = async (organizationId: string,
    grantId: string,
    refundSuperadminTopUpBodyDto: RefundSuperadminTopUpBodyDto, options?: RequestInit): Promise<refundSuperadminOrganizationTopUpResponse> => {

  return axiosInstance<refundSuperadminOrganizationTopUpResponse>(getRefundSuperadminOrganizationTopUpUrl(organizationId,grantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refundSuperadminTopUpBodyDto,)
  }
);}




export const getRefundSuperadminOrganizationTopUpMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>, TError,{organizationId: string;grantId: string;data: BodyType<RefundSuperadminTopUpBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>, TError,{organizationId: string;grantId: string;data: BodyType<RefundSuperadminTopUpBodyDto>}, TContext> => {

const mutationKey = ['refundSuperadminOrganizationTopUp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>, {organizationId: string;grantId: string;data: BodyType<RefundSuperadminTopUpBodyDto>}> = (props) => {
          const {organizationId,grantId,data} = props ?? {};

          return  refundSuperadminOrganizationTopUp(organizationId,grantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefundSuperadminOrganizationTopUpMutationResult = NonNullable<Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>>
    export type RefundSuperadminOrganizationTopUpMutationBody = BodyType<RefundSuperadminTopUpBodyDto>
    export type RefundSuperadminOrganizationTopUpMutationError = ErrorType<unknown>

    export const useRefundSuperadminOrganizationTopUp = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>, TError,{organizationId: string;grantId: string;data: BodyType<RefundSuperadminTopUpBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refundSuperadminOrganizationTopUp>>,
        TError,
        {organizationId: string;grantId: string;data: BodyType<RefundSuperadminTopUpBodyDto>},
        TContext
      > => {
      return useMutation(getRefundSuperadminOrganizationTopUpMutationOptions(options), queryClient);
    }

export type extendSuperadminOrganizationTrialResponse200 = {
  data: ExtendSuperadminTrialResponseDto
  status: 200
}

export type extendSuperadminOrganizationTrialResponseSuccess = (extendSuperadminOrganizationTrialResponse200) & {
  headers: Headers;
};
;

export type extendSuperadminOrganizationTrialResponse = (extendSuperadminOrganizationTrialResponseSuccess)

export const getExtendSuperadminOrganizationTrialUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/trial/extend`
}

export const extendSuperadminOrganizationTrial = async (organizationId: string,
    extendSuperadminTrialBodyDto: ExtendSuperadminTrialBodyDto, options?: RequestInit): Promise<extendSuperadminOrganizationTrialResponse> => {

  return axiosInstance<extendSuperadminOrganizationTrialResponse>(getExtendSuperadminOrganizationTrialUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      extendSuperadminTrialBodyDto,)
  }
);}




export const getExtendSuperadminOrganizationTrialMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>, TError,{organizationId: string;data: BodyType<ExtendSuperadminTrialBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>, TError,{organizationId: string;data: BodyType<ExtendSuperadminTrialBodyDto>}, TContext> => {

const mutationKey = ['extendSuperadminOrganizationTrial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>, {organizationId: string;data: BodyType<ExtendSuperadminTrialBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  extendSuperadminOrganizationTrial(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExtendSuperadminOrganizationTrialMutationResult = NonNullable<Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>>
    export type ExtendSuperadminOrganizationTrialMutationBody = BodyType<ExtendSuperadminTrialBodyDto>
    export type ExtendSuperadminOrganizationTrialMutationError = ErrorType<unknown>

    export const useExtendSuperadminOrganizationTrial = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>, TError,{organizationId: string;data: BodyType<ExtendSuperadminTrialBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof extendSuperadminOrganizationTrial>>,
        TError,
        {organizationId: string;data: BodyType<ExtendSuperadminTrialBodyDto>},
        TContext
      > => {
      return useMutation(getExtendSuperadminOrganizationTrialMutationOptions(options), queryClient);
    }

export type setSuperadminOrganizationAutoRechargeLockResponse200 = {
  data: SetSuperadminAutoRechargeLockResponseDto
  status: 200
}

export type setSuperadminOrganizationAutoRechargeLockResponseSuccess = (setSuperadminOrganizationAutoRechargeLockResponse200) & {
  headers: Headers;
};
;

export type setSuperadminOrganizationAutoRechargeLockResponse = (setSuperadminOrganizationAutoRechargeLockResponseSuccess)

export const getSetSuperadminOrganizationAutoRechargeLockUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/auto-recharge-lock`
}

export const setSuperadminOrganizationAutoRechargeLock = async (organizationId: string,
    setSuperadminAutoRechargeLockBodyDto: SetSuperadminAutoRechargeLockBodyDto, options?: RequestInit): Promise<setSuperadminOrganizationAutoRechargeLockResponse> => {

  return axiosInstance<setSuperadminOrganizationAutoRechargeLockResponse>(getSetSuperadminOrganizationAutoRechargeLockUrl(organizationId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setSuperadminAutoRechargeLockBodyDto,)
  }
);}




export const getSetSuperadminOrganizationAutoRechargeLockMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>, TError,{organizationId: string;data: BodyType<SetSuperadminAutoRechargeLockBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>, TError,{organizationId: string;data: BodyType<SetSuperadminAutoRechargeLockBodyDto>}, TContext> => {

const mutationKey = ['setSuperadminOrganizationAutoRechargeLock'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>, {organizationId: string;data: BodyType<SetSuperadminAutoRechargeLockBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  setSuperadminOrganizationAutoRechargeLock(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSuperadminOrganizationAutoRechargeLockMutationResult = NonNullable<Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>>
    export type SetSuperadminOrganizationAutoRechargeLockMutationBody = BodyType<SetSuperadminAutoRechargeLockBodyDto>
    export type SetSuperadminOrganizationAutoRechargeLockMutationError = ErrorType<unknown>

    export const useSetSuperadminOrganizationAutoRechargeLock = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>, TError,{organizationId: string;data: BodyType<SetSuperadminAutoRechargeLockBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSuperadminOrganizationAutoRechargeLock>>,
        TError,
        {organizationId: string;data: BodyType<SetSuperadminAutoRechargeLockBodyDto>},
        TContext
      > => {
      return useMutation(getSetSuperadminOrganizationAutoRechargeLockMutationOptions(options), queryClient);
    }

export type reconcileSuperadminOrganizationBillingResponse200 = {
  data: ReconcileSuperadminOrganizationResponseDto
  status: 200
}

export type reconcileSuperadminOrganizationBillingResponseSuccess = (reconcileSuperadminOrganizationBillingResponse200) & {
  headers: Headers;
};
;

export type reconcileSuperadminOrganizationBillingResponse = (reconcileSuperadminOrganizationBillingResponseSuccess)

export const getReconcileSuperadminOrganizationBillingUrl = (organizationId: string,) => {




  return `/superadmin/organizations/${organizationId}/billing/reconcile`
}

export const reconcileSuperadminOrganizationBilling = async (organizationId: string, options?: RequestInit): Promise<reconcileSuperadminOrganizationBillingResponse> => {

  return axiosInstance<reconcileSuperadminOrganizationBillingResponse>(getReconcileSuperadminOrganizationBillingUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReconcileSuperadminOrganizationBillingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['reconcileSuperadminOrganizationBilling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  reconcileSuperadminOrganizationBilling(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileSuperadminOrganizationBillingMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>>

    export type ReconcileSuperadminOrganizationBillingMutationError = ErrorType<unknown>

    export const useReconcileSuperadminOrganizationBilling = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconcileSuperadminOrganizationBilling>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getReconcileSuperadminOrganizationBillingMutationOptions(options), queryClient);
    }

export type getSuperadminBillingReportResponse200 = {
  data: GetSuperadminBillingReportResponseDto
  status: 200
}

export type getSuperadminBillingReportResponseSuccess = (getSuperadminBillingReportResponse200) & {
  headers: Headers;
};
;

export type getSuperadminBillingReportResponse = (getSuperadminBillingReportResponseSuccess)

export const getGetSuperadminBillingReportUrl = (params?: GetSuperadminBillingReportParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/billing/report?${stringifiedParams}` : `/superadmin/billing/report`
}

export const getSuperadminBillingReport = async (params?: GetSuperadminBillingReportParams, options?: RequestInit): Promise<getSuperadminBillingReportResponse> => {

  return axiosInstance<getSuperadminBillingReportResponse>(getGetSuperadminBillingReportUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSuperadminBillingReportQueryKey = (params?: GetSuperadminBillingReportParams,) => {
    return [
    `/superadmin/billing/report`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSuperadminBillingReportQueryOptions = <TData = Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError = ErrorType<unknown>>(params?: GetSuperadminBillingReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSuperadminBillingReportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuperadminBillingReport>>> = ({ signal }) => getSuperadminBillingReport(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuperadminBillingReportQueryResult = NonNullable<Awaited<ReturnType<typeof getSuperadminBillingReport>>>
export type GetSuperadminBillingReportQueryError = ErrorType<unknown>


export function useGetSuperadminBillingReport<TData = Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSuperadminBillingReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminBillingReport>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminBillingReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminBillingReport<TData = Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError = ErrorType<unknown>>(
 params?: GetSuperadminBillingReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuperadminBillingReport>>,
          TError,
          Awaited<ReturnType<typeof getSuperadminBillingReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuperadminBillingReport<TData = Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError = ErrorType<unknown>>(
 params?: GetSuperadminBillingReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSuperadminBillingReport<TData = Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError = ErrorType<unknown>>(
 params?: GetSuperadminBillingReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuperadminBillingReport>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuperadminBillingReportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listSuperadminFailedBillingEventsResponse200 = {
  data: ListSuperadminFailedBillingEventsResponseDto
  status: 200
}

export type listSuperadminFailedBillingEventsResponseSuccess = (listSuperadminFailedBillingEventsResponse200) & {
  headers: Headers;
};
;

export type listSuperadminFailedBillingEventsResponse = (listSuperadminFailedBillingEventsResponseSuccess)

export const getListSuperadminFailedBillingEventsUrl = () => {




  return `/superadmin/billing/events/failed`
}

export const listSuperadminFailedBillingEvents = async ( options?: RequestInit): Promise<listSuperadminFailedBillingEventsResponse> => {

  return axiosInstance<listSuperadminFailedBillingEventsResponse>(getListSuperadminFailedBillingEventsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminFailedBillingEventsQueryKey = () => {
    return [
    `/superadmin/billing/events/failed`
    ] as const;
    }


export const getListSuperadminFailedBillingEventsQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminFailedBillingEventsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>> = ({ signal }) => listSuperadminFailedBillingEvents({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminFailedBillingEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>>
export type ListSuperadminFailedBillingEventsQueryError = ErrorType<unknown>


export function useListSuperadminFailedBillingEvents<TData = Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminFailedBillingEvents<TData = Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminFailedBillingEvents<TData = Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminFailedBillingEvents<TData = Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminFailedBillingEvents>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminFailedBillingEventsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type replaySuperadminBillingEventResponse200 = {
  data: ReplaySuperadminBillingEventResponseDto
  status: 200
}

export type replaySuperadminBillingEventResponseSuccess = (replaySuperadminBillingEventResponse200) & {
  headers: Headers;
};
;

export type replaySuperadminBillingEventResponse = (replaySuperadminBillingEventResponseSuccess)

export const getReplaySuperadminBillingEventUrl = (stripeEventId: string,) => {




  return `/superadmin/billing/events/${stripeEventId}/replay`
}

export const replaySuperadminBillingEvent = async (stripeEventId: string, options?: RequestInit): Promise<replaySuperadminBillingEventResponse> => {

  return axiosInstance<replaySuperadminBillingEventResponse>(getReplaySuperadminBillingEventUrl(stripeEventId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getReplaySuperadminBillingEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaySuperadminBillingEvent>>, TError,{stripeEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof replaySuperadminBillingEvent>>, TError,{stripeEventId: string}, TContext> => {

const mutationKey = ['replaySuperadminBillingEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaySuperadminBillingEvent>>, {stripeEventId: string}> = (props) => {
          const {stripeEventId} = props ?? {};

          return  replaySuperadminBillingEvent(stripeEventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaySuperadminBillingEventMutationResult = NonNullable<Awaited<ReturnType<typeof replaySuperadminBillingEvent>>>

    export type ReplaySuperadminBillingEventMutationError = ErrorType<unknown>

    export const useReplaySuperadminBillingEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaySuperadminBillingEvent>>, TError,{stripeEventId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaySuperadminBillingEvent>>,
        TError,
        {stripeEventId: string},
        TContext
      > => {
      return useMutation(getReplaySuperadminBillingEventMutationOptions(options), queryClient);
    }

export type listSuperadminBillingAdjustmentsResponse200 = {
  data: ListSuperadminBillingAdjustmentsResponseDto
  status: 200
}

export type listSuperadminBillingAdjustmentsResponseSuccess = (listSuperadminBillingAdjustmentsResponse200) & {
  headers: Headers;
};
;

export type listSuperadminBillingAdjustmentsResponse = (listSuperadminBillingAdjustmentsResponseSuccess)

export const getListSuperadminBillingAdjustmentsUrl = (params?: ListSuperadminBillingAdjustmentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/billing/adjustments?${stringifiedParams}` : `/superadmin/billing/adjustments`
}

export const listSuperadminBillingAdjustments = async (params?: ListSuperadminBillingAdjustmentsParams, options?: RequestInit): Promise<listSuperadminBillingAdjustmentsResponse> => {

  return axiosInstance<listSuperadminBillingAdjustmentsResponse>(getListSuperadminBillingAdjustmentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminBillingAdjustmentsQueryKey = (params?: ListSuperadminBillingAdjustmentsParams,) => {
    return [
    `/superadmin/billing/adjustments`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSuperadminBillingAdjustmentsQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError = ErrorType<unknown>>(params?: ListSuperadminBillingAdjustmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminBillingAdjustmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>> = ({ signal }) => listSuperadminBillingAdjustments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminBillingAdjustmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>>
export type ListSuperadminBillingAdjustmentsQueryError = ErrorType<unknown>


export function useListSuperadminBillingAdjustments<TData = Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError = ErrorType<unknown>>(
 params: undefined |  ListSuperadminBillingAdjustmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminBillingAdjustments<TData = Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminBillingAdjustmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminBillingAdjustments<TData = Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminBillingAdjustmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSuperadminBillingAdjustments<TData = Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError = ErrorType<unknown>>(
 params?: ListSuperadminBillingAdjustmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingAdjustments>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminBillingAdjustmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary The subscription plans as the catalog sees them in Stripe (spec §4).
 */
export type listSuperadminBillingPlansResponse200 = {
  data: ListSuperadminBillingPlansResponseDto
  status: 200
}

export type listSuperadminBillingPlansResponseSuccess = (listSuperadminBillingPlansResponse200) & {
  headers: Headers;
};
;

export type listSuperadminBillingPlansResponse = (listSuperadminBillingPlansResponseSuccess)

export const getListSuperadminBillingPlansUrl = () => {




  return `/superadmin/billing/plans`
}

export const listSuperadminBillingPlans = async ( options?: RequestInit): Promise<listSuperadminBillingPlansResponse> => {

  return axiosInstance<listSuperadminBillingPlansResponse>(getListSuperadminBillingPlansUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSuperadminBillingPlansQueryKey = () => {
    return [
    `/superadmin/billing/plans`
    ] as const;
    }


export const getListSuperadminBillingPlansQueryOptions = <TData = Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSuperadminBillingPlansQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuperadminBillingPlans>>> = ({ signal }) => listSuperadminBillingPlans({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSuperadminBillingPlansQueryResult = NonNullable<Awaited<ReturnType<typeof listSuperadminBillingPlans>>>
export type ListSuperadminBillingPlansQueryError = ErrorType<unknown>


export function useListSuperadminBillingPlans<TData = Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminBillingPlans>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminBillingPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminBillingPlans<TData = Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSuperadminBillingPlans>>,
          TError,
          Awaited<ReturnType<typeof listSuperadminBillingPlans>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSuperadminBillingPlans<TData = Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The subscription plans as the catalog sees them in Stripe (spec §4).
 */

export function useListSuperadminBillingPlans<TData = Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSuperadminBillingPlans>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSuperadminBillingPlansQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createSuperadminBillingPlanResponse200 = {
  data: SuperadminBillingPlanDto
  status: 200
}

export type createSuperadminBillingPlanResponseSuccess = (createSuperadminBillingPlanResponse200) & {
  headers: Headers;
};
;

export type createSuperadminBillingPlanResponse = (createSuperadminBillingPlanResponseSuccess)

export const getCreateSuperadminBillingPlanUrl = () => {




  return `/superadmin/billing/plans`
}

export const createSuperadminBillingPlan = async (createSuperadminBillingPlanBodyDto: CreateSuperadminBillingPlanBodyDto, options?: RequestInit): Promise<createSuperadminBillingPlanResponse> => {

  return axiosInstance<createSuperadminBillingPlanResponse>(getCreateSuperadminBillingPlanUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSuperadminBillingPlanBodyDto,)
  }
);}




export const getCreateSuperadminBillingPlanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminBillingPlan>>, TError,{data: BodyType<CreateSuperadminBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSuperadminBillingPlan>>, TError,{data: BodyType<CreateSuperadminBillingPlanBodyDto>}, TContext> => {

const mutationKey = ['createSuperadminBillingPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSuperadminBillingPlan>>, {data: BodyType<CreateSuperadminBillingPlanBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  createSuperadminBillingPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSuperadminBillingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof createSuperadminBillingPlan>>>
    export type CreateSuperadminBillingPlanMutationBody = BodyType<CreateSuperadminBillingPlanBodyDto>
    export type CreateSuperadminBillingPlanMutationError = ErrorType<unknown>

    export const useCreateSuperadminBillingPlan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSuperadminBillingPlan>>, TError,{data: BodyType<CreateSuperadminBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSuperadminBillingPlan>>,
        TError,
        {data: BodyType<CreateSuperadminBillingPlanBodyDto>},
        TContext
      > => {
      return useMutation(getCreateSuperadminBillingPlanMutationOptions(options), queryClient);
    }

export type setSuperadminBillingDefaultPlanResponse200 = {
  data: SetSuperadminBillingDefaultPlanResponseDto
  status: 200
}

export type setSuperadminBillingDefaultPlanResponseSuccess = (setSuperadminBillingDefaultPlanResponse200) & {
  headers: Headers;
};
;

export type setSuperadminBillingDefaultPlanResponse = (setSuperadminBillingDefaultPlanResponseSuccess)

export const getSetSuperadminBillingDefaultPlanUrl = () => {




  return `/superadmin/billing/plans/default`
}

export const setSuperadminBillingDefaultPlan = async (setSuperadminBillingDefaultPlanBodyDto: SetSuperadminBillingDefaultPlanBodyDto, options?: RequestInit): Promise<setSuperadminBillingDefaultPlanResponse> => {

  return axiosInstance<setSuperadminBillingDefaultPlanResponse>(getSetSuperadminBillingDefaultPlanUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setSuperadminBillingDefaultPlanBodyDto,)
  }
);}




export const getSetSuperadminBillingDefaultPlanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>, TError,{data: BodyType<SetSuperadminBillingDefaultPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>, TError,{data: BodyType<SetSuperadminBillingDefaultPlanBodyDto>}, TContext> => {

const mutationKey = ['setSuperadminBillingDefaultPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>, {data: BodyType<SetSuperadminBillingDefaultPlanBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  setSuperadminBillingDefaultPlan(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSuperadminBillingDefaultPlanMutationResult = NonNullable<Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>>
    export type SetSuperadminBillingDefaultPlanMutationBody = BodyType<SetSuperadminBillingDefaultPlanBodyDto>
    export type SetSuperadminBillingDefaultPlanMutationError = ErrorType<unknown>

    export const useSetSuperadminBillingDefaultPlan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>, TError,{data: BodyType<SetSuperadminBillingDefaultPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSuperadminBillingDefaultPlan>>,
        TError,
        {data: BodyType<SetSuperadminBillingDefaultPlanBodyDto>},
        TContext
      > => {
      return useMutation(getSetSuperadminBillingDefaultPlanMutationOptions(options), queryClient);
    }

export type updateSuperadminBillingPlanResponse200 = {
  data: SuperadminBillingPlanDto
  status: 200
}

export type updateSuperadminBillingPlanResponseSuccess = (updateSuperadminBillingPlanResponse200) & {
  headers: Headers;
};
;

export type updateSuperadminBillingPlanResponse = (updateSuperadminBillingPlanResponseSuccess)

export const getUpdateSuperadminBillingPlanUrl = (priceId: string,) => {




  return `/superadmin/billing/plans/${priceId}`
}

export const updateSuperadminBillingPlan = async (priceId: string,
    updateSuperadminBillingPlanBodyDto: UpdateSuperadminBillingPlanBodyDto, options?: RequestInit): Promise<updateSuperadminBillingPlanResponse> => {

  return axiosInstance<updateSuperadminBillingPlanResponse>(getUpdateSuperadminBillingPlanUrl(priceId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSuperadminBillingPlanBodyDto,)
  }
);}




export const getUpdateSuperadminBillingPlanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminBillingPlan>>, TError,{priceId: string;data: BodyType<UpdateSuperadminBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminBillingPlan>>, TError,{priceId: string;data: BodyType<UpdateSuperadminBillingPlanBodyDto>}, TContext> => {

const mutationKey = ['updateSuperadminBillingPlan'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSuperadminBillingPlan>>, {priceId: string;data: BodyType<UpdateSuperadminBillingPlanBodyDto>}> = (props) => {
          const {priceId,data} = props ?? {};

          return  updateSuperadminBillingPlan(priceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSuperadminBillingPlanMutationResult = NonNullable<Awaited<ReturnType<typeof updateSuperadminBillingPlan>>>
    export type UpdateSuperadminBillingPlanMutationBody = BodyType<UpdateSuperadminBillingPlanBodyDto>
    export type UpdateSuperadminBillingPlanMutationError = ErrorType<unknown>

    export const useUpdateSuperadminBillingPlan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSuperadminBillingPlan>>, TError,{priceId: string;data: BodyType<UpdateSuperadminBillingPlanBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSuperadminBillingPlan>>,
        TError,
        {priceId: string;data: BodyType<UpdateSuperadminBillingPlanBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateSuperadminBillingPlanMutationOptions(options), queryClient);
    }

export type changeSuperadminBillingPlanCreditsResponse200 = {
  data: ChangeSuperadminBillingPlanCreditsResponseDto
  status: 200
}

export type changeSuperadminBillingPlanCreditsResponseSuccess = (changeSuperadminBillingPlanCreditsResponse200) & {
  headers: Headers;
};
;

export type changeSuperadminBillingPlanCreditsResponse = (changeSuperadminBillingPlanCreditsResponseSuccess)

export const getChangeSuperadminBillingPlanCreditsUrl = (priceId: string,) => {




  return `/superadmin/billing/plans/${priceId}/credits`
}

export const changeSuperadminBillingPlanCredits = async (priceId: string,
    changeSuperadminBillingPlanCreditsBodyDto: ChangeSuperadminBillingPlanCreditsBodyDto, options?: RequestInit): Promise<changeSuperadminBillingPlanCreditsResponse> => {

  return axiosInstance<changeSuperadminBillingPlanCreditsResponse>(getChangeSuperadminBillingPlanCreditsUrl(priceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changeSuperadminBillingPlanCreditsBodyDto,)
  }
);}




export const getChangeSuperadminBillingPlanCreditsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>, TError,{priceId: string;data: BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>, TError,{priceId: string;data: BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>}, TContext> => {

const mutationKey = ['changeSuperadminBillingPlanCredits'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>, {priceId: string;data: BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>}> = (props) => {
          const {priceId,data} = props ?? {};

          return  changeSuperadminBillingPlanCredits(priceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeSuperadminBillingPlanCreditsMutationResult = NonNullable<Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>>
    export type ChangeSuperadminBillingPlanCreditsMutationBody = BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>
    export type ChangeSuperadminBillingPlanCreditsMutationError = ErrorType<unknown>

    export const useChangeSuperadminBillingPlanCredits = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>, TError,{priceId: string;data: BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeSuperadminBillingPlanCredits>>,
        TError,
        {priceId: string;data: BodyType<ChangeSuperadminBillingPlanCreditsBodyDto>},
        TContext
      > => {
      return useMutation(getChangeSuperadminBillingPlanCreditsMutationOptions(options), queryClient);
    }

export type listUsersResponse200 = {
  data: ListUsersResponseDto
  status: 200
}

export type listUsersResponseSuccess = (listUsersResponse200) & {
  headers: Headers;
};
;

export type listUsersResponse = (listUsersResponseSuccess)

export const getListUsersUrl = (params?: ListUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/superadmin/users?${stringifiedParams}` : `/superadmin/users`
}

export const listUsers = async (params?: ListUsersParams, options?: RequestInit): Promise<listUsersResponse> => {

  return axiosInstance<listUsersResponse>(getListUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersQueryKey = (params?: ListUsersParams,) => {
    return [
    `/superadmin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersQueryOptions = <TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({ signal }) => listUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUsersQueryResult = NonNullable<Awaited<ReturnType<typeof listUsers>>>
export type ListUsersQueryError = ErrorType<unknown>


export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  ListUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUsers<TData = Awaited<ReturnType<typeof listUsers>>, TError = ErrorType<unknown>>(
 params?: ListUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createUserResponse201 = {
  data: void
  status: 201
}

export type createUserResponseSuccess = (createUserResponse201) & {
  headers: Headers;
};
;

export type createUserResponse = (createUserResponseSuccess)

export const getCreateUserUrl = () => {




  return `/superadmin/users`
}

export const createUser = async (createUserBodyDto: CreateUserBodyDto, options?: RequestInit): Promise<createUserResponse> => {

  return axiosInstance<createUserResponse>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserBodyDto,)
  }
);}




export const getCreateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBodyDto>}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: BodyType<CreateUserBodyDto>}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = BodyType<CreateUserBodyDto>
    export type CreateUserMutationError = ErrorType<unknown>

    export const useCreateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: BodyType<CreateUserBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: BodyType<CreateUserBodyDto>},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }

export type archiveUserResponse204 = {
  data: void
  status: 204
}

export type archiveUserResponseSuccess = (archiveUserResponse204) & {
  headers: Headers;
};
;

export type archiveUserResponse = (archiveUserResponseSuccess)

export const getArchiveUserUrl = (userId: string,) => {




  return `/superadmin/users/${userId}/archive`
}

export const archiveUser = async (userId: string, options?: RequestInit): Promise<archiveUserResponse> => {

  return axiosInstance<archiveUserResponse>(getArchiveUserUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getArchiveUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['archiveUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  archiveUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ArchiveUserMutationResult = NonNullable<Awaited<ReturnType<typeof archiveUser>>>

    export type ArchiveUserMutationError = ErrorType<unknown>

    export const useArchiveUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getArchiveUserMutationOptions(options), queryClient);
    }

export type restoreUserResponse204 = {
  data: void
  status: 204
}

export type restoreUserResponseSuccess = (restoreUserResponse204) & {
  headers: Headers;
};
;

export type restoreUserResponse = (restoreUserResponseSuccess)

export const getRestoreUserUrl = (userId: string,) => {




  return `/superadmin/users/${userId}/restore`
}

export const restoreUser = async (userId: string, options?: RequestInit): Promise<restoreUserResponse> => {

  return axiosInstance<restoreUserResponse>(getRestoreUserUrl(userId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRestoreUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof restoreUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['restoreUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof restoreUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  restoreUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RestoreUserMutationResult = NonNullable<Awaited<ReturnType<typeof restoreUser>>>

    export type RestoreUserMutationError = ErrorType<unknown>

    export const useRestoreUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof restoreUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof restoreUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getRestoreUserMutationOptions(options), queryClient);
    }

export type impersonateUserResponse200 = {
  data: ImpersonateUserResponseDto
  status: 200
}

export type impersonateUserResponseSuccess = (impersonateUserResponse200) & {
  headers: Headers;
};
;

export type impersonateUserResponse = (impersonateUserResponseSuccess)

export const getImpersonateUserUrl = (userId: string,) => {




  return `/superadmin/users/${userId}/impersonate`
}

export const impersonateUser = async (userId: string,
    impersonateUserBodyDto: ImpersonateUserBodyDto, options?: RequestInit): Promise<impersonateUserResponse> => {

  return axiosInstance<impersonateUserResponse>(getImpersonateUserUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      impersonateUserBodyDto,)
  }
);}




export const getImpersonateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: string;data: BodyType<ImpersonateUserBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: string;data: BodyType<ImpersonateUserBodyDto>}, TContext> => {

const mutationKey = ['impersonateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof impersonateUser>>, {userId: string;data: BodyType<ImpersonateUserBodyDto>}> = (props) => {
          const {userId,data} = props ?? {};

          return  impersonateUser(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImpersonateUserMutationResult = NonNullable<Awaited<ReturnType<typeof impersonateUser>>>
    export type ImpersonateUserMutationBody = BodyType<ImpersonateUserBodyDto>
    export type ImpersonateUserMutationError = ErrorType<unknown>

    export const useImpersonateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof impersonateUser>>, TError,{userId: string;data: BodyType<ImpersonateUserBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof impersonateUser>>,
        TError,
        {userId: string;data: BodyType<ImpersonateUserBodyDto>},
        TContext
      > => {
      return useMutation(getImpersonateUserMutationOptions(options), queryClient);
    }

export type setUserSessionRecordingResponse204 = {
  data: void
  status: 204
}

export type setUserSessionRecordingResponseSuccess = (setUserSessionRecordingResponse204) & {
  headers: Headers;
};
;

export type setUserSessionRecordingResponse = (setUserSessionRecordingResponseSuccess)

export const getSetUserSessionRecordingUrl = (userId: string,) => {




  return `/superadmin/users/${userId}/session-recording`
}

export const setUserSessionRecording = async (userId: string,
    setUserSessionRecordingBodyDto: SetUserSessionRecordingBodyDto, options?: RequestInit): Promise<setUserSessionRecordingResponse> => {

  return axiosInstance<setUserSessionRecordingResponse>(getSetUserSessionRecordingUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUserSessionRecordingBodyDto,)
  }
);}




export const getSetUserSessionRecordingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSessionRecording>>, TError,{userId: string;data: BodyType<SetUserSessionRecordingBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserSessionRecording>>, TError,{userId: string;data: BodyType<SetUserSessionRecordingBodyDto>}, TContext> => {

const mutationKey = ['setUserSessionRecording'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserSessionRecording>>, {userId: string;data: BodyType<SetUserSessionRecordingBodyDto>}> = (props) => {
          const {userId,data} = props ?? {};

          return  setUserSessionRecording(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserSessionRecordingMutationResult = NonNullable<Awaited<ReturnType<typeof setUserSessionRecording>>>
    export type SetUserSessionRecordingMutationBody = BodyType<SetUserSessionRecordingBodyDto>
    export type SetUserSessionRecordingMutationError = ErrorType<unknown>

    export const useSetUserSessionRecording = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSessionRecording>>, TError,{userId: string;data: BodyType<SetUserSessionRecordingBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUserSessionRecording>>,
        TError,
        {userId: string;data: BodyType<SetUserSessionRecordingBodyDto>},
        TContext
      > => {
      return useMutation(getSetUserSessionRecordingMutationOptions(options), queryClient);
    }

export type getTwilioAccountResponse200 = {
  data: GetTwilioAccountResponseDto
  status: 200
}

export type getTwilioAccountResponseSuccess = (getTwilioAccountResponse200) & {
  headers: Headers;
};
;

export type getTwilioAccountResponse = (getTwilioAccountResponseSuccess)

export const getGetTwilioAccountUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/account`
}

export const getTwilioAccount = async (organizationId: string, options?: RequestInit): Promise<getTwilioAccountResponse> => {

  return axiosInstance<getTwilioAccountResponse>(getGetTwilioAccountUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTwilioAccountQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/twilio/account`
    ] as const;
    }


export const getGetTwilioAccountQueryOptions = <TData = Awaited<ReturnType<typeof getTwilioAccount>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTwilioAccountQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTwilioAccount>>> = ({ signal }) => getTwilioAccount(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTwilioAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getTwilioAccount>>>
export type GetTwilioAccountQueryError = ErrorType<unknown>


export function useGetTwilioAccount<TData = Awaited<ReturnType<typeof getTwilioAccount>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioAccount>>,
          TError,
          Awaited<ReturnType<typeof getTwilioAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioAccount<TData = Awaited<ReturnType<typeof getTwilioAccount>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioAccount>>,
          TError,
          Awaited<ReturnType<typeof getTwilioAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioAccount<TData = Awaited<ReturnType<typeof getTwilioAccount>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTwilioAccount<TData = Awaited<ReturnType<typeof getTwilioAccount>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioAccount>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTwilioAccountQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type provisionTwilioAccountResponse200 = {
  data: GetTwilioAccountResponseDto
  status: 200
}

export type provisionTwilioAccountResponseSuccess = (provisionTwilioAccountResponse200) & {
  headers: Headers;
};
;

export type provisionTwilioAccountResponse = (provisionTwilioAccountResponseSuccess)

export const getProvisionTwilioAccountUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/account/provision`
}

export const provisionTwilioAccount = async (organizationId: string, options?: RequestInit): Promise<provisionTwilioAccountResponse> => {

  return axiosInstance<provisionTwilioAccountResponse>(getProvisionTwilioAccountUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getProvisionTwilioAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioAccount>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioAccount>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['provisionTwilioAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionTwilioAccount>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  provisionTwilioAccount(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionTwilioAccountMutationResult = NonNullable<Awaited<ReturnType<typeof provisionTwilioAccount>>>

    export type ProvisionTwilioAccountMutationError = ErrorType<unknown>

    export const useProvisionTwilioAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioAccount>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof provisionTwilioAccount>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getProvisionTwilioAccountMutationOptions(options), queryClient);
    }

export type registerTwilioA2pResponse200 = {
  data: GetTwilioAccountResponseDto
  status: 200
}

export type registerTwilioA2pResponseSuccess = (registerTwilioA2pResponse200) & {
  headers: Headers;
};
;

export type registerTwilioA2pResponse = (registerTwilioA2pResponseSuccess)

export const getRegisterTwilioA2pUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/a2p/register`
}

export const registerTwilioA2p = async (organizationId: string,
    registerTwilioA2pBodyDto: RegisterTwilioA2pBodyDto, options?: RequestInit): Promise<registerTwilioA2pResponse> => {

  return axiosInstance<registerTwilioA2pResponse>(getRegisterTwilioA2pUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerTwilioA2pBodyDto,)
  }
);}




export const getRegisterTwilioA2pMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerTwilioA2p>>, TError,{organizationId: string;data: BodyType<RegisterTwilioA2pBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof registerTwilioA2p>>, TError,{organizationId: string;data: BodyType<RegisterTwilioA2pBodyDto>}, TContext> => {

const mutationKey = ['registerTwilioA2p'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerTwilioA2p>>, {organizationId: string;data: BodyType<RegisterTwilioA2pBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  registerTwilioA2p(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterTwilioA2pMutationResult = NonNullable<Awaited<ReturnType<typeof registerTwilioA2p>>>
    export type RegisterTwilioA2pMutationBody = BodyType<RegisterTwilioA2pBodyDto>
    export type RegisterTwilioA2pMutationError = ErrorType<unknown>

    export const useRegisterTwilioA2p = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerTwilioA2p>>, TError,{organizationId: string;data: BodyType<RegisterTwilioA2pBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerTwilioA2p>>,
        TError,
        {organizationId: string;data: BodyType<RegisterTwilioA2pBodyDto>},
        TContext
      > => {
      return useMutation(getRegisterTwilioA2pMutationOptions(options), queryClient);
    }

export type listTwilioPhoneNumbersResponse200 = {
  data: ListPhoneNumbersResponseDto
  status: 200
}

export type listTwilioPhoneNumbersResponseSuccess = (listTwilioPhoneNumbersResponse200) & {
  headers: Headers;
};
;

export type listTwilioPhoneNumbersResponse = (listTwilioPhoneNumbersResponseSuccess)

export const getListTwilioPhoneNumbersUrl = (organizationId: string,
    params?: ListTwilioPhoneNumbersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/twilio/phone-numbers?${stringifiedParams}` : `/organizations/${organizationId}/twilio/phone-numbers`
}

export const listTwilioPhoneNumbers = async (organizationId: string,
    params?: ListTwilioPhoneNumbersParams, options?: RequestInit): Promise<listTwilioPhoneNumbersResponse> => {

  return axiosInstance<listTwilioPhoneNumbersResponse>(getListTwilioPhoneNumbersUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTwilioPhoneNumbersQueryKey = (organizationId: string,
    params?: ListTwilioPhoneNumbersParams,) => {
    return [
    `/organizations/${organizationId}/twilio/phone-numbers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTwilioPhoneNumbersQueryOptions = <TData = Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListTwilioPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTwilioPhoneNumbersQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>> = ({ signal }) => listTwilioPhoneNumbers(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTwilioPhoneNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>>
export type ListTwilioPhoneNumbersQueryError = ErrorType<unknown>


export function useListTwilioPhoneNumbers<TData = Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListTwilioPhoneNumbersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof listTwilioPhoneNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioPhoneNumbers<TData = Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof listTwilioPhoneNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioPhoneNumbers<TData = Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTwilioPhoneNumbers<TData = Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioPhoneNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTwilioPhoneNumbersQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type provisionTwilioPhoneNumberResponse201 = {
  data: void
  status: 201
}

export type provisionTwilioPhoneNumberResponseSuccess = (provisionTwilioPhoneNumberResponse201) & {
  headers: Headers;
};
;

export type provisionTwilioPhoneNumberResponse = (provisionTwilioPhoneNumberResponseSuccess)

export const getProvisionTwilioPhoneNumberUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/phone-numbers`
}

export const provisionTwilioPhoneNumber = async (organizationId: string,
    provisionPhoneNumberBodyDto: ProvisionPhoneNumberBodyDto, options?: RequestInit): Promise<provisionTwilioPhoneNumberResponse> => {

  return axiosInstance<provisionTwilioPhoneNumberResponse>(getProvisionTwilioPhoneNumberUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      provisionPhoneNumberBodyDto,)
  }
);}




export const getProvisionTwilioPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>, TError,{organizationId: string;data: BodyType<ProvisionPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>, TError,{organizationId: string;data: BodyType<ProvisionPhoneNumberBodyDto>}, TContext> => {

const mutationKey = ['provisionTwilioPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>, {organizationId: string;data: BodyType<ProvisionPhoneNumberBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  provisionTwilioPhoneNumber(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionTwilioPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>>
    export type ProvisionTwilioPhoneNumberMutationBody = BodyType<ProvisionPhoneNumberBodyDto>
    export type ProvisionTwilioPhoneNumberMutationError = ErrorType<unknown>

    export const useProvisionTwilioPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>, TError,{organizationId: string;data: BodyType<ProvisionPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof provisionTwilioPhoneNumber>>,
        TError,
        {organizationId: string;data: BodyType<ProvisionPhoneNumberBodyDto>},
        TContext
      > => {
      return useMutation(getProvisionTwilioPhoneNumberMutationOptions(options), queryClient);
    }

export type searchAvailableTwilioNumbersResponse200 = {
  data: SearchAvailableNumbersResponseDto
  status: 200
}

export type searchAvailableTwilioNumbersResponseSuccess = (searchAvailableTwilioNumbersResponse200) & {
  headers: Headers;
};
;

export type searchAvailableTwilioNumbersResponse = (searchAvailableTwilioNumbersResponseSuccess)

export const getSearchAvailableTwilioNumbersUrl = (organizationId: string,
    params?: SearchAvailableTwilioNumbersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/twilio/phone-numbers/available?${stringifiedParams}` : `/organizations/${organizationId}/twilio/phone-numbers/available`
}

export const searchAvailableTwilioNumbers = async (organizationId: string,
    params?: SearchAvailableTwilioNumbersParams, options?: RequestInit): Promise<searchAvailableTwilioNumbersResponse> => {

  return axiosInstance<searchAvailableTwilioNumbersResponse>(getSearchAvailableTwilioNumbersUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchAvailableTwilioNumbersQueryKey = (organizationId: string,
    params?: SearchAvailableTwilioNumbersParams,) => {
    return [
    `/organizations/${organizationId}/twilio/phone-numbers/available`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchAvailableTwilioNumbersQueryOptions = <TData = Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: SearchAvailableTwilioNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchAvailableTwilioNumbersQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>> = ({ signal }) => searchAvailableTwilioNumbers(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchAvailableTwilioNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>>
export type SearchAvailableTwilioNumbersQueryError = ErrorType<unknown>


export function useSearchAvailableTwilioNumbers<TData = Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  SearchAvailableTwilioNumbersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>,
          TError,
          Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAvailableTwilioNumbers<TData = Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: SearchAvailableTwilioNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>,
          TError,
          Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchAvailableTwilioNumbers<TData = Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: SearchAvailableTwilioNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchAvailableTwilioNumbers<TData = Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: SearchAvailableTwilioNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchAvailableTwilioNumbers>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchAvailableTwilioNumbersQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type assignTwilioPhoneNumberResponse200 = {
  data: void
  status: 200
}

export type assignTwilioPhoneNumberResponseSuccess = (assignTwilioPhoneNumberResponse200) & {
  headers: Headers;
};
;

export type assignTwilioPhoneNumberResponse = (assignTwilioPhoneNumberResponseSuccess)

export const getAssignTwilioPhoneNumberUrl = (organizationId: string,
    phoneNumberId: string,) => {




  return `/organizations/${organizationId}/twilio/phone-numbers/${phoneNumberId}/assign`
}

export const assignTwilioPhoneNumber = async (organizationId: string,
    phoneNumberId: string,
    assignPhoneNumberBodyDto: AssignPhoneNumberBodyDto, options?: RequestInit): Promise<assignTwilioPhoneNumberResponse> => {

  return axiosInstance<assignTwilioPhoneNumberResponse>(getAssignTwilioPhoneNumberUrl(organizationId,phoneNumberId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assignPhoneNumberBodyDto,)
  }
);}




export const getAssignTwilioPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string;data: BodyType<AssignPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string;data: BodyType<AssignPhoneNumberBodyDto>}, TContext> => {

const mutationKey = ['assignTwilioPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignTwilioPhoneNumber>>, {organizationId: string;phoneNumberId: string;data: BodyType<AssignPhoneNumberBodyDto>}> = (props) => {
          const {organizationId,phoneNumberId,data} = props ?? {};

          return  assignTwilioPhoneNumber(organizationId,phoneNumberId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignTwilioPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof assignTwilioPhoneNumber>>>
    export type AssignTwilioPhoneNumberMutationBody = BodyType<AssignPhoneNumberBodyDto>
    export type AssignTwilioPhoneNumberMutationError = ErrorType<unknown>

    export const useAssignTwilioPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string;data: BodyType<AssignPhoneNumberBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignTwilioPhoneNumber>>,
        TError,
        {organizationId: string;phoneNumberId: string;data: BodyType<AssignPhoneNumberBodyDto>},
        TContext
      > => {
      return useMutation(getAssignTwilioPhoneNumberMutationOptions(options), queryClient);
    }

export type deactivateTwilioPhoneNumberResponse204 = {
  data: void
  status: 204
}

export type deactivateTwilioPhoneNumberResponseSuccess = (deactivateTwilioPhoneNumberResponse204) & {
  headers: Headers;
};
;

export type deactivateTwilioPhoneNumberResponse = (deactivateTwilioPhoneNumberResponseSuccess)

export const getDeactivateTwilioPhoneNumberUrl = (organizationId: string,
    phoneNumberId: string,) => {




  return `/organizations/${organizationId}/twilio/phone-numbers/${phoneNumberId}/deactivate`
}

export const deactivateTwilioPhoneNumber = async (organizationId: string,
    phoneNumberId: string, options?: RequestInit): Promise<deactivateTwilioPhoneNumberResponse> => {

  return axiosInstance<deactivateTwilioPhoneNumberResponse>(getDeactivateTwilioPhoneNumberUrl(organizationId,phoneNumberId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDeactivateTwilioPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext> => {

const mutationKey = ['deactivateTwilioPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>, {organizationId: string;phoneNumberId: string}> = (props) => {
          const {organizationId,phoneNumberId} = props ?? {};

          return  deactivateTwilioPhoneNumber(organizationId,phoneNumberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateTwilioPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>>

    export type DeactivateTwilioPhoneNumberMutationError = ErrorType<unknown>

    export const useDeactivateTwilioPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateTwilioPhoneNumber>>,
        TError,
        {organizationId: string;phoneNumberId: string},
        TContext
      > => {
      return useMutation(getDeactivateTwilioPhoneNumberMutationOptions(options), queryClient);
    }

export type setDefaultTwilioPhoneNumberResponse204 = {
  data: void
  status: 204
}

export type setDefaultTwilioPhoneNumberResponseSuccess = (setDefaultTwilioPhoneNumberResponse204) & {
  headers: Headers;
};
;

export type setDefaultTwilioPhoneNumberResponse = (setDefaultTwilioPhoneNumberResponseSuccess)

export const getSetDefaultTwilioPhoneNumberUrl = (organizationId: string,
    phoneNumberId: string,) => {




  return `/organizations/${organizationId}/twilio/phone-numbers/${phoneNumberId}/default`
}

export const setDefaultTwilioPhoneNumber = async (organizationId: string,
    phoneNumberId: string, options?: RequestInit): Promise<setDefaultTwilioPhoneNumberResponse> => {

  return axiosInstance<setDefaultTwilioPhoneNumberResponse>(getSetDefaultTwilioPhoneNumberUrl(organizationId,phoneNumberId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getSetDefaultTwilioPhoneNumberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext> => {

const mutationKey = ['setDefaultTwilioPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>, {organizationId: string;phoneNumberId: string}> = (props) => {
          const {organizationId,phoneNumberId} = props ?? {};

          return  setDefaultTwilioPhoneNumber(organizationId,phoneNumberId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultTwilioPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>>

    export type SetDefaultTwilioPhoneNumberMutationError = ErrorType<unknown>

    export const useSetDefaultTwilioPhoneNumber = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>, TError,{organizationId: string;phoneNumberId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultTwilioPhoneNumber>>,
        TError,
        {organizationId: string;phoneNumberId: string},
        TContext
      > => {
      return useMutation(getSetDefaultTwilioPhoneNumberMutationOptions(options), queryClient);
    }

export type createSmsResponse201 = {
  data: SmsResponseDto
  status: 201
}

export type createSmsResponseSuccess = (createSmsResponse201) & {
  headers: Headers;
};
;

export type createSmsResponse = (createSmsResponseSuccess)

export const getCreateSmsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/sms`
}

export const createSms = async (organizationId: string,
    createSmsBodyDto: CreateSmsBodyDto, options?: RequestInit): Promise<createSmsResponse> => {

  return axiosInstance<createSmsResponse>(getCreateSmsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSmsBodyDto,)
  }
);}




export const getCreateSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSms>>, TError,{organizationId: string;data: BodyType<CreateSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSms>>, TError,{organizationId: string;data: BodyType<CreateSmsBodyDto>}, TContext> => {

const mutationKey = ['createSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSms>>, {organizationId: string;data: BodyType<CreateSmsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createSms(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSmsMutationResult = NonNullable<Awaited<ReturnType<typeof createSms>>>
    export type CreateSmsMutationBody = BodyType<CreateSmsBodyDto>
    export type CreateSmsMutationError = ErrorType<unknown>

    export const useCreateSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSms>>, TError,{organizationId: string;data: BodyType<CreateSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSms>>,
        TError,
        {organizationId: string;data: BodyType<CreateSmsBodyDto>},
        TContext
      > => {
      return useMutation(getCreateSmsMutationOptions(options), queryClient);
    }

export type previewBulkSmsRecipientsResponse200 = {
  data: BulkRecipientsResponseDto
  status: 200
}

export type previewBulkSmsRecipientsResponseSuccess = (previewBulkSmsRecipientsResponse200) & {
  headers: Headers;
};
;

export type previewBulkSmsRecipientsResponse = (previewBulkSmsRecipientsResponseSuccess)

export const getPreviewBulkSmsRecipientsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/bulk/recipients`
}

export const previewBulkSmsRecipients = async (organizationId: string,
    bulkRecipientsBodyDto: BulkRecipientsBodyDto, options?: RequestInit): Promise<previewBulkSmsRecipientsResponse> => {

  return axiosInstance<previewBulkSmsRecipientsResponse>(getPreviewBulkSmsRecipientsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkRecipientsBodyDto,)
  }
);}




export const getPreviewBulkSmsRecipientsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkSmsRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof previewBulkSmsRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext> => {

const mutationKey = ['previewBulkSmsRecipients'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewBulkSmsRecipients>>, {organizationId: string;data: BodyType<BulkRecipientsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  previewBulkSmsRecipients(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewBulkSmsRecipientsMutationResult = NonNullable<Awaited<ReturnType<typeof previewBulkSmsRecipients>>>
    export type PreviewBulkSmsRecipientsMutationBody = BodyType<BulkRecipientsBodyDto>
    export type PreviewBulkSmsRecipientsMutationError = ErrorType<unknown>

    export const usePreviewBulkSmsRecipients = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewBulkSmsRecipients>>, TError,{organizationId: string;data: BodyType<BulkRecipientsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewBulkSmsRecipients>>,
        TError,
        {organizationId: string;data: BodyType<BulkRecipientsBodyDto>},
        TContext
      > => {
      return useMutation(getPreviewBulkSmsRecipientsMutationOptions(options), queryClient);
    }

export type createBulkSmsResponse200 = {
  data: BulkSendResponseDto
  status: 200
}

export type createBulkSmsResponseSuccess = (createBulkSmsResponse200) & {
  headers: Headers;
};
;

export type createBulkSmsResponse = (createBulkSmsResponseSuccess)

export const getCreateBulkSmsUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/bulk`
}

export const createBulkSms = async (organizationId: string,
    createBulkSmsBodyDto: CreateBulkSmsBodyDto, options?: RequestInit): Promise<createBulkSmsResponse> => {

  return axiosInstance<createBulkSmsResponse>(getCreateBulkSmsUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createBulkSmsBodyDto,)
  }
);}




export const getCreateBulkSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkSms>>, TError,{organizationId: string;data: BodyType<CreateBulkSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBulkSms>>, TError,{organizationId: string;data: BodyType<CreateBulkSmsBodyDto>}, TContext> => {

const mutationKey = ['createBulkSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBulkSms>>, {organizationId: string;data: BodyType<CreateBulkSmsBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  createBulkSms(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBulkSmsMutationResult = NonNullable<Awaited<ReturnType<typeof createBulkSms>>>
    export type CreateBulkSmsMutationBody = BodyType<CreateBulkSmsBodyDto>
    export type CreateBulkSmsMutationError = ErrorType<unknown>

    export const useCreateBulkSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBulkSms>>, TError,{organizationId: string;data: BodyType<CreateBulkSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBulkSms>>,
        TError,
        {organizationId: string;data: BodyType<CreateBulkSmsBodyDto>},
        TContext
      > => {
      return useMutation(getCreateBulkSmsMutationOptions(options), queryClient);
    }

export type updateSmsResponse200 = {
  data: SmsResponseDto
  status: 200
}

export type updateSmsResponseSuccess = (updateSmsResponse200) & {
  headers: Headers;
};
;

export type updateSmsResponse = (updateSmsResponseSuccess)

export const getUpdateSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}`
}

export const updateSms = async (organizationId: string,
    messageId: string,
    updateSmsBodyDto: UpdateSmsBodyDto, options?: RequestInit): Promise<updateSmsResponse> => {

  return axiosInstance<updateSmsResponse>(getUpdateSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSmsBodyDto,)
  }
);}




export const getUpdateSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,{organizationId: string;messageId: string;data: BodyType<UpdateSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,{organizationId: string;messageId: string;data: BodyType<UpdateSmsBodyDto>}, TContext> => {

const mutationKey = ['updateSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSms>>, {organizationId: string;messageId: string;data: BodyType<UpdateSmsBodyDto>}> = (props) => {
          const {organizationId,messageId,data} = props ?? {};

          return  updateSms(organizationId,messageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSmsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSms>>>
    export type UpdateSmsMutationBody = BodyType<UpdateSmsBodyDto>
    export type UpdateSmsMutationError = ErrorType<unknown>

    export const useUpdateSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSms>>, TError,{organizationId: string;messageId: string;data: BodyType<UpdateSmsBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSms>>,
        TError,
        {organizationId: string;messageId: string;data: BodyType<UpdateSmsBodyDto>},
        TContext
      > => {
      return useMutation(getUpdateSmsMutationOptions(options), queryClient);
    }

export type deleteSmsResponse204 = {
  data: void
  status: 204
}

export type deleteSmsResponseSuccess = (deleteSmsResponse204) & {
  headers: Headers;
};
;

export type deleteSmsResponse = (deleteSmsResponseSuccess)

export const getDeleteSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}`
}

export const deleteSms = async (organizationId: string,
    messageId: string, options?: RequestInit): Promise<deleteSmsResponse> => {

  return axiosInstance<deleteSmsResponse>(getDeleteSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSms>>, TError,{organizationId: string;messageId: string}, TContext> => {

const mutationKey = ['deleteSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSms>>, {organizationId: string;messageId: string}> = (props) => {
          const {organizationId,messageId} = props ?? {};

          return  deleteSms(organizationId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSmsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSms>>>

    export type DeleteSmsMutationError = ErrorType<unknown>

    export const useDeleteSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSms>>,
        TError,
        {organizationId: string;messageId: string},
        TContext
      > => {
      return useMutation(getDeleteSmsMutationOptions(options), queryClient);
    }

export type hideSmsResponse204 = {
  data: void
  status: 204
}

export type hideSmsResponseSuccess = (hideSmsResponse204) & {
  headers: Headers;
};
;

export type hideSmsResponse = (hideSmsResponseSuccess)

export const getHideSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}/hide`
}

export const hideSms = async (organizationId: string,
    messageId: string, options?: RequestInit): Promise<hideSmsResponse> => {

  return axiosInstance<hideSmsResponse>(getHideSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideSms>>, TError,{organizationId: string;messageId: string}, TContext> => {

const mutationKey = ['hideSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideSms>>, {organizationId: string;messageId: string}> = (props) => {
          const {organizationId,messageId} = props ?? {};

          return  hideSms(organizationId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideSmsMutationResult = NonNullable<Awaited<ReturnType<typeof hideSms>>>

    export type HideSmsMutationError = ErrorType<unknown>

    export const useHideSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideSms>>,
        TError,
        {organizationId: string;messageId: string},
        TContext
      > => {
      return useMutation(getHideSmsMutationOptions(options), queryClient);
    }

export type unhideSmsResponse204 = {
  data: void
  status: 204
}

export type unhideSmsResponseSuccess = (unhideSmsResponse204) & {
  headers: Headers;
};
;

export type unhideSmsResponse = (unhideSmsResponseSuccess)

export const getUnhideSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}/unhide`
}

export const unhideSms = async (organizationId: string,
    messageId: string, options?: RequestInit): Promise<unhideSmsResponse> => {

  return axiosInstance<unhideSmsResponse>(getUnhideSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideSms>>, TError,{organizationId: string;messageId: string}, TContext> => {

const mutationKey = ['unhideSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideSms>>, {organizationId: string;messageId: string}> = (props) => {
          const {organizationId,messageId} = props ?? {};

          return  unhideSms(organizationId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideSmsMutationResult = NonNullable<Awaited<ReturnType<typeof unhideSms>>>

    export type UnhideSmsMutationError = ErrorType<unknown>

    export const useUnhideSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideSms>>,
        TError,
        {organizationId: string;messageId: string},
        TContext
      > => {
      return useMutation(getUnhideSmsMutationOptions(options), queryClient);
    }

export type sendSmsResponse200 = {
  data: SmsResponseDto
  status: 200
}

export type sendSmsResponseSuccess = (sendSmsResponse200) & {
  headers: Headers;
};
;

export type sendSmsResponse = (sendSmsResponseSuccess)

export const getSendSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}/send`
}

export const sendSms = async (organizationId: string,
    messageId: string, options?: RequestInit): Promise<sendSmsResponse> => {

  return axiosInstance<sendSmsResponse>(getSendSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSendSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendSms>>, TError,{organizationId: string;messageId: string}, TContext> => {

const mutationKey = ['sendSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendSms>>, {organizationId: string;messageId: string}> = (props) => {
          const {organizationId,messageId} = props ?? {};

          return  sendSms(organizationId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendSmsMutationResult = NonNullable<Awaited<ReturnType<typeof sendSms>>>

    export type SendSmsMutationError = ErrorType<unknown>

    export const useSendSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendSms>>,
        TError,
        {organizationId: string;messageId: string},
        TContext
      > => {
      return useMutation(getSendSmsMutationOptions(options), queryClient);
    }

export type approveSmsResponse200 = {
  data: SmsResponseDto
  status: 200
}

export type approveSmsResponseSuccess = (approveSmsResponse200) & {
  headers: Headers;
};
;

export type approveSmsResponse = (approveSmsResponseSuccess)

export const getApproveSmsUrl = (organizationId: string,
    messageId: string,) => {




  return `/organizations/${organizationId}/twilio/sms/${messageId}/approve`
}

export const approveSms = async (organizationId: string,
    messageId: string, options?: RequestInit): Promise<approveSmsResponse> => {

  return axiosInstance<approveSmsResponse>(getApproveSmsUrl(organizationId,messageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveSmsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveSms>>, TError,{organizationId: string;messageId: string}, TContext> => {

const mutationKey = ['approveSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveSms>>, {organizationId: string;messageId: string}> = (props) => {
          const {organizationId,messageId} = props ?? {};

          return  approveSms(organizationId,messageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveSmsMutationResult = NonNullable<Awaited<ReturnType<typeof approveSms>>>

    export type ApproveSmsMutationError = ErrorType<unknown>

    export const useApproveSms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveSms>>, TError,{organizationId: string;messageId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveSms>>,
        TError,
        {organizationId: string;messageId: string},
        TContext
      > => {
      return useMutation(getApproveSmsMutationOptions(options), queryClient);
    }

export type initiateTwilioCallResponse201 = {
  data: InitiateCallResponseDto
  status: 201
}

export type initiateTwilioCallResponseSuccess = (initiateTwilioCallResponse201) & {
  headers: Headers;
};
;

export type initiateTwilioCallResponse = (initiateTwilioCallResponseSuccess)

export const getInitiateTwilioCallUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/calls/initiate`
}

export const initiateTwilioCall = async (organizationId: string,
    initiateCallBodyDto: InitiateCallBodyDto, options?: RequestInit): Promise<initiateTwilioCallResponse> => {

  return axiosInstance<initiateTwilioCallResponse>(getInitiateTwilioCallUrl(organizationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      initiateCallBodyDto,)
  }
);}




export const getInitiateTwilioCallMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateTwilioCall>>, TError,{organizationId: string;data: BodyType<InitiateCallBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initiateTwilioCall>>, TError,{organizationId: string;data: BodyType<InitiateCallBodyDto>}, TContext> => {

const mutationKey = ['initiateTwilioCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initiateTwilioCall>>, {organizationId: string;data: BodyType<InitiateCallBodyDto>}> = (props) => {
          const {organizationId,data} = props ?? {};

          return  initiateTwilioCall(organizationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitiateTwilioCallMutationResult = NonNullable<Awaited<ReturnType<typeof initiateTwilioCall>>>
    export type InitiateTwilioCallMutationBody = BodyType<InitiateCallBodyDto>
    export type InitiateTwilioCallMutationError = ErrorType<unknown>

    export const useInitiateTwilioCall = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initiateTwilioCall>>, TError,{organizationId: string;data: BodyType<InitiateCallBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initiateTwilioCall>>,
        TError,
        {organizationId: string;data: BodyType<InitiateCallBodyDto>},
        TContext
      > => {
      return useMutation(getInitiateTwilioCallMutationOptions(options), queryClient);
    }

export type getTwilioAccessTokenResponse200 = {
  data: GetAccessTokenResponseDto
  status: 200
}

export type getTwilioAccessTokenResponseSuccess = (getTwilioAccessTokenResponse200) & {
  headers: Headers;
};
;

export type getTwilioAccessTokenResponse = (getTwilioAccessTokenResponseSuccess)

export const getGetTwilioAccessTokenUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/twilio/access-token`
}

export const getTwilioAccessToken = async (organizationId: string, options?: RequestInit): Promise<getTwilioAccessTokenResponse> => {

  return axiosInstance<getTwilioAccessTokenResponse>(getGetTwilioAccessTokenUrl(organizationId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getGetTwilioAccessTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTwilioAccessToken>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getTwilioAccessToken>>, TError,{organizationId: string}, TContext> => {

const mutationKey = ['getTwilioAccessToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTwilioAccessToken>>, {organizationId: string}> = (props) => {
          const {organizationId} = props ?? {};

          return  getTwilioAccessToken(organizationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTwilioAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof getTwilioAccessToken>>>

    export type GetTwilioAccessTokenMutationError = ErrorType<unknown>

    export const useGetTwilioAccessToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTwilioAccessToken>>, TError,{organizationId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTwilioAccessToken>>,
        TError,
        {organizationId: string},
        TContext
      > => {
      return useMutation(getGetTwilioAccessTokenMutationOptions(options), queryClient);
    }

export type listTwilioMessagesResponse200 = {
  data: ListMessagesResponseDto
  status: 200
}

export type listTwilioMessagesResponseSuccess = (listTwilioMessagesResponse200) & {
  headers: Headers;
};
;

export type listTwilioMessagesResponse = (listTwilioMessagesResponseSuccess)

export const getListTwilioMessagesUrl = (organizationId: string,
    params?: ListTwilioMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/twilio/messages?${stringifiedParams}` : `/organizations/${organizationId}/twilio/messages`
}

export const listTwilioMessages = async (organizationId: string,
    params?: ListTwilioMessagesParams, options?: RequestInit): Promise<listTwilioMessagesResponse> => {

  return axiosInstance<listTwilioMessagesResponse>(getListTwilioMessagesUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTwilioMessagesQueryKey = (organizationId: string,
    params?: ListTwilioMessagesParams,) => {
    return [
    `/organizations/${organizationId}/twilio/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTwilioMessagesQueryOptions = <TData = Awaited<ReturnType<typeof listTwilioMessages>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListTwilioMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTwilioMessagesQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTwilioMessages>>> = ({ signal }) => listTwilioMessages(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTwilioMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof listTwilioMessages>>>
export type ListTwilioMessagesQueryError = ErrorType<unknown>


export function useListTwilioMessages<TData = Awaited<ReturnType<typeof listTwilioMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListTwilioMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioMessages>>,
          TError,
          Awaited<ReturnType<typeof listTwilioMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioMessages<TData = Awaited<ReturnType<typeof listTwilioMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioMessages>>,
          TError,
          Awaited<ReturnType<typeof listTwilioMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioMessages<TData = Awaited<ReturnType<typeof listTwilioMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTwilioMessages<TData = Awaited<ReturnType<typeof listTwilioMessages>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioMessages>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTwilioMessagesQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type listTwilioCallsResponse200 = {
  data: ListCallsResponseDto
  status: 200
}

export type listTwilioCallsResponseSuccess = (listTwilioCallsResponse200) & {
  headers: Headers;
};
;

export type listTwilioCallsResponse = (listTwilioCallsResponseSuccess)

export const getListTwilioCallsUrl = (organizationId: string,
    params?: ListTwilioCallsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/organizations/${organizationId}/twilio/calls?${stringifiedParams}` : `/organizations/${organizationId}/twilio/calls`
}

export const listTwilioCalls = async (organizationId: string,
    params?: ListTwilioCallsParams, options?: RequestInit): Promise<listTwilioCallsResponse> => {

  return axiosInstance<listTwilioCallsResponse>(getListTwilioCallsUrl(organizationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTwilioCallsQueryKey = (organizationId: string,
    params?: ListTwilioCallsParams,) => {
    return [
    `/organizations/${organizationId}/twilio/calls`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTwilioCallsQueryOptions = <TData = Awaited<ReturnType<typeof listTwilioCalls>>, TError = ErrorType<unknown>>(organizationId: string,
    params?: ListTwilioCallsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTwilioCallsQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTwilioCalls>>> = ({ signal }) => listTwilioCalls(organizationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTwilioCallsQueryResult = NonNullable<Awaited<ReturnType<typeof listTwilioCalls>>>
export type ListTwilioCallsQueryError = ErrorType<unknown>


export function useListTwilioCalls<TData = Awaited<ReturnType<typeof listTwilioCalls>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params: undefined |  ListTwilioCallsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioCalls>>,
          TError,
          Awaited<ReturnType<typeof listTwilioCalls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioCalls<TData = Awaited<ReturnType<typeof listTwilioCalls>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioCallsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTwilioCalls>>,
          TError,
          Awaited<ReturnType<typeof listTwilioCalls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTwilioCalls<TData = Awaited<ReturnType<typeof listTwilioCalls>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioCallsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTwilioCalls<TData = Awaited<ReturnType<typeof listTwilioCalls>>, TError = ErrorType<unknown>>(
 organizationId: string,
    params?: ListTwilioCallsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTwilioCalls>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTwilioCallsQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type createTwilioCallEventResponse204 = {
  data: void
  status: 204
}

export type createTwilioCallEventResponseSuccess = (createTwilioCallEventResponse204) & {
  headers: Headers;
};
;

export type createTwilioCallEventResponse = (createTwilioCallEventResponseSuccess)

export const getCreateTwilioCallEventUrl = (organizationId: string,
    callId: string,) => {




  return `/organizations/${organizationId}/twilio/calls/${callId}/events`
}

export const createTwilioCallEvent = async (organizationId: string,
    callId: string,
    createCallEventBodyDto: CreateCallEventBodyDto, options?: RequestInit): Promise<createTwilioCallEventResponse> => {

  return axiosInstance<createTwilioCallEventResponse>(getCreateTwilioCallEventUrl(organizationId,callId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCallEventBodyDto,)
  }
);}




export const getCreateTwilioCallEventMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTwilioCallEvent>>, TError,{organizationId: string;callId: string;data: BodyType<CreateCallEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTwilioCallEvent>>, TError,{organizationId: string;callId: string;data: BodyType<CreateCallEventBodyDto>}, TContext> => {

const mutationKey = ['createTwilioCallEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTwilioCallEvent>>, {organizationId: string;callId: string;data: BodyType<CreateCallEventBodyDto>}> = (props) => {
          const {organizationId,callId,data} = props ?? {};

          return  createTwilioCallEvent(organizationId,callId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTwilioCallEventMutationResult = NonNullable<Awaited<ReturnType<typeof createTwilioCallEvent>>>
    export type CreateTwilioCallEventMutationBody = BodyType<CreateCallEventBodyDto>
    export type CreateTwilioCallEventMutationError = ErrorType<unknown>

    export const useCreateTwilioCallEvent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTwilioCallEvent>>, TError,{organizationId: string;callId: string;data: BodyType<CreateCallEventBodyDto>}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTwilioCallEvent>>,
        TError,
        {organizationId: string;callId: string;data: BodyType<CreateCallEventBodyDto>},
        TContext
      > => {
      return useMutation(getCreateTwilioCallEventMutationOptions(options), queryClient);
    }

export type hideTwilioCallResponse204 = {
  data: void
  status: 204
}

export type hideTwilioCallResponseSuccess = (hideTwilioCallResponse204) & {
  headers: Headers;
};
;

export type hideTwilioCallResponse = (hideTwilioCallResponseSuccess)

export const getHideTwilioCallUrl = (organizationId: string,
    callId: string,) => {




  return `/organizations/${organizationId}/twilio/calls/${callId}/hide`
}

export const hideTwilioCall = async (organizationId: string,
    callId: string, options?: RequestInit): Promise<hideTwilioCallResponse> => {

  return axiosInstance<hideTwilioCallResponse>(getHideTwilioCallUrl(organizationId,callId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getHideTwilioCallMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof hideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext> => {

const mutationKey = ['hideTwilioCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hideTwilioCall>>, {organizationId: string;callId: string}> = (props) => {
          const {organizationId,callId} = props ?? {};

          return  hideTwilioCall(organizationId,callId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HideTwilioCallMutationResult = NonNullable<Awaited<ReturnType<typeof hideTwilioCall>>>

    export type HideTwilioCallMutationError = ErrorType<unknown>

    export const useHideTwilioCall = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hideTwilioCall>>,
        TError,
        {organizationId: string;callId: string},
        TContext
      > => {
      return useMutation(getHideTwilioCallMutationOptions(options), queryClient);
    }

export type unhideTwilioCallResponse204 = {
  data: void
  status: 204
}

export type unhideTwilioCallResponseSuccess = (unhideTwilioCallResponse204) & {
  headers: Headers;
};
;

export type unhideTwilioCallResponse = (unhideTwilioCallResponseSuccess)

export const getUnhideTwilioCallUrl = (organizationId: string,
    callId: string,) => {




  return `/organizations/${organizationId}/twilio/calls/${callId}/unhide`
}

export const unhideTwilioCall = async (organizationId: string,
    callId: string, options?: RequestInit): Promise<unhideTwilioCallResponse> => {

  return axiosInstance<unhideTwilioCallResponse>(getUnhideTwilioCallUrl(organizationId,callId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUnhideTwilioCallMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof unhideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext> => {

const mutationKey = ['unhideTwilioCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unhideTwilioCall>>, {organizationId: string;callId: string}> = (props) => {
          const {organizationId,callId} = props ?? {};

          return  unhideTwilioCall(organizationId,callId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnhideTwilioCallMutationResult = NonNullable<Awaited<ReturnType<typeof unhideTwilioCall>>>

    export type UnhideTwilioCallMutationError = ErrorType<unknown>

    export const useUnhideTwilioCall = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unhideTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unhideTwilioCall>>,
        TError,
        {organizationId: string;callId: string},
        TContext
      > => {
      return useMutation(getUnhideTwilioCallMutationOptions(options), queryClient);
    }

export type deleteTwilioCallResponse204 = {
  data: void
  status: 204
}

export type deleteTwilioCallResponseSuccess = (deleteTwilioCallResponse204) & {
  headers: Headers;
};
;

export type deleteTwilioCallResponse = (deleteTwilioCallResponseSuccess)

export const getDeleteTwilioCallUrl = (organizationId: string,
    callId: string,) => {




  return `/organizations/${organizationId}/twilio/calls/${callId}`
}

export const deleteTwilioCall = async (organizationId: string,
    callId: string, options?: RequestInit): Promise<deleteTwilioCallResponse> => {

  return axiosInstance<deleteTwilioCallResponse>(getDeleteTwilioCallUrl(organizationId,callId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTwilioCallMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTwilioCall>>, TError,{organizationId: string;callId: string}, TContext> => {

const mutationKey = ['deleteTwilioCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTwilioCall>>, {organizationId: string;callId: string}> = (props) => {
          const {organizationId,callId} = props ?? {};

          return  deleteTwilioCall(organizationId,callId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTwilioCallMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTwilioCall>>>

    export type DeleteTwilioCallMutationError = ErrorType<unknown>

    export const useDeleteTwilioCall = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTwilioCall>>, TError,{organizationId: string;callId: string}, TContext>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTwilioCall>>,
        TError,
        {organizationId: string;callId: string},
        TContext
      > => {
      return useMutation(getDeleteTwilioCallMutationOptions(options), queryClient);
    }

export type getTwilioRecordingMediaResponse200 = {
  data: void
  status: 200
}

export type getTwilioRecordingMediaResponseSuccess = (getTwilioRecordingMediaResponse200) & {
  headers: Headers;
};
;

export type getTwilioRecordingMediaResponse = (getTwilioRecordingMediaResponseSuccess)

export const getGetTwilioRecordingMediaUrl = (organizationId: string,
    recordingId: string,) => {




  return `/organizations/${organizationId}/twilio/recordings/${recordingId}/media`
}

export const getTwilioRecordingMedia = async (organizationId: string,
    recordingId: string, options?: RequestInit): Promise<getTwilioRecordingMediaResponse> => {

  return axiosInstance<getTwilioRecordingMediaResponse>(getGetTwilioRecordingMediaUrl(organizationId,recordingId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTwilioRecordingMediaQueryKey = (organizationId: string,
    recordingId: string,) => {
    return [
    `/organizations/${organizationId}/twilio/recordings/${recordingId}/media`
    ] as const;
    }


export const getGetTwilioRecordingMediaQueryOptions = <TData = Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError = ErrorType<unknown>>(organizationId: string,
    recordingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTwilioRecordingMediaQueryKey(organizationId,recordingId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTwilioRecordingMedia>>> = ({ signal }) => getTwilioRecordingMedia(organizationId,recordingId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId && recordingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTwilioRecordingMediaQueryResult = NonNullable<Awaited<ReturnType<typeof getTwilioRecordingMedia>>>
export type GetTwilioRecordingMediaQueryError = ErrorType<unknown>


export function useGetTwilioRecordingMedia<TData = Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError = ErrorType<unknown>>(
 organizationId: string,
    recordingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioRecordingMedia>>,
          TError,
          Awaited<ReturnType<typeof getTwilioRecordingMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioRecordingMedia<TData = Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError = ErrorType<unknown>>(
 organizationId: string,
    recordingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTwilioRecordingMedia>>,
          TError,
          Awaited<ReturnType<typeof getTwilioRecordingMedia>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTwilioRecordingMedia<TData = Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError = ErrorType<unknown>>(
 organizationId: string,
    recordingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTwilioRecordingMedia<TData = Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError = ErrorType<unknown>>(
 organizationId: string,
    recordingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTwilioRecordingMedia>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTwilioRecordingMediaQueryOptions(organizationId,recordingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







export type getPipelineMetadataResponse200 = {
  data: GetPipelineMetadataResponseDto
  status: 200
}

export type getPipelineMetadataResponseSuccess = (getPipelineMetadataResponse200) & {
  headers: Headers;
};
;

export type getPipelineMetadataResponse = (getPipelineMetadataResponseSuccess)

export const getGetPipelineMetadataUrl = (organizationId: string,) => {




  return `/organizations/${organizationId}/pipeline/metadata`
}

export const getPipelineMetadata = async (organizationId: string, options?: RequestInit): Promise<getPipelineMetadataResponse> => {

  return axiosInstance<getPipelineMetadataResponse>(getGetPipelineMetadataUrl(organizationId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPipelineMetadataQueryKey = (organizationId: string,) => {
    return [
    `/organizations/${organizationId}/pipeline/metadata`
    ] as const;
    }


export const getGetPipelineMetadataQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineMetadata>>, TError = ErrorType<unknown>>(organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineMetadataQueryKey(organizationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineMetadata>>> = ({ signal }) => getPipelineMetadata(organizationId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineMetadataQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineMetadata>>>
export type GetPipelineMetadataQueryError = ErrorType<unknown>


export function useGetPipelineMetadata<TData = Awaited<ReturnType<typeof getPipelineMetadata>>, TError = ErrorType<unknown>>(
 organizationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPipelineMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineMetadata<TData = Awaited<ReturnType<typeof getPipelineMetadata>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineMetadata>>,
          TError,
          Awaited<ReturnType<typeof getPipelineMetadata>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineMetadata<TData = Awaited<ReturnType<typeof getPipelineMetadata>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPipelineMetadata<TData = Awaited<ReturnType<typeof getPipelineMetadata>>, TError = ErrorType<unknown>>(
 organizationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineMetadata>>, TError, TData>>, request?: SecondParameter<typeof axiosInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineMetadataQueryOptions(organizationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
